;;
(function webpackUniversalModuleDefinition(a, b) {
    if (typeof exports === 'object' && typeof module === 'object') {
        module.exports = b()
    } else if (typeof define === 'function' && define.amd) {
        define([], b)
    } else if (typeof exports === 'object') {
        exports["SIP"] = b()
    } else {
        a["SIP"] = b()
    }
})(this, function() {
    return (function(f) {
        var g = {};

        function __webpack_require__(a) {
            if (g[a]) {
                return g[a].exports
            }
            var b = g[a] = {
                i: a,
                l: false,
                exports: {}
            };
            f[a].call(b.exports, b, b.exports, __webpack_require__);
            b.l = true;
            return b.exports
        }
        __webpack_require__.m = f;
        __webpack_require__.c = g;
        __webpack_require__.d = function(a, b, c) {
            if (!__webpack_require__.o(a, b)) {
                Object.defineProperty(a, b, {
                    enumerable: true,
                    get: c
                })
            }
        };
        __webpack_require__.r = function(a) {
            if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
                Object.defineProperty(a, Symbol.toStringTag, {
                    value: 'Module'
                })
            }
            Object.defineProperty(a, '__esModule', {
                value: true
            })
        };
        __webpack_require__.t = function(b, c) {
            if (c & 1) {
                b = __webpack_require__(b)
            }
            if (c & 8) {
                return b
            }
            if ((c & 4) && typeof b === 'object' && b && b.__esModule) {
                return b
            };
            var d = Object.create(null);
            __webpack_require__.r(d);
            Object.defineProperty(d, 'default', {
                enumerable: true,
                value: b
            });
            if (c & 2 && typeof b != 'string') {
                for (var e in b) __webpack_require__.d(d, e, function(a) {
                    return b[a]
                }.bind(null, e))
            };
            return d
        };
        __webpack_require__.n = function(a) {
            var b = a && a.__esModule ? function getDefault() {
                return a['default']
            } : function getModuleExports() {
                return a
            };
            __webpack_require__.d(b, 'a', b);
            return b
        };
        __webpack_require__.o = function(a, b) {
            return Object.prototype.hasOwnProperty.call(a, b)
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = 0)
    })([(function(a, b, c) {
        "use strict";
        Object.defineProperty(b, "__esModule", {
            value: true
        });
        var d = c(1);
        b.ClientContext = d.ClientContext;
        var e = c(3);
        b.C = e.C;
        var f = c(16);
        b.Dialog = f.Dialog;
        var g = c(17);
        b.DigestAuthentication = g.DigestAuthentication;
        var h = c(5);
        b.DialogStatus = h.DialogStatus;
        b.SessionStatus = h.SessionStatus;
        b.TypeStrings = h.TypeStrings;
        b.UAStatus = h.UAStatus;
        var i = c(8);
        b.Exceptions = i.Exceptions;
        var j = c(11);
        b.Grammar = j.Grammar;
        var k = c(20);
        b.LoggerFactory = k.LoggerFactory;
        var l = c(13);
        b.NameAddrHeader = l.NameAddrHeader;
        var m = c(21);
        b.Parser = m.Parser;
        var n = c(22);
        b.PublishContext = n.PublishContext;
        var o = c(23);
        b.RegisterContext = o.RegisterContext;
        var p = c(6);
        b.RequestSender = p.RequestSender;
        var q = c(24);
        var r = q.SanityCheck.sanityCheck;
        b.sanityCheck = r;
        var s = c(25);
        b.ServerContext = s.ServerContext;
        var t = c(26);
        b.InviteClientContext = t.InviteClientContext;
        b.InviteServerContext = t.InviteServerContext;
        b.ReferClientContext = t.ReferClientContext;
        b.ReferServerContext = t.ReferServerContext;
        b.Session = t.Session;
        var u = c(10);
        b.IncomingRequest = u.IncomingRequest;
        b.IncomingResponse = u.IncomingResponse;
        b.OutgoingRequest = u.OutgoingRequest;
        var v = c(28);
        b.Subscription = v.Subscription;
        var w = c(9);
        b.Timers = w.Timers;
        var x = c(7);
        var y = {
            InviteClientTransaction: x.InviteClientTransaction,
            InviteServerTransaction: x.InviteServerTransaction,
            NonInviteClientTransaction: x.NonInviteClientTransaction,
            NonInviteServerTransaction: x.NonInviteServerTransaction
        };
        b.Transactions = y;
        var z = c(29);
        b.Transport = z.Transport;
        var A = c(30);
        b.UA = A.UA;
        var B = c(14);
        b.URI = B.URI;
        var C = c(15);
        b.Utils = C.Utils;
        var D = c(36);
        b.Web = D;
        var E = c(4);
        var F = E.title;
        b.name = F;
        var G = E.version;
        b.version = G
    }), (function(h, i, j) {
        "use strict";
        var k = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        Object.defineProperty(i, "__esModule", {
            value: true
        });
        var l = j(2);
        var m = j(3);
        var n = j(5);
        var o = j(6);
        var q = j(10);
        var r = j(15);
        var s = (function(g) {
            k(s, g);

            function s(a, b, c, d) {
                var e = g.call(this) || this;
                e.data = {};
                s.initializer(e, a, b, c, d);
                return e
            }
            s.initializer = function(a, b, c, d, e) {
                a.type = n.TypeStrings.ClientContext;
                if (d === undefined) {
                    throw new TypeError("Not enough arguments");
                }
                a.ua = b;
                a.logger = b.getLogger("sip.clientcontext");
                a.method = c;
                var f = b.normalizeTarget(d);
                if (!f) {
                    throw new TypeError("Invalid target: " + d);
                }
                e = Object.create(e || Object.prototype);
                e.extraHeaders = (e.extraHeaders || [])
                    .slice();
                a.request = new q.OutgoingRequest(a.method, f, a.ua, e.params, e.extraHeaders);
                if (e.body) {
                    a.body = {};
                    a.body.body = e.body;
                    if (e.contentType) {
                        a.body.contentType = e.contentType
                    }
                    a.request.body = a.body
                }
                if (a.request.from) {
                    a.localIdentity = a.request.from
                }
                if (a.request.to) {
                    a.remoteIdentity = a.request.to
                }
            };
            s.prototype.send = function() {
                var a = new o.RequestSender(this, this.ua);
                a.send();
                return this
            };
            s.prototype.receiveResponse = function(a) {
                var b = a.statusCode || 0;
                var c = r.Utils.getReasonPhrase(b);
                switch (true) {
                    case /^1[0-9]{2}$/.test(b.toString()):
                        this.emit("progress", a, c);
                        break;
                    case /^2[0-9]{2}$/.test(b.toString()):
                        if (this.ua.applicants[this.toString()]) {
                            delete this.ua.applicants[this.toString()]
                        }
                        this.emit("accepted", a, c);
                        break;
                    default:
                        if (this.ua.applicants[this.toString()]) {
                            delete this.ua.applicants[this.toString()]
                        }
                        this.emit("rejected", a, c);
                        this.emit("failed", a, c);
                        break
                }
            };
            s.prototype.onRequestTimeout = function() {
                this.emit("failed", undefined, m.C.causes.REQUEST_TIMEOUT)
            };
            s.prototype.onTransportError = function() {
                this.emit("failed", undefined, m.C.causes.CONNECTION_ERROR)
            };
            return s
        }(l.EventEmitter));
        i.ClientContext = s
    }), (function(k, l, o) {
        "use strict";
        var R = typeof Reflect === 'object' ? Reflect : null;
        var p = R && typeof R.apply === 'function' ? R.apply : function p(a, b, c) {
            return Function.prototype.apply.call(a, b, c)
        };
        var q;
        if (R && typeof R.ownKeys === 'function') {
            q = R.ownKeys
        } else if (Object.getOwnPropertySymbols) {
            q = function q(a) {
                return Object.getOwnPropertyNames(a)
                    .concat(Object.getOwnPropertySymbols(a))
            }
        } else {
            q = function q(a) {
                return Object.getOwnPropertyNames(a)
            }
        }

        function ProcessEmitWarning(a) {
            if (console && console.warn) console.warn(a)
        }
        var r = Number.isNaN || function r(a) {
            return a !== a
        };

        function EventEmitter() {
            EventEmitter.init.call(this)
        }
        k.exports = EventEmitter;
        EventEmitter.EventEmitter = EventEmitter;
        EventEmitter.prototype._events = undefined;
        EventEmitter.prototype._eventsCount = 0;
        EventEmitter.prototype._maxListeners = undefined;
        var s = 10;
        Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
            enumerable: true,
            get: function() {
                return s
            },
            set: function(a) {
                if (typeof a !== 'number' || a < 0 || r(a)) {
                    throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + a + '.');
                }
                s = a
            }
        });
        EventEmitter.init = function() {
            if (this._events === undefined || this._events === Object.getPrototypeOf(this)
                ._events) {
                this._events = Object.create(null);
                this._eventsCount = 0
            }
            this._maxListeners = this._maxListeners || undefined
        };
        EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
            if (typeof n !== 'number' || n < 0 || r(n)) {
                throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
            }
            this._maxListeners = n;
            return this
        };

        function $getMaxListeners(a) {
            if (a._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
            return a._maxListeners
        }
        EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
            return $getMaxListeners(this)
        };
        EventEmitter.prototype.emit = function emit(a) {
            var b = [];
            for (var i = 1; i < arguments.length; i++) b.push(arguments[i]);
            var c = (a === 'error');
            var d = this._events;
            if (d !== undefined) c = (c && d.error === undefined);
            else if (!c) return false;
            if (c) {
                var e;
                if (b.length > 0) e = b[0];
                if (e instanceof Error) {
                    throw e;
                }
                var f = new Error('Unhandled error.' + (e ? ' (' + e.message + ')' : ''));
                f.context = e;
                throw f;
            }
            var g = d[a];
            if (g === undefined) return false;
            if (typeof g === 'function') {
                p(g, this, b)
            } else {
                var h = g.length;
                var j = arrayClone(g, h);
                for (var i = 0; i < h; ++i) p(j[i], this, b)
            }
            return true
        };

        function _addListener(a, b, c, d) {
            var m;
            var e;
            var f;
            if (typeof c !== 'function') {
                throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof c);
            }
            e = a._events;
            if (e === undefined) {
                e = a._events = Object.create(null);
                a._eventsCount = 0
            } else {
                if (e.newListener !== undefined) {
                    a.emit('newListener', b, c.listener ? c.listener : c);
                    e = a._events
                }
                f = e[b]
            }
            if (f === undefined) {
                f = e[b] = c;
                ++a._eventsCount
            } else {
                if (typeof f === 'function') {
                    f = e[b] = d ? [c, f] : [f, c]
                } else if (d) {
                    f.unshift(c)
                } else {
                    f.push(c)
                }
                m = $getMaxListeners(a);
                if (m > 0 && f.length > m && !f.warned) {
                    f.warned = true;
                    var w = new Error('Possible EventEmitter memory leak detected. ' + f.length + ' ' + String(b) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
                    w.name = 'MaxListenersExceededWarning';
                    w.emitter = a;
                    w.type = b;
                    w.count = f.length;
                    ProcessEmitWarning(w)
                }
            }
            return a
        }
        EventEmitter.prototype.addListener = function addListener(a, b) {
            return _addListener(this, a, b, false)
        };
        EventEmitter.prototype.on = EventEmitter.prototype.addListener;
        EventEmitter.prototype.prependListener = function prependListener(a, b) {
            return _addListener(this, a, b, true)
        };

        function onceWrapper() {
            var a = [];
            for (var i = 0; i < arguments.length; i++) a.push(arguments[i]);
            if (!this.fired) {
                this.target.removeListener(this.type, this.wrapFn);
                this.fired = true;
                p(this.listener, this.target, a)
            }
        }

        function _onceWrap(a, b, c) {
            var d = {
                fired: false,
                wrapFn: undefined,
                target: a,
                type: b,
                listener: c
            };
            var e = onceWrapper.bind(d);
            e.listener = c;
            d.wrapFn = e;
            return e
        }
        EventEmitter.prototype.once = function once(a, b) {
            if (typeof b !== 'function') {
                throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof b);
            }
            this.on(a, _onceWrap(this, a, b));
            return this
        };
        EventEmitter.prototype.prependOnceListener = function prependOnceListener(a, b) {
            if (typeof b !== 'function') {
                throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof b);
            }
            this.prependListener(a, _onceWrap(this, a, b));
            return this
        };
        EventEmitter.prototype.removeListener = function removeListener(a, b) {
            var c, events, position, i, originalListener;
            if (typeof b !== 'function') {
                throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof b);
            }
            events = this._events;
            if (events === undefined) return this;
            c = events[a];
            if (c === undefined) return this;
            if (c === b || c.listener === b) {
                if (--this._eventsCount === 0) this._events = Object.create(null);
                else {
                    delete events[a];
                    if (events.removeListener) this.emit('removeListener', a, c.listener || b)
                }
            } else if (typeof c !== 'function') {
                position = -1;
                for (i = c.length - 1; i >= 0; i--) {
                    if (c[i] === b || c[i].listener === b) {
                        originalListener = c[i].listener;
                        position = i;
                        break
                    }
                }
                if (position < 0) return this;
                if (position === 0) c.shift();
                else {
                    spliceOne(c, position)
                }
                if (c.length === 1) events[a] = c[0];
                if (events.removeListener !== undefined) this.emit('removeListener', a, originalListener || b)
            }
            return this
        };
        EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
        EventEmitter.prototype.removeAllListeners = function removeAllListeners(a) {
            var b, events, i;
            events = this._events;
            if (events === undefined) return this;
            if (events.removeListener === undefined) {
                if (arguments.length === 0) {
                    this._events = Object.create(null);
                    this._eventsCount = 0
                } else if (events[a] !== undefined) {
                    if (--this._eventsCount === 0) this._events = Object.create(null);
                    else delete events[a]
                }
                return this
            }
            if (arguments.length === 0) {
                var c = Object.keys(events);
                var d;
                for (i = 0; i < c.length; ++i) {
                    d = c[i];
                    if (d === 'removeListener') continue;
                    this.removeAllListeners(d)
                }
                this.removeAllListeners('removeListener');
                this._events = Object.create(null);
                this._eventsCount = 0;
                return this
            }
            b = events[a];
            if (typeof b === 'function') {
                this.removeListener(a, b)
            } else if (b !== undefined) {
                for (i = b.length - 1; i >= 0; i--) {
                    this.removeListener(a, b[i])
                }
            }
            return this
        };

        function _listeners(a, b, c) {
            var d = a._events;
            if (d === undefined) return [];
            var e = d[b];
            if (e === undefined) return [];
            if (typeof e === 'function') return c ? [e.listener || e] : [e];
            return c ? unwrapListeners(e) : arrayClone(e, e.length)
        }
        EventEmitter.prototype.listeners = function listeners(a) {
            return _listeners(this, a, true)
        };
        EventEmitter.prototype.rawListeners = function rawListeners(a) {
            return _listeners(this, a, false)
        };
        EventEmitter.listenerCount = function(a, b) {
            if (typeof a.listenerCount === 'function') {
                return a.listenerCount(b)
            } else {
                return listenerCount.call(a, b)
            }
        };
        EventEmitter.prototype.listenerCount = listenerCount;

        function listenerCount(a) {
            var b = this._events;
            if (b !== undefined) {
                var c = b[a];
                if (typeof c === 'function') {
                    return 1
                } else if (c !== undefined) {
                    return c.length
                }
            }
            return 0
        }
        EventEmitter.prototype.eventNames = function eventNames() {
            return this._eventsCount > 0 ? q(this._events) : []
        };

        function arrayClone(a, n) {
            var b = new Array(n);
            for (var i = 0; i < n; ++i) b[i] = a[i];
            return b
        }

        function spliceOne(a, b) {
            for (; b + 1 < a.length; b++) a[b] = a[b + 1];
            a.pop()
        }

        function unwrapListeners(a) {
            var b = new Array(a.length);
            for (var i = 0; i < b.length; ++i) {
                b[i] = a[i].listener || a[i]
            }
            return b
        }
    }), (function(e, f, g) {
        "use strict";
        Object.defineProperty(f, "__esModule", {
            value: true
        });
        var h = g(4);
        var C;
        (function(C) {
            C.USER_AGENT = h.title + "/" + h.version;
            C.SIP = "sip";
            C.SIPS = "sips";
            var b;
            (function(a) {
                a["CONNECTION_ERROR"] = "Connection Error";
                a["INTERNAL_ERROR"] = "Internal Error";
                a["REQUEST_TIMEOUT"] = "Request Timeout";
                a["SIP_FAILURE_CODE"] = "SIP Failure Code";
                a["ADDRESS_INCOMPLETE"] = "Address Incomplete";
                a["AUTHENTICATION_ERROR"] = "Authentication Error";
                a["BUSY"] = "Busy";
                a["DIALOG_ERROR"] = "Dialog Error";
                a["INCOMPATIBLE_SDP"] = "Incompatible SDP";
                a["NOT_FOUND"] = "Not Found";
                a["REDIRECTED"] = "Redirected";
                a["REJECTED"] = "Rejected";
                a["UNAVAILABLE"] = "Unavailable";
                a["BAD_MEDIA_DESCRIPTION"] = "Bad Media Description";
                a["CANCELED"] = "Canceled";
                a["EXPIRES"] = "Expires";
                a["NO_ACK"] = "No ACK";
                a["NO_ANSWER"] = "No Answer";
                a["NO_PRACK"] = "No PRACK";
                a["RTP_TIMEOUT"] = "RTP Timeout";
                a["USER_DENIED_MEDIA_ACCESS"] = "User Denied Media Access";
                a["WEBRTC_ERROR"] = "WebRTC Error";
                a["WEBRTC_NOT_SUPPORTED"] = "WebRTC Not Supported"
            })(b = C.causes || (C.causes = {}));
            var c;
            (function(a) {
                a["REQUIRED"] = "required";
                a["SUPPORTED"] = "supported";
                a["UNSUPPORTED"] = "none"
            })(c = C.supported || (C.supported = {}));
            C.SIP_ERROR_CAUSES = {
                ADDRESS_INCOMPLETE: [484],
                AUTHENTICATION_ERROR: [401, 407],
                BUSY: [486, 600],
                INCOMPATIBLE_SDP: [488, 606],
                NOT_FOUND: [404, 604],
                REDIRECTED: [300, 301, 302, 305, 380],
                REJECTED: [403, 603],
                UNAVAILABLE: [480, 410, 408, 430]
            };
            C.ACK = "ACK";
            C.BYE = "BYE";
            C.CANCEL = "CANCEL";
            C.INFO = "INFO";
            C.INVITE = "INVITE";
            C.MESSAGE = "MESSAGE";
            C.NOTIFY = "NOTIFY";
            C.OPTIONS = "OPTIONS";
            C.REGISTER = "REGISTER";
            C.UPDATE = "UPDATE";
            C.SUBSCRIBE = "SUBSCRIBE";
            C.PUBLISH = "PUBLISH";
            C.REFER = "REFER";
            C.PRACK = "PRACK";
            C.REASON_PHRASE = {
                100: "Trying",
                180: "Ringing",
                181: "Call Is Being Forwarded",
                182: "Queued",
                183: "Session Progress",
                199: "Early Dialog Terminated",
                200: "OK",
                202: "Accepted",
                204: "No Notification",
                300: "Multiple Choices",
                301: "Moved Permanently",
                302: "Moved Temporarily",
                305: "Use Proxy",
                380: "Alternative Service",
                400: "Bad Request",
                401: "Unauthorized",
                402: "Payment Required",
                403: "Forbidden",
                404: "Not Found",
                405: "Method Not Allowed",
                406: "Not Acceptable",
                407: "Proxy Authentication Required",
                408: "Request Timeout",
                410: "Gone",
                412: "Conditional Request Failed",
                413: "Request Entity Too Large",
                414: "Request-URI Too Long",
                415: "Unsupported Media Type",
                416: "Unsupported URI Scheme",
                417: "Unknown Resource-Priority",
                420: "Bad Extension",
                421: "Extension Required",
                422: "Session Interval Too Small",
                423: "Interval Too Brief",
                428: "Use Identity Header",
                429: "Provide Referrer Identity",
                430: "Flow Failed",
                433: "Anonymity Disallowed",
                436: "Bad Identity-Info",
                437: "Unsupported Certificate",
                438: "Invalid Identity Header",
                439: "First Hop Lacks Outbound Support",
                440: "Max-Breadth Exceeded",
                469: "Bad Info Package",
                470: "Consent Needed",
                478: "Unresolvable Destination",
                480: "Temporarily Unavailable",
                481: "Call/Transaction Does Not Exist",
                482: "Loop Detected",
                483: "Too Many Hops",
                484: "Address Incomplete",
                485: "Ambiguous",
                486: "Busy Here",
                487: "Request Terminated",
                488: "Not Acceptable Here",
                489: "Bad Event",
                491: "Request Pending",
                493: "Undecipherable",
                494: "Security Agreement Required",
                500: "Internal Server Error",
                501: "Not Implemented",
                502: "Bad Gateway",
                503: "Service Unavailable",
                504: "Server Time-out",
                505: "Version Not Supported",
                513: "Message Too Large",
                580: "Precondition Failure",
                600: "Busy Everywhere",
                603: "Decline",
                604: "Does Not Exist Anywhere",
                606: "Not Acceptable"
            };
            C.OPTION_TAGS = {
                "100rel": true,
                "199": true,
                "answermode": true,
                "early-session": true,
                "eventlist": true,
                "explicitsub": true,
                "from-change": true,
                "geolocation-http": true,
                "geolocation-sip": true,
                "gin": true,
                "gruu": true,
                "histinfo": true,
                "ice": true,
                "join": true,
                "multiple-refer": true,
                "norefersub": true,
                "nosub": true,
                "outbound": true,
                "path": true,
                "policy": true,
                "precondition": true,
                "pref": true,
                "privacy": true,
                "recipient-list-invite": true,
                "recipient-list-message": true,
                "recipient-list-subscribe": true,
                "replaces": true,
                "resource-priority": true,
                "sdp-anat": true,
                "sec-agree": true,
                "tdialog": true,
                "timer": true,
                "uui": true
            };
            var d;
            (function(a) {
                a["INFO"] = "info";
                a["RTP"] = "rtp"
            })(d = C.dtmfType || (C.dtmfType = {}))
        })(C = f.C || (f.C = {}))
    }), (function(a) {
        a.exports = {
            "name": "sip.js",
            "title": "SIP.js",
            "description": "A simple, intuitive, and powerful JavaScript signaling library",
            "version": "0.13.8",
            "license": "MIT",
            "main": "./lib/index.js",
            "types": "./lib/index.d.ts",
            "homepage": "https://sipjs.com",
            "author": "OnSIP <developer@onsip.com> (https://sipjs.com/aboutus/)",
            "contributors": [{
                "url": "https://github.com/onsip/SIP.js/blob/master/THANKS.md"
            }],
            "repository": {
                "type": "git",
                "url": "https://github.com/onsip/SIP.js.git"
            },
            "keywords": ["sip", "webrtc", "library", "websocket", "javascript", "typescript"],
            "dependencies": {
                "crypto-js": "^3.1.9-1"
            },
            "devDependencies": {
                "@types/jasmine": "^3.3.11",
                "@types/node": "^11.11.6",
                "circular-dependency-plugin": "^5.0.2",
                "jasmine-core": "^3.3.0",
                "karma": "^4.0.1",
                "karma-chrome-launcher": "^2.2.0",
                "karma-cli": "^2.0.0",
                "karma-jasmine": "^2.0.1",
                "karma-jasmine-html-reporter": "^1.4.0",
                "karma-mocha-reporter": "^2.2.5",
                "karma-sourcemap-loader": "^0.3.7",
                "karma-webpack": "^3.0.5",
                "pegjs": "^0.10.0",
                "ts-loader": "^5.3.3",
                "ts-pegjs": "0.2.2",
                "tslint": "^5.14.0",
                "typescript": "^3.3.4000",
                "webpack": "^4.29.6",
                "webpack-cli": "^3.3.0"
            },
            "engines": {
                "node": ">=8.0"
            },
            "scripts": {
                "prebuild": "tslint -p tsconfig-base.json -c tslint.json",
                "generate-grammar": "node build/grammarGenerator.js",
                "build-reg-bundle": "webpack --progress --config build/webpack.config.js --env.buildType reg",
                "build-min-bundle": "webpack --progress --config build/webpack.config.js --env.buildType min",
                "build-bundles": "npm run build-reg-bundle && npm run build-min-bundle",
                "build-lib": "tsc -p src",
                "build-test": "tsc -p test",
                "copy-dist-files": "cp dist/sip.js dist/sip-$npm_package_version.js && cp dist/sip.min.js dist/sip-$npm_package_version.min.js",
                "build": "npm run generate-grammar && npm run build-lib && npm run build-reg-bundle && npm run build-min-bundle && npm run copy-dist-files",
                "browserTest": "npm run build-test && sleep 2 && open http://0.0.0.0:9876/debug.html & karma start --reporters kjhtml --no-single-run",
                "commandLineTest": "npm run build-test && karma start --reporters mocha --browsers ChromeHeadless --single-run",
                "buildAndTest": "npm run build && npm run commandLineTest",
                "buildAndBrowserTest": "npm run build && npm run browserTest"
            }
        }
    }), (function(b, c, d) {
        "use strict";
        Object.defineProperty(c, "__esModule", {
            value: true
        });
        var e;
        (function(a) {
            a[a["STATUS_EARLY"] = 1] = "STATUS_EARLY";
            a[a["STATUS_CONFIRMED"] = 2] = "STATUS_CONFIRMED"
        })(e = c.DialogStatus || (c.DialogStatus = {}));
        var f;
        (function(a) {
            a[a["STATUS_NULL"] = 0] = "STATUS_NULL";
            a[a["STATUS_INVITE_SENT"] = 1] = "STATUS_INVITE_SENT";
            a[a["STATUS_1XX_RECEIVED"] = 2] = "STATUS_1XX_RECEIVED";
            a[a["STATUS_INVITE_RECEIVED"] = 3] = "STATUS_INVITE_RECEIVED";
            a[a["STATUS_WAITING_FOR_ANSWER"] = 4] = "STATUS_WAITING_FOR_ANSWER";
            a[a["STATUS_ANSWERED"] = 5] = "STATUS_ANSWERED";
            a[a["STATUS_WAITING_FOR_PRACK"] = 6] = "STATUS_WAITING_FOR_PRACK";
            a[a["STATUS_WAITING_FOR_ACK"] = 7] = "STATUS_WAITING_FOR_ACK";
            a[a["STATUS_CANCELED"] = 8] = "STATUS_CANCELED";
            a[a["STATUS_TERMINATED"] = 9] = "STATUS_TERMINATED";
            a[a["STATUS_ANSWERED_WAITING_FOR_PRACK"] = 10] = "STATUS_ANSWERED_WAITING_FOR_PRACK";
            a[a["STATUS_EARLY_MEDIA"] = 11] = "STATUS_EARLY_MEDIA";
            a[a["STATUS_CONFIRMED"] = 12] = "STATUS_CONFIRMED"
        })(f = c.SessionStatus || (c.SessionStatus = {}));
        var g;
        (function(a) {
            a[a["ClientContext"] = 0] = "ClientContext";
            a[a["ConfigurationError"] = 1] = "ConfigurationError";
            a[a["Dialog"] = 2] = "Dialog";
            a[a["DigestAuthentication"] = 3] = "DigestAuthentication";
            a[a["DTMF"] = 4] = "DTMF";
            a[a["IncomingMessage"] = 5] = "IncomingMessage";
            a[a["IncomingRequest"] = 6] = "IncomingRequest";
            a[a["IncomingResponse"] = 7] = "IncomingResponse";
            a[a["InvalidStateError"] = 8] = "InvalidStateError";
            a[a["InviteClientContext"] = 9] = "InviteClientContext";
            a[a["InviteServerContext"] = 10] = "InviteServerContext";
            a[a["Logger"] = 11] = "Logger";
            a[a["LoggerFactory"] = 12] = "LoggerFactory";
            a[a["MethodParameterError"] = 13] = "MethodParameterError";
            a[a["NameAddrHeader"] = 14] = "NameAddrHeader";
            a[a["NotSupportedError"] = 15] = "NotSupportedError";
            a[a["OutgoingRequest"] = 16] = "OutgoingRequest";
            a[a["Parameters"] = 17] = "Parameters";
            a[a["PublishContext"] = 18] = "PublishContext";
            a[a["ReferClientContext"] = 19] = "ReferClientContext";
            a[a["ReferServerContext"] = 20] = "ReferServerContext";
            a[a["RegisterContext"] = 21] = "RegisterContext";
            a[a["RenegotiationError"] = 22] = "RenegotiationError";
            a[a["RequestSender"] = 23] = "RequestSender";
            a[a["ServerContext"] = 24] = "ServerContext";
            a[a["Session"] = 25] = "Session";
            a[a["SessionDescriptionHandler"] = 26] = "SessionDescriptionHandler";
            a[a["SessionDescriptionHandlerError"] = 27] = "SessionDescriptionHandlerError";
            a[a["SessionDescriptionHandlerObserver"] = 28] = "SessionDescriptionHandlerObserver";
            a[a["Subscription"] = 29] = "Subscription";
            a[a["Transport"] = 30] = "Transport";
            a[a["UA"] = 31] = "UA";
            a[a["URI"] = 32] = "URI"
        })(g = c.TypeStrings || (c.TypeStrings = {}));
        var h;
        (function(a) {
            a[a["STATUS_INIT"] = 0] = "STATUS_INIT";
            a[a["STATUS_STARTING"] = 1] = "STATUS_STARTING";
            a[a["STATUS_READY"] = 2] = "STATUS_READY";
            a[a["STATUS_USER_CLOSED"] = 3] = "STATUS_USER_CLOSED";
            a[a["STATUS_NOT_READY"] = 4] = "STATUS_NOT_READY"
        })(h = c.UAStatus || (c.UAStatus = {}))
    }), (function(f, g, h) {
        "use strict";
        Object.defineProperty(g, "__esModule", {
            value: true
        });
        var i = h(3);
        var j = h(5);
        var k = h(7);
        var l = (function() {
            function l(a, b) {
                this.type = j.TypeStrings.RequestSender;
                this.logger = b.getLogger("sip.requestsender");
                this.loggerFactory = b.getLoggerFactory();
                this.ua = b;
                this.applicant = a;
                this.method = a.request.method;
                this.request = a.request;
                this.credentials = undefined;
                this.challenged = false;
                this.staled = false;
                if (b.status === j.UAStatus.STATUS_USER_CLOSED && (this.method !== i.C.BYE && this.method !== i.C.ACK)) {
                    this.onTransportError()
                }
            }
            l.prototype.send = function() {
                var b = this;
                var c = this.ua.transport;
                if (!c) {
                    throw new Error("Transport undefined.");
                }
                var d = {
                    loggerFactory: this.ua.getLoggerFactory(),
                    onRequestTimeout: function() {
                        return b.onRequestTimeout()
                    },
                    onStateChange: function(a) {
                        if (a === k.TransactionState.Terminated) {
                            b.ua.destroyTransaction(e)
                        }
                    },
                    onTransportError: function(a) {
                        return b.onTransportError()
                    },
                    receiveResponse: function(a) {
                        return b.receiveResponse(a)
                    }
                };
                var e;
                switch (this.method) {
                    case "INVITE":
                        e = new k.InviteClientTransaction(this.request, c, d);
                        break;
                    case "ACK":
                        throw new Error("Cannot make client transaction for ACK method.");
                    default:
                        e = new k.NonInviteClientTransaction(this.request, c, d)
                }
                this.clientTransaction = e;
                this.ua.newTransaction(e);
                return e
            };
            l.prototype.onRequestTimeout = function() {
                this.applicant.onRequestTimeout()
            };
            l.prototype.onTransportError = function() {
                this.applicant.onTransportError()
            };
            l.prototype.receiveResponse = function(a) {
                var b = a && a.statusCode ? a.statusCode : 0;
                if (b === 401 || b === 407) {
                    var c = void 0;
                    var d = void 0;
                    if (b === 401) {
                        c = a.parseHeader("www-authenticate");
                        d = "authorization"
                    } else {
                        c = a.parseHeader("proxy-authenticate");
                        d = "proxy-authorization"
                    }
                    if (!c) {
                        this.logger.warn(b + " with wrong or missing challenge, cannot authenticate");
                        this.applicant.receiveResponse(a);
                        return
                    }
                    if (!this.challenged || (!this.staled && c.stale === true)) {
                        if (!this.credentials && this.ua.configuration.authenticationFactory) {
                            this.credentials = this.ua.configuration.authenticationFactory(this.ua)
                        }
                        if (!this.credentials.authenticate(this.request, c)) {
                            this.applicant.receiveResponse(a);
                            return
                        }
                        this.challenged = true;
                        if (c.stale) {
                            this.staled = true
                        }
                        var e = void 0;
                        if (a.method === i.C.REGISTER) {
                            e = this.applicant.cseq += 1
                        } else if (this.request.dialog) {
                            e = this.request.dialog.localSeqnum += 1
                        } else {
                            e = (this.request.cseq || 0) + 1;
                            this.request.cseq = e
                        }
                        this.request.setHeader("cseq", e + " " + this.method);
                        this.request.setHeader(d, this.credentials.toString());
                        this.send()
                    } else {
                        this.applicant.receiveResponse(a)
                    }
                } else {
                    this.applicant.receiveResponse(a)
                }
            };
            return l
        }());
        g.RequestSender = l
    }), (function(m, n, o) {
        "use strict";
        var q = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        Object.defineProperty(n, "__esModule", {
            value: true
        });
        var r = o(2);
        var s = o(3);
        var t = o(8);
        var u = o(9);
        var v;
        (function(a) {
            a["Accepted"] = "Accepted";
            a["Calling"] = "Calling";
            a["Completed"] = "Completed";
            a["Confirmed"] = "Confirmed";
            a["Proceeding"] = "Proceeding";
            a["Terminated"] = "Terminated";
            a["Trying"] = "Trying"
        })(v = n.TransactionState || (n.TransactionState = {}));
        var w = (function(g) {
            q(w, g);

            function w(a, b, c, d, e) {
                var f = g.call(this) || this;
                f._transport = a;
                f._user = b;
                f._id = c;
                f._state = d;
                f.logger = b.loggerFactory.getLogger(e, c);
                f.logger.debug("Constructing " + f.typeToString() + " with id " + f.id + ".");
                return f
            }
            w.prototype.dispose = function() {
                this.logger.debug("Destroyed " + this.typeToString() + " with id " + this.id + ".")
            };
            Object.defineProperty(w.prototype, "id", {
                get: function() {
                    return this._id
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(w.prototype, "kind", {
                get: function() {
                    if (this instanceof y) {
                        return "ict"
                    } else if (this instanceof z) {
                        return "nict"
                    } else if (this instanceof B) {
                        return "ist"
                    } else if (this instanceof C) {
                        return "nist"
                    }
                    throw new Error("Invalid kind.");
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(w.prototype, "state", {
                get: function() {
                    return this._state
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(w.prototype, "transport", {
                get: function() {
                    return this._transport
                },
                enumerable: true,
                configurable: true
            });
            w.prototype.on = function(a, b) {
                return g.prototype.on.call(this, a, b)
            };
            w.prototype.logTransportError = function(a, b) {
                this.logger.error(a.message);
                this.logger.error("Transport error occurred in " + this.typeToString() + " with id " + this.id + ".");
                this.logger.error(b)
            };
            w.prototype.send = function(c) {
                var d = this;
                return this.transport.send(c)
                    .catch(function(a) {
                        if (a instanceof t.Exceptions.TransportError) {
                            d.onTransportError(a);
                            return
                        }
                        var b;
                        if (a && typeof a.message === "string") {
                            b = new t.Exceptions.TransportError(a.message)
                        } else {
                            b = new t.Exceptions.TransportError()
                        }
                        d.onTransportError(b);
                        throw b;
                    })
            };
            w.prototype.setState = function(a) {
                this.logger.debug("State change to \"" + a + "\" on " + this.typeToString() + " with id " + this.id + ".");
                this._state = a;
                if (this._user.onStateChange) {
                    this._user.onStateChange(a)
                }
                this.emit("stateChanged")
            };
            w.prototype.typeToString = function() {
                var a = "UnknownType";
                if (this instanceof y) {
                    a = "INVITE client transaction"
                } else if (this instanceof z) {
                    a = "non-INVITE client transaction"
                } else if (this instanceof B) {
                    a = "INVITE server transaction"
                } else if (this instanceof C) {
                    a = "non-INVITE server transaction"
                }
                return a
            };
            return w
        }(r.EventEmitter));
        n.Transaction = w;
        var x = (function(g) {
            q(x, g);

            function x(a, b, c, d, e) {
                var f = g.call(this, b, c, x.makeId(a), d, e) || this;
                f._request = a;
                f.user = c;
                a.setViaHeader(f.id, b);
                a.transaction = f;
                return f
            }
            x.makeId = function(a) {
                if (a.method === "CANCEL") {
                    if (!a.branch) {
                        throw new Error("Outgoing CANCEL request without a branch.");
                    }
                    return a.branch
                } else {
                    return "z9hG4bK" + Math.floor(Math.random() * 10000000)
                }
            };
            Object.defineProperty(x.prototype, "request", {
                get: function() {
                    return this._request
                },
                enumerable: true,
                configurable: true
            });
            x.prototype.onRequestTimeout = function() {
                if (this.user.onRequestTimeout) {
                    this.user.onRequestTimeout()
                }
            };
            return x
        }(w));
        n.ClientTransaction = x;
        var y = (function(l) {
            q(y, l);

            function y(b, c, d) {
                var e = l.call(this, b, c, d, v.Calling, "sip.transaction.ict") || this;
                e.ackRetransmissionCache = new Map();
                e.B = setTimeout(function() {
                    return e.timer_B()
                }, u.Timers.TIMER_B);
                e.send(b.toString())
                    .catch(function(a) {
                        e.logTransportError(a, "Failed to send initial outgoing request.")
                    });
                return e
            }
            y.prototype.dispose = function() {
                if (this.B) {
                    clearTimeout(this.B);
                    this.B = undefined
                }
                if (this.D) {
                    clearTimeout(this.D);
                    this.D = undefined
                }
                if (this.M) {
                    clearTimeout(this.M);
                    this.M = undefined
                }
                l.prototype.dispose.call(this)
            };
            y.prototype.ackResponse = function(b) {
                var c = this;
                var d = b.toTag;
                if (!d) {
                    throw new Error("To tag undefined.");
                }
                var e = "z9hG4bK" + Math.floor(Math.random() * 10000000);
                b.setViaHeader(e, this.transport);
                this.ackRetransmissionCache.set(d, b);
                this.send(b.toString())
                    .catch(function(a) {
                        c.logTransportError(a, "Failed to send ACK to 2xx response.")
                    })
            };
            y.prototype.receiveResponse = function(b) {
                var c = this;
                var d = b.statusCode;
                if (!d || d < 100 || d > 699) {
                    throw new Error("Invalid status code " + d);
                }
                switch (this.state) {
                    case v.Calling:
                        if (d >= 100 && d <= 199) {
                            this.stateTransition(v.Proceeding);
                            if (this.user.receiveResponse) {
                                this.user.receiveResponse(b)
                            }
                            return
                        }
                        if (d >= 200 && d <= 299) {
                            this.ackRetransmissionCache.set(b.toTag, undefined);
                            this.stateTransition(v.Accepted);
                            if (this.user.receiveResponse) {
                                this.user.receiveResponse(b)
                            }
                            return
                        }
                        if (d >= 300 && d <= 699) {
                            this.stateTransition(v.Completed);
                            this.ack(b);
                            if (this.user.receiveResponse) {
                                this.user.receiveResponse(b)
                            }
                            return
                        }
                        break;
                    case v.Proceeding:
                        if (d >= 100 && d <= 199) {
                            if (this.user.receiveResponse) {
                                this.user.receiveResponse(b)
                            }
                            return
                        }
                        if (d >= 200 && d <= 299) {
                            this.ackRetransmissionCache.set(b.toTag, undefined);
                            this.stateTransition(v.Accepted);
                            if (this.user.receiveResponse) {
                                this.user.receiveResponse(b)
                            }
                            return
                        }
                        if (d >= 300 && d <= 699) {
                            this.stateTransition(v.Completed);
                            this.ack(b);
                            if (this.user.receiveResponse) {
                                this.user.receiveResponse(b)
                            }
                            return
                        }
                        break;
                    case v.Accepted:
                        if (d >= 200 && d <= 299) {
                            if (!this.ackRetransmissionCache.has(b.toTag)) {
                                this.ackRetransmissionCache.set(b.toTag, undefined);
                                if (this.user.receiveResponse) {
                                    this.user.receiveResponse(b)
                                }
                                return
                            }
                            var e = this.ackRetransmissionCache.get(b.toTag);
                            if (e) {
                                this.send(e.toString())
                                    .catch(function(a) {
                                        c.logTransportError(a, "Failed to send retransmission of ACK to 2xx response.")
                                    });
                                return
                            }
                            return
                        }
                        break;
                    case v.Completed:
                        if (d >= 300 && d <= 699) {
                            this.ack(b);
                            return
                        }
                        break;
                    case v.Terminated:
                        break;
                    default:
                        throw new Error("Invalid state " + this.state);
                }
                var f = "Received unexpected " + d + " response while in state " + this.state + ".";
                this.logger.warn(f);
                return
            };
            y.prototype.onTransportError = function(a) {
                if (this.user.onTransportError) {
                    this.user.onTransportError(a)
                }
                this.stateTransition(v.Terminated, true)
            };
            y.prototype.ack = function(b) {
                var c = this;
                var d = this.request.ruri;
                var e = this.request.callId;
                var f = this.request.cseq;
                var g = this.request.getHeader("from");
                var h = b.getHeader("to");
                var i = this.request.getHeader("via");
                var j = this.request.getHeader("route");
                if (!g) {
                    throw new Error("From undefined.");
                }
                if (!h) {
                    throw new Error("To undefined.");
                }
                if (!i) {
                    throw new Error("Via undefined.");
                }
                var k = "ACK " + d + " SIP/2.0\r\n";
                if (j) {
                    k += "Route: " + j + "\r\n"
                }
                k += "Via: " + i + "\r\n";
                k += "To: " + h + "\r\n";
                k += "From: " + g + "\r\n";
                k += "Call-ID: " + e + "\r\n";
                k += "CSeq: " + f + " ACK\r\n";
                k += "Max-Forwards: 70\r\n";
                k += "Content-Length: 0\r\n\r\n";
                this.send(k)
                    .catch(function(a) {
                        c.logTransportError(a, "Failed to send ACK to non-2xx response.")
                    });
                return
            };
            y.prototype.stateTransition = function(a, b) {
                var c = this;
                if (b === void 0) {
                    b = false
                }
                var d = function() {
                    throw new Error("Invalid state transition from " + c.state + " to " + a);
                };
                switch (a) {
                    case v.Calling:
                        d();
                        break;
                    case v.Proceeding:
                        if (this.state !== v.Calling) {
                            d()
                        }
                        break;
                    case v.Accepted:
                    case v.Completed:
                        if (this.state !== v.Calling && this.state !== v.Proceeding) {
                            d()
                        }
                        break;
                    case v.Terminated:
                        if (this.state !== v.Calling && this.state !== v.Accepted && this.state !== v.Completed) {
                            if (!b) {
                                d()
                            }
                        }
                        break;
                    default:
                        d()
                }
                if (this.B) {
                    clearTimeout(this.B);
                    this.B = undefined
                }
                if (a === v.Proceeding) {}
                if (a === v.Completed) {
                    this.D = setTimeout(function() {
                        return c.timer_D()
                    }, u.Timers.TIMER_D)
                }
                if (a === v.Accepted) {
                    this.M = setTimeout(function() {
                        return c.timer_M()
                    }, u.Timers.TIMER_M)
                }
                if (a === v.Terminated) {
                    this.dispose()
                }
                this.setState(a)
            };
            y.prototype.timer_A = function() {};
            y.prototype.timer_B = function() {
                this.logger.debug("Timer B expired for INVITE client transaction " + this.id + ".");
                if (this.state === v.Calling) {
                    this.onRequestTimeout();
                    this.stateTransition(v.Terminated)
                }
            };
            y.prototype.timer_D = function() {
                this.logger.debug("Timer D expired for INVITE client transaction " + this.id + ".");
                if (this.state === v.Completed) {
                    this.stateTransition(v.Terminated)
                }
            };
            y.prototype.timer_M = function() {
                this.logger.debug("Timer M expired for INVITE client transaction " + this.id + ".");
                if (this.state === v.Accepted) {
                    this.stateTransition(v.Terminated)
                }
            };
            return y
        }(x));
        n.InviteClientTransaction = y;
        var z = (function(f) {
            q(z, f);

            function z(b, c, d) {
                var e = f.call(this, b, c, d, v.Trying, "sip.transaction.nict") || this;
                e.F = setTimeout(function() {
                    return e.timer_F()
                }, u.Timers.TIMER_F);
                e.send(b.toString())
                    .catch(function(a) {
                        e.logTransportError(a, "Failed to send initial outgoing request.")
                    });
                return e
            }
            z.prototype.dispose = function() {
                if (this.F) {
                    clearTimeout(this.F);
                    this.F = undefined
                }
                if (this.K) {
                    clearTimeout(this.K);
                    this.K = undefined
                }
                f.prototype.dispose.call(this)
            };
            z.prototype.receiveResponse = function(a) {
                var b = a.statusCode;
                if (!b || b < 100 || b > 699) {
                    throw new Error("Invalid status code " + b);
                }
                switch (this.state) {
                    case v.Trying:
                        if (b >= 100 && b <= 199) {
                            this.stateTransition(v.Proceeding);
                            if (this.user.receiveResponse) {
                                this.user.receiveResponse(a)
                            }
                            return
                        }
                        if (b >= 200 && b <= 699) {
                            this.stateTransition(v.Completed);
                            if (b === 408) {
                                this.onRequestTimeout();
                                return
                            }
                            if (this.user.receiveResponse) {
                                this.user.receiveResponse(a)
                            }
                            return
                        }
                        break;
                    case v.Proceeding:
                        if (b >= 100 && b <= 199) {
                            if (this.user.receiveResponse) {
                                return this.user.receiveResponse(a)
                            }
                        }
                        if (b >= 200 && b <= 699) {
                            this.stateTransition(v.Completed);
                            if (b === 408) {
                                this.onRequestTimeout();
                                return
                            }
                            if (this.user.receiveResponse) {
                                this.user.receiveResponse(a)
                            }
                            return
                        }
                    case v.Completed:
                        return;
                    case v.Terminated:
                        return;
                    default:
                        throw new Error("Invalid state " + this.state);
                }
                var c = "Non-INVITE client transaction received unexpected " + b + " response while in state " + this.state + ".";
                this.logger.warn(c);
                return
            };
            z.prototype.onTransportError = function(a) {
                if (this.user.onTransportError) {
                    this.user.onTransportError(a)
                }
                this.stateTransition(v.Terminated, true)
            };
            z.prototype.stateTransition = function(a, b) {
                var c = this;
                if (b === void 0) {
                    b = false
                }
                var d = function() {
                    throw new Error("Invalid state transition from " + c.state + " to " + a);
                };
                switch (a) {
                    case v.Trying:
                        d();
                        break;
                    case v.Proceeding:
                        if (this.state !== v.Trying) {
                            d()
                        }
                        break;
                    case v.Completed:
                        if (this.state !== v.Trying && this.state !== v.Proceeding) {
                            d()
                        }
                        break;
                    case v.Terminated:
                        if (this.state !== v.Trying && this.state !== v.Proceeding && this.state !== v.Completed) {
                            if (!b) {
                                d()
                            }
                        }
                        break;
                    default:
                        d()
                }
                if (a === v.Completed) {
                    if (this.F) {
                        clearTimeout(this.F);
                        this.F = undefined
                    }
                    this.K = setTimeout(function() {
                        return c.timer_K()
                    }, u.Timers.TIMER_K)
                }
                if (a === v.Terminated) {
                    this.dispose()
                }
                this.setState(a)
            };
            z.prototype.timer_F = function() {
                this.logger.debug("Timer F expired for non-INVITE client transaction " + this.id + ".");
                if (this.state === v.Trying || this.state === v.Proceeding) {
                    this.onRequestTimeout();
                    this.stateTransition(v.Terminated)
                }
            };
            z.prototype.timer_K = function() {
                if (this.state === v.Completed) {
                    this.stateTransition(v.Terminated)
                }
            };
            return z
        }(x));
        n.NonInviteClientTransaction = z;
        var A = (function(g) {
            q(A, g);

            function A(a, b, c, d, e) {
                var f = g.call(this, b, c, a.viaBranch, d, e) || this;
                f._request = a;
                f.user = c;
                a.transaction = f;
                return f
            }
            Object.defineProperty(A.prototype, "request", {
                get: function() {
                    return this._request
                },
                enumerable: true,
                configurable: true
            });
            return A
        }(w));
        n.ServerTransaction = A;
        var B = (function(f) {
            q(B, f);

            function B(a, b, c) {
                var d = f.call(this, a, b, c, v.Proceeding, "sip.transaction.ist") || this;
                a.reply(100);
                return d
            }
            B.prototype.dispose = function() {
                this.stopProgressExtensionTimer();
                if (this.H) {
                    clearTimeout(this.H);
                    this.H = undefined
                }
                if (this.I) {
                    clearTimeout(this.I);
                    this.I = undefined
                }
                if (this.L) {
                    clearTimeout(this.L);
                    this.L = undefined
                }
                f.prototype.dispose.call(this)
            };
            B.prototype.receiveRequest = function(b) {
                var c = this;
                switch (this.state) {
                    case v.Proceeding:
                        if (b.method === s.C.INVITE) {
                            if (this.lastProvisionalResponse) {
                                this.send(this.lastProvisionalResponse)
                                    .catch(function(a) {
                                        c.logTransportError(a, "Failed to send retransmission of provisional response.")
                                    })
                            }
                            return
                        }
                        break;
                    case v.Accepted:
                        if (b.method === s.C.INVITE) {
                            return
                        }
                        break;
                    case v.Completed:
                        if (b.method === s.C.INVITE) {
                            if (!this.lastFinalResponse) {
                                throw new Error("Last final response undefined.");
                            }
                            this.send(this.lastFinalResponse)
                                .catch(function(a) {
                                    c.logTransportError(a, "Failed to send retransmission of final response.")
                                });
                            return
                        }
                        if (b.method === s.C.ACK) {
                            this.stateTransition(v.Confirmed);
                            return
                        }
                        break;
                    case v.Confirmed:
                        if (b.method === s.C.INVITE || b.method === s.C.ACK) {
                            return
                        }
                        break;
                    case v.Terminated:
                        if (b.method === s.C.INVITE || b.method === s.C.ACK) {
                            return
                        }
                        break;
                    default:
                        throw new Error("Invalid state " + this.state);
                }
                var d = "INVITE server transaction received unexpected " + b.method + " request while in state " + this.state + ".";
                this.logger.warn(d);
                return
            };
            B.prototype.receiveResponse = function(b, c) {
                var d = this;
                if (b < 100 || b > 699) {
                    throw new Error("Invalid status code " + b);
                }
                switch (this.state) {
                    case v.Proceeding:
                        if (b >= 100 && b <= 199) {
                            this.lastProvisionalResponse = c;
                            if (b > 100) {
                                this.startProgressExtensionTimer()
                            }
                            this.send(c)
                                .catch(function(a) {
                                    d.logTransportError(a, "Failed to send 1xx response.")
                                });
                            return
                        }
                        if (b >= 200 && b <= 299) {
                            this.lastFinalResponse = c;
                            this.stateTransition(v.Accepted);
                            this.send(c)
                                .catch(function(a) {
                                    d.logTransportError(a, "Failed to send 2xx response.")
                                });
                            return
                        }
                        if (b >= 300 && b <= 699) {
                            this.lastFinalResponse = c;
                            this.stateTransition(v.Completed);
                            this.send(c)
                                .catch(function(a) {
                                    d.logTransportError(a, "Failed to send non-2xx final response.")
                                });
                            return
                        }
                        break;
                    case v.Accepted:
                        if (b >= 200 && b <= 299) {
                            this.send(c)
                                .catch(function(a) {
                                    d.logTransportError(a, "Failed to send 2xx response.")
                                });
                            return
                        }
                        break;
                    case v.Completed:
                        break;
                    case v.Confirmed:
                        break;
                    case v.Terminated:
                        break;
                    default:
                        throw new Error("Invalid state " + this.state);
                }
                var e = "INVITE server transaction received unexpected " + b + " response from TU while in state " + this.state + ".";
                this.logger.error(e);
                throw new Error(e);
            };
            B.prototype.onTransportError = function(a) {
                if (this.user.onTransportError) {
                    this.user.onTransportError(a)
                }
            };
            B.prototype.stateTransition = function(a) {
                var b = this;
                var c = function() {
                    throw new Error("Invalid state transition from " + b.state + " to " + a);
                };
                switch (a) {
                    case v.Proceeding:
                        c();
                        break;
                    case v.Accepted:
                    case v.Completed:
                        if (this.state !== v.Proceeding) {
                            c()
                        }
                        break;
                    case v.Confirmed:
                        if (this.state !== v.Completed) {
                            c()
                        }
                        break;
                    case v.Terminated:
                        if (this.state !== v.Accepted && this.state !== v.Completed && this.state !== v.Confirmed) {
                            c()
                        }
                        break;
                    default:
                        c()
                }
                this.stopProgressExtensionTimer();
                if (a === v.Accepted) {
                    this.L = setTimeout(function() {
                        return b.timer_L()
                    }, u.Timers.TIMER_L)
                }
                if (a === v.Completed) {
                    this.H = setTimeout(function() {
                        return b.timer_H()
                    }, u.Timers.TIMER_H)
                }
                if (a === v.Confirmed) {
                    this.I = setTimeout(function() {
                        return b.timer_I()
                    }, u.Timers.TIMER_I)
                }
                if (a === v.Terminated) {
                    this.dispose()
                }
                this.setState(a)
            };
            B.prototype.startProgressExtensionTimer = function() {
                var b = this;
                if (this.progressExtensionTimer === undefined) {
                    this.progressExtensionTimer = setInterval(function() {
                        b.logger.debug("Progress extension timer expired for INVITE server transaction " + b.id + ".");
                        if (!b.lastProvisionalResponse) {
                            throw new Error("Last provisional response undefined.");
                        }
                        b.send(b.lastProvisionalResponse)
                            .catch(function(a) {
                                b.logTransportError(a, "Failed to send retransmission of provisional response.")
                            })
                    }, u.Timers.PROVISIONAL_RESPONSE_INTERVAL)
                }
            };
            B.prototype.stopProgressExtensionTimer = function() {
                if (this.progressExtensionTimer !== undefined) {
                    clearInterval(this.progressExtensionTimer);
                    this.progressExtensionTimer = undefined
                }
            };
            B.prototype.timer_G = function() {};
            B.prototype.timer_H = function() {
                this.logger.debug("Timer H expired for INVITE server transaction " + this.id + ".");
                if (this.state === v.Completed) {
                    this.logger.warn("ACK to negative final response was never received, terminating transaction.");
                    this.stateTransition(v.Terminated)
                }
            };
            B.prototype.timer_I = function() {
                this.logger.debug("Timer I expired for INVITE server transaction " + this.id + ".");
                this.stateTransition(v.Terminated)
            };
            B.prototype.timer_L = function() {
                this.logger.debug("Timer L expired for INVITE server transaction " + this.id + ".");
                if (this.state === v.Accepted) {
                    this.stateTransition(v.Terminated)
                }
            };
            return B
        }(A));
        n.InviteServerTransaction = B;
        var C = (function(f) {
            q(C, f);

            function C(a, b, c) {
                return f.call(this, a, b, c, v.Trying, "sip.transaction.nist") || this
            }
            C.prototype.dispose = function() {
                if (this.J) {
                    clearTimeout(this.J);
                    this.J = undefined
                }
                f.prototype.dispose.call(this)
            };
            C.prototype.receiveRequest = function(b) {
                var c = this;
                switch (this.state) {
                    case v.Trying:
                        break;
                    case v.Proceeding:
                        if (!this.lastResponse) {
                            throw new Error("Last response undefined.");
                        }
                        this.send(this.lastResponse)
                            .catch(function(a) {
                                c.logTransportError(a, "Failed to send retransmission of provisional response.")
                            });
                        break;
                    case v.Completed:
                        if (!this.lastResponse) {
                            throw new Error("Last response undefined.");
                        }
                        this.send(this.lastResponse)
                            .catch(function(a) {
                                c.logTransportError(a, "Failed to send retransmission of final response.")
                            });
                        break;
                    case v.Terminated:
                        break;
                    default:
                        throw new Error("Invalid state " + this.state);
                }
            };
            C.prototype.receiveResponse = function(b, c) {
                var d = this;
                if (b < 100 || b > 699) {
                    throw new Error("Invalid status code " + b);
                }
                if (b > 100 && b <= 199) {
                    throw new Error("Provisional response other than 100 not allowed.");
                }
                switch (this.state) {
                    case v.Trying:
                        this.lastResponse = c;
                        if (b >= 100 && b < 200) {
                            this.stateTransition(v.Proceeding);
                            this.send(c)
                                .catch(function(a) {
                                    d.logTransportError(a, "Failed to send provisional response.")
                                });
                            return
                        }
                        if (b >= 200 && b <= 699) {
                            this.stateTransition(v.Completed);
                            this.send(c)
                                .catch(function(a) {
                                    d.logTransportError(a, "Failed to send final response.")
                                });
                            return
                        }
                        break;
                    case v.Proceeding:
                        this.lastResponse = c;
                        if (b >= 200 && b <= 699) {
                            this.stateTransition(v.Completed);
                            this.send(c)
                                .catch(function(a) {
                                    d.logTransportError(a, "Failed to send final response.")
                                });
                            return
                        }
                        break;
                    case v.Completed:
                        return;
                    case v.Terminated:
                        break;
                    default:
                        throw new Error("Invalid state " + this.state);
                }
                var e = "Non-INVITE server transaction received unexpected " + b + " response from TU while in state " + this.state + ".";
                this.logger.error(e);
                throw new Error(e);
            };
            C.prototype.onTransportError = function(a) {
                if (this.user.onTransportError) {
                    this.user.onTransportError(a)
                }
                this.stateTransition(v.Terminated, true)
            };
            C.prototype.stateTransition = function(a, b) {
                var c = this;
                if (b === void 0) {
                    b = false
                }
                var d = function() {
                    throw new Error("Invalid state transition from " + c.state + " to " + a);
                };
                switch (a) {
                    case v.Trying:
                        d();
                        break;
                    case v.Proceeding:
                        if (this.state !== v.Trying) {
                            d()
                        }
                        break;
                    case v.Completed:
                        if (this.state !== v.Trying && this.state !== v.Proceeding) {
                            d()
                        }
                        break;
                    case v.Terminated:
                        if (this.state !== v.Proceeding && this.state !== v.Completed) {
                            if (!b) {
                                d()
                            }
                        }
                        break;
                    default:
                        d()
                }
                if (a === v.Completed) {
                    this.J = setTimeout(function() {
                        return c.timer_J()
                    }, u.Timers.TIMER_J)
                }
                if (a === v.Terminated) {
                    this.dispose()
                }
                this.setState(a)
            };
            C.prototype.timer_J = function() {
                this.logger.debug("Timer J expired for NON-INVITE server transaction " + this.id + ".");
                if (this.state === v.Completed) {
                    this.stateTransition(v.Terminated)
                }
            };
            return C
        }(A));
        n.NonInviteServerTransaction = C
    }), (function(m, n, o) {
        "use strict";
        var q = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        Object.defineProperty(n, "__esModule", {
            value: true
        });
        var r = o(5);
        var s = (function(d) {
            q(s, d);

            function s(a) {
                var b = this.constructor;
                var c = d.call(this, a) || this;
                Object.setPrototypeOf(c, b.prototype);
                return c
            }
            return s
        }(Error));
        n.Exception = s;
        var t;
        (function(c) {
            var d = (function(b) {
                q(d, b);

                function d(a) {
                    return b.call(this, a ? a : "Unspecified transport error.") || this
                }
                return d
            }(s));
            c.TransportError = d
        })(t = n.Exceptions || (n.Exceptions = {}));
        var u = (function(e) {
            q(u, e);

            function u(a, b, c) {
                var d = e.call(this, c) || this;
                d.code = a;
                d.name = b;
                d.message = c;
                return d
            }
            return u
        }(s));
        (function(f) {
            var g = (function(d) {
                q(g, d);

                function g(a, b) {
                    var c = d.call(this, 1, "CONFIGURATION_ERROR", (!b) ? "Missing parameter: " + a : "Invalid value " + JSON.stringify(b) + " for parameter '" + a + "'") || this;
                    c.type = r.TypeStrings.ConfigurationError;
                    c.parameter = a;
                    c.value = b;
                    return c
                }
                return g
            }(u));
            f.ConfigurationError = g;
            var h = (function(c) {
                q(h, c);

                function h(a) {
                    var b = c.call(this, 2, "INVALID_STATE_ERROR", "Invalid status: " + a) || this;
                    b.type = r.TypeStrings.InvalidStateError;
                    b.status = a;
                    return b
                }
                return h
            }(u));
            f.InvalidStateError = h;
            var i = (function(c) {
                q(i, c);

                function i(a) {
                    var b = c.call(this, 3, "NOT_SUPPORTED_ERROR", a) || this;
                    b.type = r.TypeStrings.NotSupportedError;
                    return b
                }
                return i
            }(u));
            f.NotSupportedError = i;
            var j = (function(c) {
                q(j, c);

                function j(a) {
                    var b = c.call(this, 5, "RENEGOTIATION_ERROR", a) || this;
                    b.type = r.TypeStrings.RenegotiationError;
                    return b
                }
                return j
            }(u));
            f.RenegotiationError = j;
            var k = (function(e) {
                q(k, e);

                function k(a, b, c) {
                    var d = e.call(this, 6, "METHOD_PARAMETER_ERROR", (!c) ? "Missing parameter: " + b : "Invalid value " + JSON.stringify(c) + " for parameter '" + b + "'") || this;
                    d.type = r.TypeStrings.MethodParameterError;
                    d.method = a;
                    d.parameter = b;
                    d.value = c;
                    return d
                }
                return k
            }(u));
            f.MethodParameterError = k;
            var l = (function(e) {
                q(l, e);

                function l(a, b, c) {
                    var d = e.call(this, 8, "SESSION_DESCRIPTION_HANDLER_ERROR", c || "Error with Session Description Handler") || this;
                    d.type = r.TypeStrings.SessionDescriptionHandlerError;
                    d.method = a;
                    d.error = b;
                    return d
                }
                return l
            }(u));
            f.SessionDescriptionHandlerError = l
        })(t = n.Exceptions || (n.Exceptions = {}))
    }), (function(a, b, c) {
        "use strict";
        Object.defineProperty(b, "__esModule", {
            value: true
        });
        var d = 500;
        var e = 4000;
        var f = 5000;
        b.Timers = {
            T1: d,
            T2: e,
            T4: f,
            TIMER_B: 64 * d,
            TIMER_D: 0 * d,
            TIMER_F: 64 * d,
            TIMER_H: 64 * d,
            TIMER_I: 0 * f,
            TIMER_J: 0 * d,
            TIMER_K: 0 * f,
            TIMER_L: 64 * d,
            TIMER_M: 64 * d,
            TIMER_N: 64 * d,
            PROVISIONAL_RESPONSE_INTERVAL: 60000
        }
    }), (function(n, o, q) {
        "use strict";
        var r = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        Object.defineProperty(o, "__esModule", {
            value: true
        });
        var s = q(3);
        var t = q(5);
        var u = q(11);
        var v = q(7);
        var w = q(15);
        o.getSupportedHeader = function(d) {
            var e = [];
            if (d.method === s.C.REGISTER) {
                e.push("path", "gruu")
            } else if (d.method === s.C.INVITE && (d.ua.contact.pubGruu || d.ua.contact.tempGruu)) {
                e.push("gruu")
            }
            if (d.ua.configuration.rel100 === s.C.supported.SUPPORTED) {
                e.push("100rel")
            }
            if (d.ua.configuration.replaces === s.C.supported.SUPPORTED) {
                e.push("replaces")
            }
            e.push("outbound");
            e = e.concat(d.ua.configuration.extraSupported || []);
            var f = d.ua.configuration.hackAllowUnregisteredOptionTags || false;
            var g = {};
            e = e.filter(function(a) {
                var b = s.C.OPTION_TAGS[a];
                var c = !g[a];
                g[a] = true;
                return (b || f) && c
            });
            return "Supported: " + e.join(", ") + "\r\n"
        };
        var x = (function() {
            function x(a, b, c, d, e, f) {
                if (d === void 0) {
                    d = {}
                }
                this.type = t.TypeStrings.OutgoingRequest;
                this.logger = c.getLogger("sip.sipmessage");
                this.ua = c;
                this.headers = {};
                this.method = a;
                this.ruri = b;
                this.body = f;
                this.extraHeaders = (e || [])
                    .slice();
                this.statusCode = d.statusCode;
                this.reasonPhrase = d.reasonPhrase;
                if (d.routeSet) {
                    this.setHeader("route", d.routeSet)
                } else if (c.configuration.usePreloadedRoute && c.transport) {
                    this.setHeader("route", c.transport.server.sipUri)
                }
                this.setHeader("via", "");
                this.setHeader("max-forwards", "70");
                var g = d.toUri || b;
                this.toTag = d.toTag;
                var h = (d.toDisplayName || d.toDisplayName === 0) ? '"' + d.toDisplayName + '" ' : "";
                h += "<" + (g.type === t.TypeStrings.URI ? g.toRaw() : g) + ">";
                h += this.toTag ? ";tag=" + this.toTag : "";
                this.to = u.Grammar.nameAddrHeaderParse(h);
                this.setHeader("to", h);
                var i = d.fromUri || c.configuration.uri || "";
                this.fromTag = d.fromTag || w.Utils.newTag();
                var j;
                if (d.fromDisplayName || d.fromDisplayName === 0) {
                    j = '"' + d.fromDisplayName + '" '
                } else if (c.configuration.displayName) {
                    j = '"' + c.configuration.displayName + '" '
                } else {
                    j = ""
                }
                j += "<" + (i.type === t.TypeStrings.URI ? i.toRaw() : i) + ">;tag=";
                j += this.fromTag;
                this.from = u.Grammar.nameAddrHeaderParse(j);
                this.setHeader("from", j);
                this.callId = d.callId || (c.configuration.sipjsId + w.Utils.createRandomToken(15));
                this.setHeader("call-id", this.callId);
                this.cseq = d.cseq || Math.floor(Math.random() * 10000);
                this.setHeader("cseq", this.cseq + " " + a)
            }
            x.prototype.getHeader = function(a) {
                var b = this.headers[w.Utils.headerize(a)];
                if (b) {
                    if (b[0]) {
                        return b[0]
                    }
                } else {
                    var c = new RegExp("^\\s*" + a + "\\s*:", "i");
                    for (var d = 0, _a = this.extraHeaders; d < _a.length; d++) {
                        var e = _a[d];
                        if (c.test(e)) {
                            return e.substring(e.indexOf(":") + 1)
                                .trim()
                        }
                    }
                }
                return
            };
            x.prototype.getHeaders = function(a) {
                var b = [];
                var c = this.headers[w.Utils.headerize(a)];
                if (c) {
                    for (var d = 0, headerArray_1 = c; d < headerArray_1.length; d++) {
                        var e = headerArray_1[d];
                        b.push(e)
                    }
                } else {
                    var f = new RegExp("^\\s*" + a + "\\s*:", "i");
                    for (var g = 0, _b = this.extraHeaders; g < _b.length; g++) {
                        var h = _b[g];
                        if (f.test(h)) {
                            b.push(h.substring(h.indexOf(":") + 1)
                                .trim())
                        }
                    }
                }
                return b
            };
            x.prototype.hasHeader = function(a) {
                if (this.headers[w.Utils.headerize(a)]) {
                    return true
                } else {
                    var b = new RegExp("^\\s*" + a + "\\s*:", "i");
                    for (var c = 0, _a = this.extraHeaders; c < _a.length; c++) {
                        var d = _a[c];
                        if (b.test(d)) {
                            return true
                        }
                    }
                }
                return false
            };
            x.prototype.setHeader = function(a, b) {
                this.headers[w.Utils.headerize(a)] = (b instanceof Array) ? b : [b]
            };
            x.prototype.setViaHeader = function(a, b) {
                var c = "WSS";
                if (b.server && b.server.scheme) {
                    c = b.server.scheme
                }
                if (this.ua.configuration.hackViaTcp) {
                    c = "TCP"
                }
                var d = "SIP/2.0/" + c;
                d += " " + this.ua.configuration.viaHost + ";branch=" + a;
                if (this.ua.configuration.forceRport) {
                    d += ";rport"
                }
                this.setHeader("via", d);
                this.branch = a
            };
            x.prototype.cancel = function(f, g) {
                var h = this;
                if (!this.transaction) {
                    throw new Error("Transaction undefined.");
                }
                var i = function() {
                    if (!h.transaction) {
                        throw new Error("Transaction undefined.");
                    }
                    if (!h.to) {
                        throw new Error("To undefined.");
                    }
                    if (!h.from) {
                        throw new Error("From undefined.");
                    }
                    var b = new x(s.C.CANCEL, h.ruri, h.ua, {
                        toUri: h.to.uri,
                        toTag: h.toTag,
                        fromUri: h.from.uri,
                        fromTag: h.fromTag,
                        callId: h.callId,
                        cseq: h.cseq
                    }, g);
                    b.branch = h.branch;
                    if (h.headers.Route) {
                        b.headers.Route = h.headers.Route
                    }
                    if (f) {
                        b.setHeader("Reason", f)
                    }
                    var c = h.transaction.transport;
                    var d = {
                        loggerFactory: h.ua.getLoggerFactory(),
                        onStateChange: function(a) {
                            if (a === v.TransactionState.Terminated) {
                                h.ua.destroyTransaction(e)
                            }
                        },
                        receiveResponse: function(a) {
                            return
                        }
                    };
                    var e = new v.NonInviteClientTransaction(b, c, d);
                    h.ua.newTransaction(e)
                };
                if (!(this.transaction instanceof v.InviteClientTransaction)) {
                    return
                }
                if (this.transaction.state === v.TransactionState.Proceeding) {
                    i()
                } else {
                    this.transaction.once("stateChanged", function() {
                        if (h.transaction && h.transaction.state === v.TransactionState.Proceeding) {
                            i()
                        }
                    })
                }
            };
            x.prototype.toString = function() {
                var a = "";
                a += this.method + " " + (this.ruri.type === t.TypeStrings.URI ? this.ruri.toRaw() : this.ruri) + " SIP/2.0\r\n";
                for (var b in this.headers) {
                    if (this.headers[b]) {
                        for (var c = 0, _a = this.headers[b]; c < _a.length; c++) {
                            var d = _a[c];
                            a += b + ": " + d + "\r\n"
                        }
                    }
                }
                for (var e = 0, _c = this.extraHeaders; e < _c.length; e++) {
                    var b = _c[e];
                    a += b.trim() + "\r\n"
                }
                a += o.getSupportedHeader(this);
                a += "User-Agent: " + this.ua.configuration.userAgentString + "\r\n";
                if (this.body) {
                    if (typeof this.body === "string") {
                        a += "Content-Length: " + w.Utils.str_utf8_length(this.body) + "\r\n\r\n";
                        a += this.body
                    } else {
                        if (this.body.body && this.body.contentType) {
                            a += "Content-Type: " + this.body.contentType + "\r\n";
                            a += "Content-Length: " + w.Utils.str_utf8_length(this.body.body) + "\r\n\r\n";
                            a += this.body.body
                        } else {
                            a += "Content-Length: " + 0 + "\r\n\r\n"
                        }
                    }
                } else {
                    a += "Content-Length: " + 0 + "\r\n\r\n"
                }
                return a
            };
            return x
        }());
        o.OutgoingRequest = x;
        var y = (function() {
            function y() {
                this.type = t.TypeStrings.IncomingMessage;
                this.headers = {}
            }
            y.prototype.addHeader = function(a, b) {
                var c = {
                    raw: b
                };
                a = w.Utils.headerize(a);
                if (this.headers[a]) {
                    this.headers[a].push(c)
                } else {
                    this.headers[a] = [c]
                }
            };
            y.prototype.getHeader = function(a) {
                var b = this.headers[w.Utils.headerize(a)];
                if (b) {
                    if (b[0]) {
                        return b[0].raw
                    }
                } else {
                    return
                }
            };
            y.prototype.getHeaders = function(a) {
                var b = this.headers[w.Utils.headerize(a)];
                var c = [];
                if (!b) {
                    return []
                }
                for (var d = 0, header_1 = b; d < header_1.length; d++) {
                    var e = header_1[d];
                    c.push(e.raw)
                }
                return c
            };
            y.prototype.hasHeader = function(a) {
                return !!this.headers[w.Utils.headerize(a)]
            };
            y.prototype.parseHeader = function(a, b) {
                if (b === void 0) {
                    b = 0
                }
                a = w.Utils.headerize(a);
                if (!this.headers[a]) {
                    return
                } else if (b >= this.headers[a].length) {
                    return
                }
                var c = this.headers[a][b];
                var d = c.raw;
                if (c.parsed) {
                    return c.parsed
                }
                var e = u.Grammar.parse(d, a.replace(/-/g, "_"));
                if (e === -1) {
                    this.headers[a].splice(b, 1);
                    return
                } else {
                    c.parsed = e;
                    return e
                }
            };
            y.prototype.s = function(a, b) {
                if (b === void 0) {
                    b = 0
                }
                return this.parseHeader(a, b)
            };
            y.prototype.setHeader = function(a, b) {
                this.headers[w.Utils.headerize(a)] = [{
                    raw: b
                }]
            };
            y.prototype.toString = function() {
                return this.data
            };
            return y
        }());
        o.IncomingMessage = y;
        var z = (function(m) {
            r(z, m);

            function z(a) {
                var b = m.call(this) || this;
                b.ua = a;
                b.type = t.TypeStrings.IncomingRequest;
                b.logger = a.getLogger("sip.sipmessage");
                return b
            }
            z.prototype.reply = function(a, b, c, d) {
                if (!this.transaction) {
                    throw new Error("Transaction undefined.");
                }
                var e = w.Utils.buildStatusLine(a, b);
                c = (c || [])
                    .slice();
                if (this.method === s.C.INVITE && a > 100 && a <= 200) {
                    for (var f = 0, _a = this.getHeaders("record-route"); f < _a.length; f++) {
                        var g = _a[f];
                        e += "Record-Route: " + g + "\r\n"
                    }
                }
                for (var h = 0, _c = this.getHeaders("via"); h < _c.length; h++) {
                    var i = _c[h];
                    e += "Via: " + i + "\r\n"
                }
                var j = this.getHeader("to") || "";
                if (!this.toTag && a > 100) {
                    j += ";tag=" + w.Utils.newTag()
                } else if (this.toTag && !this.s("to")
                    .hasParam("tag")) {
                    j += ";tag=" + this.toTag
                }
                e += "To: " + j + "\r\n";
                e += "From: " + this.getHeader("From") + "\r\n";
                e += "Call-ID: " + this.callId + "\r\n";
                e += "CSeq: " + this.cseq + " " + this.method + "\r\n";
                for (var k = 0, extraHeaders_1 = c; k < extraHeaders_1.length; k++) {
                    var l = extraHeaders_1[k];
                    e += l.trim() + "\r\n"
                }
                e += o.getSupportedHeader(this);
                e += "User-Agent: " + this.ua.configuration.userAgentString + "\r\n";
                if (d) {
                    if (typeof d === "string") {
                        e += "Content-Type: application/sdp\r\n";
                        e += "Content-Length: " + w.Utils.str_utf8_length(d) + "\r\n\r\n";
                        e += d
                    } else {
                        if (d.body && d.contentType) {
                            e += "Content-Type: " + d.contentType + "\r\n";
                            e += "Content-Length: " + w.Utils.str_utf8_length(d.body) + "\r\n\r\n";
                            e += d.body
                        } else {
                            e += "Content-Length: " + 0 + "\r\n\r\n"
                        }
                    }
                } else {
                    e += "Content-Length: " + 0 + "\r\n\r\n"
                }
                this.transaction.receiveResponse(a, e);
                return e
            };
            z.prototype.reply_sl = function(a, b) {
                if (!this.transport) {
                    throw new Error("Transport undefined.");
                }
                var c = w.Utils.buildStatusLine(a, b);
                for (var d = 0, _a = this.getHeaders("via"); d < _a.length; d++) {
                    var e = _a[d];
                    c += "Via: " + e + "\r\n"
                }
                var f = this.getHeader("To") || "";
                if (!this.toTag && a > 100) {
                    f += ";tag=" + w.Utils.newTag()
                } else if (this.toTag && !this.s("to")
                    .hasParam("tag")) {
                    f += ";tag=" + this.toTag
                }
                c += "To: " + f + "\r\n";
                c += "From: " + this.getHeader("From") + "\r\n";
                c += "Call-ID: " + this.callId + "\r\n";
                c += "CSeq: " + this.cseq + " " + this.method + "\r\n";
                c += "User-Agent: " + this.ua.configuration.userAgentString + "\r\n";
                c += "Content-Length: " + 0 + "\r\n\r\n";
                this.transport.send(c);
                return c
            };
            return z
        }(y));
        o.IncomingRequest = z;
        var A = (function(l) {
            r(A, l);

            function A(a) {
                var b = l.call(this) || this;
                b.ua = a;
                b.type = t.TypeStrings.IncomingResponse;
                b.logger = a.getLogger("sip.sipmessage");
                b.headers = {};
                return b
            }
            A.prototype.ack = function(a) {
                if (!this.statusCode || this.statusCode < 200 || this.statusCode > 299) {
                    throw new Error("Response status code must be 2xx to ACK.");
                }
                if (this.method !== s.C.INVITE) {
                    throw new Error("Response must to be for an INVITE to ACK.");
                }
                if (!this.transaction) {
                    throw new Error("Transaction undefined.");
                }
                if (!(this.transaction instanceof v.InviteClientTransaction)) {
                    throw new Error("Transaction not instance of InviteServerTrasaction.");
                }
                var b = this.ua.dialogs[this.callId + this.fromTag + this.toTag];
                if (!b) {
                    throw new Error("Dialog undefined.");
                }
                var c = this.callId;
                var d = this.cseq;
                var e = b.localUri;
                var f = this.fromTag;
                var g = b.remoteUri;
                var h = this.toTag;
                var i = b.remoteTarget;
                var j = b.routeSet;
                var k = new x(s.C.ACK, i, this.ua, {
                    callId: c,
                    cseq: d,
                    fromUri: e,
                    fromTag: f,
                    toUri: g,
                    toTag: h,
                    routeSet: j
                }, a ? a.extraHeaders : undefined, a ? a.body : undefined);
                this.transaction.ackResponse(k);
                return k
            };
            return A
        }(y));
        o.IncomingResponse = A
    }), (function(f, g, h) {
        "use strict";
        Object.defineProperty(g, "__esModule", {
            value: true
        });
        var i = h(12);
        var j;
        (function(d) {
            function parse(a, b) {
                var c = {
                    startRule: b
                };
                try {
                    i.parse(a, c)
                } catch (e) {
                    c.data = -1
                }
                return c.data
            }
            d.parse = parse;

            function nameAddrHeaderParse(a) {
                var b = d.parse(a, "Name_Addr_Header");
                return b !== -1 ? b : undefined
            }
            d.nameAddrHeaderParse = nameAddrHeaderParse;

            function URIParse(a) {
                var b = d.parse(a, "SIP_URI");
                return b !== -1 ? b : undefined
            }
            d.URIParse = URIParse
        })(j = g.Grammar || (g.Grammar = {}))
    }), (function(ig, ih, ii) {
        "use strict";
        var ba = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        Object.defineProperty(ih, "__esModule", {
            value: true
        });
        var bb = ii(13);
        var bc = ii(14);
        var bd = (function(f) {
            ba(bd, f);

            function bd(a, b, c, d) {
                var e = f.call(this) || this;
                e.message = a;
                e.expected = b;
                e.found = c;
                e.location = d;
                e.name = "SyntaxError";
                if (typeof Error.captureStackTrace === "function") {
                    Error.captureStackTrace(e, bd)
                }
                return e
            }
            bd.buildMessage = function(d, e) {
                function hex(a) {
                    return a.charCodeAt(0)
                        .toString(16)
                        .toUpperCase()
                }

                function literalEscape(s) {
                    return s.replace(/\\/g, "\\\\")
                        .replace(/"/g, "\\\"")
                        .replace(/\0/g, "\\0")
                        .replace(/\t/g, "\\t")
                        .replace(/\n/g, "\\n")
                        .replace(/\r/g, "\\r")
                        .replace(/[\x00-\x0F]/g, function(a) {
                            return "\\x0" + hex(a)
                        })
                        .replace(/[\x10-\x1F\x7F-\x9F]/g, function(a) {
                            return "\\x" + hex(a)
                        })
                }

                function classEscape(s) {
                    return s.replace(/\\/g, "\\\\")
                        .replace(/\]/g, "\\]")
                        .replace(/\^/g, "\\^")
                        .replace(/-/g, "\\-")
                        .replace(/\0/g, "\\0")
                        .replace(/\t/g, "\\t")
                        .replace(/\n/g, "\\n")
                        .replace(/\r/g, "\\r")
                        .replace(/[\x00-\x0F]/g, function(a) {
                            return "\\x0" + hex(a)
                        })
                        .replace(/[\x10-\x1F\x7F-\x9F]/g, function(a) {
                            return "\\x" + hex(a)
                        })
                }

                function describeExpectation(b) {
                    switch (b.type) {
                        case "literal":
                            return "\"" + literalEscape(b.text) + "\"";
                        case "class":
                            var c = b.parts.map(function(a) {
                                return Array.isArray(a) ? classEscape(a[0]) + "-" + classEscape(a[1]) : classEscape(a)
                            });
                            return "[" + (b.inverted ? "^" : "") + c + "]";
                        case "any":
                            return "any character";
                        case "end":
                            return "end of input";
                        case "other":
                            return b.description
                    }
                }

                function describeExpected(a) {
                    var b = a.map(describeExpectation);
                    var i;
                    var j;
                    b.sort();
                    if (b.length > 0) {
                        for (i = 1, j = 1; i < b.length; i++) {
                            if (b[i - 1] !== b[i]) {
                                b[j] = b[i];
                                j++
                            }
                        }
                        b.length = j
                    }
                    switch (b.length) {
                        case 1:
                            return b[0];
                        case 2:
                            return b[0] + " or " + b[1];
                        default:
                            return b.slice(0, -1)
                                .join(", ") + ", or " + b[b.length - 1]
                    }
                }

                function describeFound(a) {
                    return a ? "\"" + literalEscape(a) + "\"" : "end of input"
                }
                return "Expected " + describeExpected(d) + " but " + describeFound(e) + " found."
            };
            return bd
        }(Error));
        ih.SyntaxError = bd;

        function peg$parse(f, g) {
            g = g !== undefined ? g : {};
            var h = {};
            var i = {
                Contact: peg$parseContact,
                Name_Addr_Header: peg$parseName_Addr_Header,
                Record_Route: peg$parseRecord_Route,
                Request_Response: peg$parseRequest_Response,
                SIP_URI: peg$parseSIP_URI,
                Subscription_State: peg$parseSubscription_State,
                Supported: peg$parseSupported,
                Require: peg$parseRequire,
                Via: peg$parseVia,
                absoluteURI: peg$parseabsoluteURI,
                Call_ID: peg$parseCall_ID,
                Content_Disposition: peg$parseContent_Disposition,
                Content_Length: peg$parseContent_Length,
                Content_Type: peg$parseContent_Type,
                CSeq: peg$parseCSeq,
                displayName: peg$parsedisplayName,
                Event: peg$parseEvent,
                From: peg$parseFrom,
                host: peg$parsehost,
                Max_Forwards: peg$parseMax_Forwards,
                Min_SE: peg$parseMin_SE,
                Proxy_Authenticate: peg$parseProxy_Authenticate,
                quoted_string: peg$parsequoted_string,
                Refer_To: peg$parseRefer_To,
                Replaces: peg$parseReplaces,
                Session_Expires: peg$parseSession_Expires,
                stun_URI: peg$parsestun_URI,
                To: peg$parseTo,
                turn_URI: peg$parseturn_URI,
                uuid: peg$parseuuid,
                WWW_Authenticate: peg$parseWWW_Authenticate,
                challenge: peg$parsechallenge,
                sipfrag: peg$parsesipfrag,
                Referred_By: peg$parseReferred_By
            };
            var j = peg$parseContact;
            var k = "\r\n";
            var l = peg$literalExpectation("\r\n", false);
            var m = /^[0-9]/;
            var n = peg$classExpectation([
                ["0", "9"]
            ], false, false);
            var o = /^[a-zA-Z]/;
            var s = peg$classExpectation([
                ["a", "z"],
                ["A", "Z"]
            ], false, false);
            var t = /^[0-9a-fA-F]/;
            var u = peg$classExpectation([
                ["0", "9"],
                ["a", "f"],
                ["A", "F"]
            ], false, false);
            var v = /^[\0-\xFF]/;
            var w = peg$classExpectation([
                ["\0", "\xFF"]
            ], false, false);
            var x = /^["]/;
            var y = peg$classExpectation(["\""], false, false);
            var z = " ";
            var A = peg$literalExpectation(" ", false);
            var B = "\t";
            var C = peg$literalExpectation("\t", false);
            var D = /^[a-zA-Z0-9]/;
            var E = peg$classExpectation([
                ["a", "z"],
                ["A", "Z"],
                ["0", "9"]
            ], false, false);
            var F = ";";
            var G = peg$literalExpectation(";", false);
            var H = "/";
            var I = peg$literalExpectation("/", false);
            var J = "?";
            var K = peg$literalExpectation("?", false);
            var L = ":";
            var M = peg$literalExpectation(":", false);
            var N = "@";
            var O = peg$literalExpectation("@", false);
            var P = "&";
            var Q = peg$literalExpectation("&", false);
            var R = "=";
            var S = peg$literalExpectation("=", false);
            var T = "+";
            var U = peg$literalExpectation("+", false);
            var V = "$";
            var W = peg$literalExpectation("$", false);
            var X = ",";
            var Y = peg$literalExpectation(",", false);
            var Z = "-";
            var be = peg$literalExpectation("-", false);
            var bf = "_";
            var bg = peg$literalExpectation("_", false);
            var bh = ".";
            var bi = peg$literalExpectation(".", false);
            var bj = "!";
            var bk = peg$literalExpectation("!", false);
            var bl = "~";
            var bm = peg$literalExpectation("~", false);
            var bn = "*";
            var bo = peg$literalExpectation("*", false);
            var bp = "'";
            var bq = peg$literalExpectation("'", false);
            var br = "(";
            var bs = peg$literalExpectation("(", false);
            var bt = ")";
            var bu = peg$literalExpectation(")", false);
            var bv = "%";
            var bw = peg$literalExpectation("%", false);
            var bx = function() {
                return " "
            };
            var by = function() {
                return ':'
            };
            var bz = /^[!-~]/;
            var bA = peg$classExpectation([
                ["!", "~"]
            ], false, false);
            var bB = /^[\x80-\uFFFF]/;
            var bC = peg$classExpectation([
                ["\x80", "\uFFFF"]
            ], false, false);
            var bD = /^[\x80-\xBF]/;
            var bE = peg$classExpectation([
                ["\x80", "\xBF"]
            ], false, false);
            var bF = /^[a-f]/;
            var bG = peg$classExpectation([
                ["a", "f"]
            ], false, false);
            var bH = "`";
            var bI = peg$literalExpectation("`", false);
            var bJ = "<";
            var bK = peg$literalExpectation("<", false);
            var bL = ">";
            var bM = peg$literalExpectation(">", false);
            var bN = "\\";
            var bO = peg$literalExpectation("\\", false);
            var bP = "[";
            var bQ = peg$literalExpectation("[", false);
            var bR = "]";
            var bS = peg$literalExpectation("]", false);
            var bT = "{";
            var bU = peg$literalExpectation("{", false);
            var bV = "}";
            var bW = peg$literalExpectation("}", false);
            var bX = function() {
                return "*"
            };
            var bY = function() {
                return "/"
            };
            var bZ = function() {
                return "="
            };
            var ca = function() {
                return "("
            };
            var cb = function() {
                return ")"
            };
            var cc = function() {
                return ">"
            };
            var cd = function() {
                return "<"
            };
            var ce = function() {
                return ","
            };
            var cf = function() {
                return ";"
            };
            var cg = function() {
                return ":"
            };
            var ch = function() {
                return "\""
            };
            var ci = /^[!-']/;
            var cj = peg$classExpectation([
                ["!", "'"]
            ], false, false);
            var ck = /^[*-[]/;
            var cl = peg$classExpectation([
                ["*", "["]
            ], false, false);
            var cm = /^[\]-~]/;
            var cn = peg$classExpectation([
                ["]", "~"]
            ], false, false);
            var co = function(a) {
                return a
            };
            var cp = /^[#-[]/;
            var cq = peg$classExpectation([
                ["#", "["]
            ], false, false);
            var cr = /^[\0-\t]/;
            var cs = peg$classExpectation([
                ["\0", "\t"]
            ], false, false);
            var ct = /^[\x0B-\f]/;
            var cu = peg$classExpectation([
                ["\x0B", "\f"]
            ], false, false);
            var cv = /^[\x0E-\x7F]/;
            var cw = peg$classExpectation([
                ["\x0E", "\x7F"]
            ], false, false);
            var cx = function() {
                g = g || {
                    data: {}
                };
                g.data.uri = new bc.URI(g.data.scheme, g.data.user, g.data.host, g.data.port);
                delete g.data.scheme;
                delete g.data.user;
                delete g.data.host;
                delete g.data.host_type;
                delete g.data.port
            };
            var cy = function() {
                g = g || {
                    data: {}
                };
                g.data.uri = new bc.URI(g.data.scheme, g.data.user, g.data.host, g.data.port, g.data.uri_params, g.data.uri_headers);
                delete g.data.scheme;
                delete g.data.user;
                delete g.data.host;
                delete g.data.host_type;
                delete g.data.port;
                delete g.data.uri_params;
                if (g.startRule === 'SIP_URI') {
                    g.data = g.data.uri
                }
            };
            var cz = "sips";
            var cA = peg$literalExpectation("sips", true);
            var cB = "sip";
            var cC = peg$literalExpectation("sip", true);
            var cD = function(a) {
                g = g || {
                    data: {}
                };
                g.data.scheme = a
            };
            var cE = function() {
                g = g || {
                    data: {}
                };
                g.data.user = decodeURIComponent(text()
                    .slice(0, -1))
            };
            var cF = function() {
                g = g || {
                    data: {}
                };
                g.data.password = text()
            };
            var cG = function() {
                g = g || {
                    data: {}
                };
                g.data.host = text();
                return g.data.host
            };
            var cH = function() {
                g = g || {
                    data: {}
                };
                g.data.host_type = 'domain';
                return text()
            };
            var cI = /^[a-zA-Z0-9_\-]/;
            var cJ = peg$classExpectation([
                ["a", "z"],
                ["A", "Z"],
                ["0", "9"], "_", "-"
            ], false, false);
            var cK = /^[a-zA-Z0-9\-]/;
            var cL = peg$classExpectation([
                ["a", "z"],
                ["A", "Z"],
                ["0", "9"], "-"
            ], false, false);
            var cM = function() {
                g = g || {
                    data: {}
                };
                g.data.host_type = 'IPv6';
                return text()
            };
            var cN = "::";
            var cO = peg$literalExpectation("::", false);
            var cP = function() {
                g = g || {
                    data: {}
                };
                g.data.host_type = 'IPv6';
                return text()
            };
            var cQ = function() {
                g = g || {
                    data: {}
                };
                g.data.host_type = 'IPv4';
                return text()
            };
            var cR = "25";
            var cS = peg$literalExpectation("25", false);
            var cT = /^[0-5]/;
            var cU = peg$classExpectation([
                ["0", "5"]
            ], false, false);
            var cV = "2";
            var cW = peg$literalExpectation("2", false);
            var cX = /^[0-4]/;
            var cY = peg$classExpectation([
                ["0", "4"]
            ], false, false);
            var cZ = "1";
            var da = peg$literalExpectation("1", false);
            var db = /^[1-9]/;
            var dc = peg$classExpectation([
                ["1", "9"]
            ], false, false);
            var dd = function(a) {
                g = g || {
                    data: {}
                };
                a = parseInt(a.join(''));
                g.data.port = a;
                return a
            };
            var de = "transport=";
            var df = peg$literalExpectation("transport=", true);
            var dg = "udp";
            var dh = peg$literalExpectation("udp", true);
            var di = "tcp";
            var dj = peg$literalExpectation("tcp", true);
            var dk = "sctp";
            var dl = peg$literalExpectation("sctp", true);
            var dm = "tls";
            var dn = peg$literalExpectation("tls", true);
            var do_1 = function(a) {
                g = g || {
                    data: {}
                };
                if (!g.data.uri_params) g.data.uri_params = {};
                g.data.uri_params['transport'] = a.toLowerCase()
            };
            var dp = "user=";
            var dq = peg$literalExpectation("user=", true);
            var dr = "phone";
            var ds = peg$literalExpectation("phone", true);
            var dt = "ip";
            var du = peg$literalExpectation("ip", true);
            var dv = function(a) {
                g = g || {
                    data: {}
                };
                if (!g.data.uri_params) g.data.uri_params = {};
                g.data.uri_params['user'] = a.toLowerCase()
            };
            var dw = "method=";
            var dx = peg$literalExpectation("method=", true);
            var dy = function(a) {
                g = g || {
                    data: {}
                };
                if (!g.data.uri_params) g.data.uri_params = {};
                g.data.uri_params['method'] = a
            };
            var dz = "ttl=";
            var dA = peg$literalExpectation("ttl=", true);
            var dB = function(a) {
                g = g || {
                    data: {}
                };
                if (!g.data.params) g.data.params = {};
                g.data.params['ttl'] = a
            };
            var dC = "maddr=";
            var dD = peg$literalExpectation("maddr=", true);
            var dE = function(a) {
                g = g || {
                    data: {}
                };
                if (!g.data.uri_params) g.data.uri_params = {};
                g.data.uri_params['maddr'] = a
            };
            var dF = "lr";
            var dG = peg$literalExpectation("lr", true);
            var dH = function() {
                g = g || {
                    data: {}
                };
                if (!g.data.uri_params) g.data.uri_params = {};
                g.data.uri_params['lr'] = undefined
            };
            var dI = function(a, b) {
                g = g || {
                    data: {}
                };
                if (!g.data.uri_params) g.data.uri_params = {};
                if (b === null) {
                    b = undefined
                } else {
                    b = b[1]
                }
                g.data.uri_params[a.toLowerCase()] = b
            };
            var dJ = function(a, b) {
                a = a.join('')
                    .toLowerCase();
                b = b.join('');
                g = g || {
                    data: {}
                };
                if (!g.data.uri_headers) g.data.uri_headers = {};
                if (!g.data.uri_headers[a]) {
                    g.data.uri_headers[a] = [b]
                } else {
                    g.data.uri_headers[a].push(b)
                }
            };
            var dK = function() {
                g = g || {
                    data: {}
                };
                if (g.startRule === 'Refer_To') {
                    g.data.uri = new bc.URI(g.data.scheme, g.data.user, g.data.host, g.data.port, g.data.uri_params, g.data.uri_headers);
                    delete g.data.scheme;
                    delete g.data.user;
                    delete g.data.host;
                    delete g.data.host_type;
                    delete g.data.port;
                    delete g.data.uri_params
                }
            };
            var dL = "//";
            var dM = peg$literalExpectation("//", false);
            var dN = function() {
                g = g || {
                    data: {}
                };
                g.data.scheme = text()
            };
            var dO = peg$literalExpectation("SIP", true);
            var dP = function() {
                g = g || {
                    data: {}
                };
                g.data.sip_version = text()
            };
            var dQ = "INVITE";
            var dR = peg$literalExpectation("INVITE", false);
            var dS = "ACK";
            var dT = peg$literalExpectation("ACK", false);
            var dU = "VXACH";
            var dV = peg$literalExpectation("VXACH", false);
            var dW = "OPTIONS";
            var dX = peg$literalExpectation("OPTIONS", false);
            var dY = "BYE";
            var dZ = peg$literalExpectation("BYE", false);
            var ea = "CANCEL";
            var eb = peg$literalExpectation("CANCEL", false);
            var ec = "REGISTER";
            var ed = peg$literalExpectation("REGISTER", false);
            var ee = "SUBSCRIBE";
            var ef = peg$literalExpectation("SUBSCRIBE", false);
            var eg = "NOTIFY";
            var eh = peg$literalExpectation("NOTIFY", false);
            var ei = "REFER";
            var ej = peg$literalExpectation("REFER", false);
            var ek = "PUBLISH";
            var el = peg$literalExpectation("PUBLISH", false);
            var em = function() {
                g = g || {
                    data: {}
                };
                g.data.method = text();
                return g.data.method
            };
            var en = function(a) {
                g = g || {
                    data: {}
                };
                g.data.status_code = parseInt(a.join(''))
            };
            var eo = function() {
                g = g || {
                    data: {}
                };
                g.data.reason_phrase = text()
            };
            var ep = function() {
                g = g || {
                    data: {}
                };
                g.data = text()
            };
            var eq = function() {
                var a, length;
                g = g || {
                    data: {}
                };
                length = g.data.multi_header.length;
                for (a = 0; a < length; a++) {
                    if (g.data.multi_header[a].parsed === null) {
                        g.data = null;
                        break
                    }
                }
                if (g.data !== null) {
                    g.data = g.data.multi_header
                } else {
                    g.data = -1
                }
            };
            var er = function() {
                var a;
                g = g || {
                    data: {}
                };
                if (!g.data.multi_header) g.data.multi_header = [];
                try {
                    a = new bb.NameAddrHeader(g.data.uri, g.data.displayName, g.data.params);
                    delete g.data.uri;
                    delete g.data.displayName;
                    delete g.data.params
                } catch (e) {
                    a = null
                }
                g.data.multi_header.push({
                    'position': ic,
                    'offset': location()
                        .start.offset,
                    'parsed': a
                })
            };
            var es = function(a) {
                a = text()
                    .trim();
                if (a[0] === '\"') {
                    a = a.substring(1, a.length - 1)
                }
                g = g || {
                    data: {}
                };
                g.data.displayName = a
            };
            var et = "q";
            var eu = peg$literalExpectation("q", true);
            var ev = function(q) {
                g = g || {
                    data: {}
                };
                if (!g.data.params) g.data.params = {};
                g.data.params['q'] = q
            };
            var ew = "expires";
            var ex = peg$literalExpectation("expires", true);
            var ey = function(a) {
                g = g || {
                    data: {}
                };
                if (!g.data.params) g.data.params = {};
                g.data.params['expires'] = a
            };
            var ez = function(a) {
                return parseInt(a.join(''))
            };
            var eA = "0";
            var eB = peg$literalExpectation("0", false);
            var eC = function() {
                return parseFloat(text())
            };
            var eD = function(a, b) {
                g = g || {
                    data: {}
                };
                if (!g.data.params) g.data.params = {};
                if (b === null) {
                    b = undefined
                } else {
                    b = b[1]
                }
                g.data.params[a.toLowerCase()] = b
            };
            var eE = "render";
            var eF = peg$literalExpectation("render", true);
            var eG = "session";
            var eH = peg$literalExpectation("session", true);
            var eI = "icon";
            var eJ = peg$literalExpectation("icon", true);
            var eK = "alert";
            var eL = peg$literalExpectation("alert", true);
            var eM = function() {
                g = g || {
                    data: {}
                };
                if (g.startRule === 'Content_Disposition') {
                    g.data.type = text()
                        .toLowerCase()
                }
            };
            var eN = "handling";
            var eO = peg$literalExpectation("handling", true);
            var eP = "optional";
            var eQ = peg$literalExpectation("optional", true);
            var eR = "required";
            var eS = peg$literalExpectation("required", true);
            var eT = function(a) {
                g = g || {
                    data: {}
                };
                g.data = parseInt(a.join(''))
            };
            var eU = function() {
                g = g || {
                    data: {}
                };
                g.data = text()
            };
            var eV = "text";
            var eW = peg$literalExpectation("text", true);
            var eX = "image";
            var eY = peg$literalExpectation("image", true);
            var eZ = "audio";
            var fa = peg$literalExpectation("audio", true);
            var fb = "video";
            var fc = peg$literalExpectation("video", true);
            var fd = "application";
            var fe = peg$literalExpectation("application", true);
            var ff = "message";
            var fg = peg$literalExpectation("message", true);
            var fh = "multipart";
            var fi = peg$literalExpectation("multipart", true);
            var fj = "x-";
            var fk = peg$literalExpectation("x-", true);
            var fl = function(a) {
                g = g || {
                    data: {}
                };
                g.data.value = parseInt(a.join(''))
            };
            var fm = function(a) {
                g = g || {
                    data: {}
                };
                g.data = a
            };
            var fn = function(a) {
                g = g || {
                    data: {}
                };
                g.data.event = a.toLowerCase()
            };
            var fo = function() {
                g = g || {
                    data: {}
                };
                var a = g.data.tag;
                g.data = new bb.NameAddrHeader(g.data.uri, g.data.displayName, g.data.params);
                if (a) {
                    g.data.setParam('tag', a)
                }
            };
            var fp = "tag";
            var fq = peg$literalExpectation("tag", true);
            var fr = function(a) {
                g = g || {
                    data: {}
                };
                g.data.tag = a
            };
            var fs = function(a) {
                g = g || {
                    data: {}
                };
                g.data = parseInt(a.join(''))
            };
            var ft = function(a) {
                g = g || {
                    data: {}
                };
                g.data = a
            };
            var fu = function() {
                g = g || {
                    data: {}
                };
                g.data = new bb.NameAddrHeader(g.data.uri, g.data.displayName, g.data.params)
            };
            var fv = "digest";
            var fw = peg$literalExpectation("Digest", true);
            var fx = "realm";
            var fy = peg$literalExpectation("realm", true);
            var fz = function(a) {
                g = g || {
                    data: {}
                };
                g.data.realm = a
            };
            var fA = "domain";
            var fB = peg$literalExpectation("domain", true);
            var fC = "nonce";
            var fD = peg$literalExpectation("nonce", true);
            var fE = function(a) {
                g = g || {
                    data: {}
                };
                g.data.nonce = a
            };
            var fF = "opaque";
            var fG = peg$literalExpectation("opaque", true);
            var fH = function(a) {
                g = g || {
                    data: {}
                };
                g.data.opaque = a
            };
            var fI = "stale";
            var fJ = peg$literalExpectation("stale", true);
            var fK = "true";
            var fL = peg$literalExpectation("true", true);
            var fM = function() {
                g = g || {
                    data: {}
                };
                g.data.stale = true
            };
            var fN = "false";
            var fO = peg$literalExpectation("false", true);
            var fP = function() {
                g = g || {
                    data: {}
                };
                g.data.stale = false
            };
            var fQ = "algorithm";
            var fR = peg$literalExpectation("algorithm", true);
            var fS = "md5";
            var fT = peg$literalExpectation("MD5", true);
            var fU = "md5-sess";
            var fV = peg$literalExpectation("MD5-sess", true);
            var fW = function(a) {
                g = g || {
                    data: {}
                };
                g.data.algorithm = a.toUpperCase()
            };
            var fX = "qop";
            var fY = peg$literalExpectation("qop", true);
            var fZ = "auth-int";
            var ga = peg$literalExpectation("auth-int", true);
            var gb = "auth";
            var gc = peg$literalExpectation("auth", true);
            var gd = function(a) {
                g = g || {
                    data: {}
                };
                g.data.qop || (g.data.qop = []);
                g.data.qop.push(a.toLowerCase())
            };
            var ge = function(a) {
                g = g || {
                    data: {}
                };
                g.data.value = parseInt(a.join(''))
            };
            var gf = function() {
                var a, length;
                g = g || {
                    data: {}
                };
                length = g.data.multi_header.length;
                for (a = 0; a < length; a++) {
                    if (g.data.multi_header[a].parsed === null) {
                        g.data = null;
                        break
                    }
                }
                if (g.data !== null) {
                    g.data = g.data.multi_header
                } else {
                    g.data = -1
                }
            };
            var gg = function() {
                var a;
                g = g || {
                    data: {}
                };
                if (!g.data.multi_header) g.data.multi_header = [];
                try {
                    a = new bb.NameAddrHeader(g.data.uri, g.data.displayName, g.data.params);
                    delete g.data.uri;
                    delete g.data.displayName;
                    delete g.data.params
                } catch (e) {
                    a = null
                }
                g.data.multi_header.push({
                    'position': ic,
                    'offset': location()
                        .start.offset,
                    'parsed': a
                })
            };
            var gh = function() {
                g = g || {
                    data: {}
                };
                g.data = new bb.NameAddrHeader(g.data.uri, g.data.displayName, g.data.params)
            };
            var gi = function() {
                g = g || {
                    data: {}
                };
                if (!(g.data.replaces_from_tag && g.data.replaces_to_tag)) {
                    g.data = -1
                }
            };
            var gj = function() {
                g = g || {
                    data: {}
                };
                g.data = {
                    call_id: g.data
                }
            };
            var gk = "from-tag";
            var gl = peg$literalExpectation("from-tag", true);
            var gm = function(a) {
                g = g || {
                    data: {}
                };
                g.data.replaces_from_tag = a
            };
            var gn = "to-tag";
            var go = peg$literalExpectation("to-tag", true);
            var gp = function(a) {
                g = g || {
                    data: {}
                };
                g.data.replaces_to_tag = a
            };
            var gq = "early-only";
            var gr = peg$literalExpectation("early-only", true);
            var gs = function() {
                g = g || {
                    data: {}
                };
                g.data.early_only = true
            };
            var gt = function(a, r) {
                return r
            };
            var gu = function(a, b) {
                return list(a, b)
            };
            var gv = function(a) {
                g = g || {
                    data: {}
                };
                if (g.startRule === 'Require') {
                    g.data = a || []
                }
            };
            var gw = function(a) {
                g = g || {
                    data: {}
                };
                g.data.value = parseInt(a.join(''))
            };
            var gx = "active";
            var gy = peg$literalExpectation("active", true);
            var gz = "pending";
            var gA = peg$literalExpectation("pending", true);
            var gB = "terminated";
            var gC = peg$literalExpectation("terminated", true);
            var gD = function() {
                g = g || {
                    data: {}
                };
                g.data.state = text()
            };
            var gE = "reason";
            var gF = peg$literalExpectation("reason", true);
            var gG = function(a) {
                g = g || {
                    data: {}
                };
                if (typeof a !== 'undefined') g.data.reason = a
            };
            var gH = function(a) {
                g = g || {
                    data: {}
                };
                if (typeof a !== 'undefined') g.data.expires = a
            };
            var gI = "retry_after";
            var gJ = peg$literalExpectation("retry_after", true);
            var gK = function(a) {
                g = g || {
                    data: {}
                };
                if (typeof a !== 'undefined') g.data.retry_after = a
            };
            var gL = "deactivated";
            var gM = peg$literalExpectation("deactivated", true);
            var gN = "probation";
            var gO = peg$literalExpectation("probation", true);
            var gP = "rejected";
            var gQ = peg$literalExpectation("rejected", true);
            var gR = "timeout";
            var gS = peg$literalExpectation("timeout", true);
            var gT = "giveup";
            var gU = peg$literalExpectation("giveup", true);
            var gV = "noresource";
            var gW = peg$literalExpectation("noresource", true);
            var gX = "invariant";
            var gY = peg$literalExpectation("invariant", true);
            var gZ = function(a) {
                g = g || {
                    data: {}
                };
                if (g.startRule === 'Supported') {
                    g.data = a || []
                }
            };
            var ha = function() {
                g = g || {
                    data: {}
                };
                var a = g.data.tag;
                g.data = new bb.NameAddrHeader(g.data.uri, g.data.displayName, g.data.params);
                if (a) {
                    g.data.setParam('tag', a)
                }
            };
            var hb = "ttl";
            var hc = peg$literalExpectation("ttl", true);
            var hd = function(a) {
                g = g || {
                    data: {}
                };
                g.data.ttl = a
            };
            var he = "maddr";
            var hf = peg$literalExpectation("maddr", true);
            var hg = function(a) {
                g = g || {
                    data: {}
                };
                g.data.maddr = a
            };
            var hh = "received";
            var hi = peg$literalExpectation("received", true);
            var hj = function(a) {
                g = g || {
                    data: {}
                };
                g.data.received = a
            };
            var hk = "branch";
            var hl = peg$literalExpectation("branch", true);
            var hm = function(a) {
                g = g || {
                    data: {}
                };
                g.data.branch = a
            };
            var hn = "rport";
            var ho = peg$literalExpectation("rport", true);
            var hp = function(a) {
                g = g || {
                    data: {}
                };
                if (typeof a !== 'undefined') g.data.rport = a.join('')
            };
            var hq = function(a) {
                g = g || {
                    data: {}
                };
                g.data.protocol = a
            };
            var hr = peg$literalExpectation("UDP", true);
            var hs = peg$literalExpectation("TCP", true);
            var ht = peg$literalExpectation("TLS", true);
            var hu = peg$literalExpectation("SCTP", true);
            var hv = function(a) {
                g = g || {
                    data: {}
                };
                g.data.transport = a
            };
            var hw = function() {
                g = g || {
                    data: {}
                };
                g.data.host = text()
            };
            var hx = function(a) {
                g = g || {
                    data: {}
                };
                g.data.port = parseInt(a.join(''))
            };
            var hy = function(a) {
                return parseInt(a.join(''))
            };
            var hz = function(a) {
                g = g || {
                    data: {}
                };
                if (g.startRule === 'Session_Expires') {
                    g.data.deltaSeconds = a
                }
            };
            var hA = "refresher";
            var hB = peg$literalExpectation("refresher", false);
            var hC = "uas";
            var hD = peg$literalExpectation("uas", false);
            var hE = "uac";
            var hF = peg$literalExpectation("uac", false);
            var hG = function(a) {
                g = g || {
                    data: {}
                };
                if (g.startRule === 'Session_Expires') {
                    g.data.refresher = a
                }
            };
            var hH = function(a) {
                g = g || {
                    data: {}
                };
                if (g.startRule === 'Min_SE') {
                    g.data = a
                }
            };
            var hI = "stuns";
            var hJ = peg$literalExpectation("stuns", true);
            var hK = "stun";
            var hL = peg$literalExpectation("stun", true);
            var hM = function(a) {
                g = g || {
                    data: {}
                };
                g.data.scheme = a
            };
            var hN = function(a) {
                g = g || {
                    data: {}
                };
                g.data.host = a
            };
            var hO = "?transport=";
            var hP = peg$literalExpectation("?transport=", false);
            var hQ = "turns";
            var hR = peg$literalExpectation("turns", true);
            var hS = "turn";
            var hT = peg$literalExpectation("turn", true);
            var hU = function(a) {
                g = g || {
                    data: {}
                };
                g.data.transport = a
            };
            var hV = function() {
                g = g || {
                    data: {}
                };
                g.data = text()
            };
            var hW = "Referred-By";
            var hX = peg$literalExpectation("Referred-By", false);
            var hY = "b";
            var hZ = peg$literalExpectation("b", false);
            var ia = "cid";
            var ib = peg$literalExpectation("cid", false);
            var ic = 0;
            var id = 0;
            var ie = [{
                line: 1,
                column: 1
            }];
            var ij = 0;
            var ik = [];
            var il = 0;
            var im;
            if (g.startRule !== undefined) {
                if (!(g.startRule in i)) {
                    throw new Error("Can't start parsing from rule \"" + g.startRule + "\".");
                }
                j = i[g.startRule]
            }

            function text() {
                return f.substring(id, ic)
            }

            function location() {
                return peg$computeLocation(id, ic)
            }

            function expected(a, b) {
                b = b !== undefined ? b : peg$computeLocation(id, ic);
                throw peg$buildStructuredError([peg$otherExpectation(a)], f.substring(id, ic), b);
            }

            function error(a, b) {
                b = b !== undefined ? b : peg$computeLocation(id, ic);
                throw peg$buildSimpleError(a, b);
            }

            function peg$literalExpectation(a, b) {
                return {
                    type: "literal",
                    text: a,
                    ignoreCase: b
                }
            }

            function peg$classExpectation(a, b, c) {
                return {
                    type: "class",
                    parts: a,
                    inverted: b,
                    ignoreCase: c
                }
            }

            function peg$anyExpectation() {
                return {
                    type: "any"
                }
            }

            function peg$endExpectation() {
                return {
                    type: "end"
                }
            }

            function peg$otherExpectation(a) {
                return {
                    type: "other",
                    description: a
                }
            }

            function peg$computePosDetails(a) {
                var b = ie[a];
                var p;
                if (b) {
                    return b
                } else {
                    p = a - 1;
                    while (!ie[p]) {
                        p--
                    }
                    b = ie[p];
                    b = {
                        line: b.line,
                        column: b.column
                    };
                    while (p < a) {
                        if (f.charCodeAt(p) === 10) {
                            b.line++;
                            b.column = 1
                        } else {
                            b.column++
                        }
                        p++
                    }
                    ie[a] = b;
                    return b
                }
            }

            function peg$computeLocation(a, b) {
                var c = peg$computePosDetails(a);
                var d = peg$computePosDetails(b);
                return {
                    start: {
                        offset: a,
                        line: c.line,
                        column: c.column
                    },
                    end: {
                        offset: b,
                        line: d.line,
                        column: d.column
                    }
                }
            }

            function peg$fail(a) {
                if (ic < ij) {
                    return
                }
                if (ic > ij) {
                    ij = ic;
                    ik = []
                }
                ik.push(a)
            }

            function peg$buildSimpleError(a, b) {
                return new bd(a, [], "", b)
            }

            function peg$buildStructuredError(a, b, c) {
                return new bd(bd.buildMessage(a, b), a, b, c)
            }

            function peg$parseCRLF() {
                var a;
                if (f.substr(ic, 2) === k) {
                    a = k;
                    ic += 2
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(l)
                    }
                }
                return a
            }

            function peg$parseDIGIT() {
                var a;
                if (m.test(f.charAt(ic))) {
                    a = f.charAt(ic);
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(n)
                    }
                }
                return a
            }

            function peg$parseALPHA() {
                var a;
                if (o.test(f.charAt(ic))) {
                    a = f.charAt(ic);
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(s)
                    }
                }
                return a
            }

            function peg$parseHEXDIG() {
                var a;
                if (t.test(f.charAt(ic))) {
                    a = f.charAt(ic);
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(u)
                    }
                }
                return a
            }

            function peg$parseWSP() {
                var a;
                a = peg$parseSP();
                if (a === h) {
                    a = peg$parseHTAB()
                }
                return a
            }

            function peg$parseOCTET() {
                var a;
                if (v.test(f.charAt(ic))) {
                    a = f.charAt(ic);
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(w)
                    }
                }
                return a
            }

            function peg$parseDQUOTE() {
                var a;
                if (x.test(f.charAt(ic))) {
                    a = f.charAt(ic);
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(y)
                    }
                }
                return a
            }

            function peg$parseSP() {
                var a;
                if (f.charCodeAt(ic) === 32) {
                    a = z;
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(A)
                    }
                }
                return a
            }

            function peg$parseHTAB() {
                var a;
                if (f.charCodeAt(ic) === 9) {
                    a = B;
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(C)
                    }
                }
                return a
            }

            function peg$parsealphanum() {
                var a;
                if (D.test(f.charAt(ic))) {
                    a = f.charAt(ic);
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(E)
                    }
                }
                return a
            }

            function peg$parsereserved() {
                var a;
                if (f.charCodeAt(ic) === 59) {
                    a = F;
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(G)
                    }
                }
                if (a === h) {
                    if (f.charCodeAt(ic) === 47) {
                        a = H;
                        ic++
                    } else {
                        a = h;
                        if (il === 0) {
                            peg$fail(I)
                        }
                    }
                    if (a === h) {
                        if (f.charCodeAt(ic) === 63) {
                            a = J;
                            ic++
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(K)
                            }
                        }
                        if (a === h) {
                            if (f.charCodeAt(ic) === 58) {
                                a = L;
                                ic++
                            } else {
                                a = h;
                                if (il === 0) {
                                    peg$fail(M)
                                }
                            }
                            if (a === h) {
                                if (f.charCodeAt(ic) === 64) {
                                    a = N;
                                    ic++
                                } else {
                                    a = h;
                                    if (il === 0) {
                                        peg$fail(O)
                                    }
                                }
                                if (a === h) {
                                    if (f.charCodeAt(ic) === 38) {
                                        a = P;
                                        ic++
                                    } else {
                                        a = h;
                                        if (il === 0) {
                                            peg$fail(Q)
                                        }
                                    }
                                    if (a === h) {
                                        if (f.charCodeAt(ic) === 61) {
                                            a = R;
                                            ic++
                                        } else {
                                            a = h;
                                            if (il === 0) {
                                                peg$fail(S)
                                            }
                                        }
                                        if (a === h) {
                                            if (f.charCodeAt(ic) === 43) {
                                                a = T;
                                                ic++
                                            } else {
                                                a = h;
                                                if (il === 0) {
                                                    peg$fail(U)
                                                }
                                            }
                                            if (a === h) {
                                                if (f.charCodeAt(ic) === 36) {
                                                    a = V;
                                                    ic++
                                                } else {
                                                    a = h;
                                                    if (il === 0) {
                                                        peg$fail(W)
                                                    }
                                                }
                                                if (a === h) {
                                                    if (f.charCodeAt(ic) === 44) {
                                                        a = X;
                                                        ic++
                                                    } else {
                                                        a = h;
                                                        if (il === 0) {
                                                            peg$fail(Y)
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parseunreserved() {
                var a;
                a = peg$parsealphanum();
                if (a === h) {
                    a = peg$parsemark()
                }
                return a
            }

            function peg$parsemark() {
                var a;
                if (f.charCodeAt(ic) === 45) {
                    a = Z;
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(be)
                    }
                }
                if (a === h) {
                    if (f.charCodeAt(ic) === 95) {
                        a = bf;
                        ic++
                    } else {
                        a = h;
                        if (il === 0) {
                            peg$fail(bg)
                        }
                    }
                    if (a === h) {
                        if (f.charCodeAt(ic) === 46) {
                            a = bh;
                            ic++
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(bi)
                            }
                        }
                        if (a === h) {
                            if (f.charCodeAt(ic) === 33) {
                                a = bj;
                                ic++
                            } else {
                                a = h;
                                if (il === 0) {
                                    peg$fail(bk)
                                }
                            }
                            if (a === h) {
                                if (f.charCodeAt(ic) === 126) {
                                    a = bl;
                                    ic++
                                } else {
                                    a = h;
                                    if (il === 0) {
                                        peg$fail(bm)
                                    }
                                }
                                if (a === h) {
                                    if (f.charCodeAt(ic) === 42) {
                                        a = bn;
                                        ic++
                                    } else {
                                        a = h;
                                        if (il === 0) {
                                            peg$fail(bo)
                                        }
                                    }
                                    if (a === h) {
                                        if (f.charCodeAt(ic) === 39) {
                                            a = bp;
                                            ic++
                                        } else {
                                            a = h;
                                            if (il === 0) {
                                                peg$fail(bq)
                                            }
                                        }
                                        if (a === h) {
                                            if (f.charCodeAt(ic) === 40) {
                                                a = br;
                                                ic++
                                            } else {
                                                a = h;
                                                if (il === 0) {
                                                    peg$fail(bs)
                                                }
                                            }
                                            if (a === h) {
                                                if (f.charCodeAt(ic) === 41) {
                                                    a = bt;
                                                    ic++
                                                } else {
                                                    a = h;
                                                    if (il === 0) {
                                                        peg$fail(bu)
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parseescaped() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = ic;
                if (f.charCodeAt(ic) === 37) {
                    s2 = bv;
                    ic++
                } else {
                    s2 = h;
                    if (il === 0) {
                        peg$fail(bw)
                    }
                }
                if (s2 !== h) {
                    s3 = peg$parseHEXDIG();
                    if (s3 !== h) {
                        s4 = peg$parseHEXDIG();
                        if (s4 !== h) {
                            s2 = [s2, s3, s4];
                            s1 = s2
                        } else {
                            ic = s1;
                            s1 = h
                        }
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 !== h) {
                    a = f.substring(a, ic)
                } else {
                    a = s1
                }
                return a
            }

            function peg$parseLWS() {
                var a, s1, s2, s3;
                a = ic;
                s1 = ic;
                s2 = [];
                s3 = peg$parseWSP();
                while (s3 !== h) {
                    s2.push(s3);
                    s3 = peg$parseWSP()
                }
                if (s2 !== h) {
                    s3 = peg$parseCRLF();
                    if (s3 !== h) {
                        s2 = [s2, s3];
                        s1 = s2
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 === h) {
                    s1 = null
                }
                if (s1 !== h) {
                    s2 = [];
                    s3 = peg$parseWSP();
                    if (s3 !== h) {
                        while (s3 !== h) {
                            s2.push(s3);
                            s3 = peg$parseWSP()
                        }
                    } else {
                        s2 = h
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = bx();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseSWS() {
                var a;
                a = peg$parseLWS();
                if (a === h) {
                    a = null
                }
                return a
            }

            function peg$parseHCOLON() {
                var a, s1, s2, s3;
                a = ic;
                s1 = [];
                s2 = peg$parseSP();
                if (s2 === h) {
                    s2 = peg$parseHTAB()
                }
                while (s2 !== h) {
                    s1.push(s2);
                    s2 = peg$parseSP();
                    if (s2 === h) {
                        s2 = peg$parseHTAB()
                    }
                }
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 58) {
                        s2 = L;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(M)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseSWS();
                        if (s3 !== h) {
                            id = a;
                            s1 = by();
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseTEXT_UTF8_TRIM() {
                var a, s1, s2, s3, s4, s5, s6;
                a = ic;
                s1 = ic;
                s2 = [];
                s3 = peg$parseTEXT_UTF8char();
                if (s3 !== h) {
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = peg$parseTEXT_UTF8char()
                    }
                } else {
                    s2 = h
                }
                if (s2 !== h) {
                    s3 = [];
                    s4 = ic;
                    s5 = [];
                    s6 = peg$parseLWS();
                    while (s6 !== h) {
                        s5.push(s6);
                        s6 = peg$parseLWS()
                    }
                    if (s5 !== h) {
                        s6 = peg$parseTEXT_UTF8char();
                        if (s6 !== h) {
                            s5 = [s5, s6];
                            s4 = s5
                        } else {
                            ic = s4;
                            s4 = h
                        }
                    } else {
                        ic = s4;
                        s4 = h
                    }
                    while (s4 !== h) {
                        s3.push(s4);
                        s4 = ic;
                        s5 = [];
                        s6 = peg$parseLWS();
                        while (s6 !== h) {
                            s5.push(s6);
                            s6 = peg$parseLWS()
                        }
                        if (s5 !== h) {
                            s6 = peg$parseTEXT_UTF8char();
                            if (s6 !== h) {
                                s5 = [s5, s6];
                                s4 = s5
                            } else {
                                ic = s4;
                                s4 = h
                            }
                        } else {
                            ic = s4;
                            s4 = h
                        }
                    }
                    if (s3 !== h) {
                        s2 = [s2, s3];
                        s1 = s2
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 !== h) {
                    a = f.substring(a, ic)
                } else {
                    a = s1
                }
                return a
            }

            function peg$parseTEXT_UTF8char() {
                var a;
                if (bz.test(f.charAt(ic))) {
                    a = f.charAt(ic);
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(bA)
                    }
                }
                if (a === h) {
                    a = peg$parseUTF8_NONASCII()
                }
                return a
            }

            function peg$parseUTF8_NONASCII() {
                var a;
                if (bB.test(f.charAt(ic))) {
                    a = f.charAt(ic);
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(bC)
                    }
                }
                return a
            }

            function peg$parseUTF8_CONT() {
                var a;
                if (bD.test(f.charAt(ic))) {
                    a = f.charAt(ic);
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(bE)
                    }
                }
                return a
            }

            function peg$parseLHEX() {
                var a;
                a = peg$parseDIGIT();
                if (a === h) {
                    if (bF.test(f.charAt(ic))) {
                        a = f.charAt(ic);
                        ic++
                    } else {
                        a = h;
                        if (il === 0) {
                            peg$fail(bG)
                        }
                    }
                }
                return a
            }

            function peg$parsetoken() {
                var a, s1, s2;
                a = ic;
                s1 = [];
                s2 = peg$parsealphanum();
                if (s2 === h) {
                    if (f.charCodeAt(ic) === 45) {
                        s2 = Z;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(be)
                        }
                    }
                    if (s2 === h) {
                        if (f.charCodeAt(ic) === 46) {
                            s2 = bh;
                            ic++
                        } else {
                            s2 = h;
                            if (il === 0) {
                                peg$fail(bi)
                            }
                        }
                        if (s2 === h) {
                            if (f.charCodeAt(ic) === 33) {
                                s2 = bj;
                                ic++
                            } else {
                                s2 = h;
                                if (il === 0) {
                                    peg$fail(bk)
                                }
                            }
                            if (s2 === h) {
                                if (f.charCodeAt(ic) === 37) {
                                    s2 = bv;
                                    ic++
                                } else {
                                    s2 = h;
                                    if (il === 0) {
                                        peg$fail(bw)
                                    }
                                }
                                if (s2 === h) {
                                    if (f.charCodeAt(ic) === 42) {
                                        s2 = bn;
                                        ic++
                                    } else {
                                        s2 = h;
                                        if (il === 0) {
                                            peg$fail(bo)
                                        }
                                    }
                                    if (s2 === h) {
                                        if (f.charCodeAt(ic) === 95) {
                                            s2 = bf;
                                            ic++
                                        } else {
                                            s2 = h;
                                            if (il === 0) {
                                                peg$fail(bg)
                                            }
                                        }
                                        if (s2 === h) {
                                            if (f.charCodeAt(ic) === 43) {
                                                s2 = T;
                                                ic++
                                            } else {
                                                s2 = h;
                                                if (il === 0) {
                                                    peg$fail(U)
                                                }
                                            }
                                            if (s2 === h) {
                                                if (f.charCodeAt(ic) === 96) {
                                                    s2 = bH;
                                                    ic++
                                                } else {
                                                    s2 = h;
                                                    if (il === 0) {
                                                        peg$fail(bI)
                                                    }
                                                }
                                                if (s2 === h) {
                                                    if (f.charCodeAt(ic) === 39) {
                                                        s2 = bp;
                                                        ic++
                                                    } else {
                                                        s2 = h;
                                                        if (il === 0) {
                                                            peg$fail(bq)
                                                        }
                                                    }
                                                    if (s2 === h) {
                                                        if (f.charCodeAt(ic) === 126) {
                                                            s2 = bl;
                                                            ic++
                                                        } else {
                                                            s2 = h;
                                                            if (il === 0) {
                                                                peg$fail(bm)
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (s2 !== h) {
                    while (s2 !== h) {
                        s1.push(s2);
                        s2 = peg$parsealphanum();
                        if (s2 === h) {
                            if (f.charCodeAt(ic) === 45) {
                                s2 = Z;
                                ic++
                            } else {
                                s2 = h;
                                if (il === 0) {
                                    peg$fail(be)
                                }
                            }
                            if (s2 === h) {
                                if (f.charCodeAt(ic) === 46) {
                                    s2 = bh;
                                    ic++
                                } else {
                                    s2 = h;
                                    if (il === 0) {
                                        peg$fail(bi)
                                    }
                                }
                                if (s2 === h) {
                                    if (f.charCodeAt(ic) === 33) {
                                        s2 = bj;
                                        ic++
                                    } else {
                                        s2 = h;
                                        if (il === 0) {
                                            peg$fail(bk)
                                        }
                                    }
                                    if (s2 === h) {
                                        if (f.charCodeAt(ic) === 37) {
                                            s2 = bv;
                                            ic++
                                        } else {
                                            s2 = h;
                                            if (il === 0) {
                                                peg$fail(bw)
                                            }
                                        }
                                        if (s2 === h) {
                                            if (f.charCodeAt(ic) === 42) {
                                                s2 = bn;
                                                ic++
                                            } else {
                                                s2 = h;
                                                if (il === 0) {
                                                    peg$fail(bo)
                                                }
                                            }
                                            if (s2 === h) {
                                                if (f.charCodeAt(ic) === 95) {
                                                    s2 = bf;
                                                    ic++
                                                } else {
                                                    s2 = h;
                                                    if (il === 0) {
                                                        peg$fail(bg)
                                                    }
                                                }
                                                if (s2 === h) {
                                                    if (f.charCodeAt(ic) === 43) {
                                                        s2 = T;
                                                        ic++
                                                    } else {
                                                        s2 = h;
                                                        if (il === 0) {
                                                            peg$fail(U)
                                                        }
                                                    }
                                                    if (s2 === h) {
                                                        if (f.charCodeAt(ic) === 96) {
                                                            s2 = bH;
                                                            ic++
                                                        } else {
                                                            s2 = h;
                                                            if (il === 0) {
                                                                peg$fail(bI)
                                                            }
                                                        }
                                                        if (s2 === h) {
                                                            if (f.charCodeAt(ic) === 39) {
                                                                s2 = bp;
                                                                ic++
                                                            } else {
                                                                s2 = h;
                                                                if (il === 0) {
                                                                    peg$fail(bq)
                                                                }
                                                            }
                                                            if (s2 === h) {
                                                                if (f.charCodeAt(ic) === 126) {
                                                                    s2 = bl;
                                                                    ic++
                                                                } else {
                                                                    s2 = h;
                                                                    if (il === 0) {
                                                                        peg$fail(bm)
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else {
                    s1 = h
                }
                if (s1 !== h) {
                    a = f.substring(a, ic)
                } else {
                    a = s1
                }
                return a
            }

            function peg$parsetoken_nodot() {
                var a, s1, s2;
                a = ic;
                s1 = [];
                s2 = peg$parsealphanum();
                if (s2 === h) {
                    if (f.charCodeAt(ic) === 45) {
                        s2 = Z;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(be)
                        }
                    }
                    if (s2 === h) {
                        if (f.charCodeAt(ic) === 33) {
                            s2 = bj;
                            ic++
                        } else {
                            s2 = h;
                            if (il === 0) {
                                peg$fail(bk)
                            }
                        }
                        if (s2 === h) {
                            if (f.charCodeAt(ic) === 37) {
                                s2 = bv;
                                ic++
                            } else {
                                s2 = h;
                                if (il === 0) {
                                    peg$fail(bw)
                                }
                            }
                            if (s2 === h) {
                                if (f.charCodeAt(ic) === 42) {
                                    s2 = bn;
                                    ic++
                                } else {
                                    s2 = h;
                                    if (il === 0) {
                                        peg$fail(bo)
                                    }
                                }
                                if (s2 === h) {
                                    if (f.charCodeAt(ic) === 95) {
                                        s2 = bf;
                                        ic++
                                    } else {
                                        s2 = h;
                                        if (il === 0) {
                                            peg$fail(bg)
                                        }
                                    }
                                    if (s2 === h) {
                                        if (f.charCodeAt(ic) === 43) {
                                            s2 = T;
                                            ic++
                                        } else {
                                            s2 = h;
                                            if (il === 0) {
                                                peg$fail(U)
                                            }
                                        }
                                        if (s2 === h) {
                                            if (f.charCodeAt(ic) === 96) {
                                                s2 = bH;
                                                ic++
                                            } else {
                                                s2 = h;
                                                if (il === 0) {
                                                    peg$fail(bI)
                                                }
                                            }
                                            if (s2 === h) {
                                                if (f.charCodeAt(ic) === 39) {
                                                    s2 = bp;
                                                    ic++
                                                } else {
                                                    s2 = h;
                                                    if (il === 0) {
                                                        peg$fail(bq)
                                                    }
                                                }
                                                if (s2 === h) {
                                                    if (f.charCodeAt(ic) === 126) {
                                                        s2 = bl;
                                                        ic++
                                                    } else {
                                                        s2 = h;
                                                        if (il === 0) {
                                                            peg$fail(bm)
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (s2 !== h) {
                    while (s2 !== h) {
                        s1.push(s2);
                        s2 = peg$parsealphanum();
                        if (s2 === h) {
                            if (f.charCodeAt(ic) === 45) {
                                s2 = Z;
                                ic++
                            } else {
                                s2 = h;
                                if (il === 0) {
                                    peg$fail(be)
                                }
                            }
                            if (s2 === h) {
                                if (f.charCodeAt(ic) === 33) {
                                    s2 = bj;
                                    ic++
                                } else {
                                    s2 = h;
                                    if (il === 0) {
                                        peg$fail(bk)
                                    }
                                }
                                if (s2 === h) {
                                    if (f.charCodeAt(ic) === 37) {
                                        s2 = bv;
                                        ic++
                                    } else {
                                        s2 = h;
                                        if (il === 0) {
                                            peg$fail(bw)
                                        }
                                    }
                                    if (s2 === h) {
                                        if (f.charCodeAt(ic) === 42) {
                                            s2 = bn;
                                            ic++
                                        } else {
                                            s2 = h;
                                            if (il === 0) {
                                                peg$fail(bo)
                                            }
                                        }
                                        if (s2 === h) {
                                            if (f.charCodeAt(ic) === 95) {
                                                s2 = bf;
                                                ic++
                                            } else {
                                                s2 = h;
                                                if (il === 0) {
                                                    peg$fail(bg)
                                                }
                                            }
                                            if (s2 === h) {
                                                if (f.charCodeAt(ic) === 43) {
                                                    s2 = T;
                                                    ic++
                                                } else {
                                                    s2 = h;
                                                    if (il === 0) {
                                                        peg$fail(U)
                                                    }
                                                }
                                                if (s2 === h) {
                                                    if (f.charCodeAt(ic) === 96) {
                                                        s2 = bH;
                                                        ic++
                                                    } else {
                                                        s2 = h;
                                                        if (il === 0) {
                                                            peg$fail(bI)
                                                        }
                                                    }
                                                    if (s2 === h) {
                                                        if (f.charCodeAt(ic) === 39) {
                                                            s2 = bp;
                                                            ic++
                                                        } else {
                                                            s2 = h;
                                                            if (il === 0) {
                                                                peg$fail(bq)
                                                            }
                                                        }
                                                        if (s2 === h) {
                                                            if (f.charCodeAt(ic) === 126) {
                                                                s2 = bl;
                                                                ic++
                                                            } else {
                                                                s2 = h;
                                                                if (il === 0) {
                                                                    peg$fail(bm)
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else {
                    s1 = h
                }
                if (s1 !== h) {
                    a = f.substring(a, ic)
                } else {
                    a = s1
                }
                return a
            }

            function peg$parseseparators() {
                var a;
                if (f.charCodeAt(ic) === 40) {
                    a = br;
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(bs)
                    }
                }
                if (a === h) {
                    if (f.charCodeAt(ic) === 41) {
                        a = bt;
                        ic++
                    } else {
                        a = h;
                        if (il === 0) {
                            peg$fail(bu)
                        }
                    }
                    if (a === h) {
                        if (f.charCodeAt(ic) === 60) {
                            a = bJ;
                            ic++
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(bK)
                            }
                        }
                        if (a === h) {
                            if (f.charCodeAt(ic) === 62) {
                                a = bL;
                                ic++
                            } else {
                                a = h;
                                if (il === 0) {
                                    peg$fail(bM)
                                }
                            }
                            if (a === h) {
                                if (f.charCodeAt(ic) === 64) {
                                    a = N;
                                    ic++
                                } else {
                                    a = h;
                                    if (il === 0) {
                                        peg$fail(O)
                                    }
                                }
                                if (a === h) {
                                    if (f.charCodeAt(ic) === 44) {
                                        a = X;
                                        ic++
                                    } else {
                                        a = h;
                                        if (il === 0) {
                                            peg$fail(Y)
                                        }
                                    }
                                    if (a === h) {
                                        if (f.charCodeAt(ic) === 59) {
                                            a = F;
                                            ic++
                                        } else {
                                            a = h;
                                            if (il === 0) {
                                                peg$fail(G)
                                            }
                                        }
                                        if (a === h) {
                                            if (f.charCodeAt(ic) === 58) {
                                                a = L;
                                                ic++
                                            } else {
                                                a = h;
                                                if (il === 0) {
                                                    peg$fail(M)
                                                }
                                            }
                                            if (a === h) {
                                                if (f.charCodeAt(ic) === 92) {
                                                    a = bN;
                                                    ic++
                                                } else {
                                                    a = h;
                                                    if (il === 0) {
                                                        peg$fail(bO)
                                                    }
                                                }
                                                if (a === h) {
                                                    a = peg$parseDQUOTE();
                                                    if (a === h) {
                                                        if (f.charCodeAt(ic) === 47) {
                                                            a = H;
                                                            ic++
                                                        } else {
                                                            a = h;
                                                            if (il === 0) {
                                                                peg$fail(I)
                                                            }
                                                        }
                                                        if (a === h) {
                                                            if (f.charCodeAt(ic) === 91) {
                                                                a = bP;
                                                                ic++
                                                            } else {
                                                                a = h;
                                                                if (il === 0) {
                                                                    peg$fail(bQ)
                                                                }
                                                            }
                                                            if (a === h) {
                                                                if (f.charCodeAt(ic) === 93) {
                                                                    a = bR;
                                                                    ic++
                                                                } else {
                                                                    a = h;
                                                                    if (il === 0) {
                                                                        peg$fail(bS)
                                                                    }
                                                                }
                                                                if (a === h) {
                                                                    if (f.charCodeAt(ic) === 63) {
                                                                        a = J;
                                                                        ic++
                                                                    } else {
                                                                        a = h;
                                                                        if (il === 0) {
                                                                            peg$fail(K)
                                                                        }
                                                                    }
                                                                    if (a === h) {
                                                                        if (f.charCodeAt(ic) === 61) {
                                                                            a = R;
                                                                            ic++
                                                                        } else {
                                                                            a = h;
                                                                            if (il === 0) {
                                                                                peg$fail(S)
                                                                            }
                                                                        }
                                                                        if (a === h) {
                                                                            if (f.charCodeAt(ic) === 123) {
                                                                                a = bT;
                                                                                ic++
                                                                            } else {
                                                                                a = h;
                                                                                if (il === 0) {
                                                                                    peg$fail(bU)
                                                                                }
                                                                            }
                                                                            if (a === h) {
                                                                                if (f.charCodeAt(ic) === 125) {
                                                                                    a = bV;
                                                                                    ic++
                                                                                } else {
                                                                                    a = h;
                                                                                    if (il === 0) {
                                                                                        peg$fail(bW)
                                                                                    }
                                                                                }
                                                                                if (a === h) {
                                                                                    a = peg$parseSP();
                                                                                    if (a === h) {
                                                                                        a = peg$parseHTAB()
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parseword() {
                var a, s1, s2;
                a = ic;
                s1 = [];
                s2 = peg$parsealphanum();
                if (s2 === h) {
                    if (f.charCodeAt(ic) === 45) {
                        s2 = Z;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(be)
                        }
                    }
                    if (s2 === h) {
                        if (f.charCodeAt(ic) === 46) {
                            s2 = bh;
                            ic++
                        } else {
                            s2 = h;
                            if (il === 0) {
                                peg$fail(bi)
                            }
                        }
                        if (s2 === h) {
                            if (f.charCodeAt(ic) === 33) {
                                s2 = bj;
                                ic++
                            } else {
                                s2 = h;
                                if (il === 0) {
                                    peg$fail(bk)
                                }
                            }
                            if (s2 === h) {
                                if (f.charCodeAt(ic) === 37) {
                                    s2 = bv;
                                    ic++
                                } else {
                                    s2 = h;
                                    if (il === 0) {
                                        peg$fail(bw)
                                    }
                                }
                                if (s2 === h) {
                                    if (f.charCodeAt(ic) === 42) {
                                        s2 = bn;
                                        ic++
                                    } else {
                                        s2 = h;
                                        if (il === 0) {
                                            peg$fail(bo)
                                        }
                                    }
                                    if (s2 === h) {
                                        if (f.charCodeAt(ic) === 95) {
                                            s2 = bf;
                                            ic++
                                        } else {
                                            s2 = h;
                                            if (il === 0) {
                                                peg$fail(bg)
                                            }
                                        }
                                        if (s2 === h) {
                                            if (f.charCodeAt(ic) === 43) {
                                                s2 = T;
                                                ic++
                                            } else {
                                                s2 = h;
                                                if (il === 0) {
                                                    peg$fail(U)
                                                }
                                            }
                                            if (s2 === h) {
                                                if (f.charCodeAt(ic) === 96) {
                                                    s2 = bH;
                                                    ic++
                                                } else {
                                                    s2 = h;
                                                    if (il === 0) {
                                                        peg$fail(bI)
                                                    }
                                                }
                                                if (s2 === h) {
                                                    if (f.charCodeAt(ic) === 39) {
                                                        s2 = bp;
                                                        ic++
                                                    } else {
                                                        s2 = h;
                                                        if (il === 0) {
                                                            peg$fail(bq)
                                                        }
                                                    }
                                                    if (s2 === h) {
                                                        if (f.charCodeAt(ic) === 126) {
                                                            s2 = bl;
                                                            ic++
                                                        } else {
                                                            s2 = h;
                                                            if (il === 0) {
                                                                peg$fail(bm)
                                                            }
                                                        }
                                                        if (s2 === h) {
                                                            if (f.charCodeAt(ic) === 40) {
                                                                s2 = br;
                                                                ic++
                                                            } else {
                                                                s2 = h;
                                                                if (il === 0) {
                                                                    peg$fail(bs)
                                                                }
                                                            }
                                                            if (s2 === h) {
                                                                if (f.charCodeAt(ic) === 41) {
                                                                    s2 = bt;
                                                                    ic++
                                                                } else {
                                                                    s2 = h;
                                                                    if (il === 0) {
                                                                        peg$fail(bu)
                                                                    }
                                                                }
                                                                if (s2 === h) {
                                                                    if (f.charCodeAt(ic) === 60) {
                                                                        s2 = bJ;
                                                                        ic++
                                                                    } else {
                                                                        s2 = h;
                                                                        if (il === 0) {
                                                                            peg$fail(bK)
                                                                        }
                                                                    }
                                                                    if (s2 === h) {
                                                                        if (f.charCodeAt(ic) === 62) {
                                                                            s2 = bL;
                                                                            ic++
                                                                        } else {
                                                                            s2 = h;
                                                                            if (il === 0) {
                                                                                peg$fail(bM)
                                                                            }
                                                                        }
                                                                        if (s2 === h) {
                                                                            if (f.charCodeAt(ic) === 58) {
                                                                                s2 = L;
                                                                                ic++
                                                                            } else {
                                                                                s2 = h;
                                                                                if (il === 0) {
                                                                                    peg$fail(M)
                                                                                }
                                                                            }
                                                                            if (s2 === h) {
                                                                                if (f.charCodeAt(ic) === 92) {
                                                                                    s2 = bN;
                                                                                    ic++
                                                                                } else {
                                                                                    s2 = h;
                                                                                    if (il === 0) {
                                                                                        peg$fail(bO)
                                                                                    }
                                                                                }
                                                                                if (s2 === h) {
                                                                                    s2 = peg$parseDQUOTE();
                                                                                    if (s2 === h) {
                                                                                        if (f.charCodeAt(ic) === 47) {
                                                                                            s2 = H;
                                                                                            ic++
                                                                                        } else {
                                                                                            s2 = h;
                                                                                            if (il === 0) {
                                                                                                peg$fail(I)
                                                                                            }
                                                                                        }
                                                                                        if (s2 === h) {
                                                                                            if (f.charCodeAt(ic) === 91) {
                                                                                                s2 = bP;
                                                                                                ic++
                                                                                            } else {
                                                                                                s2 = h;
                                                                                                if (il === 0) {
                                                                                                    peg$fail(bQ)
                                                                                                }
                                                                                            }
                                                                                            if (s2 === h) {
                                                                                                if (f.charCodeAt(ic) === 93) {
                                                                                                    s2 = bR;
                                                                                                    ic++
                                                                                                } else {
                                                                                                    s2 = h;
                                                                                                    if (il === 0) {
                                                                                                        peg$fail(bS)
                                                                                                    }
                                                                                                }
                                                                                                if (s2 === h) {
                                                                                                    if (f.charCodeAt(ic) === 63) {
                                                                                                        s2 = J;
                                                                                                        ic++
                                                                                                    } else {
                                                                                                        s2 = h;
                                                                                                        if (il === 0) {
                                                                                                            peg$fail(K)
                                                                                                        }
                                                                                                    }
                                                                                                    if (s2 === h) {
                                                                                                        if (f.charCodeAt(ic) === 123) {
                                                                                                            s2 = bT;
                                                                                                            ic++
                                                                                                        } else {
                                                                                                            s2 = h;
                                                                                                            if (il === 0) {
                                                                                                                peg$fail(bU)
                                                                                                            }
                                                                                                        }
                                                                                                        if (s2 === h) {
                                                                                                            if (f.charCodeAt(ic) === 125) {
                                                                                                                s2 = bV;
                                                                                                                ic++
                                                                                                            } else {
                                                                                                                s2 = h;
                                                                                                                if (il === 0) {
                                                                                                                    peg$fail(bW)
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (s2 !== h) {
                    while (s2 !== h) {
                        s1.push(s2);
                        s2 = peg$parsealphanum();
                        if (s2 === h) {
                            if (f.charCodeAt(ic) === 45) {
                                s2 = Z;
                                ic++
                            } else {
                                s2 = h;
                                if (il === 0) {
                                    peg$fail(be)
                                }
                            }
                            if (s2 === h) {
                                if (f.charCodeAt(ic) === 46) {
                                    s2 = bh;
                                    ic++
                                } else {
                                    s2 = h;
                                    if (il === 0) {
                                        peg$fail(bi)
                                    }
                                }
                                if (s2 === h) {
                                    if (f.charCodeAt(ic) === 33) {
                                        s2 = bj;
                                        ic++
                                    } else {
                                        s2 = h;
                                        if (il === 0) {
                                            peg$fail(bk)
                                        }
                                    }
                                    if (s2 === h) {
                                        if (f.charCodeAt(ic) === 37) {
                                            s2 = bv;
                                            ic++
                                        } else {
                                            s2 = h;
                                            if (il === 0) {
                                                peg$fail(bw)
                                            }
                                        }
                                        if (s2 === h) {
                                            if (f.charCodeAt(ic) === 42) {
                                                s2 = bn;
                                                ic++
                                            } else {
                                                s2 = h;
                                                if (il === 0) {
                                                    peg$fail(bo)
                                                }
                                            }
                                            if (s2 === h) {
                                                if (f.charCodeAt(ic) === 95) {
                                                    s2 = bf;
                                                    ic++
                                                } else {
                                                    s2 = h;
                                                    if (il === 0) {
                                                        peg$fail(bg)
                                                    }
                                                }
                                                if (s2 === h) {
                                                    if (f.charCodeAt(ic) === 43) {
                                                        s2 = T;
                                                        ic++
                                                    } else {
                                                        s2 = h;
                                                        if (il === 0) {
                                                            peg$fail(U)
                                                        }
                                                    }
                                                    if (s2 === h) {
                                                        if (f.charCodeAt(ic) === 96) {
                                                            s2 = bH;
                                                            ic++
                                                        } else {
                                                            s2 = h;
                                                            if (il === 0) {
                                                                peg$fail(bI)
                                                            }
                                                        }
                                                        if (s2 === h) {
                                                            if (f.charCodeAt(ic) === 39) {
                                                                s2 = bp;
                                                                ic++
                                                            } else {
                                                                s2 = h;
                                                                if (il === 0) {
                                                                    peg$fail(bq)
                                                                }
                                                            }
                                                            if (s2 === h) {
                                                                if (f.charCodeAt(ic) === 126) {
                                                                    s2 = bl;
                                                                    ic++
                                                                } else {
                                                                    s2 = h;
                                                                    if (il === 0) {
                                                                        peg$fail(bm)
                                                                    }
                                                                }
                                                                if (s2 === h) {
                                                                    if (f.charCodeAt(ic) === 40) {
                                                                        s2 = br;
                                                                        ic++
                                                                    } else {
                                                                        s2 = h;
                                                                        if (il === 0) {
                                                                            peg$fail(bs)
                                                                        }
                                                                    }
                                                                    if (s2 === h) {
                                                                        if (f.charCodeAt(ic) === 41) {
                                                                            s2 = bt;
                                                                            ic++
                                                                        } else {
                                                                            s2 = h;
                                                                            if (il === 0) {
                                                                                peg$fail(bu)
                                                                            }
                                                                        }
                                                                        if (s2 === h) {
                                                                            if (f.charCodeAt(ic) === 60) {
                                                                                s2 = bJ;
                                                                                ic++
                                                                            } else {
                                                                                s2 = h;
                                                                                if (il === 0) {
                                                                                    peg$fail(bK)
                                                                                }
                                                                            }
                                                                            if (s2 === h) {
                                                                                if (f.charCodeAt(ic) === 62) {
                                                                                    s2 = bL;
                                                                                    ic++
                                                                                } else {
                                                                                    s2 = h;
                                                                                    if (il === 0) {
                                                                                        peg$fail(bM)
                                                                                    }
                                                                                }
                                                                                if (s2 === h) {
                                                                                    if (f.charCodeAt(ic) === 58) {
                                                                                        s2 = L;
                                                                                        ic++
                                                                                    } else {
                                                                                        s2 = h;
                                                                                        if (il === 0) {
                                                                                            peg$fail(M)
                                                                                        }
                                                                                    }
                                                                                    if (s2 === h) {
                                                                                        if (f.charCodeAt(ic) === 92) {
                                                                                            s2 = bN;
                                                                                            ic++
                                                                                        } else {
                                                                                            s2 = h;
                                                                                            if (il === 0) {
                                                                                                peg$fail(bO)
                                                                                            }
                                                                                        }
                                                                                        if (s2 === h) {
                                                                                            s2 = peg$parseDQUOTE();
                                                                                            if (s2 === h) {
                                                                                                if (f.charCodeAt(ic) === 47) {
                                                                                                    s2 = H;
                                                                                                    ic++
                                                                                                } else {
                                                                                                    s2 = h;
                                                                                                    if (il === 0) {
                                                                                                        peg$fail(I)
                                                                                                    }
                                                                                                }
                                                                                                if (s2 === h) {
                                                                                                    if (f.charCodeAt(ic) === 91) {
                                                                                                        s2 = bP;
                                                                                                        ic++
                                                                                                    } else {
                                                                                                        s2 = h;
                                                                                                        if (il === 0) {
                                                                                                            peg$fail(bQ)
                                                                                                        }
                                                                                                    }
                                                                                                    if (s2 === h) {
                                                                                                        if (f.charCodeAt(ic) === 93) {
                                                                                                            s2 = bR;
                                                                                                            ic++
                                                                                                        } else {
                                                                                                            s2 = h;
                                                                                                            if (il === 0) {
                                                                                                                peg$fail(bS)
                                                                                                            }
                                                                                                        }
                                                                                                        if (s2 === h) {
                                                                                                            if (f.charCodeAt(ic) === 63) {
                                                                                                                s2 = J;
                                                                                                                ic++
                                                                                                            } else {
                                                                                                                s2 = h;
                                                                                                                if (il === 0) {
                                                                                                                    peg$fail(K)
                                                                                                                }
                                                                                                            }
                                                                                                            if (s2 === h) {
                                                                                                                if (f.charCodeAt(ic) === 123) {
                                                                                                                    s2 = bT;
                                                                                                                    ic++
                                                                                                                } else {
                                                                                                                    s2 = h;
                                                                                                                    if (il === 0) {
                                                                                                                        peg$fail(bU)
                                                                                                                    }
                                                                                                                }
                                                                                                                if (s2 === h) {
                                                                                                                    if (f.charCodeAt(ic) === 125) {
                                                                                                                        s2 = bV;
                                                                                                                        ic++
                                                                                                                    } else {
                                                                                                                        s2 = h;
                                                                                                                        if (il === 0) {
                                                                                                                            peg$fail(bW)
                                                                                                                        }
                                                                                                                    }
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else {
                    s1 = h
                }
                if (s1 !== h) {
                    a = f.substring(a, ic)
                } else {
                    a = s1
                }
                return a
            }

            function peg$parseSTAR() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parseSWS();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 42) {
                        s2 = bn;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(bo)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseSWS();
                        if (s3 !== h) {
                            id = a;
                            s1 = bX();
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseSLASH() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parseSWS();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 47) {
                        s2 = H;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(I)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseSWS();
                        if (s3 !== h) {
                            id = a;
                            s1 = bY();
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseEQUAL() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parseSWS();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 61) {
                        s2 = R;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(S)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseSWS();
                        if (s3 !== h) {
                            id = a;
                            s1 = bZ();
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseLPAREN() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parseSWS();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 40) {
                        s2 = br;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(bs)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseSWS();
                        if (s3 !== h) {
                            id = a;
                            s1 = ca();
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseRPAREN() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parseSWS();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 41) {
                        s2 = bt;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(bu)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseSWS();
                        if (s3 !== h) {
                            id = a;
                            s1 = cb();
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseRAQUOT() {
                var a, s1, s2;
                a = ic;
                if (f.charCodeAt(ic) === 62) {
                    s1 = bL;
                    ic++
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(bM)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseSWS();
                    if (s2 !== h) {
                        id = a;
                        s1 = cc();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseLAQUOT() {
                var a, s1, s2;
                a = ic;
                s1 = peg$parseSWS();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 60) {
                        s2 = bJ;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(bK)
                        }
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = cd();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseCOMMA() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parseSWS();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 44) {
                        s2 = X;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(Y)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseSWS();
                        if (s3 !== h) {
                            id = a;
                            s1 = ce();
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseSEMI() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parseSWS();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 59) {
                        s2 = F;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(G)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseSWS();
                        if (s3 !== h) {
                            id = a;
                            s1 = cf();
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseCOLON() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parseSWS();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 58) {
                        s2 = L;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(M)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseSWS();
                        if (s3 !== h) {
                            id = a;
                            s1 = cg();
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseLDQUOT() {
                var a, s1, s2;
                a = ic;
                s1 = peg$parseSWS();
                if (s1 !== h) {
                    s2 = peg$parseDQUOTE();
                    if (s2 !== h) {
                        id = a;
                        s1 = ch();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseRDQUOT() {
                var a, s1, s2;
                a = ic;
                s1 = peg$parseDQUOTE();
                if (s1 !== h) {
                    s2 = peg$parseSWS();
                    if (s2 !== h) {
                        id = a;
                        s1 = ch();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsecomment() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parseLPAREN();
                if (s1 !== h) {
                    s2 = [];
                    s3 = peg$parsectext();
                    if (s3 === h) {
                        s3 = peg$parsequoted_pair();
                        if (s3 === h) {
                            s3 = peg$parsecomment()
                        }
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = peg$parsectext();
                        if (s3 === h) {
                            s3 = peg$parsequoted_pair();
                            if (s3 === h) {
                                s3 = peg$parsecomment()
                            }
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseRPAREN();
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsectext() {
                var a;
                if (ci.test(f.charAt(ic))) {
                    a = f.charAt(ic);
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(cj)
                    }
                }
                if (a === h) {
                    if (ck.test(f.charAt(ic))) {
                        a = f.charAt(ic);
                        ic++
                    } else {
                        a = h;
                        if (il === 0) {
                            peg$fail(cl)
                        }
                    }
                    if (a === h) {
                        if (cm.test(f.charAt(ic))) {
                            a = f.charAt(ic);
                            ic++
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(cn)
                            }
                        }
                        if (a === h) {
                            a = peg$parseUTF8_NONASCII();
                            if (a === h) {
                                a = peg$parseLWS()
                            }
                        }
                    }
                }
                return a
            }

            function peg$parsequoted_string() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = ic;
                s2 = peg$parseSWS();
                if (s2 !== h) {
                    s3 = peg$parseDQUOTE();
                    if (s3 !== h) {
                        s4 = [];
                        s5 = peg$parseqdtext();
                        if (s5 === h) {
                            s5 = peg$parsequoted_pair()
                        }
                        while (s5 !== h) {
                            s4.push(s5);
                            s5 = peg$parseqdtext();
                            if (s5 === h) {
                                s5 = peg$parsequoted_pair()
                            }
                        }
                        if (s4 !== h) {
                            s5 = peg$parseDQUOTE();
                            if (s5 !== h) {
                                s2 = [s2, s3, s4, s5];
                                s1 = s2
                            } else {
                                ic = s1;
                                s1 = h
                            }
                        } else {
                            ic = s1;
                            s1 = h
                        }
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 !== h) {
                    a = f.substring(a, ic)
                } else {
                    a = s1
                }
                return a
            }

            function peg$parsequoted_string_clean() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseSWS();
                if (s1 !== h) {
                    s2 = peg$parseDQUOTE();
                    if (s2 !== h) {
                        s3 = ic;
                        s4 = [];
                        s5 = peg$parseqdtext();
                        if (s5 === h) {
                            s5 = peg$parsequoted_pair()
                        }
                        while (s5 !== h) {
                            s4.push(s5);
                            s5 = peg$parseqdtext();
                            if (s5 === h) {
                                s5 = peg$parsequoted_pair()
                            }
                        }
                        if (s4 !== h) {
                            s3 = f.substring(s3, ic)
                        } else {
                            s3 = s4
                        }
                        if (s3 !== h) {
                            s4 = peg$parseDQUOTE();
                            if (s4 !== h) {
                                id = a;
                                s1 = co(s3);
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseqdtext() {
                var a;
                a = peg$parseLWS();
                if (a === h) {
                    if (f.charCodeAt(ic) === 33) {
                        a = bj;
                        ic++
                    } else {
                        a = h;
                        if (il === 0) {
                            peg$fail(bk)
                        }
                    }
                    if (a === h) {
                        if (cp.test(f.charAt(ic))) {
                            a = f.charAt(ic);
                            ic++
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(cq)
                            }
                        }
                        if (a === h) {
                            if (cm.test(f.charAt(ic))) {
                                a = f.charAt(ic);
                                ic++
                            } else {
                                a = h;
                                if (il === 0) {
                                    peg$fail(cn)
                                }
                            }
                            if (a === h) {
                                a = peg$parseUTF8_NONASCII()
                            }
                        }
                    }
                }
                return a
            }

            function peg$parsequoted_pair() {
                var a, s1, s2;
                a = ic;
                if (f.charCodeAt(ic) === 92) {
                    s1 = bN;
                    ic++
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(bO)
                    }
                }
                if (s1 !== h) {
                    if (cr.test(f.charAt(ic))) {
                        s2 = f.charAt(ic);
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(cs)
                        }
                    }
                    if (s2 === h) {
                        if (ct.test(f.charAt(ic))) {
                            s2 = f.charAt(ic);
                            ic++
                        } else {
                            s2 = h;
                            if (il === 0) {
                                peg$fail(cu)
                            }
                        }
                        if (s2 === h) {
                            if (cv.test(f.charAt(ic))) {
                                s2 = f.charAt(ic);
                                ic++
                            } else {
                                s2 = h;
                                if (il === 0) {
                                    peg$fail(cw)
                                }
                            }
                        }
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseSIP_URI_noparams() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = peg$parseuri_scheme();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 58) {
                        s2 = L;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(M)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseuserinfo();
                        if (s3 === h) {
                            s3 = null
                        }
                        if (s3 !== h) {
                            s4 = peg$parsehostport();
                            if (s4 !== h) {
                                id = a;
                                s1 = cx();
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseSIP_URI() {
                var a, s1, s2, s3, s4, s5, s6;
                a = ic;
                s1 = peg$parseuri_scheme();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 58) {
                        s2 = L;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(M)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseuserinfo();
                        if (s3 === h) {
                            s3 = null
                        }
                        if (s3 !== h) {
                            s4 = peg$parsehostport();
                            if (s4 !== h) {
                                s5 = peg$parseuri_parameters();
                                if (s5 !== h) {
                                    s6 = peg$parseheaders();
                                    if (s6 === h) {
                                        s6 = null
                                    }
                                    if (s6 !== h) {
                                        id = a;
                                        s1 = cy();
                                        a = s1
                                    } else {
                                        ic = a;
                                        a = h
                                    }
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseuri_scheme() {
                var a, s1;
                a = ic;
                if (f.substr(ic, 4)
                    .toLowerCase() === cz) {
                    s1 = f.substr(ic, 4);
                    ic += 4
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(cA)
                    }
                }
                if (s1 === h) {
                    if (f.substr(ic, 3)
                        .toLowerCase() === cB) {
                        s1 = f.substr(ic, 3);
                        ic += 3
                    } else {
                        s1 = h;
                        if (il === 0) {
                            peg$fail(cC)
                        }
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = cD(s1)
                }
                a = s1;
                return a
            }

            function peg$parseuserinfo() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = peg$parseuser();
                if (s1 !== h) {
                    s2 = ic;
                    if (f.charCodeAt(ic) === 58) {
                        s3 = L;
                        ic++
                    } else {
                        s3 = h;
                        if (il === 0) {
                            peg$fail(M)
                        }
                    }
                    if (s3 !== h) {
                        s4 = peg$parsepassword();
                        if (s4 !== h) {
                            s3 = [s3, s4];
                            s2 = s3
                        } else {
                            ic = s2;
                            s2 = h
                        }
                    } else {
                        ic = s2;
                        s2 = h
                    }
                    if (s2 === h) {
                        s2 = null
                    }
                    if (s2 !== h) {
                        if (f.charCodeAt(ic) === 64) {
                            s3 = N;
                            ic++
                        } else {
                            s3 = h;
                            if (il === 0) {
                                peg$fail(O)
                            }
                        }
                        if (s3 !== h) {
                            id = a;
                            s1 = cE();
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseuser() {
                var a, s1;
                a = [];
                s1 = peg$parseunreserved();
                if (s1 === h) {
                    s1 = peg$parseescaped();
                    if (s1 === h) {
                        s1 = peg$parseuser_unreserved()
                    }
                }
                if (s1 !== h) {
                    while (s1 !== h) {
                        a.push(s1);
                        s1 = peg$parseunreserved();
                        if (s1 === h) {
                            s1 = peg$parseescaped();
                            if (s1 === h) {
                                s1 = peg$parseuser_unreserved()
                            }
                        }
                    }
                } else {
                    a = h
                }
                return a
            }

            function peg$parseuser_unreserved() {
                var a;
                if (f.charCodeAt(ic) === 38) {
                    a = P;
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(Q)
                    }
                }
                if (a === h) {
                    if (f.charCodeAt(ic) === 61) {
                        a = R;
                        ic++
                    } else {
                        a = h;
                        if (il === 0) {
                            peg$fail(S)
                        }
                    }
                    if (a === h) {
                        if (f.charCodeAt(ic) === 43) {
                            a = T;
                            ic++
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(U)
                            }
                        }
                        if (a === h) {
                            if (f.charCodeAt(ic) === 36) {
                                a = V;
                                ic++
                            } else {
                                a = h;
                                if (il === 0) {
                                    peg$fail(W)
                                }
                            }
                            if (a === h) {
                                if (f.charCodeAt(ic) === 44) {
                                    a = X;
                                    ic++
                                } else {
                                    a = h;
                                    if (il === 0) {
                                        peg$fail(Y)
                                    }
                                }
                                if (a === h) {
                                    if (f.charCodeAt(ic) === 59) {
                                        a = F;
                                        ic++
                                    } else {
                                        a = h;
                                        if (il === 0) {
                                            peg$fail(G)
                                        }
                                    }
                                    if (a === h) {
                                        if (f.charCodeAt(ic) === 63) {
                                            a = J;
                                            ic++
                                        } else {
                                            a = h;
                                            if (il === 0) {
                                                peg$fail(K)
                                            }
                                        }
                                        if (a === h) {
                                            if (f.charCodeAt(ic) === 47) {
                                                a = H;
                                                ic++
                                            } else {
                                                a = h;
                                                if (il === 0) {
                                                    peg$fail(I)
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parsepassword() {
                var a, s1, s2;
                a = ic;
                s1 = [];
                s2 = peg$parseunreserved();
                if (s2 === h) {
                    s2 = peg$parseescaped();
                    if (s2 === h) {
                        if (f.charCodeAt(ic) === 38) {
                            s2 = P;
                            ic++
                        } else {
                            s2 = h;
                            if (il === 0) {
                                peg$fail(Q)
                            }
                        }
                        if (s2 === h) {
                            if (f.charCodeAt(ic) === 61) {
                                s2 = R;
                                ic++
                            } else {
                                s2 = h;
                                if (il === 0) {
                                    peg$fail(S)
                                }
                            }
                            if (s2 === h) {
                                if (f.charCodeAt(ic) === 43) {
                                    s2 = T;
                                    ic++
                                } else {
                                    s2 = h;
                                    if (il === 0) {
                                        peg$fail(U)
                                    }
                                }
                                if (s2 === h) {
                                    if (f.charCodeAt(ic) === 36) {
                                        s2 = V;
                                        ic++
                                    } else {
                                        s2 = h;
                                        if (il === 0) {
                                            peg$fail(W)
                                        }
                                    }
                                    if (s2 === h) {
                                        if (f.charCodeAt(ic) === 44) {
                                            s2 = X;
                                            ic++
                                        } else {
                                            s2 = h;
                                            if (il === 0) {
                                                peg$fail(Y)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                while (s2 !== h) {
                    s1.push(s2);
                    s2 = peg$parseunreserved();
                    if (s2 === h) {
                        s2 = peg$parseescaped();
                        if (s2 === h) {
                            if (f.charCodeAt(ic) === 38) {
                                s2 = P;
                                ic++
                            } else {
                                s2 = h;
                                if (il === 0) {
                                    peg$fail(Q)
                                }
                            }
                            if (s2 === h) {
                                if (f.charCodeAt(ic) === 61) {
                                    s2 = R;
                                    ic++
                                } else {
                                    s2 = h;
                                    if (il === 0) {
                                        peg$fail(S)
                                    }
                                }
                                if (s2 === h) {
                                    if (f.charCodeAt(ic) === 43) {
                                        s2 = T;
                                        ic++
                                    } else {
                                        s2 = h;
                                        if (il === 0) {
                                            peg$fail(U)
                                        }
                                    }
                                    if (s2 === h) {
                                        if (f.charCodeAt(ic) === 36) {
                                            s2 = V;
                                            ic++
                                        } else {
                                            s2 = h;
                                            if (il === 0) {
                                                peg$fail(W)
                                            }
                                        }
                                        if (s2 === h) {
                                            if (f.charCodeAt(ic) === 44) {
                                                s2 = X;
                                                ic++
                                            } else {
                                                s2 = h;
                                                if (il === 0) {
                                                    peg$fail(Y)
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = cF()
                }
                a = s1;
                return a
            }

            function peg$parsehostport() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = peg$parsehost();
                if (s1 !== h) {
                    s2 = ic;
                    if (f.charCodeAt(ic) === 58) {
                        s3 = L;
                        ic++
                    } else {
                        s3 = h;
                        if (il === 0) {
                            peg$fail(M)
                        }
                    }
                    if (s3 !== h) {
                        s4 = peg$parseport();
                        if (s4 !== h) {
                            s3 = [s3, s4];
                            s2 = s3
                        } else {
                            ic = s2;
                            s2 = h
                        }
                    } else {
                        ic = s2;
                        s2 = h
                    }
                    if (s2 === h) {
                        s2 = null
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsehost() {
                var a, s1;
                a = ic;
                s1 = peg$parsehostname();
                if (s1 === h) {
                    s1 = peg$parseIPv4address();
                    if (s1 === h) {
                        s1 = peg$parseIPv6reference()
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = cG()
                }
                a = s1;
                return a
            }

            function peg$parsehostname() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = [];
                s2 = ic;
                s3 = peg$parsedomainlabel();
                if (s3 !== h) {
                    if (f.charCodeAt(ic) === 46) {
                        s4 = bh;
                        ic++
                    } else {
                        s4 = h;
                        if (il === 0) {
                            peg$fail(bi)
                        }
                    }
                    if (s4 !== h) {
                        s3 = [s3, s4];
                        s2 = s3
                    } else {
                        ic = s2;
                        s2 = h
                    }
                } else {
                    ic = s2;
                    s2 = h
                }
                while (s2 !== h) {
                    s1.push(s2);
                    s2 = ic;
                    s3 = peg$parsedomainlabel();
                    if (s3 !== h) {
                        if (f.charCodeAt(ic) === 46) {
                            s4 = bh;
                            ic++
                        } else {
                            s4 = h;
                            if (il === 0) {
                                peg$fail(bi)
                            }
                        }
                        if (s4 !== h) {
                            s3 = [s3, s4];
                            s2 = s3
                        } else {
                            ic = s2;
                            s2 = h
                        }
                    } else {
                        ic = s2;
                        s2 = h
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parsetoplabel();
                    if (s2 !== h) {
                        if (f.charCodeAt(ic) === 46) {
                            s3 = bh;
                            ic++
                        } else {
                            s3 = h;
                            if (il === 0) {
                                peg$fail(bi)
                            }
                        }
                        if (s3 === h) {
                            s3 = null
                        }
                        if (s3 !== h) {
                            id = a;
                            s1 = cH();
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsedomainlabel() {
                var a, s1;
                a = [];
                if (cI.test(f.charAt(ic))) {
                    s1 = f.charAt(ic);
                    ic++
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(cJ)
                    }
                }
                if (s1 !== h) {
                    while (s1 !== h) {
                        a.push(s1);
                        if (cI.test(f.charAt(ic))) {
                            s1 = f.charAt(ic);
                            ic++
                        } else {
                            s1 = h;
                            if (il === 0) {
                                peg$fail(cJ)
                            }
                        }
                    }
                } else {
                    a = h
                }
                return a
            }

            function peg$parsetoplabel() {
                var a, s1, s2, s3;
                a = ic;
                if (o.test(f.charAt(ic))) {
                    s1 = f.charAt(ic);
                    ic++
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(s)
                    }
                }
                if (s1 !== h) {
                    s2 = [];
                    if (cK.test(f.charAt(ic))) {
                        s3 = f.charAt(ic);
                        ic++
                    } else {
                        s3 = h;
                        if (il === 0) {
                            peg$fail(cL)
                        }
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        if (cK.test(f.charAt(ic))) {
                            s3 = f.charAt(ic);
                            ic++
                        } else {
                            s3 = h;
                            if (il === 0) {
                                peg$fail(cL)
                            }
                        }
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseIPv6reference() {
                var a, s1, s2, s3;
                a = ic;
                if (f.charCodeAt(ic) === 91) {
                    s1 = bP;
                    ic++
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(bQ)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseIPv6address();
                    if (s2 !== h) {
                        if (f.charCodeAt(ic) === 93) {
                            s3 = bR;
                            ic++
                        } else {
                            s3 = h;
                            if (il === 0) {
                                peg$fail(bS)
                            }
                        }
                        if (s3 !== h) {
                            id = a;
                            s1 = cM();
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseIPv6address() {
                var a, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14;
                a = ic;
                s1 = ic;
                s2 = peg$parseh16();
                if (s2 !== h) {
                    if (f.charCodeAt(ic) === 58) {
                        s3 = L;
                        ic++
                    } else {
                        s3 = h;
                        if (il === 0) {
                            peg$fail(M)
                        }
                    }
                    if (s3 !== h) {
                        s4 = peg$parseh16();
                        if (s4 !== h) {
                            if (f.charCodeAt(ic) === 58) {
                                s5 = L;
                                ic++
                            } else {
                                s5 = h;
                                if (il === 0) {
                                    peg$fail(M)
                                }
                            }
                            if (s5 !== h) {
                                s6 = peg$parseh16();
                                if (s6 !== h) {
                                    if (f.charCodeAt(ic) === 58) {
                                        s7 = L;
                                        ic++
                                    } else {
                                        s7 = h;
                                        if (il === 0) {
                                            peg$fail(M)
                                        }
                                    }
                                    if (s7 !== h) {
                                        s8 = peg$parseh16();
                                        if (s8 !== h) {
                                            if (f.charCodeAt(ic) === 58) {
                                                s9 = L;
                                                ic++
                                            } else {
                                                s9 = h;
                                                if (il === 0) {
                                                    peg$fail(M)
                                                }
                                            }
                                            if (s9 !== h) {
                                                s10 = peg$parseh16();
                                                if (s10 !== h) {
                                                    if (f.charCodeAt(ic) === 58) {
                                                        s11 = L;
                                                        ic++
                                                    } else {
                                                        s11 = h;
                                                        if (il === 0) {
                                                            peg$fail(M)
                                                        }
                                                    }
                                                    if (s11 !== h) {
                                                        s12 = peg$parseh16();
                                                        if (s12 !== h) {
                                                            if (f.charCodeAt(ic) === 58) {
                                                                s13 = L;
                                                                ic++
                                                            } else {
                                                                s13 = h;
                                                                if (il === 0) {
                                                                    peg$fail(M)
                                                                }
                                                            }
                                                            if (s13 !== h) {
                                                                s14 = peg$parsels32();
                                                                if (s14 !== h) {
                                                                    s2 = [s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14];
                                                                    s1 = s2
                                                                } else {
                                                                    ic = s1;
                                                                    s1 = h
                                                                }
                                                            } else {
                                                                ic = s1;
                                                                s1 = h
                                                            }
                                                        } else {
                                                            ic = s1;
                                                            s1 = h
                                                        }
                                                    } else {
                                                        ic = s1;
                                                        s1 = h
                                                    }
                                                } else {
                                                    ic = s1;
                                                    s1 = h
                                                }
                                            } else {
                                                ic = s1;
                                                s1 = h
                                            }
                                        } else {
                                            ic = s1;
                                            s1 = h
                                        }
                                    } else {
                                        ic = s1;
                                        s1 = h
                                    }
                                } else {
                                    ic = s1;
                                    s1 = h
                                }
                            } else {
                                ic = s1;
                                s1 = h
                            }
                        } else {
                            ic = s1;
                            s1 = h
                        }
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 === h) {
                    s1 = ic;
                    if (f.substr(ic, 2) === cN) {
                        s2 = cN;
                        ic += 2
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(cO)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseh16();
                        if (s3 !== h) {
                            if (f.charCodeAt(ic) === 58) {
                                s4 = L;
                                ic++
                            } else {
                                s4 = h;
                                if (il === 0) {
                                    peg$fail(M)
                                }
                            }
                            if (s4 !== h) {
                                s5 = peg$parseh16();
                                if (s5 !== h) {
                                    if (f.charCodeAt(ic) === 58) {
                                        s6 = L;
                                        ic++
                                    } else {
                                        s6 = h;
                                        if (il === 0) {
                                            peg$fail(M)
                                        }
                                    }
                                    if (s6 !== h) {
                                        s7 = peg$parseh16();
                                        if (s7 !== h) {
                                            if (f.charCodeAt(ic) === 58) {
                                                s8 = L;
                                                ic++
                                            } else {
                                                s8 = h;
                                                if (il === 0) {
                                                    peg$fail(M)
                                                }
                                            }
                                            if (s8 !== h) {
                                                s9 = peg$parseh16();
                                                if (s9 !== h) {
                                                    if (f.charCodeAt(ic) === 58) {
                                                        s10 = L;
                                                        ic++
                                                    } else {
                                                        s10 = h;
                                                        if (il === 0) {
                                                            peg$fail(M)
                                                        }
                                                    }
                                                    if (s10 !== h) {
                                                        s11 = peg$parseh16();
                                                        if (s11 !== h) {
                                                            if (f.charCodeAt(ic) === 58) {
                                                                s12 = L;
                                                                ic++
                                                            } else {
                                                                s12 = h;
                                                                if (il === 0) {
                                                                    peg$fail(M)
                                                                }
                                                            }
                                                            if (s12 !== h) {
                                                                s13 = peg$parsels32();
                                                                if (s13 !== h) {
                                                                    s2 = [s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13];
                                                                    s1 = s2
                                                                } else {
                                                                    ic = s1;
                                                                    s1 = h
                                                                }
                                                            } else {
                                                                ic = s1;
                                                                s1 = h
                                                            }
                                                        } else {
                                                            ic = s1;
                                                            s1 = h
                                                        }
                                                    } else {
                                                        ic = s1;
                                                        s1 = h
                                                    }
                                                } else {
                                                    ic = s1;
                                                    s1 = h
                                                }
                                            } else {
                                                ic = s1;
                                                s1 = h
                                            }
                                        } else {
                                            ic = s1;
                                            s1 = h
                                        }
                                    } else {
                                        ic = s1;
                                        s1 = h
                                    }
                                } else {
                                    ic = s1;
                                    s1 = h
                                }
                            } else {
                                ic = s1;
                                s1 = h
                            }
                        } else {
                            ic = s1;
                            s1 = h
                        }
                    } else {
                        ic = s1;
                        s1 = h
                    }
                    if (s1 === h) {
                        s1 = ic;
                        if (f.substr(ic, 2) === cN) {
                            s2 = cN;
                            ic += 2
                        } else {
                            s2 = h;
                            if (il === 0) {
                                peg$fail(cO)
                            }
                        }
                        if (s2 !== h) {
                            s3 = peg$parseh16();
                            if (s3 !== h) {
                                if (f.charCodeAt(ic) === 58) {
                                    s4 = L;
                                    ic++
                                } else {
                                    s4 = h;
                                    if (il === 0) {
                                        peg$fail(M)
                                    }
                                }
                                if (s4 !== h) {
                                    s5 = peg$parseh16();
                                    if (s5 !== h) {
                                        if (f.charCodeAt(ic) === 58) {
                                            s6 = L;
                                            ic++
                                        } else {
                                            s6 = h;
                                            if (il === 0) {
                                                peg$fail(M)
                                            }
                                        }
                                        if (s6 !== h) {
                                            s7 = peg$parseh16();
                                            if (s7 !== h) {
                                                if (f.charCodeAt(ic) === 58) {
                                                    s8 = L;
                                                    ic++
                                                } else {
                                                    s8 = h;
                                                    if (il === 0) {
                                                        peg$fail(M)
                                                    }
                                                }
                                                if (s8 !== h) {
                                                    s9 = peg$parseh16();
                                                    if (s9 !== h) {
                                                        if (f.charCodeAt(ic) === 58) {
                                                            s10 = L;
                                                            ic++
                                                        } else {
                                                            s10 = h;
                                                            if (il === 0) {
                                                                peg$fail(M)
                                                            }
                                                        }
                                                        if (s10 !== h) {
                                                            s11 = peg$parsels32();
                                                            if (s11 !== h) {
                                                                s2 = [s2, s3, s4, s5, s6, s7, s8, s9, s10, s11];
                                                                s1 = s2
                                                            } else {
                                                                ic = s1;
                                                                s1 = h
                                                            }
                                                        } else {
                                                            ic = s1;
                                                            s1 = h
                                                        }
                                                    } else {
                                                        ic = s1;
                                                        s1 = h
                                                    }
                                                } else {
                                                    ic = s1;
                                                    s1 = h
                                                }
                                            } else {
                                                ic = s1;
                                                s1 = h
                                            }
                                        } else {
                                            ic = s1;
                                            s1 = h
                                        }
                                    } else {
                                        ic = s1;
                                        s1 = h
                                    }
                                } else {
                                    ic = s1;
                                    s1 = h
                                }
                            } else {
                                ic = s1;
                                s1 = h
                            }
                        } else {
                            ic = s1;
                            s1 = h
                        }
                        if (s1 === h) {
                            s1 = ic;
                            if (f.substr(ic, 2) === cN) {
                                s2 = cN;
                                ic += 2
                            } else {
                                s2 = h;
                                if (il === 0) {
                                    peg$fail(cO)
                                }
                            }
                            if (s2 !== h) {
                                s3 = peg$parseh16();
                                if (s3 !== h) {
                                    if (f.charCodeAt(ic) === 58) {
                                        s4 = L;
                                        ic++
                                    } else {
                                        s4 = h;
                                        if (il === 0) {
                                            peg$fail(M)
                                        }
                                    }
                                    if (s4 !== h) {
                                        s5 = peg$parseh16();
                                        if (s5 !== h) {
                                            if (f.charCodeAt(ic) === 58) {
                                                s6 = L;
                                                ic++
                                            } else {
                                                s6 = h;
                                                if (il === 0) {
                                                    peg$fail(M)
                                                }
                                            }
                                            if (s6 !== h) {
                                                s7 = peg$parseh16();
                                                if (s7 !== h) {
                                                    if (f.charCodeAt(ic) === 58) {
                                                        s8 = L;
                                                        ic++
                                                    } else {
                                                        s8 = h;
                                                        if (il === 0) {
                                                            peg$fail(M)
                                                        }
                                                    }
                                                    if (s8 !== h) {
                                                        s9 = peg$parsels32();
                                                        if (s9 !== h) {
                                                            s2 = [s2, s3, s4, s5, s6, s7, s8, s9];
                                                            s1 = s2
                                                        } else {
                                                            ic = s1;
                                                            s1 = h
                                                        }
                                                    } else {
                                                        ic = s1;
                                                        s1 = h
                                                    }
                                                } else {
                                                    ic = s1;
                                                    s1 = h
                                                }
                                            } else {
                                                ic = s1;
                                                s1 = h
                                            }
                                        } else {
                                            ic = s1;
                                            s1 = h
                                        }
                                    } else {
                                        ic = s1;
                                        s1 = h
                                    }
                                } else {
                                    ic = s1;
                                    s1 = h
                                }
                            } else {
                                ic = s1;
                                s1 = h
                            }
                            if (s1 === h) {
                                s1 = ic;
                                if (f.substr(ic, 2) === cN) {
                                    s2 = cN;
                                    ic += 2
                                } else {
                                    s2 = h;
                                    if (il === 0) {
                                        peg$fail(cO)
                                    }
                                }
                                if (s2 !== h) {
                                    s3 = peg$parseh16();
                                    if (s3 !== h) {
                                        if (f.charCodeAt(ic) === 58) {
                                            s4 = L;
                                            ic++
                                        } else {
                                            s4 = h;
                                            if (il === 0) {
                                                peg$fail(M)
                                            }
                                        }
                                        if (s4 !== h) {
                                            s5 = peg$parseh16();
                                            if (s5 !== h) {
                                                if (f.charCodeAt(ic) === 58) {
                                                    s6 = L;
                                                    ic++
                                                } else {
                                                    s6 = h;
                                                    if (il === 0) {
                                                        peg$fail(M)
                                                    }
                                                }
                                                if (s6 !== h) {
                                                    s7 = peg$parsels32();
                                                    if (s7 !== h) {
                                                        s2 = [s2, s3, s4, s5, s6, s7];
                                                        s1 = s2
                                                    } else {
                                                        ic = s1;
                                                        s1 = h
                                                    }
                                                } else {
                                                    ic = s1;
                                                    s1 = h
                                                }
                                            } else {
                                                ic = s1;
                                                s1 = h
                                            }
                                        } else {
                                            ic = s1;
                                            s1 = h
                                        }
                                    } else {
                                        ic = s1;
                                        s1 = h
                                    }
                                } else {
                                    ic = s1;
                                    s1 = h
                                }
                                if (s1 === h) {
                                    s1 = ic;
                                    if (f.substr(ic, 2) === cN) {
                                        s2 = cN;
                                        ic += 2
                                    } else {
                                        s2 = h;
                                        if (il === 0) {
                                            peg$fail(cO)
                                        }
                                    }
                                    if (s2 !== h) {
                                        s3 = peg$parseh16();
                                        if (s3 !== h) {
                                            if (f.charCodeAt(ic) === 58) {
                                                s4 = L;
                                                ic++
                                            } else {
                                                s4 = h;
                                                if (il === 0) {
                                                    peg$fail(M)
                                                }
                                            }
                                            if (s4 !== h) {
                                                s5 = peg$parsels32();
                                                if (s5 !== h) {
                                                    s2 = [s2, s3, s4, s5];
                                                    s1 = s2
                                                } else {
                                                    ic = s1;
                                                    s1 = h
                                                }
                                            } else {
                                                ic = s1;
                                                s1 = h
                                            }
                                        } else {
                                            ic = s1;
                                            s1 = h
                                        }
                                    } else {
                                        ic = s1;
                                        s1 = h
                                    }
                                    if (s1 === h) {
                                        s1 = ic;
                                        if (f.substr(ic, 2) === cN) {
                                            s2 = cN;
                                            ic += 2
                                        } else {
                                            s2 = h;
                                            if (il === 0) {
                                                peg$fail(cO)
                                            }
                                        }
                                        if (s2 !== h) {
                                            s3 = peg$parsels32();
                                            if (s3 !== h) {
                                                s2 = [s2, s3];
                                                s1 = s2
                                            } else {
                                                ic = s1;
                                                s1 = h
                                            }
                                        } else {
                                            ic = s1;
                                            s1 = h
                                        }
                                        if (s1 === h) {
                                            s1 = ic;
                                            if (f.substr(ic, 2) === cN) {
                                                s2 = cN;
                                                ic += 2
                                            } else {
                                                s2 = h;
                                                if (il === 0) {
                                                    peg$fail(cO)
                                                }
                                            }
                                            if (s2 !== h) {
                                                s3 = peg$parseh16();
                                                if (s3 !== h) {
                                                    s2 = [s2, s3];
                                                    s1 = s2
                                                } else {
                                                    ic = s1;
                                                    s1 = h
                                                }
                                            } else {
                                                ic = s1;
                                                s1 = h
                                            }
                                            if (s1 === h) {
                                                s1 = ic;
                                                s2 = peg$parseh16();
                                                if (s2 !== h) {
                                                    if (f.substr(ic, 2) === cN) {
                                                        s3 = cN;
                                                        ic += 2
                                                    } else {
                                                        s3 = h;
                                                        if (il === 0) {
                                                            peg$fail(cO)
                                                        }
                                                    }
                                                    if (s3 !== h) {
                                                        s4 = peg$parseh16();
                                                        if (s4 !== h) {
                                                            if (f.charCodeAt(ic) === 58) {
                                                                s5 = L;
                                                                ic++
                                                            } else {
                                                                s5 = h;
                                                                if (il === 0) {
                                                                    peg$fail(M)
                                                                }
                                                            }
                                                            if (s5 !== h) {
                                                                s6 = peg$parseh16();
                                                                if (s6 !== h) {
                                                                    if (f.charCodeAt(ic) === 58) {
                                                                        s7 = L;
                                                                        ic++
                                                                    } else {
                                                                        s7 = h;
                                                                        if (il === 0) {
                                                                            peg$fail(M)
                                                                        }
                                                                    }
                                                                    if (s7 !== h) {
                                                                        s8 = peg$parseh16();
                                                                        if (s8 !== h) {
                                                                            if (f.charCodeAt(ic) === 58) {
                                                                                s9 = L;
                                                                                ic++
                                                                            } else {
                                                                                s9 = h;
                                                                                if (il === 0) {
                                                                                    peg$fail(M)
                                                                                }
                                                                            }
                                                                            if (s9 !== h) {
                                                                                s10 = peg$parseh16();
                                                                                if (s10 !== h) {
                                                                                    if (f.charCodeAt(ic) === 58) {
                                                                                        s11 = L;
                                                                                        ic++
                                                                                    } else {
                                                                                        s11 = h;
                                                                                        if (il === 0) {
                                                                                            peg$fail(M)
                                                                                        }
                                                                                    }
                                                                                    if (s11 !== h) {
                                                                                        s12 = peg$parsels32();
                                                                                        if (s12 !== h) {
                                                                                            s2 = [s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12];
                                                                                            s1 = s2
                                                                                        } else {
                                                                                            ic = s1;
                                                                                            s1 = h
                                                                                        }
                                                                                    } else {
                                                                                        ic = s1;
                                                                                        s1 = h
                                                                                    }
                                                                                } else {
                                                                                    ic = s1;
                                                                                    s1 = h
                                                                                }
                                                                            } else {
                                                                                ic = s1;
                                                                                s1 = h
                                                                            }
                                                                        } else {
                                                                            ic = s1;
                                                                            s1 = h
                                                                        }
                                                                    } else {
                                                                        ic = s1;
                                                                        s1 = h
                                                                    }
                                                                } else {
                                                                    ic = s1;
                                                                    s1 = h
                                                                }
                                                            } else {
                                                                ic = s1;
                                                                s1 = h
                                                            }
                                                        } else {
                                                            ic = s1;
                                                            s1 = h
                                                        }
                                                    } else {
                                                        ic = s1;
                                                        s1 = h
                                                    }
                                                } else {
                                                    ic = s1;
                                                    s1 = h
                                                }
                                                if (s1 === h) {
                                                    s1 = ic;
                                                    s2 = peg$parseh16();
                                                    if (s2 !== h) {
                                                        s3 = ic;
                                                        if (f.charCodeAt(ic) === 58) {
                                                            s4 = L;
                                                            ic++
                                                        } else {
                                                            s4 = h;
                                                            if (il === 0) {
                                                                peg$fail(M)
                                                            }
                                                        }
                                                        if (s4 !== h) {
                                                            s5 = peg$parseh16();
                                                            if (s5 !== h) {
                                                                s4 = [s4, s5];
                                                                s3 = s4
                                                            } else {
                                                                ic = s3;
                                                                s3 = h
                                                            }
                                                        } else {
                                                            ic = s3;
                                                            s3 = h
                                                        }
                                                        if (s3 === h) {
                                                            s3 = null
                                                        }
                                                        if (s3 !== h) {
                                                            if (f.substr(ic, 2) === cN) {
                                                                s4 = cN;
                                                                ic += 2
                                                            } else {
                                                                s4 = h;
                                                                if (il === 0) {
                                                                    peg$fail(cO)
                                                                }
                                                            }
                                                            if (s4 !== h) {
                                                                s5 = peg$parseh16();
                                                                if (s5 !== h) {
                                                                    if (f.charCodeAt(ic) === 58) {
                                                                        s6 = L;
                                                                        ic++
                                                                    } else {
                                                                        s6 = h;
                                                                        if (il === 0) {
                                                                            peg$fail(M)
                                                                        }
                                                                    }
                                                                    if (s6 !== h) {
                                                                        s7 = peg$parseh16();
                                                                        if (s7 !== h) {
                                                                            if (f.charCodeAt(ic) === 58) {
                                                                                s8 = L;
                                                                                ic++
                                                                            } else {
                                                                                s8 = h;
                                                                                if (il === 0) {
                                                                                    peg$fail(M)
                                                                                }
                                                                            }
                                                                            if (s8 !== h) {
                                                                                s9 = peg$parseh16();
                                                                                if (s9 !== h) {
                                                                                    if (f.charCodeAt(ic) === 58) {
                                                                                        s10 = L;
                                                                                        ic++
                                                                                    } else {
                                                                                        s10 = h;
                                                                                        if (il === 0) {
                                                                                            peg$fail(M)
                                                                                        }
                                                                                    }
                                                                                    if (s10 !== h) {
                                                                                        s11 = peg$parsels32();
                                                                                        if (s11 !== h) {
                                                                                            s2 = [s2, s3, s4, s5, s6, s7, s8, s9, s10, s11];
                                                                                            s1 = s2
                                                                                        } else {
                                                                                            ic = s1;
                                                                                            s1 = h
                                                                                        }
                                                                                    } else {
                                                                                        ic = s1;
                                                                                        s1 = h
                                                                                    }
                                                                                } else {
                                                                                    ic = s1;
                                                                                    s1 = h
                                                                                }
                                                                            } else {
                                                                                ic = s1;
                                                                                s1 = h
                                                                            }
                                                                        } else {
                                                                            ic = s1;
                                                                            s1 = h
                                                                        }
                                                                    } else {
                                                                        ic = s1;
                                                                        s1 = h
                                                                    }
                                                                } else {
                                                                    ic = s1;
                                                                    s1 = h
                                                                }
                                                            } else {
                                                                ic = s1;
                                                                s1 = h
                                                            }
                                                        } else {
                                                            ic = s1;
                                                            s1 = h
                                                        }
                                                    } else {
                                                        ic = s1;
                                                        s1 = h
                                                    }
                                                    if (s1 === h) {
                                                        s1 = ic;
                                                        s2 = peg$parseh16();
                                                        if (s2 !== h) {
                                                            s3 = ic;
                                                            if (f.charCodeAt(ic) === 58) {
                                                                s4 = L;
                                                                ic++
                                                            } else {
                                                                s4 = h;
                                                                if (il === 0) {
                                                                    peg$fail(M)
                                                                }
                                                            }
                                                            if (s4 !== h) {
                                                                s5 = peg$parseh16();
                                                                if (s5 !== h) {
                                                                    s4 = [s4, s5];
                                                                    s3 = s4
                                                                } else {
                                                                    ic = s3;
                                                                    s3 = h
                                                                }
                                                            } else {
                                                                ic = s3;
                                                                s3 = h
                                                            }
                                                            if (s3 === h) {
                                                                s3 = null
                                                            }
                                                            if (s3 !== h) {
                                                                s4 = ic;
                                                                if (f.charCodeAt(ic) === 58) {
                                                                    s5 = L;
                                                                    ic++
                                                                } else {
                                                                    s5 = h;
                                                                    if (il === 0) {
                                                                        peg$fail(M)
                                                                    }
                                                                }
                                                                if (s5 !== h) {
                                                                    s6 = peg$parseh16();
                                                                    if (s6 !== h) {
                                                                        s5 = [s5, s6];
                                                                        s4 = s5
                                                                    } else {
                                                                        ic = s4;
                                                                        s4 = h
                                                                    }
                                                                } else {
                                                                    ic = s4;
                                                                    s4 = h
                                                                }
                                                                if (s4 === h) {
                                                                    s4 = null
                                                                }
                                                                if (s4 !== h) {
                                                                    if (f.substr(ic, 2) === cN) {
                                                                        s5 = cN;
                                                                        ic += 2
                                                                    } else {
                                                                        s5 = h;
                                                                        if (il === 0) {
                                                                            peg$fail(cO)
                                                                        }
                                                                    }
                                                                    if (s5 !== h) {
                                                                        s6 = peg$parseh16();
                                                                        if (s6 !== h) {
                                                                            if (f.charCodeAt(ic) === 58) {
                                                                                s7 = L;
                                                                                ic++
                                                                            } else {
                                                                                s7 = h;
                                                                                if (il === 0) {
                                                                                    peg$fail(M)
                                                                                }
                                                                            }
                                                                            if (s7 !== h) {
                                                                                s8 = peg$parseh16();
                                                                                if (s8 !== h) {
                                                                                    if (f.charCodeAt(ic) === 58) {
                                                                                        s9 = L;
                                                                                        ic++
                                                                                    } else {
                                                                                        s9 = h;
                                                                                        if (il === 0) {
                                                                                            peg$fail(M)
                                                                                        }
                                                                                    }
                                                                                    if (s9 !== h) {
                                                                                        s10 = peg$parsels32();
                                                                                        if (s10 !== h) {
                                                                                            s2 = [s2, s3, s4, s5, s6, s7, s8, s9, s10];
                                                                                            s1 = s2
                                                                                        } else {
                                                                                            ic = s1;
                                                                                            s1 = h
                                                                                        }
                                                                                    } else {
                                                                                        ic = s1;
                                                                                        s1 = h
                                                                                    }
                                                                                } else {
                                                                                    ic = s1;
                                                                                    s1 = h
                                                                                }
                                                                            } else {
                                                                                ic = s1;
                                                                                s1 = h
                                                                            }
                                                                        } else {
                                                                            ic = s1;
                                                                            s1 = h
                                                                        }
                                                                    } else {
                                                                        ic = s1;
                                                                        s1 = h
                                                                    }
                                                                } else {
                                                                    ic = s1;
                                                                    s1 = h
                                                                }
                                                            } else {
                                                                ic = s1;
                                                                s1 = h
                                                            }
                                                        } else {
                                                            ic = s1;
                                                            s1 = h
                                                        }
                                                        if (s1 === h) {
                                                            s1 = ic;
                                                            s2 = peg$parseh16();
                                                            if (s2 !== h) {
                                                                s3 = ic;
                                                                if (f.charCodeAt(ic) === 58) {
                                                                    s4 = L;
                                                                    ic++
                                                                } else {
                                                                    s4 = h;
                                                                    if (il === 0) {
                                                                        peg$fail(M)
                                                                    }
                                                                }
                                                                if (s4 !== h) {
                                                                    s5 = peg$parseh16();
                                                                    if (s5 !== h) {
                                                                        s4 = [s4, s5];
                                                                        s3 = s4
                                                                    } else {
                                                                        ic = s3;
                                                                        s3 = h
                                                                    }
                                                                } else {
                                                                    ic = s3;
                                                                    s3 = h
                                                                }
                                                                if (s3 === h) {
                                                                    s3 = null
                                                                }
                                                                if (s3 !== h) {
                                                                    s4 = ic;
                                                                    if (f.charCodeAt(ic) === 58) {
                                                                        s5 = L;
                                                                        ic++
                                                                    } else {
                                                                        s5 = h;
                                                                        if (il === 0) {
                                                                            peg$fail(M)
                                                                        }
                                                                    }
                                                                    if (s5 !== h) {
                                                                        s6 = peg$parseh16();
                                                                        if (s6 !== h) {
                                                                            s5 = [s5, s6];
                                                                            s4 = s5
                                                                        } else {
                                                                            ic = s4;
                                                                            s4 = h
                                                                        }
                                                                    } else {
                                                                        ic = s4;
                                                                        s4 = h
                                                                    }
                                                                    if (s4 === h) {
                                                                        s4 = null
                                                                    }
                                                                    if (s4 !== h) {
                                                                        s5 = ic;
                                                                        if (f.charCodeAt(ic) === 58) {
                                                                            s6 = L;
                                                                            ic++
                                                                        } else {
                                                                            s6 = h;
                                                                            if (il === 0) {
                                                                                peg$fail(M)
                                                                            }
                                                                        }
                                                                        if (s6 !== h) {
                                                                            s7 = peg$parseh16();
                                                                            if (s7 !== h) {
                                                                                s6 = [s6, s7];
                                                                                s5 = s6
                                                                            } else {
                                                                                ic = s5;
                                                                                s5 = h
                                                                            }
                                                                        } else {
                                                                            ic = s5;
                                                                            s5 = h
                                                                        }
                                                                        if (s5 === h) {
                                                                            s5 = null
                                                                        }
                                                                        if (s5 !== h) {
                                                                            if (f.substr(ic, 2) === cN) {
                                                                                s6 = cN;
                                                                                ic += 2
                                                                            } else {
                                                                                s6 = h;
                                                                                if (il === 0) {
                                                                                    peg$fail(cO)
                                                                                }
                                                                            }
                                                                            if (s6 !== h) {
                                                                                s7 = peg$parseh16();
                                                                                if (s7 !== h) {
                                                                                    if (f.charCodeAt(ic) === 58) {
                                                                                        s8 = L;
                                                                                        ic++
                                                                                    } else {
                                                                                        s8 = h;
                                                                                        if (il === 0) {
                                                                                            peg$fail(M)
                                                                                        }
                                                                                    }
                                                                                    if (s8 !== h) {
                                                                                        s9 = peg$parsels32();
                                                                                        if (s9 !== h) {
                                                                                            s2 = [s2, s3, s4, s5, s6, s7, s8, s9];
                                                                                            s1 = s2
                                                                                        } else {
                                                                                            ic = s1;
                                                                                            s1 = h
                                                                                        }
                                                                                    } else {
                                                                                        ic = s1;
                                                                                        s1 = h
                                                                                    }
                                                                                } else {
                                                                                    ic = s1;
                                                                                    s1 = h
                                                                                }
                                                                            } else {
                                                                                ic = s1;
                                                                                s1 = h
                                                                            }
                                                                        } else {
                                                                            ic = s1;
                                                                            s1 = h
                                                                        }
                                                                    } else {
                                                                        ic = s1;
                                                                        s1 = h
                                                                    }
                                                                } else {
                                                                    ic = s1;
                                                                    s1 = h
                                                                }
                                                            } else {
                                                                ic = s1;
                                                                s1 = h
                                                            }
                                                            if (s1 === h) {
                                                                s1 = ic;
                                                                s2 = peg$parseh16();
                                                                if (s2 !== h) {
                                                                    s3 = ic;
                                                                    if (f.charCodeAt(ic) === 58) {
                                                                        s4 = L;
                                                                        ic++
                                                                    } else {
                                                                        s4 = h;
                                                                        if (il === 0) {
                                                                            peg$fail(M)
                                                                        }
                                                                    }
                                                                    if (s4 !== h) {
                                                                        s5 = peg$parseh16();
                                                                        if (s5 !== h) {
                                                                            s4 = [s4, s5];
                                                                            s3 = s4
                                                                        } else {
                                                                            ic = s3;
                                                                            s3 = h
                                                                        }
                                                                    } else {
                                                                        ic = s3;
                                                                        s3 = h
                                                                    }
                                                                    if (s3 === h) {
                                                                        s3 = null
                                                                    }
                                                                    if (s3 !== h) {
                                                                        s4 = ic;
                                                                        if (f.charCodeAt(ic) === 58) {
                                                                            s5 = L;
                                                                            ic++
                                                                        } else {
                                                                            s5 = h;
                                                                            if (il === 0) {
                                                                                peg$fail(M)
                                                                            }
                                                                        }
                                                                        if (s5 !== h) {
                                                                            s6 = peg$parseh16();
                                                                            if (s6 !== h) {
                                                                                s5 = [s5, s6];
                                                                                s4 = s5
                                                                            } else {
                                                                                ic = s4;
                                                                                s4 = h
                                                                            }
                                                                        } else {
                                                                            ic = s4;
                                                                            s4 = h
                                                                        }
                                                                        if (s4 === h) {
                                                                            s4 = null
                                                                        }
                                                                        if (s4 !== h) {
                                                                            s5 = ic;
                                                                            if (f.charCodeAt(ic) === 58) {
                                                                                s6 = L;
                                                                                ic++
                                                                            } else {
                                                                                s6 = h;
                                                                                if (il === 0) {
                                                                                    peg$fail(M)
                                                                                }
                                                                            }
                                                                            if (s6 !== h) {
                                                                                s7 = peg$parseh16();
                                                                                if (s7 !== h) {
                                                                                    s6 = [s6, s7];
                                                                                    s5 = s6
                                                                                } else {
                                                                                    ic = s5;
                                                                                    s5 = h
                                                                                }
                                                                            } else {
                                                                                ic = s5;
                                                                                s5 = h
                                                                            }
                                                                            if (s5 === h) {
                                                                                s5 = null
                                                                            }
                                                                            if (s5 !== h) {
                                                                                s6 = ic;
                                                                                if (f.charCodeAt(ic) === 58) {
                                                                                    s7 = L;
                                                                                    ic++
                                                                                } else {
                                                                                    s7 = h;
                                                                                    if (il === 0) {
                                                                                        peg$fail(M)
                                                                                    }
                                                                                }
                                                                                if (s7 !== h) {
                                                                                    s8 = peg$parseh16();
                                                                                    if (s8 !== h) {
                                                                                        s7 = [s7, s8];
                                                                                        s6 = s7
                                                                                    } else {
                                                                                        ic = s6;
                                                                                        s6 = h
                                                                                    }
                                                                                } else {
                                                                                    ic = s6;
                                                                                    s6 = h
                                                                                }
                                                                                if (s6 === h) {
                                                                                    s6 = null
                                                                                }
                                                                                if (s6 !== h) {
                                                                                    if (f.substr(ic, 2) === cN) {
                                                                                        s7 = cN;
                                                                                        ic += 2
                                                                                    } else {
                                                                                        s7 = h;
                                                                                        if (il === 0) {
                                                                                            peg$fail(cO)
                                                                                        }
                                                                                    }
                                                                                    if (s7 !== h) {
                                                                                        s8 = peg$parsels32();
                                                                                        if (s8 !== h) {
                                                                                            s2 = [s2, s3, s4, s5, s6, s7, s8];
                                                                                            s1 = s2
                                                                                        } else {
                                                                                            ic = s1;
                                                                                            s1 = h
                                                                                        }
                                                                                    } else {
                                                                                        ic = s1;
                                                                                        s1 = h
                                                                                    }
                                                                                } else {
                                                                                    ic = s1;
                                                                                    s1 = h
                                                                                }
                                                                            } else {
                                                                                ic = s1;
                                                                                s1 = h
                                                                            }
                                                                        } else {
                                                                            ic = s1;
                                                                            s1 = h
                                                                        }
                                                                    } else {
                                                                        ic = s1;
                                                                        s1 = h
                                                                    }
                                                                } else {
                                                                    ic = s1;
                                                                    s1 = h
                                                                }
                                                                if (s1 === h) {
                                                                    s1 = ic;
                                                                    s2 = peg$parseh16();
                                                                    if (s2 !== h) {
                                                                        s3 = ic;
                                                                        if (f.charCodeAt(ic) === 58) {
                                                                            s4 = L;
                                                                            ic++
                                                                        } else {
                                                                            s4 = h;
                                                                            if (il === 0) {
                                                                                peg$fail(M)
                                                                            }
                                                                        }
                                                                        if (s4 !== h) {
                                                                            s5 = peg$parseh16();
                                                                            if (s5 !== h) {
                                                                                s4 = [s4, s5];
                                                                                s3 = s4
                                                                            } else {
                                                                                ic = s3;
                                                                                s3 = h
                                                                            }
                                                                        } else {
                                                                            ic = s3;
                                                                            s3 = h
                                                                        }
                                                                        if (s3 === h) {
                                                                            s3 = null
                                                                        }
                                                                        if (s3 !== h) {
                                                                            s4 = ic;
                                                                            if (f.charCodeAt(ic) === 58) {
                                                                                s5 = L;
                                                                                ic++
                                                                            } else {
                                                                                s5 = h;
                                                                                if (il === 0) {
                                                                                    peg$fail(M)
                                                                                }
                                                                            }
                                                                            if (s5 !== h) {
                                                                                s6 = peg$parseh16();
                                                                                if (s6 !== h) {
                                                                                    s5 = [s5, s6];
                                                                                    s4 = s5
                                                                                } else {
                                                                                    ic = s4;
                                                                                    s4 = h
                                                                                }
                                                                            } else {
                                                                                ic = s4;
                                                                                s4 = h
                                                                            }
                                                                            if (s4 === h) {
                                                                                s4 = null
                                                                            }
                                                                            if (s4 !== h) {
                                                                                s5 = ic;
                                                                                if (f.charCodeAt(ic) === 58) {
                                                                                    s6 = L;
                                                                                    ic++
                                                                                } else {
                                                                                    s6 = h;
                                                                                    if (il === 0) {
                                                                                        peg$fail(M)
                                                                                    }
                                                                                }
                                                                                if (s6 !== h) {
                                                                                    s7 = peg$parseh16();
                                                                                    if (s7 !== h) {
                                                                                        s6 = [s6, s7];
                                                                                        s5 = s6
                                                                                    } else {
                                                                                        ic = s5;
                                                                                        s5 = h
                                                                                    }
                                                                                } else {
                                                                                    ic = s5;
                                                                                    s5 = h
                                                                                }
                                                                                if (s5 === h) {
                                                                                    s5 = null
                                                                                }
                                                                                if (s5 !== h) {
                                                                                    s6 = ic;
                                                                                    if (f.charCodeAt(ic) === 58) {
                                                                                        s7 = L;
                                                                                        ic++
                                                                                    } else {
                                                                                        s7 = h;
                                                                                        if (il === 0) {
                                                                                            peg$fail(M)
                                                                                        }
                                                                                    }
                                                                                    if (s7 !== h) {
                                                                                        s8 = peg$parseh16();
                                                                                        if (s8 !== h) {
                                                                                            s7 = [s7, s8];
                                                                                            s6 = s7
                                                                                        } else {
                                                                                            ic = s6;
                                                                                            s6 = h
                                                                                        }
                                                                                    } else {
                                                                                        ic = s6;
                                                                                        s6 = h
                                                                                    }
                                                                                    if (s6 === h) {
                                                                                        s6 = null
                                                                                    }
                                                                                    if (s6 !== h) {
                                                                                        s7 = ic;
                                                                                        if (f.charCodeAt(ic) === 58) {
                                                                                            s8 = L;
                                                                                            ic++
                                                                                        } else {
                                                                                            s8 = h;
                                                                                            if (il === 0) {
                                                                                                peg$fail(M)
                                                                                            }
                                                                                        }
                                                                                        if (s8 !== h) {
                                                                                            s9 = peg$parseh16();
                                                                                            if (s9 !== h) {
                                                                                                s8 = [s8, s9];
                                                                                                s7 = s8
                                                                                            } else {
                                                                                                ic = s7;
                                                                                                s7 = h
                                                                                            }
                                                                                        } else {
                                                                                            ic = s7;
                                                                                            s7 = h
                                                                                        }
                                                                                        if (s7 === h) {
                                                                                            s7 = null
                                                                                        }
                                                                                        if (s7 !== h) {
                                                                                            if (f.substr(ic, 2) === cN) {
                                                                                                s8 = cN;
                                                                                                ic += 2
                                                                                            } else {
                                                                                                s8 = h;
                                                                                                if (il === 0) {
                                                                                                    peg$fail(cO)
                                                                                                }
                                                                                            }
                                                                                            if (s8 !== h) {
                                                                                                s9 = peg$parseh16();
                                                                                                if (s9 !== h) {
                                                                                                    s2 = [s2, s3, s4, s5, s6, s7, s8, s9];
                                                                                                    s1 = s2
                                                                                                } else {
                                                                                                    ic = s1;
                                                                                                    s1 = h
                                                                                                }
                                                                                            } else {
                                                                                                ic = s1;
                                                                                                s1 = h
                                                                                            }
                                                                                        } else {
                                                                                            ic = s1;
                                                                                            s1 = h
                                                                                        }
                                                                                    } else {
                                                                                        ic = s1;
                                                                                        s1 = h
                                                                                    }
                                                                                } else {
                                                                                    ic = s1;
                                                                                    s1 = h
                                                                                }
                                                                            } else {
                                                                                ic = s1;
                                                                                s1 = h
                                                                            }
                                                                        } else {
                                                                            ic = s1;
                                                                            s1 = h
                                                                        }
                                                                    } else {
                                                                        ic = s1;
                                                                        s1 = h
                                                                    }
                                                                    if (s1 === h) {
                                                                        s1 = ic;
                                                                        s2 = peg$parseh16();
                                                                        if (s2 !== h) {
                                                                            s3 = ic;
                                                                            if (f.charCodeAt(ic) === 58) {
                                                                                s4 = L;
                                                                                ic++
                                                                            } else {
                                                                                s4 = h;
                                                                                if (il === 0) {
                                                                                    peg$fail(M)
                                                                                }
                                                                            }
                                                                            if (s4 !== h) {
                                                                                s5 = peg$parseh16();
                                                                                if (s5 !== h) {
                                                                                    s4 = [s4, s5];
                                                                                    s3 = s4
                                                                                } else {
                                                                                    ic = s3;
                                                                                    s3 = h
                                                                                }
                                                                            } else {
                                                                                ic = s3;
                                                                                s3 = h
                                                                            }
                                                                            if (s3 === h) {
                                                                                s3 = null
                                                                            }
                                                                            if (s3 !== h) {
                                                                                s4 = ic;
                                                                                if (f.charCodeAt(ic) === 58) {
                                                                                    s5 = L;
                                                                                    ic++
                                                                                } else {
                                                                                    s5 = h;
                                                                                    if (il === 0) {
                                                                                        peg$fail(M)
                                                                                    }
                                                                                }
                                                                                if (s5 !== h) {
                                                                                    s6 = peg$parseh16();
                                                                                    if (s6 !== h) {
                                                                                        s5 = [s5, s6];
                                                                                        s4 = s5
                                                                                    } else {
                                                                                        ic = s4;
                                                                                        s4 = h
                                                                                    }
                                                                                } else {
                                                                                    ic = s4;
                                                                                    s4 = h
                                                                                }
                                                                                if (s4 === h) {
                                                                                    s4 = null
                                                                                }
                                                                                if (s4 !== h) {
                                                                                    s5 = ic;
                                                                                    if (f.charCodeAt(ic) === 58) {
                                                                                        s6 = L;
                                                                                        ic++
                                                                                    } else {
                                                                                        s6 = h;
                                                                                        if (il === 0) {
                                                                                            peg$fail(M)
                                                                                        }
                                                                                    }
                                                                                    if (s6 !== h) {
                                                                                        s7 = peg$parseh16();
                                                                                        if (s7 !== h) {
                                                                                            s6 = [s6, s7];
                                                                                            s5 = s6
                                                                                        } else {
                                                                                            ic = s5;
                                                                                            s5 = h
                                                                                        }
                                                                                    } else {
                                                                                        ic = s5;
                                                                                        s5 = h
                                                                                    }
                                                                                    if (s5 === h) {
                                                                                        s5 = null
                                                                                    }
                                                                                    if (s5 !== h) {
                                                                                        s6 = ic;
                                                                                        if (f.charCodeAt(ic) === 58) {
                                                                                            s7 = L;
                                                                                            ic++
                                                                                        } else {
                                                                                            s7 = h;
                                                                                            if (il === 0) {
                                                                                                peg$fail(M)
                                                                                            }
                                                                                        }
                                                                                        if (s7 !== h) {
                                                                                            s8 = peg$parseh16();
                                                                                            if (s8 !== h) {
                                                                                                s7 = [s7, s8];
                                                                                                s6 = s7
                                                                                            } else {
                                                                                                ic = s6;
                                                                                                s6 = h
                                                                                            }
                                                                                        } else {
                                                                                            ic = s6;
                                                                                            s6 = h
                                                                                        }
                                                                                        if (s6 === h) {
                                                                                            s6 = null
                                                                                        }
                                                                                        if (s6 !== h) {
                                                                                            s7 = ic;
                                                                                            if (f.charCodeAt(ic) === 58) {
                                                                                                s8 = L;
                                                                                                ic++
                                                                                            } else {
                                                                                                s8 = h;
                                                                                                if (il === 0) {
                                                                                                    peg$fail(M)
                                                                                                }
                                                                                            }
                                                                                            if (s8 !== h) {
                                                                                                s9 = peg$parseh16();
                                                                                                if (s9 !== h) {
                                                                                                    s8 = [s8, s9];
                                                                                                    s7 = s8
                                                                                                } else {
                                                                                                    ic = s7;
                                                                                                    s7 = h
                                                                                                }
                                                                                            } else {
                                                                                                ic = s7;
                                                                                                s7 = h
                                                                                            }
                                                                                            if (s7 === h) {
                                                                                                s7 = null
                                                                                            }
                                                                                            if (s7 !== h) {
                                                                                                s8 = ic;
                                                                                                if (f.charCodeAt(ic) === 58) {
                                                                                                    s9 = L;
                                                                                                    ic++
                                                                                                } else {
                                                                                                    s9 = h;
                                                                                                    if (il === 0) {
                                                                                                        peg$fail(M)
                                                                                                    }
                                                                                                }
                                                                                                if (s9 !== h) {
                                                                                                    s10 = peg$parseh16();
                                                                                                    if (s10 !== h) {
                                                                                                        s9 = [s9, s10];
                                                                                                        s8 = s9
                                                                                                    } else {
                                                                                                        ic = s8;
                                                                                                        s8 = h
                                                                                                    }
                                                                                                } else {
                                                                                                    ic = s8;
                                                                                                    s8 = h
                                                                                                }
                                                                                                if (s8 === h) {
                                                                                                    s8 = null
                                                                                                }
                                                                                                if (s8 !== h) {
                                                                                                    if (f.substr(ic, 2) === cN) {
                                                                                                        s9 = cN;
                                                                                                        ic += 2
                                                                                                    } else {
                                                                                                        s9 = h;
                                                                                                        if (il === 0) {
                                                                                                            peg$fail(cO)
                                                                                                        }
                                                                                                    }
                                                                                                    if (s9 !== h) {
                                                                                                        s2 = [s2, s3, s4, s5, s6, s7, s8, s9];
                                                                                                        s1 = s2
                                                                                                    } else {
                                                                                                        ic = s1;
                                                                                                        s1 = h
                                                                                                    }
                                                                                                } else {
                                                                                                    ic = s1;
                                                                                                    s1 = h
                                                                                                }
                                                                                            } else {
                                                                                                ic = s1;
                                                                                                s1 = h
                                                                                            }
                                                                                        } else {
                                                                                            ic = s1;
                                                                                            s1 = h
                                                                                        }
                                                                                    } else {
                                                                                        ic = s1;
                                                                                        s1 = h
                                                                                    }
                                                                                } else {
                                                                                    ic = s1;
                                                                                    s1 = h
                                                                                }
                                                                            } else {
                                                                                ic = s1;
                                                                                s1 = h
                                                                            }
                                                                        } else {
                                                                            ic = s1;
                                                                            s1 = h
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = cP()
                }
                a = s1;
                return a
            }

            function peg$parseh16() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = peg$parseHEXDIG();
                if (s1 !== h) {
                    s2 = peg$parseHEXDIG();
                    if (s2 === h) {
                        s2 = null
                    }
                    if (s2 !== h) {
                        s3 = peg$parseHEXDIG();
                        if (s3 === h) {
                            s3 = null
                        }
                        if (s3 !== h) {
                            s4 = peg$parseHEXDIG();
                            if (s4 === h) {
                                s4 = null
                            }
                            if (s4 !== h) {
                                s1 = [s1, s2, s3, s4];
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsels32() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parseh16();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 58) {
                        s2 = L;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(M)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseh16();
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                if (a === h) {
                    a = peg$parseIPv4address()
                }
                return a
            }

            function peg$parseIPv4address() {
                var a, s1, s2, s3, s4, s5, s6, s7;
                a = ic;
                s1 = peg$parsedec_octet();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 46) {
                        s2 = bh;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(bi)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parsedec_octet();
                        if (s3 !== h) {
                            if (f.charCodeAt(ic) === 46) {
                                s4 = bh;
                                ic++
                            } else {
                                s4 = h;
                                if (il === 0) {
                                    peg$fail(bi)
                                }
                            }
                            if (s4 !== h) {
                                s5 = peg$parsedec_octet();
                                if (s5 !== h) {
                                    if (f.charCodeAt(ic) === 46) {
                                        s6 = bh;
                                        ic++
                                    } else {
                                        s6 = h;
                                        if (il === 0) {
                                            peg$fail(bi)
                                        }
                                    }
                                    if (s6 !== h) {
                                        s7 = peg$parsedec_octet();
                                        if (s7 !== h) {
                                            id = a;
                                            s1 = cQ();
                                            a = s1
                                        } else {
                                            ic = a;
                                            a = h
                                        }
                                    } else {
                                        ic = a;
                                        a = h
                                    }
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsedec_octet() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 2) === cR) {
                    s1 = cR;
                    ic += 2
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(cS)
                    }
                }
                if (s1 !== h) {
                    if (cT.test(f.charAt(ic))) {
                        s2 = f.charAt(ic);
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(cU)
                        }
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                if (a === h) {
                    a = ic;
                    if (f.charCodeAt(ic) === 50) {
                        s1 = cV;
                        ic++
                    } else {
                        s1 = h;
                        if (il === 0) {
                            peg$fail(cW)
                        }
                    }
                    if (s1 !== h) {
                        if (cX.test(f.charAt(ic))) {
                            s2 = f.charAt(ic);
                            ic++
                        } else {
                            s2 = h;
                            if (il === 0) {
                                peg$fail(cY)
                            }
                        }
                        if (s2 !== h) {
                            s3 = peg$parseDIGIT();
                            if (s3 !== h) {
                                s1 = [s1, s2, s3];
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                    if (a === h) {
                        a = ic;
                        if (f.charCodeAt(ic) === 49) {
                            s1 = cZ;
                            ic++
                        } else {
                            s1 = h;
                            if (il === 0) {
                                peg$fail(da)
                            }
                        }
                        if (s1 !== h) {
                            s2 = peg$parseDIGIT();
                            if (s2 !== h) {
                                s3 = peg$parseDIGIT();
                                if (s3 !== h) {
                                    s1 = [s1, s2, s3];
                                    a = s1
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                        if (a === h) {
                            a = ic;
                            if (db.test(f.charAt(ic))) {
                                s1 = f.charAt(ic);
                                ic++
                            } else {
                                s1 = h;
                                if (il === 0) {
                                    peg$fail(dc)
                                }
                            }
                            if (s1 !== h) {
                                s2 = peg$parseDIGIT();
                                if (s2 !== h) {
                                    s1 = [s1, s2];
                                    a = s1
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                            if (a === h) {
                                a = peg$parseDIGIT()
                            }
                        }
                    }
                }
                return a
            }

            function peg$parseport() {
                var a, s1, s2, s3, s4, s5, s6;
                a = ic;
                s1 = ic;
                s2 = peg$parseDIGIT();
                if (s2 === h) {
                    s2 = null
                }
                if (s2 !== h) {
                    s3 = peg$parseDIGIT();
                    if (s3 === h) {
                        s3 = null
                    }
                    if (s3 !== h) {
                        s4 = peg$parseDIGIT();
                        if (s4 === h) {
                            s4 = null
                        }
                        if (s4 !== h) {
                            s5 = peg$parseDIGIT();
                            if (s5 === h) {
                                s5 = null
                            }
                            if (s5 !== h) {
                                s6 = peg$parseDIGIT();
                                if (s6 === h) {
                                    s6 = null
                                }
                                if (s6 !== h) {
                                    s2 = [s2, s3, s4, s5, s6];
                                    s1 = s2
                                } else {
                                    ic = s1;
                                    s1 = h
                                }
                            } else {
                                ic = s1;
                                s1 = h
                            }
                        } else {
                            ic = s1;
                            s1 = h
                        }
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 !== h) {
                    id = a;
                    s1 = dd(s1)
                }
                a = s1;
                return a
            }

            function peg$parseuri_parameters() {
                var a, s1, s2, s3;
                a = [];
                s1 = ic;
                if (f.charCodeAt(ic) === 59) {
                    s2 = F;
                    ic++
                } else {
                    s2 = h;
                    if (il === 0) {
                        peg$fail(G)
                    }
                }
                if (s2 !== h) {
                    s3 = peg$parseuri_parameter();
                    if (s3 !== h) {
                        s2 = [s2, s3];
                        s1 = s2
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                while (s1 !== h) {
                    a.push(s1);
                    s1 = ic;
                    if (f.charCodeAt(ic) === 59) {
                        s2 = F;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(G)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parseuri_parameter();
                        if (s3 !== h) {
                            s2 = [s2, s3];
                            s1 = s2
                        } else {
                            ic = s1;
                            s1 = h
                        }
                    } else {
                        ic = s1;
                        s1 = h
                    }
                }
                return a
            }

            function peg$parseuri_parameter() {
                var a;
                a = peg$parsetransport_param();
                if (a === h) {
                    a = peg$parseuser_param();
                    if (a === h) {
                        a = peg$parsemethod_param();
                        if (a === h) {
                            a = peg$parsettl_param();
                            if (a === h) {
                                a = peg$parsemaddr_param();
                                if (a === h) {
                                    a = peg$parselr_param();
                                    if (a === h) {
                                        a = peg$parseother_param()
                                    }
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parsetransport_param() {
                var a, s1, s2;
                a = ic;
                if (f.substr(ic, 10)
                    .toLowerCase() === de) {
                    s1 = f.substr(ic, 10);
                    ic += 10
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(df)
                    }
                }
                if (s1 !== h) {
                    if (f.substr(ic, 3)
                        .toLowerCase() === dg) {
                        s2 = f.substr(ic, 3);
                        ic += 3
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(dh)
                        }
                    }
                    if (s2 === h) {
                        if (f.substr(ic, 3)
                            .toLowerCase() === di) {
                            s2 = f.substr(ic, 3);
                            ic += 3
                        } else {
                            s2 = h;
                            if (il === 0) {
                                peg$fail(dj)
                            }
                        }
                        if (s2 === h) {
                            if (f.substr(ic, 4)
                                .toLowerCase() === dk) {
                                s2 = f.substr(ic, 4);
                                ic += 4
                            } else {
                                s2 = h;
                                if (il === 0) {
                                    peg$fail(dl)
                                }
                            }
                            if (s2 === h) {
                                if (f.substr(ic, 3)
                                    .toLowerCase() === dm) {
                                    s2 = f.substr(ic, 3);
                                    ic += 3
                                } else {
                                    s2 = h;
                                    if (il === 0) {
                                        peg$fail(dn)
                                    }
                                }
                                if (s2 === h) {
                                    s2 = peg$parsetoken()
                                }
                            }
                        }
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = do_1(s2);
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseuser_param() {
                var a, s1, s2;
                a = ic;
                if (f.substr(ic, 5)
                    .toLowerCase() === dp) {
                    s1 = f.substr(ic, 5);
                    ic += 5
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(dq)
                    }
                }
                if (s1 !== h) {
                    if (f.substr(ic, 5)
                        .toLowerCase() === dr) {
                        s2 = f.substr(ic, 5);
                        ic += 5
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(ds)
                        }
                    }
                    if (s2 === h) {
                        if (f.substr(ic, 2)
                            .toLowerCase() === dt) {
                            s2 = f.substr(ic, 2);
                            ic += 2
                        } else {
                            s2 = h;
                            if (il === 0) {
                                peg$fail(du)
                            }
                        }
                        if (s2 === h) {
                            s2 = peg$parsetoken()
                        }
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = dv(s2);
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsemethod_param() {
                var a, s1, s2;
                a = ic;
                if (f.substr(ic, 7)
                    .toLowerCase() === dw) {
                    s1 = f.substr(ic, 7);
                    ic += 7
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(dx)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseMethod();
                    if (s2 !== h) {
                        id = a;
                        s1 = dy(s2);
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsettl_param() {
                var a, s1, s2;
                a = ic;
                if (f.substr(ic, 4)
                    .toLowerCase() === dz) {
                    s1 = f.substr(ic, 4);
                    ic += 4
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(dA)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parsettl();
                    if (s2 !== h) {
                        id = a;
                        s1 = dB(s2);
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsemaddr_param() {
                var a, s1, s2;
                a = ic;
                if (f.substr(ic, 6)
                    .toLowerCase() === dC) {
                    s1 = f.substr(ic, 6);
                    ic += 6
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(dD)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parsehost();
                    if (s2 !== h) {
                        id = a;
                        s1 = dE(s2);
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parselr_param() {
                var a, s1, s2, s3, s4;
                a = ic;
                if (f.substr(ic, 2)
                    .toLowerCase() === dF) {
                    s1 = f.substr(ic, 2);
                    ic += 2
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(dG)
                    }
                }
                if (s1 !== h) {
                    s2 = ic;
                    if (f.charCodeAt(ic) === 61) {
                        s3 = R;
                        ic++
                    } else {
                        s3 = h;
                        if (il === 0) {
                            peg$fail(S)
                        }
                    }
                    if (s3 !== h) {
                        s4 = peg$parsetoken();
                        if (s4 !== h) {
                            s3 = [s3, s4];
                            s2 = s3
                        } else {
                            ic = s2;
                            s2 = h
                        }
                    } else {
                        ic = s2;
                        s2 = h
                    }
                    if (s2 === h) {
                        s2 = null
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = dH();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseother_param() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = peg$parsepname();
                if (s1 !== h) {
                    s2 = ic;
                    if (f.charCodeAt(ic) === 61) {
                        s3 = R;
                        ic++
                    } else {
                        s3 = h;
                        if (il === 0) {
                            peg$fail(S)
                        }
                    }
                    if (s3 !== h) {
                        s4 = peg$parsepvalue();
                        if (s4 !== h) {
                            s3 = [s3, s4];
                            s2 = s3
                        } else {
                            ic = s2;
                            s2 = h
                        }
                    } else {
                        ic = s2;
                        s2 = h
                    }
                    if (s2 === h) {
                        s2 = null
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = dI(s1, s2);
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsepname() {
                var a, s1, s2;
                a = ic;
                s1 = [];
                s2 = peg$parseparamchar();
                if (s2 !== h) {
                    while (s2 !== h) {
                        s1.push(s2);
                        s2 = peg$parseparamchar()
                    }
                } else {
                    s1 = h
                }
                if (s1 !== h) {
                    a = f.substring(a, ic)
                } else {
                    a = s1
                }
                return a
            }

            function peg$parsepvalue() {
                var a, s1, s2;
                a = ic;
                s1 = [];
                s2 = peg$parseparamchar();
                if (s2 !== h) {
                    while (s2 !== h) {
                        s1.push(s2);
                        s2 = peg$parseparamchar()
                    }
                } else {
                    s1 = h
                }
                if (s1 !== h) {
                    a = f.substring(a, ic)
                } else {
                    a = s1
                }
                return a
            }

            function peg$parseparamchar() {
                var a;
                a = peg$parseparam_unreserved();
                if (a === h) {
                    a = peg$parseunreserved();
                    if (a === h) {
                        a = peg$parseescaped()
                    }
                }
                return a
            }

            function peg$parseparam_unreserved() {
                var a;
                if (f.charCodeAt(ic) === 91) {
                    a = bP;
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(bQ)
                    }
                }
                if (a === h) {
                    if (f.charCodeAt(ic) === 93) {
                        a = bR;
                        ic++
                    } else {
                        a = h;
                        if (il === 0) {
                            peg$fail(bS)
                        }
                    }
                    if (a === h) {
                        if (f.charCodeAt(ic) === 47) {
                            a = H;
                            ic++
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(I)
                            }
                        }
                        if (a === h) {
                            if (f.charCodeAt(ic) === 58) {
                                a = L;
                                ic++
                            } else {
                                a = h;
                                if (il === 0) {
                                    peg$fail(M)
                                }
                            }
                            if (a === h) {
                                if (f.charCodeAt(ic) === 38) {
                                    a = P;
                                    ic++
                                } else {
                                    a = h;
                                    if (il === 0) {
                                        peg$fail(Q)
                                    }
                                }
                                if (a === h) {
                                    if (f.charCodeAt(ic) === 43) {
                                        a = T;
                                        ic++
                                    } else {
                                        a = h;
                                        if (il === 0) {
                                            peg$fail(U)
                                        }
                                    }
                                    if (a === h) {
                                        if (f.charCodeAt(ic) === 36) {
                                            a = V;
                                            ic++
                                        } else {
                                            a = h;
                                            if (il === 0) {
                                                peg$fail(W)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parseheaders() {
                var a, s1, s2, s3, s4, s5, s6;
                a = ic;
                if (f.charCodeAt(ic) === 63) {
                    s1 = J;
                    ic++
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(K)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseheader();
                    if (s2 !== h) {
                        s3 = [];
                        s4 = ic;
                        if (f.charCodeAt(ic) === 38) {
                            s5 = P;
                            ic++
                        } else {
                            s5 = h;
                            if (il === 0) {
                                peg$fail(Q)
                            }
                        }
                        if (s5 !== h) {
                            s6 = peg$parseheader();
                            if (s6 !== h) {
                                s5 = [s5, s6];
                                s4 = s5
                            } else {
                                ic = s4;
                                s4 = h
                            }
                        } else {
                            ic = s4;
                            s4 = h
                        }
                        while (s4 !== h) {
                            s3.push(s4);
                            s4 = ic;
                            if (f.charCodeAt(ic) === 38) {
                                s5 = P;
                                ic++
                            } else {
                                s5 = h;
                                if (il === 0) {
                                    peg$fail(Q)
                                }
                            }
                            if (s5 !== h) {
                                s6 = peg$parseheader();
                                if (s6 !== h) {
                                    s5 = [s5, s6];
                                    s4 = s5
                                } else {
                                    ic = s4;
                                    s4 = h
                                }
                            } else {
                                ic = s4;
                                s4 = h
                            }
                        }
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseheader() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parsehname();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 61) {
                        s2 = R;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(S)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parsehvalue();
                        if (s3 !== h) {
                            id = a;
                            s1 = dJ(s1, s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsehname() {
                var a, s1;
                a = [];
                s1 = peg$parsehnv_unreserved();
                if (s1 === h) {
                    s1 = peg$parseunreserved();
                    if (s1 === h) {
                        s1 = peg$parseescaped()
                    }
                }
                if (s1 !== h) {
                    while (s1 !== h) {
                        a.push(s1);
                        s1 = peg$parsehnv_unreserved();
                        if (s1 === h) {
                            s1 = peg$parseunreserved();
                            if (s1 === h) {
                                s1 = peg$parseescaped()
                            }
                        }
                    }
                } else {
                    a = h
                }
                return a
            }

            function peg$parsehvalue() {
                var a, s1;
                a = [];
                s1 = peg$parsehnv_unreserved();
                if (s1 === h) {
                    s1 = peg$parseunreserved();
                    if (s1 === h) {
                        s1 = peg$parseescaped()
                    }
                }
                while (s1 !== h) {
                    a.push(s1);
                    s1 = peg$parsehnv_unreserved();
                    if (s1 === h) {
                        s1 = peg$parseunreserved();
                        if (s1 === h) {
                            s1 = peg$parseescaped()
                        }
                    }
                }
                return a
            }

            function peg$parsehnv_unreserved() {
                var a;
                if (f.charCodeAt(ic) === 91) {
                    a = bP;
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(bQ)
                    }
                }
                if (a === h) {
                    if (f.charCodeAt(ic) === 93) {
                        a = bR;
                        ic++
                    } else {
                        a = h;
                        if (il === 0) {
                            peg$fail(bS)
                        }
                    }
                    if (a === h) {
                        if (f.charCodeAt(ic) === 47) {
                            a = H;
                            ic++
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(I)
                            }
                        }
                        if (a === h) {
                            if (f.charCodeAt(ic) === 63) {
                                a = J;
                                ic++
                            } else {
                                a = h;
                                if (il === 0) {
                                    peg$fail(K)
                                }
                            }
                            if (a === h) {
                                if (f.charCodeAt(ic) === 58) {
                                    a = L;
                                    ic++
                                } else {
                                    a = h;
                                    if (il === 0) {
                                        peg$fail(M)
                                    }
                                }
                                if (a === h) {
                                    if (f.charCodeAt(ic) === 43) {
                                        a = T;
                                        ic++
                                    } else {
                                        a = h;
                                        if (il === 0) {
                                            peg$fail(U)
                                        }
                                    }
                                    if (a === h) {
                                        if (f.charCodeAt(ic) === 36) {
                                            a = V;
                                            ic++
                                        } else {
                                            a = h;
                                            if (il === 0) {
                                                peg$fail(W)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parseRequest_Response() {
                var a;
                a = peg$parseStatus_Line();
                if (a === h) {
                    a = peg$parseRequest_Line()
                }
                return a
            }

            function peg$parseRequest_Line() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseMethod();
                if (s1 !== h) {
                    s2 = peg$parseSP();
                    if (s2 !== h) {
                        s3 = peg$parseRequest_URI();
                        if (s3 !== h) {
                            s4 = peg$parseSP();
                            if (s4 !== h) {
                                s5 = peg$parseSIP_Version();
                                if (s5 !== h) {
                                    s1 = [s1, s2, s3, s4, s5];
                                    a = s1
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseRequest_URI() {
                var a;
                a = peg$parseSIP_URI();
                if (a === h) {
                    a = peg$parseabsoluteURI()
                }
                return a
            }

            function peg$parseabsoluteURI() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parsescheme();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 58) {
                        s2 = L;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(M)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parsehier_part();
                        if (s3 === h) {
                            s3 = peg$parseopaque_part()
                        }
                        if (s3 !== h) {
                            id = a;
                            s1 = dK();
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsehier_part() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = peg$parsenet_path();
                if (s1 === h) {
                    s1 = peg$parseabs_path()
                }
                if (s1 !== h) {
                    s2 = ic;
                    if (f.charCodeAt(ic) === 63) {
                        s3 = J;
                        ic++
                    } else {
                        s3 = h;
                        if (il === 0) {
                            peg$fail(K)
                        }
                    }
                    if (s3 !== h) {
                        s4 = peg$parsequery();
                        if (s4 !== h) {
                            s3 = [s3, s4];
                            s2 = s3
                        } else {
                            ic = s2;
                            s2 = h
                        }
                    } else {
                        ic = s2;
                        s2 = h
                    }
                    if (s2 === h) {
                        s2 = null
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsenet_path() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 2) === dL) {
                    s1 = dL;
                    ic += 2
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(dM)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseauthority();
                    if (s2 !== h) {
                        s3 = peg$parseabs_path();
                        if (s3 === h) {
                            s3 = null
                        }
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseabs_path() {
                var a, s1, s2;
                a = ic;
                if (f.charCodeAt(ic) === 47) {
                    s1 = H;
                    ic++
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(I)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parsepath_segments();
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseopaque_part() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parseuric_no_slash();
                if (s1 !== h) {
                    s2 = [];
                    s3 = peg$parseuric();
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = peg$parseuric()
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseuric() {
                var a;
                a = peg$parsereserved();
                if (a === h) {
                    a = peg$parseunreserved();
                    if (a === h) {
                        a = peg$parseescaped()
                    }
                }
                return a
            }

            function peg$parseuric_no_slash() {
                var a;
                a = peg$parseunreserved();
                if (a === h) {
                    a = peg$parseescaped();
                    if (a === h) {
                        if (f.charCodeAt(ic) === 59) {
                            a = F;
                            ic++
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(G)
                            }
                        }
                        if (a === h) {
                            if (f.charCodeAt(ic) === 63) {
                                a = J;
                                ic++
                            } else {
                                a = h;
                                if (il === 0) {
                                    peg$fail(K)
                                }
                            }
                            if (a === h) {
                                if (f.charCodeAt(ic) === 58) {
                                    a = L;
                                    ic++
                                } else {
                                    a = h;
                                    if (il === 0) {
                                        peg$fail(M)
                                    }
                                }
                                if (a === h) {
                                    if (f.charCodeAt(ic) === 64) {
                                        a = N;
                                        ic++
                                    } else {
                                        a = h;
                                        if (il === 0) {
                                            peg$fail(O)
                                        }
                                    }
                                    if (a === h) {
                                        if (f.charCodeAt(ic) === 38) {
                                            a = P;
                                            ic++
                                        } else {
                                            a = h;
                                            if (il === 0) {
                                                peg$fail(Q)
                                            }
                                        }
                                        if (a === h) {
                                            if (f.charCodeAt(ic) === 61) {
                                                a = R;
                                                ic++
                                            } else {
                                                a = h;
                                                if (il === 0) {
                                                    peg$fail(S)
                                                }
                                            }
                                            if (a === h) {
                                                if (f.charCodeAt(ic) === 43) {
                                                    a = T;
                                                    ic++
                                                } else {
                                                    a = h;
                                                    if (il === 0) {
                                                        peg$fail(U)
                                                    }
                                                }
                                                if (a === h) {
                                                    if (f.charCodeAt(ic) === 36) {
                                                        a = V;
                                                        ic++
                                                    } else {
                                                        a = h;
                                                        if (il === 0) {
                                                            peg$fail(W)
                                                        }
                                                    }
                                                    if (a === h) {
                                                        if (f.charCodeAt(ic) === 44) {
                                                            a = X;
                                                            ic++
                                                        } else {
                                                            a = h;
                                                            if (il === 0) {
                                                                peg$fail(Y)
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parsepath_segments() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parsesegment();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    if (f.charCodeAt(ic) === 47) {
                        s4 = H;
                        ic++
                    } else {
                        s4 = h;
                        if (il === 0) {
                            peg$fail(I)
                        }
                    }
                    if (s4 !== h) {
                        s5 = peg$parsesegment();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        if (f.charCodeAt(ic) === 47) {
                            s4 = H;
                            ic++
                        } else {
                            s4 = h;
                            if (il === 0) {
                                peg$fail(I)
                            }
                        }
                        if (s4 !== h) {
                            s5 = peg$parsesegment();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsesegment() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = [];
                s2 = peg$parsepchar();
                while (s2 !== h) {
                    s1.push(s2);
                    s2 = peg$parsepchar()
                }
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    if (f.charCodeAt(ic) === 59) {
                        s4 = F;
                        ic++
                    } else {
                        s4 = h;
                        if (il === 0) {
                            peg$fail(G)
                        }
                    }
                    if (s4 !== h) {
                        s5 = peg$parseparam();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        if (f.charCodeAt(ic) === 59) {
                            s4 = F;
                            ic++
                        } else {
                            s4 = h;
                            if (il === 0) {
                                peg$fail(G)
                            }
                        }
                        if (s4 !== h) {
                            s5 = peg$parseparam();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseparam() {
                var a, s1;
                a = [];
                s1 = peg$parsepchar();
                while (s1 !== h) {
                    a.push(s1);
                    s1 = peg$parsepchar()
                }
                return a
            }

            function peg$parsepchar() {
                var a;
                a = peg$parseunreserved();
                if (a === h) {
                    a = peg$parseescaped();
                    if (a === h) {
                        if (f.charCodeAt(ic) === 58) {
                            a = L;
                            ic++
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(M)
                            }
                        }
                        if (a === h) {
                            if (f.charCodeAt(ic) === 64) {
                                a = N;
                                ic++
                            } else {
                                a = h;
                                if (il === 0) {
                                    peg$fail(O)
                                }
                            }
                            if (a === h) {
                                if (f.charCodeAt(ic) === 38) {
                                    a = P;
                                    ic++
                                } else {
                                    a = h;
                                    if (il === 0) {
                                        peg$fail(Q)
                                    }
                                }
                                if (a === h) {
                                    if (f.charCodeAt(ic) === 61) {
                                        a = R;
                                        ic++
                                    } else {
                                        a = h;
                                        if (il === 0) {
                                            peg$fail(S)
                                        }
                                    }
                                    if (a === h) {
                                        if (f.charCodeAt(ic) === 43) {
                                            a = T;
                                            ic++
                                        } else {
                                            a = h;
                                            if (il === 0) {
                                                peg$fail(U)
                                            }
                                        }
                                        if (a === h) {
                                            if (f.charCodeAt(ic) === 36) {
                                                a = V;
                                                ic++
                                            } else {
                                                a = h;
                                                if (il === 0) {
                                                    peg$fail(W)
                                                }
                                            }
                                            if (a === h) {
                                                if (f.charCodeAt(ic) === 44) {
                                                    a = X;
                                                    ic++
                                                } else {
                                                    a = h;
                                                    if (il === 0) {
                                                        peg$fail(Y)
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parsescheme() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = ic;
                s2 = peg$parseALPHA();
                if (s2 !== h) {
                    s3 = [];
                    s4 = peg$parseALPHA();
                    if (s4 === h) {
                        s4 = peg$parseDIGIT();
                        if (s4 === h) {
                            if (f.charCodeAt(ic) === 43) {
                                s4 = T;
                                ic++
                            } else {
                                s4 = h;
                                if (il === 0) {
                                    peg$fail(U)
                                }
                            }
                            if (s4 === h) {
                                if (f.charCodeAt(ic) === 45) {
                                    s4 = Z;
                                    ic++
                                } else {
                                    s4 = h;
                                    if (il === 0) {
                                        peg$fail(be)
                                    }
                                }
                                if (s4 === h) {
                                    if (f.charCodeAt(ic) === 46) {
                                        s4 = bh;
                                        ic++
                                    } else {
                                        s4 = h;
                                        if (il === 0) {
                                            peg$fail(bi)
                                        }
                                    }
                                }
                            }
                        }
                    }
                    while (s4 !== h) {
                        s3.push(s4);
                        s4 = peg$parseALPHA();
                        if (s4 === h) {
                            s4 = peg$parseDIGIT();
                            if (s4 === h) {
                                if (f.charCodeAt(ic) === 43) {
                                    s4 = T;
                                    ic++
                                } else {
                                    s4 = h;
                                    if (il === 0) {
                                        peg$fail(U)
                                    }
                                }
                                if (s4 === h) {
                                    if (f.charCodeAt(ic) === 45) {
                                        s4 = Z;
                                        ic++
                                    } else {
                                        s4 = h;
                                        if (il === 0) {
                                            peg$fail(be)
                                        }
                                    }
                                    if (s4 === h) {
                                        if (f.charCodeAt(ic) === 46) {
                                            s4 = bh;
                                            ic++
                                        } else {
                                            s4 = h;
                                            if (il === 0) {
                                                peg$fail(bi)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (s3 !== h) {
                        s2 = [s2, s3];
                        s1 = s2
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 !== h) {
                    id = a;
                    s1 = dN()
                }
                a = s1;
                return a
            }

            function peg$parseauthority() {
                var a;
                a = peg$parsesrvr();
                if (a === h) {
                    a = peg$parsereg_name()
                }
                return a
            }

            function peg$parsesrvr() {
                var a, s1, s2, s3;
                a = ic;
                s1 = ic;
                s2 = peg$parseuserinfo();
                if (s2 !== h) {
                    if (f.charCodeAt(ic) === 64) {
                        s3 = N;
                        ic++
                    } else {
                        s3 = h;
                        if (il === 0) {
                            peg$fail(O)
                        }
                    }
                    if (s3 !== h) {
                        s2 = [s2, s3];
                        s1 = s2
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 === h) {
                    s1 = null
                }
                if (s1 !== h) {
                    s2 = peg$parsehostport();
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                if (a === h) {
                    a = null
                }
                return a
            }

            function peg$parsereg_name() {
                var a, s1;
                a = [];
                s1 = peg$parseunreserved();
                if (s1 === h) {
                    s1 = peg$parseescaped();
                    if (s1 === h) {
                        if (f.charCodeAt(ic) === 36) {
                            s1 = V;
                            ic++
                        } else {
                            s1 = h;
                            if (il === 0) {
                                peg$fail(W)
                            }
                        }
                        if (s1 === h) {
                            if (f.charCodeAt(ic) === 44) {
                                s1 = X;
                                ic++
                            } else {
                                s1 = h;
                                if (il === 0) {
                                    peg$fail(Y)
                                }
                            }
                            if (s1 === h) {
                                if (f.charCodeAt(ic) === 59) {
                                    s1 = F;
                                    ic++
                                } else {
                                    s1 = h;
                                    if (il === 0) {
                                        peg$fail(G)
                                    }
                                }
                                if (s1 === h) {
                                    if (f.charCodeAt(ic) === 58) {
                                        s1 = L;
                                        ic++
                                    } else {
                                        s1 = h;
                                        if (il === 0) {
                                            peg$fail(M)
                                        }
                                    }
                                    if (s1 === h) {
                                        if (f.charCodeAt(ic) === 64) {
                                            s1 = N;
                                            ic++
                                        } else {
                                            s1 = h;
                                            if (il === 0) {
                                                peg$fail(O)
                                            }
                                        }
                                        if (s1 === h) {
                                            if (f.charCodeAt(ic) === 38) {
                                                s1 = P;
                                                ic++
                                            } else {
                                                s1 = h;
                                                if (il === 0) {
                                                    peg$fail(Q)
                                                }
                                            }
                                            if (s1 === h) {
                                                if (f.charCodeAt(ic) === 61) {
                                                    s1 = R;
                                                    ic++
                                                } else {
                                                    s1 = h;
                                                    if (il === 0) {
                                                        peg$fail(S)
                                                    }
                                                }
                                                if (s1 === h) {
                                                    if (f.charCodeAt(ic) === 43) {
                                                        s1 = T;
                                                        ic++
                                                    } else {
                                                        s1 = h;
                                                        if (il === 0) {
                                                            peg$fail(U)
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (s1 !== h) {
                    while (s1 !== h) {
                        a.push(s1);
                        s1 = peg$parseunreserved();
                        if (s1 === h) {
                            s1 = peg$parseescaped();
                            if (s1 === h) {
                                if (f.charCodeAt(ic) === 36) {
                                    s1 = V;
                                    ic++
                                } else {
                                    s1 = h;
                                    if (il === 0) {
                                        peg$fail(W)
                                    }
                                }
                                if (s1 === h) {
                                    if (f.charCodeAt(ic) === 44) {
                                        s1 = X;
                                        ic++
                                    } else {
                                        s1 = h;
                                        if (il === 0) {
                                            peg$fail(Y)
                                        }
                                    }
                                    if (s1 === h) {
                                        if (f.charCodeAt(ic) === 59) {
                                            s1 = F;
                                            ic++
                                        } else {
                                            s1 = h;
                                            if (il === 0) {
                                                peg$fail(G)
                                            }
                                        }
                                        if (s1 === h) {
                                            if (f.charCodeAt(ic) === 58) {
                                                s1 = L;
                                                ic++
                                            } else {
                                                s1 = h;
                                                if (il === 0) {
                                                    peg$fail(M)
                                                }
                                            }
                                            if (s1 === h) {
                                                if (f.charCodeAt(ic) === 64) {
                                                    s1 = N;
                                                    ic++
                                                } else {
                                                    s1 = h;
                                                    if (il === 0) {
                                                        peg$fail(O)
                                                    }
                                                }
                                                if (s1 === h) {
                                                    if (f.charCodeAt(ic) === 38) {
                                                        s1 = P;
                                                        ic++
                                                    } else {
                                                        s1 = h;
                                                        if (il === 0) {
                                                            peg$fail(Q)
                                                        }
                                                    }
                                                    if (s1 === h) {
                                                        if (f.charCodeAt(ic) === 61) {
                                                            s1 = R;
                                                            ic++
                                                        } else {
                                                            s1 = h;
                                                            if (il === 0) {
                                                                peg$fail(S)
                                                            }
                                                        }
                                                        if (s1 === h) {
                                                            if (f.charCodeAt(ic) === 43) {
                                                                s1 = T;
                                                                ic++
                                                            } else {
                                                                s1 = h;
                                                                if (il === 0) {
                                                                    peg$fail(U)
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else {
                    a = h
                }
                return a
            }

            function peg$parsequery() {
                var a, s1;
                a = [];
                s1 = peg$parseuric();
                while (s1 !== h) {
                    a.push(s1);
                    s1 = peg$parseuric()
                }
                return a
            }

            function peg$parseSIP_Version() {
                var a, s1, s2, s3, s4, s5, s6;
                a = ic;
                if (f.substr(ic, 3)
                    .toLowerCase() === cB) {
                    s1 = f.substr(ic, 3);
                    ic += 3
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(dO)
                    }
                }
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 47) {
                        s2 = H;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(I)
                        }
                    }
                    if (s2 !== h) {
                        s3 = [];
                        s4 = peg$parseDIGIT();
                        if (s4 !== h) {
                            while (s4 !== h) {
                                s3.push(s4);
                                s4 = peg$parseDIGIT()
                            }
                        } else {
                            s3 = h
                        }
                        if (s3 !== h) {
                            if (f.charCodeAt(ic) === 46) {
                                s4 = bh;
                                ic++
                            } else {
                                s4 = h;
                                if (il === 0) {
                                    peg$fail(bi)
                                }
                            }
                            if (s4 !== h) {
                                s5 = [];
                                s6 = peg$parseDIGIT();
                                if (s6 !== h) {
                                    while (s6 !== h) {
                                        s5.push(s6);
                                        s6 = peg$parseDIGIT()
                                    }
                                } else {
                                    s5 = h
                                }
                                if (s5 !== h) {
                                    id = a;
                                    s1 = dP();
                                    a = s1
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseINVITEm() {
                var a;
                if (f.substr(ic, 6) === dQ) {
                    a = dQ;
                    ic += 6
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(dR)
                    }
                }
                return a
            }

            function peg$parseACKm() {
                var a;
                if (f.substr(ic, 3) === dS) {
                    a = dS;
                    ic += 3
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(dT)
                    }
                }
                return a
            }

            function peg$parsePRACKm() {
                var a;
                if (f.substr(ic, 5) === dU) {
                    a = dU;
                    ic += 5
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(dV)
                    }
                }
                return a
            }

            function peg$parseOPTIONSm() {
                var a;
                if (f.substr(ic, 7) === dW) {
                    a = dW;
                    ic += 7
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(dX)
                    }
                }
                return a
            }

            function peg$parseBYEm() {
                var a;
                if (f.substr(ic, 3) === dY) {
                    a = dY;
                    ic += 3
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(dZ)
                    }
                }
                return a
            }

            function peg$parseCANCELm() {
                var a;
                if (f.substr(ic, 6) === ea) {
                    a = ea;
                    ic += 6
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(eb)
                    }
                }
                return a
            }

            function peg$parseREGISTERm() {
                var a;
                if (f.substr(ic, 8) === ec) {
                    a = ec;
                    ic += 8
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(ed)
                    }
                }
                return a
            }

            function peg$parseSUBSCRIBEm() {
                var a;
                if (f.substr(ic, 9) === ee) {
                    a = ee;
                    ic += 9
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(ef)
                    }
                }
                return a
            }

            function peg$parseNOTIFYm() {
                var a;
                if (f.substr(ic, 6) === eg) {
                    a = eg;
                    ic += 6
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(eh)
                    }
                }
                return a
            }

            function peg$parseREFERm() {
                var a;
                if (f.substr(ic, 5) === ei) {
                    a = ei;
                    ic += 5
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(ej)
                    }
                }
                return a
            }

            function peg$parsePUBLISHm() {
                var a;
                if (f.substr(ic, 7) === ek) {
                    a = ek;
                    ic += 7
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(el)
                    }
                }
                return a
            }

            function peg$parseMethod() {
                var a, s1;
                a = ic;
                s1 = peg$parseINVITEm();
                if (s1 === h) {
                    s1 = peg$parseACKm();
                    if (s1 === h) {
                        s1 = peg$parseOPTIONSm();
                        if (s1 === h) {
                            s1 = peg$parseBYEm();
                            if (s1 === h) {
                                s1 = peg$parseCANCELm();
                                if (s1 === h) {
                                    s1 = peg$parseREGISTERm();
                                    if (s1 === h) {
                                        s1 = peg$parseSUBSCRIBEm();
                                        if (s1 === h) {
                                            s1 = peg$parsePUBLISHm();
                                            if (s1 === h) {
                                                s1 = peg$parseNOTIFYm();
                                                if (s1 === h) {
                                                    s1 = peg$parseREFERm();
                                                    if (s1 === h) {
                                                        s1 = peg$parsetoken()
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = em()
                }
                a = s1;
                return a
            }

            function peg$parseStatus_Line() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseSIP_Version();
                if (s1 !== h) {
                    s2 = peg$parseSP();
                    if (s2 !== h) {
                        s3 = peg$parseStatus_Code();
                        if (s3 !== h) {
                            s4 = peg$parseSP();
                            if (s4 !== h) {
                                s5 = peg$parseReason_Phrase();
                                if (s5 !== h) {
                                    s1 = [s1, s2, s3, s4, s5];
                                    a = s1
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseStatus_Code() {
                var a, s1;
                a = ic;
                s1 = peg$parseextension_code();
                if (s1 !== h) {
                    id = a;
                    s1 = en(s1)
                }
                a = s1;
                return a
            }

            function peg$parseextension_code() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parseDIGIT();
                if (s1 !== h) {
                    s2 = peg$parseDIGIT();
                    if (s2 !== h) {
                        s3 = peg$parseDIGIT();
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseReason_Phrase() {
                var a, s1, s2;
                a = ic;
                s1 = [];
                s2 = peg$parsereserved();
                if (s2 === h) {
                    s2 = peg$parseunreserved();
                    if (s2 === h) {
                        s2 = peg$parseescaped();
                        if (s2 === h) {
                            s2 = peg$parseUTF8_NONASCII();
                            if (s2 === h) {
                                s2 = peg$parseUTF8_CONT();
                                if (s2 === h) {
                                    s2 = peg$parseSP();
                                    if (s2 === h) {
                                        s2 = peg$parseHTAB()
                                    }
                                }
                            }
                        }
                    }
                }
                while (s2 !== h) {
                    s1.push(s2);
                    s2 = peg$parsereserved();
                    if (s2 === h) {
                        s2 = peg$parseunreserved();
                        if (s2 === h) {
                            s2 = peg$parseescaped();
                            if (s2 === h) {
                                s2 = peg$parseUTF8_NONASCII();
                                if (s2 === h) {
                                    s2 = peg$parseUTF8_CONT();
                                    if (s2 === h) {
                                        s2 = peg$parseSP();
                                        if (s2 === h) {
                                            s2 = peg$parseHTAB()
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = eo()
                }
                a = s1;
                return a
            }

            function peg$parseAllow_Events() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseevent_type();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseCOMMA();
                    if (s4 !== h) {
                        s5 = peg$parseevent_type();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseCOMMA();
                        if (s4 !== h) {
                            s5 = peg$parseevent_type();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseCall_ID() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = peg$parseword();
                if (s1 !== h) {
                    s2 = ic;
                    if (f.charCodeAt(ic) === 64) {
                        s3 = N;
                        ic++
                    } else {
                        s3 = h;
                        if (il === 0) {
                            peg$fail(O)
                        }
                    }
                    if (s3 !== h) {
                        s4 = peg$parseword();
                        if (s4 !== h) {
                            s3 = [s3, s4];
                            s2 = s3
                        } else {
                            ic = s2;
                            s2 = h
                        }
                    } else {
                        ic = s2;
                        s2 = h
                    }
                    if (s2 === h) {
                        s2 = null
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = ep();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseContact() {
                var a, s1, s2, s3, s4, s5, s6;
                a = ic;
                s1 = peg$parseSTAR();
                if (s1 === h) {
                    s1 = ic;
                    s2 = peg$parsecontact_param();
                    if (s2 !== h) {
                        s3 = [];
                        s4 = ic;
                        s5 = peg$parseCOMMA();
                        if (s5 !== h) {
                            s6 = peg$parsecontact_param();
                            if (s6 !== h) {
                                s5 = [s5, s6];
                                s4 = s5
                            } else {
                                ic = s4;
                                s4 = h
                            }
                        } else {
                            ic = s4;
                            s4 = h
                        }
                        while (s4 !== h) {
                            s3.push(s4);
                            s4 = ic;
                            s5 = peg$parseCOMMA();
                            if (s5 !== h) {
                                s6 = peg$parsecontact_param();
                                if (s6 !== h) {
                                    s5 = [s5, s6];
                                    s4 = s5
                                } else {
                                    ic = s4;
                                    s4 = h
                                }
                            } else {
                                ic = s4;
                                s4 = h
                            }
                        }
                        if (s3 !== h) {
                            s2 = [s2, s3];
                            s1 = s2
                        } else {
                            ic = s1;
                            s1 = h
                        }
                    } else {
                        ic = s1;
                        s1 = h
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = eq()
                }
                a = s1;
                return a
            }

            function peg$parsecontact_param() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseSIP_URI_noparams();
                if (s1 === h) {
                    s1 = peg$parsename_addr()
                }
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseSEMI();
                    if (s4 !== h) {
                        s5 = peg$parsecontact_params();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseSEMI();
                        if (s4 !== h) {
                            s5 = peg$parsecontact_params();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = er();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsename_addr() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = peg$parsedisplayName();
                if (s1 === h) {
                    s1 = null
                }
                if (s1 !== h) {
                    s2 = peg$parseLAQUOT();
                    if (s2 !== h) {
                        s3 = peg$parseSIP_URI();
                        if (s3 !== h) {
                            s4 = peg$parseRAQUOT();
                            if (s4 !== h) {
                                s1 = [s1, s2, s3, s4];
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsedisplayName() {
                var a, s1, s2, s3, s4, s5, s6;
                a = ic;
                s1 = ic;
                s2 = peg$parsetoken();
                if (s2 !== h) {
                    s3 = [];
                    s4 = ic;
                    s5 = peg$parseLWS();
                    if (s5 !== h) {
                        s6 = peg$parsetoken();
                        if (s6 !== h) {
                            s5 = [s5, s6];
                            s4 = s5
                        } else {
                            ic = s4;
                            s4 = h
                        }
                    } else {
                        ic = s4;
                        s4 = h
                    }
                    while (s4 !== h) {
                        s3.push(s4);
                        s4 = ic;
                        s5 = peg$parseLWS();
                        if (s5 !== h) {
                            s6 = peg$parsetoken();
                            if (s6 !== h) {
                                s5 = [s5, s6];
                                s4 = s5
                            } else {
                                ic = s4;
                                s4 = h
                            }
                        } else {
                            ic = s4;
                            s4 = h
                        }
                    }
                    if (s3 !== h) {
                        s2 = [s2, s3];
                        s1 = s2
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 === h) {
                    s1 = peg$parsequoted_string()
                }
                if (s1 !== h) {
                    id = a;
                    s1 = es(s1)
                }
                a = s1;
                return a
            }

            function peg$parsecontact_params() {
                var a;
                a = peg$parsec_p_q();
                if (a === h) {
                    a = peg$parsec_p_expires();
                    if (a === h) {
                        a = peg$parsegeneric_param()
                    }
                }
                return a
            }

            function peg$parsec_p_q() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 1)
                    .toLowerCase() === et) {
                    s1 = f.charAt(ic);
                    ic++
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(eu)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parseqvalue();
                        if (s3 !== h) {
                            id = a;
                            s1 = ev(s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsec_p_expires() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 7)
                    .toLowerCase() === ew) {
                    s1 = f.substr(ic, 7);
                    ic += 7
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(ex)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parsedelta_seconds();
                        if (s3 !== h) {
                            id = a;
                            s1 = ey(s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsedelta_seconds() {
                var a, s1, s2;
                a = ic;
                s1 = [];
                s2 = peg$parseDIGIT();
                if (s2 !== h) {
                    while (s2 !== h) {
                        s1.push(s2);
                        s2 = peg$parseDIGIT()
                    }
                } else {
                    s1 = h
                }
                if (s1 !== h) {
                    id = a;
                    s1 = ez(s1)
                }
                a = s1;
                return a
            }

            function peg$parseqvalue() {
                var a, s1, s2, s3, s4, s5, s6;
                a = ic;
                if (f.charCodeAt(ic) === 48) {
                    s1 = eA;
                    ic++
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(eB)
                    }
                }
                if (s1 !== h) {
                    s2 = ic;
                    if (f.charCodeAt(ic) === 46) {
                        s3 = bh;
                        ic++
                    } else {
                        s3 = h;
                        if (il === 0) {
                            peg$fail(bi)
                        }
                    }
                    if (s3 !== h) {
                        s4 = peg$parseDIGIT();
                        if (s4 === h) {
                            s4 = null
                        }
                        if (s4 !== h) {
                            s5 = peg$parseDIGIT();
                            if (s5 === h) {
                                s5 = null
                            }
                            if (s5 !== h) {
                                s6 = peg$parseDIGIT();
                                if (s6 === h) {
                                    s6 = null
                                }
                                if (s6 !== h) {
                                    s3 = [s3, s4, s5, s6];
                                    s2 = s3
                                } else {
                                    ic = s2;
                                    s2 = h
                                }
                            } else {
                                ic = s2;
                                s2 = h
                            }
                        } else {
                            ic = s2;
                            s2 = h
                        }
                    } else {
                        ic = s2;
                        s2 = h
                    }
                    if (s2 === h) {
                        s2 = null
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = eC();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsegeneric_param() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = peg$parsetoken();
                if (s1 !== h) {
                    s2 = ic;
                    s3 = peg$parseEQUAL();
                    if (s3 !== h) {
                        s4 = peg$parsegen_value();
                        if (s4 !== h) {
                            s3 = [s3, s4];
                            s2 = s3
                        } else {
                            ic = s2;
                            s2 = h
                        }
                    } else {
                        ic = s2;
                        s2 = h
                    }
                    if (s2 === h) {
                        s2 = null
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = eD(s1, s2);
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsegen_value() {
                var a;
                a = peg$parsetoken();
                if (a === h) {
                    a = peg$parsehost();
                    if (a === h) {
                        a = peg$parsequoted_string()
                    }
                }
                return a
            }

            function peg$parseContent_Disposition() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parsedisp_type();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseSEMI();
                    if (s4 !== h) {
                        s5 = peg$parsedisp_param();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseSEMI();
                        if (s4 !== h) {
                            s5 = peg$parsedisp_param();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsedisp_type() {
                var a, s1;
                a = ic;
                if (f.substr(ic, 6)
                    .toLowerCase() === eE) {
                    s1 = f.substr(ic, 6);
                    ic += 6
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(eF)
                    }
                }
                if (s1 === h) {
                    if (f.substr(ic, 7)
                        .toLowerCase() === eG) {
                        s1 = f.substr(ic, 7);
                        ic += 7
                    } else {
                        s1 = h;
                        if (il === 0) {
                            peg$fail(eH)
                        }
                    }
                    if (s1 === h) {
                        if (f.substr(ic, 4)
                            .toLowerCase() === eI) {
                            s1 = f.substr(ic, 4);
                            ic += 4
                        } else {
                            s1 = h;
                            if (il === 0) {
                                peg$fail(eJ)
                            }
                        }
                        if (s1 === h) {
                            if (f.substr(ic, 5)
                                .toLowerCase() === eK) {
                                s1 = f.substr(ic, 5);
                                ic += 5
                            } else {
                                s1 = h;
                                if (il === 0) {
                                    peg$fail(eL)
                                }
                            }
                            if (s1 === h) {
                                s1 = peg$parsetoken()
                            }
                        }
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = eM()
                }
                a = s1;
                return a
            }

            function peg$parsedisp_param() {
                var a;
                a = peg$parsehandling_param();
                if (a === h) {
                    a = peg$parsegeneric_param()
                }
                return a
            }

            function peg$parsehandling_param() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 8)
                    .toLowerCase() === eN) {
                    s1 = f.substr(ic, 8);
                    ic += 8
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(eO)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        if (f.substr(ic, 8)
                            .toLowerCase() === eP) {
                            s3 = f.substr(ic, 8);
                            ic += 8
                        } else {
                            s3 = h;
                            if (il === 0) {
                                peg$fail(eQ)
                            }
                        }
                        if (s3 === h) {
                            if (f.substr(ic, 8)
                                .toLowerCase() === eR) {
                                s3 = f.substr(ic, 8);
                                ic += 8
                            } else {
                                s3 = h;
                                if (il === 0) {
                                    peg$fail(eS)
                                }
                            }
                            if (s3 === h) {
                                s3 = peg$parsetoken()
                            }
                        }
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseContent_Encoding() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parsetoken();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseCOMMA();
                    if (s4 !== h) {
                        s5 = peg$parsetoken();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseCOMMA();
                        if (s4 !== h) {
                            s5 = peg$parsetoken();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseContent_Length() {
                var a, s1, s2;
                a = ic;
                s1 = [];
                s2 = peg$parseDIGIT();
                if (s2 !== h) {
                    while (s2 !== h) {
                        s1.push(s2);
                        s2 = peg$parseDIGIT()
                    }
                } else {
                    s1 = h
                }
                if (s1 !== h) {
                    id = a;
                    s1 = eT(s1)
                }
                a = s1;
                return a
            }

            function peg$parseContent_Type() {
                var a, s1;
                a = ic;
                s1 = peg$parsemedia_type();
                if (s1 !== h) {
                    id = a;
                    s1 = eU()
                }
                a = s1;
                return a
            }

            function peg$parsemedia_type() {
                var a, s1, s2, s3, s4, s5, s6, s7;
                a = ic;
                s1 = peg$parsem_type();
                if (s1 !== h) {
                    s2 = peg$parseSLASH();
                    if (s2 !== h) {
                        s3 = peg$parsem_subtype();
                        if (s3 !== h) {
                            s4 = [];
                            s5 = ic;
                            s6 = peg$parseSEMI();
                            if (s6 !== h) {
                                s7 = peg$parsem_parameter();
                                if (s7 !== h) {
                                    s6 = [s6, s7];
                                    s5 = s6
                                } else {
                                    ic = s5;
                                    s5 = h
                                }
                            } else {
                                ic = s5;
                                s5 = h
                            }
                            while (s5 !== h) {
                                s4.push(s5);
                                s5 = ic;
                                s6 = peg$parseSEMI();
                                if (s6 !== h) {
                                    s7 = peg$parsem_parameter();
                                    if (s7 !== h) {
                                        s6 = [s6, s7];
                                        s5 = s6
                                    } else {
                                        ic = s5;
                                        s5 = h
                                    }
                                } else {
                                    ic = s5;
                                    s5 = h
                                }
                            }
                            if (s4 !== h) {
                                s1 = [s1, s2, s3, s4];
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsem_type() {
                var a;
                a = peg$parsediscrete_type();
                if (a === h) {
                    a = peg$parsecomposite_type()
                }
                return a
            }

            function peg$parsediscrete_type() {
                var a;
                if (f.substr(ic, 4)
                    .toLowerCase() === eV) {
                    a = f.substr(ic, 4);
                    ic += 4
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(eW)
                    }
                }
                if (a === h) {
                    if (f.substr(ic, 5)
                        .toLowerCase() === eX) {
                        a = f.substr(ic, 5);
                        ic += 5
                    } else {
                        a = h;
                        if (il === 0) {
                            peg$fail(eY)
                        }
                    }
                    if (a === h) {
                        if (f.substr(ic, 5)
                            .toLowerCase() === eZ) {
                            a = f.substr(ic, 5);
                            ic += 5
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(fa)
                            }
                        }
                        if (a === h) {
                            if (f.substr(ic, 5)
                                .toLowerCase() === fb) {
                                a = f.substr(ic, 5);
                                ic += 5
                            } else {
                                a = h;
                                if (il === 0) {
                                    peg$fail(fc)
                                }
                            }
                            if (a === h) {
                                if (f.substr(ic, 11)
                                    .toLowerCase() === fd) {
                                    a = f.substr(ic, 11);
                                    ic += 11
                                } else {
                                    a = h;
                                    if (il === 0) {
                                        peg$fail(fe)
                                    }
                                }
                                if (a === h) {
                                    a = peg$parseextension_token()
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parsecomposite_type() {
                var a;
                if (f.substr(ic, 7)
                    .toLowerCase() === ff) {
                    a = f.substr(ic, 7);
                    ic += 7
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(fg)
                    }
                }
                if (a === h) {
                    if (f.substr(ic, 9)
                        .toLowerCase() === fh) {
                        a = f.substr(ic, 9);
                        ic += 9
                    } else {
                        a = h;
                        if (il === 0) {
                            peg$fail(fi)
                        }
                    }
                    if (a === h) {
                        a = peg$parseextension_token()
                    }
                }
                return a
            }

            function peg$parseextension_token() {
                var a;
                a = peg$parsetoken();
                if (a === h) {
                    a = peg$parsex_token()
                }
                return a
            }

            function peg$parsex_token() {
                var a, s1, s2;
                a = ic;
                if (f.substr(ic, 2)
                    .toLowerCase() === fj) {
                    s1 = f.substr(ic, 2);
                    ic += 2
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(fk)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parsetoken();
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsem_subtype() {
                var a;
                a = peg$parseextension_token();
                if (a === h) {
                    a = peg$parsetoken()
                }
                return a
            }

            function peg$parsem_parameter() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parsetoken();
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parsem_value();
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsem_value() {
                var a;
                a = peg$parsetoken();
                if (a === h) {
                    a = peg$parsequoted_string()
                }
                return a
            }

            function peg$parseCSeq() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parseCSeq_value();
                if (s1 !== h) {
                    s2 = peg$parseLWS();
                    if (s2 !== h) {
                        s3 = peg$parseMethod();
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseCSeq_value() {
                var a, s1, s2;
                a = ic;
                s1 = [];
                s2 = peg$parseDIGIT();
                if (s2 !== h) {
                    while (s2 !== h) {
                        s1.push(s2);
                        s2 = peg$parseDIGIT()
                    }
                } else {
                    s1 = h
                }
                if (s1 !== h) {
                    id = a;
                    s1 = fl(s1)
                }
                a = s1;
                return a
            }

            function peg$parseExpires() {
                var a, s1;
                a = ic;
                s1 = peg$parsedelta_seconds();
                if (s1 !== h) {
                    id = a;
                    s1 = fm(s1)
                }
                a = s1;
                return a
            }

            function peg$parseEvent() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseevent_type();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseSEMI();
                    if (s4 !== h) {
                        s5 = peg$parsegeneric_param();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseSEMI();
                        if (s4 !== h) {
                            s5 = peg$parsegeneric_param();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = fn(s1);
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseevent_type() {
                var a, s1, s2, s3, s4, s5, s6;
                a = ic;
                s1 = ic;
                s2 = peg$parsetoken_nodot();
                if (s2 !== h) {
                    s3 = [];
                    s4 = ic;
                    if (f.charCodeAt(ic) === 46) {
                        s5 = bh;
                        ic++
                    } else {
                        s5 = h;
                        if (il === 0) {
                            peg$fail(bi)
                        }
                    }
                    if (s5 !== h) {
                        s6 = peg$parsetoken_nodot();
                        if (s6 !== h) {
                            s5 = [s5, s6];
                            s4 = s5
                        } else {
                            ic = s4;
                            s4 = h
                        }
                    } else {
                        ic = s4;
                        s4 = h
                    }
                    while (s4 !== h) {
                        s3.push(s4);
                        s4 = ic;
                        if (f.charCodeAt(ic) === 46) {
                            s5 = bh;
                            ic++
                        } else {
                            s5 = h;
                            if (il === 0) {
                                peg$fail(bi)
                            }
                        }
                        if (s5 !== h) {
                            s6 = peg$parsetoken_nodot();
                            if (s6 !== h) {
                                s5 = [s5, s6];
                                s4 = s5
                            } else {
                                ic = s4;
                                s4 = h
                            }
                        } else {
                            ic = s4;
                            s4 = h
                        }
                    }
                    if (s3 !== h) {
                        s2 = [s2, s3];
                        s1 = s2
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 !== h) {
                    a = f.substring(a, ic)
                } else {
                    a = s1
                }
                return a
            }

            function peg$parseFrom() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseSIP_URI_noparams();
                if (s1 === h) {
                    s1 = peg$parsename_addr()
                }
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseSEMI();
                    if (s4 !== h) {
                        s5 = peg$parsefrom_param();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseSEMI();
                        if (s4 !== h) {
                            s5 = peg$parsefrom_param();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = fo();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsefrom_param() {
                var a;
                a = peg$parsetag_param();
                if (a === h) {
                    a = peg$parsegeneric_param()
                }
                return a
            }

            function peg$parsetag_param() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 3)
                    .toLowerCase() === fp) {
                    s1 = f.substr(ic, 3);
                    ic += 3
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(fq)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parsetoken();
                        if (s3 !== h) {
                            id = a;
                            s1 = fr(s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseMax_Forwards() {
                var a, s1, s2;
                a = ic;
                s1 = [];
                s2 = peg$parseDIGIT();
                if (s2 !== h) {
                    while (s2 !== h) {
                        s1.push(s2);
                        s2 = peg$parseDIGIT()
                    }
                } else {
                    s1 = h
                }
                if (s1 !== h) {
                    id = a;
                    s1 = fs(s1)
                }
                a = s1;
                return a
            }

            function peg$parseMin_Expires() {
                var a, s1;
                a = ic;
                s1 = peg$parsedelta_seconds();
                if (s1 !== h) {
                    id = a;
                    s1 = ft(s1)
                }
                a = s1;
                return a
            }

            function peg$parseName_Addr_Header() {
                var a, s1, s2, s3, s4, s5, s6, s7, s8;
                a = ic;
                s1 = [];
                s2 = peg$parsedisplayName();
                while (s2 !== h) {
                    s1.push(s2);
                    s2 = peg$parsedisplayName()
                }
                if (s1 !== h) {
                    s2 = peg$parseLAQUOT();
                    if (s2 !== h) {
                        s3 = peg$parseSIP_URI();
                        if (s3 !== h) {
                            s4 = peg$parseRAQUOT();
                            if (s4 !== h) {
                                s5 = [];
                                s6 = ic;
                                s7 = peg$parseSEMI();
                                if (s7 !== h) {
                                    s8 = peg$parsegeneric_param();
                                    if (s8 !== h) {
                                        s7 = [s7, s8];
                                        s6 = s7
                                    } else {
                                        ic = s6;
                                        s6 = h
                                    }
                                } else {
                                    ic = s6;
                                    s6 = h
                                }
                                while (s6 !== h) {
                                    s5.push(s6);
                                    s6 = ic;
                                    s7 = peg$parseSEMI();
                                    if (s7 !== h) {
                                        s8 = peg$parsegeneric_param();
                                        if (s8 !== h) {
                                            s7 = [s7, s8];
                                            s6 = s7
                                        } else {
                                            ic = s6;
                                            s6 = h
                                        }
                                    } else {
                                        ic = s6;
                                        s6 = h
                                    }
                                }
                                if (s5 !== h) {
                                    id = a;
                                    s1 = fu();
                                    a = s1
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseProxy_Authenticate() {
                var a;
                a = peg$parsechallenge();
                return a
            }

            function peg$parsechallenge() {
                var a, s1, s2, s3, s4, s5, s6, s7;
                a = ic;
                if (f.substr(ic, 6)
                    .toLowerCase() === fv) {
                    s1 = f.substr(ic, 6);
                    ic += 6
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(fw)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseLWS();
                    if (s2 !== h) {
                        s3 = peg$parsedigest_cln();
                        if (s3 !== h) {
                            s4 = [];
                            s5 = ic;
                            s6 = peg$parseCOMMA();
                            if (s6 !== h) {
                                s7 = peg$parsedigest_cln();
                                if (s7 !== h) {
                                    s6 = [s6, s7];
                                    s5 = s6
                                } else {
                                    ic = s5;
                                    s5 = h
                                }
                            } else {
                                ic = s5;
                                s5 = h
                            }
                            while (s5 !== h) {
                                s4.push(s5);
                                s5 = ic;
                                s6 = peg$parseCOMMA();
                                if (s6 !== h) {
                                    s7 = peg$parsedigest_cln();
                                    if (s7 !== h) {
                                        s6 = [s6, s7];
                                        s5 = s6
                                    } else {
                                        ic = s5;
                                        s5 = h
                                    }
                                } else {
                                    ic = s5;
                                    s5 = h
                                }
                            }
                            if (s4 !== h) {
                                s1 = [s1, s2, s3, s4];
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                if (a === h) {
                    a = peg$parseother_challenge()
                }
                return a
            }

            function peg$parseother_challenge() {
                var a, s1, s2, s3, s4, s5, s6, s7;
                a = ic;
                s1 = peg$parsetoken();
                if (s1 !== h) {
                    s2 = peg$parseLWS();
                    if (s2 !== h) {
                        s3 = peg$parseauth_param();
                        if (s3 !== h) {
                            s4 = [];
                            s5 = ic;
                            s6 = peg$parseCOMMA();
                            if (s6 !== h) {
                                s7 = peg$parseauth_param();
                                if (s7 !== h) {
                                    s6 = [s6, s7];
                                    s5 = s6
                                } else {
                                    ic = s5;
                                    s5 = h
                                }
                            } else {
                                ic = s5;
                                s5 = h
                            }
                            while (s5 !== h) {
                                s4.push(s5);
                                s5 = ic;
                                s6 = peg$parseCOMMA();
                                if (s6 !== h) {
                                    s7 = peg$parseauth_param();
                                    if (s7 !== h) {
                                        s6 = [s6, s7];
                                        s5 = s6
                                    } else {
                                        ic = s5;
                                        s5 = h
                                    }
                                } else {
                                    ic = s5;
                                    s5 = h
                                }
                            }
                            if (s4 !== h) {
                                s1 = [s1, s2, s3, s4];
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseauth_param() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parsetoken();
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parsetoken();
                        if (s3 === h) {
                            s3 = peg$parsequoted_string()
                        }
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsedigest_cln() {
                var a;
                a = peg$parserealm();
                if (a === h) {
                    a = peg$parsedomain();
                    if (a === h) {
                        a = peg$parsenonce();
                        if (a === h) {
                            a = peg$parseopaque();
                            if (a === h) {
                                a = peg$parsestale();
                                if (a === h) {
                                    a = peg$parsealgorithm();
                                    if (a === h) {
                                        a = peg$parseqop_options();
                                        if (a === h) {
                                            a = peg$parseauth_param()
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parserealm() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 5)
                    .toLowerCase() === fx) {
                    s1 = f.substr(ic, 5);
                    ic += 5
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(fy)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parserealm_value();
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parserealm_value() {
                var a, s1;
                a = ic;
                s1 = peg$parsequoted_string_clean();
                if (s1 !== h) {
                    id = a;
                    s1 = fz(s1)
                }
                a = s1;
                return a
            }

            function peg$parsedomain() {
                var a, s1, s2, s3, s4, s5, s6, s7, s8;
                a = ic;
                if (f.substr(ic, 6)
                    .toLowerCase() === fA) {
                    s1 = f.substr(ic, 6);
                    ic += 6
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(fB)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parseLDQUOT();
                        if (s3 !== h) {
                            s4 = peg$parseURI();
                            if (s4 !== h) {
                                s5 = [];
                                s6 = ic;
                                s7 = [];
                                s8 = peg$parseSP();
                                if (s8 !== h) {
                                    while (s8 !== h) {
                                        s7.push(s8);
                                        s8 = peg$parseSP()
                                    }
                                } else {
                                    s7 = h
                                }
                                if (s7 !== h) {
                                    s8 = peg$parseURI();
                                    if (s8 !== h) {
                                        s7 = [s7, s8];
                                        s6 = s7
                                    } else {
                                        ic = s6;
                                        s6 = h
                                    }
                                } else {
                                    ic = s6;
                                    s6 = h
                                }
                                while (s6 !== h) {
                                    s5.push(s6);
                                    s6 = ic;
                                    s7 = [];
                                    s8 = peg$parseSP();
                                    if (s8 !== h) {
                                        while (s8 !== h) {
                                            s7.push(s8);
                                            s8 = peg$parseSP()
                                        }
                                    } else {
                                        s7 = h
                                    }
                                    if (s7 !== h) {
                                        s8 = peg$parseURI();
                                        if (s8 !== h) {
                                            s7 = [s7, s8];
                                            s6 = s7
                                        } else {
                                            ic = s6;
                                            s6 = h
                                        }
                                    } else {
                                        ic = s6;
                                        s6 = h
                                    }
                                }
                                if (s5 !== h) {
                                    s6 = peg$parseRDQUOT();
                                    if (s6 !== h) {
                                        s1 = [s1, s2, s3, s4, s5, s6];
                                        a = s1
                                    } else {
                                        ic = a;
                                        a = h
                                    }
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseURI() {
                var a;
                a = peg$parseabsoluteURI();
                if (a === h) {
                    a = peg$parseabs_path()
                }
                return a
            }

            function peg$parsenonce() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 5)
                    .toLowerCase() === fC) {
                    s1 = f.substr(ic, 5);
                    ic += 5
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(fD)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parsenonce_value();
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsenonce_value() {
                var a, s1;
                a = ic;
                s1 = peg$parsequoted_string_clean();
                if (s1 !== h) {
                    id = a;
                    s1 = fE(s1)
                }
                a = s1;
                return a
            }

            function peg$parseopaque() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 6)
                    .toLowerCase() === fF) {
                    s1 = f.substr(ic, 6);
                    ic += 6
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(fG)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parsequoted_string_clean();
                        if (s3 !== h) {
                            id = a;
                            s1 = fH(s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsestale() {
                var a, s1, s2, s3, s4;
                a = ic;
                if (f.substr(ic, 5)
                    .toLowerCase() === fI) {
                    s1 = f.substr(ic, 5);
                    ic += 5
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(fJ)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = ic;
                        if (f.substr(ic, 4)
                            .toLowerCase() === fK) {
                            s4 = f.substr(ic, 4);
                            ic += 4
                        } else {
                            s4 = h;
                            if (il === 0) {
                                peg$fail(fL)
                            }
                        }
                        if (s4 !== h) {
                            id = s3;
                            s4 = fM()
                        }
                        s3 = s4;
                        if (s3 === h) {
                            s3 = ic;
                            if (f.substr(ic, 5)
                                .toLowerCase() === fN) {
                                s4 = f.substr(ic, 5);
                                ic += 5
                            } else {
                                s4 = h;
                                if (il === 0) {
                                    peg$fail(fO)
                                }
                            }
                            if (s4 !== h) {
                                id = s3;
                                s4 = fP()
                            }
                            s3 = s4
                        }
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsealgorithm() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 9)
                    .toLowerCase() === fQ) {
                    s1 = f.substr(ic, 9);
                    ic += 9
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(fR)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        if (f.substr(ic, 3)
                            .toLowerCase() === fS) {
                            s3 = f.substr(ic, 3);
                            ic += 3
                        } else {
                            s3 = h;
                            if (il === 0) {
                                peg$fail(fT)
                            }
                        }
                        if (s3 === h) {
                            if (f.substr(ic, 8)
                                .toLowerCase() === fU) {
                                s3 = f.substr(ic, 8);
                                ic += 8
                            } else {
                                s3 = h;
                                if (il === 0) {
                                    peg$fail(fV)
                                }
                            }
                            if (s3 === h) {
                                s3 = peg$parsetoken()
                            }
                        }
                        if (s3 !== h) {
                            id = a;
                            s1 = fW(s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseqop_options() {
                var a, s1, s2, s3, s4, s5, s6, s7, s8, s9;
                a = ic;
                if (f.substr(ic, 3)
                    .toLowerCase() === fX) {
                    s1 = f.substr(ic, 3);
                    ic += 3
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(fY)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parseLDQUOT();
                        if (s3 !== h) {
                            s4 = ic;
                            s5 = peg$parseqop_value();
                            if (s5 !== h) {
                                s6 = [];
                                s7 = ic;
                                if (f.charCodeAt(ic) === 44) {
                                    s8 = X;
                                    ic++
                                } else {
                                    s8 = h;
                                    if (il === 0) {
                                        peg$fail(Y)
                                    }
                                }
                                if (s8 !== h) {
                                    s9 = peg$parseqop_value();
                                    if (s9 !== h) {
                                        s8 = [s8, s9];
                                        s7 = s8
                                    } else {
                                        ic = s7;
                                        s7 = h
                                    }
                                } else {
                                    ic = s7;
                                    s7 = h
                                }
                                while (s7 !== h) {
                                    s6.push(s7);
                                    s7 = ic;
                                    if (f.charCodeAt(ic) === 44) {
                                        s8 = X;
                                        ic++
                                    } else {
                                        s8 = h;
                                        if (il === 0) {
                                            peg$fail(Y)
                                        }
                                    }
                                    if (s8 !== h) {
                                        s9 = peg$parseqop_value();
                                        if (s9 !== h) {
                                            s8 = [s8, s9];
                                            s7 = s8
                                        } else {
                                            ic = s7;
                                            s7 = h
                                        }
                                    } else {
                                        ic = s7;
                                        s7 = h
                                    }
                                }
                                if (s6 !== h) {
                                    s5 = [s5, s6];
                                    s4 = s5
                                } else {
                                    ic = s4;
                                    s4 = h
                                }
                            } else {
                                ic = s4;
                                s4 = h
                            }
                            if (s4 !== h) {
                                s5 = peg$parseRDQUOT();
                                if (s5 !== h) {
                                    s1 = [s1, s2, s3, s4, s5];
                                    a = s1
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseqop_value() {
                var a, s1;
                a = ic;
                if (f.substr(ic, 8)
                    .toLowerCase() === fZ) {
                    s1 = f.substr(ic, 8);
                    ic += 8
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(ga)
                    }
                }
                if (s1 === h) {
                    if (f.substr(ic, 4)
                        .toLowerCase() === gb) {
                        s1 = f.substr(ic, 4);
                        ic += 4
                    } else {
                        s1 = h;
                        if (il === 0) {
                            peg$fail(gc)
                        }
                    }
                    if (s1 === h) {
                        s1 = peg$parsetoken()
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = gd(s1)
                }
                a = s1;
                return a
            }

            function peg$parseProxy_Require() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parsetoken();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseCOMMA();
                    if (s4 !== h) {
                        s5 = peg$parsetoken();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseCOMMA();
                        if (s4 !== h) {
                            s5 = peg$parsetoken();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseRAck() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseRAck_value();
                if (s1 !== h) {
                    s2 = peg$parseLWS();
                    if (s2 !== h) {
                        s3 = peg$parseRAck_value();
                        if (s3 !== h) {
                            s4 = peg$parseLWS();
                            if (s4 !== h) {
                                s5 = peg$parseMethod();
                                if (s5 !== h) {
                                    s1 = [s1, s2, s3, s4, s5];
                                    a = s1
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseRAck_value() {
                var a, s1, s2;
                a = ic;
                s1 = [];
                s2 = peg$parseDIGIT();
                if (s2 !== h) {
                    while (s2 !== h) {
                        s1.push(s2);
                        s2 = peg$parseDIGIT()
                    }
                } else {
                    s1 = h
                }
                if (s1 !== h) {
                    id = a;
                    s1 = ge(s1)
                }
                a = s1;
                return a
            }

            function peg$parseRecord_Route() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parserec_route();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseCOMMA();
                    if (s4 !== h) {
                        s5 = peg$parserec_route();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseCOMMA();
                        if (s4 !== h) {
                            s5 = peg$parserec_route();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = gf();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parserec_route() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parsename_addr();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseSEMI();
                    if (s4 !== h) {
                        s5 = peg$parsegeneric_param();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseSEMI();
                        if (s4 !== h) {
                            s5 = peg$parsegeneric_param();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = gg();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseRefer_To() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseSIP_URI_noparams();
                if (s1 === h) {
                    s1 = peg$parsename_addr();
                    if (s1 === h) {
                        s1 = ic;
                        s2 = peg$parseLAQUOT();
                        if (s2 === h) {
                            s2 = null
                        }
                        if (s2 !== h) {
                            s3 = peg$parseabsoluteURI();
                            if (s3 !== h) {
                                s4 = peg$parseRAQUOT();
                                if (s4 === h) {
                                    s4 = null
                                }
                                if (s4 !== h) {
                                    s2 = [s2, s3, s4];
                                    s1 = s2
                                } else {
                                    ic = s1;
                                    s1 = h
                                }
                            } else {
                                ic = s1;
                                s1 = h
                            }
                        } else {
                            ic = s1;
                            s1 = h
                        }
                    }
                }
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseSEMI();
                    if (s4 !== h) {
                        s5 = peg$parsegeneric_param();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseSEMI();
                        if (s4 !== h) {
                            s5 = peg$parsegeneric_param();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = gh();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseReplaces() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parsereplaces_call_id();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseSEMI();
                    if (s4 !== h) {
                        s5 = peg$parsereplaces_params();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseSEMI();
                        if (s4 !== h) {
                            s5 = peg$parsereplaces_params();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = gi();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsereplaces_call_id() {
                var a, s1;
                a = ic;
                s1 = peg$parseCall_ID();
                if (s1 !== h) {
                    id = a;
                    s1 = gj()
                }
                a = s1;
                return a
            }

            function peg$parsereplaces_params() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 8)
                    .toLowerCase() === gk) {
                    s1 = f.substr(ic, 8);
                    ic += 8
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(gl)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parsetoken();
                        if (s3 !== h) {
                            id = a;
                            s1 = gm(s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                if (a === h) {
                    a = ic;
                    if (f.substr(ic, 6)
                        .toLowerCase() === gn) {
                        s1 = f.substr(ic, 6);
                        ic += 6
                    } else {
                        s1 = h;
                        if (il === 0) {
                            peg$fail(go)
                        }
                    }
                    if (s1 !== h) {
                        s2 = peg$parseEQUAL();
                        if (s2 !== h) {
                            s3 = peg$parsetoken();
                            if (s3 !== h) {
                                id = a;
                                s1 = gp(s3);
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                    if (a === h) {
                        a = ic;
                        if (f.substr(ic, 10)
                            .toLowerCase() === gq) {
                            s1 = f.substr(ic, 10);
                            ic += 10
                        } else {
                            s1 = h;
                            if (il === 0) {
                                peg$fail(gr)
                            }
                        }
                        if (s1 !== h) {
                            id = a;
                            s1 = gs()
                        }
                        a = s1;
                        if (a === h) {
                            a = peg$parsegeneric_param()
                        }
                    }
                }
                return a
            }

            function peg$parseRequire() {
                var a, s1, s2, s3, s4, s5, s6;
                a = ic;
                s1 = ic;
                s2 = peg$parsetoken();
                if (s2 !== h) {
                    s3 = [];
                    s4 = ic;
                    s5 = peg$parseCOMMA();
                    if (s5 !== h) {
                        s6 = peg$parsetoken();
                        if (s6 !== h) {
                            id = s4;
                            s5 = gt(s2, s6);
                            s4 = s5
                        } else {
                            ic = s4;
                            s4 = h
                        }
                    } else {
                        ic = s4;
                        s4 = h
                    }
                    while (s4 !== h) {
                        s3.push(s4);
                        s4 = ic;
                        s5 = peg$parseCOMMA();
                        if (s5 !== h) {
                            s6 = peg$parsetoken();
                            if (s6 !== h) {
                                id = s4;
                                s5 = gt(s2, s6);
                                s4 = s5
                            } else {
                                ic = s4;
                                s4 = h
                            }
                        } else {
                            ic = s4;
                            s4 = h
                        }
                    }
                    if (s3 !== h) {
                        id = s1;
                        s2 = gu(s2, s3);
                        s1 = s2
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 === h) {
                    s1 = null
                }
                if (s1 !== h) {
                    id = a;
                    s1 = gv(s1)
                }
                a = s1;
                return a
            }

            function peg$parseRoute() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseroute_param();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseCOMMA();
                    if (s4 !== h) {
                        s5 = peg$parseroute_param();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseCOMMA();
                        if (s4 !== h) {
                            s5 = peg$parseroute_param();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseroute_param() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parsename_addr();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseSEMI();
                    if (s4 !== h) {
                        s5 = peg$parsegeneric_param();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseSEMI();
                        if (s4 !== h) {
                            s5 = peg$parsegeneric_param();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseRSeq() {
                var a, s1, s2;
                a = ic;
                s1 = [];
                s2 = peg$parseDIGIT();
                if (s2 !== h) {
                    while (s2 !== h) {
                        s1.push(s2);
                        s2 = peg$parseDIGIT()
                    }
                } else {
                    s1 = h
                }
                if (s1 !== h) {
                    id = a;
                    s1 = gw(s1)
                }
                a = s1;
                return a
            }

            function peg$parseSubscription_State() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parsesubstate_value();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseSEMI();
                    if (s4 !== h) {
                        s5 = peg$parsesubexp_params();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseSEMI();
                        if (s4 !== h) {
                            s5 = peg$parsesubexp_params();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsesubstate_value() {
                var a, s1;
                a = ic;
                if (f.substr(ic, 6)
                    .toLowerCase() === gx) {
                    s1 = f.substr(ic, 6);
                    ic += 6
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(gy)
                    }
                }
                if (s1 === h) {
                    if (f.substr(ic, 7)
                        .toLowerCase() === gz) {
                        s1 = f.substr(ic, 7);
                        ic += 7
                    } else {
                        s1 = h;
                        if (il === 0) {
                            peg$fail(gA)
                        }
                    }
                    if (s1 === h) {
                        if (f.substr(ic, 10)
                            .toLowerCase() === gB) {
                            s1 = f.substr(ic, 10);
                            ic += 10
                        } else {
                            s1 = h;
                            if (il === 0) {
                                peg$fail(gC)
                            }
                        }
                        if (s1 === h) {
                            s1 = peg$parsetoken()
                        }
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = gD()
                }
                a = s1;
                return a
            }

            function peg$parsesubexp_params() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 6)
                    .toLowerCase() === gE) {
                    s1 = f.substr(ic, 6);
                    ic += 6
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(gF)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parseevent_reason_value();
                        if (s3 !== h) {
                            id = a;
                            s1 = gG(s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                if (a === h) {
                    a = ic;
                    if (f.substr(ic, 7)
                        .toLowerCase() === ew) {
                        s1 = f.substr(ic, 7);
                        ic += 7
                    } else {
                        s1 = h;
                        if (il === 0) {
                            peg$fail(ex)
                        }
                    }
                    if (s1 !== h) {
                        s2 = peg$parseEQUAL();
                        if (s2 !== h) {
                            s3 = peg$parsedelta_seconds();
                            if (s3 !== h) {
                                id = a;
                                s1 = gH(s3);
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                    if (a === h) {
                        a = ic;
                        if (f.substr(ic, 11)
                            .toLowerCase() === gI) {
                            s1 = f.substr(ic, 11);
                            ic += 11
                        } else {
                            s1 = h;
                            if (il === 0) {
                                peg$fail(gJ)
                            }
                        }
                        if (s1 !== h) {
                            s2 = peg$parseEQUAL();
                            if (s2 !== h) {
                                s3 = peg$parsedelta_seconds();
                                if (s3 !== h) {
                                    id = a;
                                    s1 = gK(s3);
                                    a = s1
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                        if (a === h) {
                            a = peg$parsegeneric_param()
                        }
                    }
                }
                return a
            }

            function peg$parseevent_reason_value() {
                var a;
                if (f.substr(ic, 11)
                    .toLowerCase() === gL) {
                    a = f.substr(ic, 11);
                    ic += 11
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(gM)
                    }
                }
                if (a === h) {
                    if (f.substr(ic, 9)
                        .toLowerCase() === gN) {
                        a = f.substr(ic, 9);
                        ic += 9
                    } else {
                        a = h;
                        if (il === 0) {
                            peg$fail(gO)
                        }
                    }
                    if (a === h) {
                        if (f.substr(ic, 8)
                            .toLowerCase() === gP) {
                            a = f.substr(ic, 8);
                            ic += 8
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(gQ)
                            }
                        }
                        if (a === h) {
                            if (f.substr(ic, 7)
                                .toLowerCase() === gR) {
                                a = f.substr(ic, 7);
                                ic += 7
                            } else {
                                a = h;
                                if (il === 0) {
                                    peg$fail(gS)
                                }
                            }
                            if (a === h) {
                                if (f.substr(ic, 6)
                                    .toLowerCase() === gT) {
                                    a = f.substr(ic, 6);
                                    ic += 6
                                } else {
                                    a = h;
                                    if (il === 0) {
                                        peg$fail(gU)
                                    }
                                }
                                if (a === h) {
                                    if (f.substr(ic, 10)
                                        .toLowerCase() === gV) {
                                        a = f.substr(ic, 10);
                                        ic += 10
                                    } else {
                                        a = h;
                                        if (il === 0) {
                                            peg$fail(gW)
                                        }
                                    }
                                    if (a === h) {
                                        if (f.substr(ic, 9)
                                            .toLowerCase() === gX) {
                                            a = f.substr(ic, 9);
                                            ic += 9
                                        } else {
                                            a = h;
                                            if (il === 0) {
                                                peg$fail(gY)
                                            }
                                        }
                                        if (a === h) {
                                            a = peg$parsetoken()
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parseSubject() {
                var a;
                a = peg$parseTEXT_UTF8_TRIM();
                if (a === h) {
                    a = null
                }
                return a
            }

            function peg$parseSupported() {
                var a, s1, s2, s3, s4, s5, s6;
                a = ic;
                s1 = ic;
                s2 = peg$parsetoken();
                if (s2 !== h) {
                    s3 = [];
                    s4 = ic;
                    s5 = peg$parseCOMMA();
                    if (s5 !== h) {
                        s6 = peg$parsetoken();
                        if (s6 !== h) {
                            id = s4;
                            s5 = gt(s2, s6);
                            s4 = s5
                        } else {
                            ic = s4;
                            s4 = h
                        }
                    } else {
                        ic = s4;
                        s4 = h
                    }
                    while (s4 !== h) {
                        s3.push(s4);
                        s4 = ic;
                        s5 = peg$parseCOMMA();
                        if (s5 !== h) {
                            s6 = peg$parsetoken();
                            if (s6 !== h) {
                                id = s4;
                                s5 = gt(s2, s6);
                                s4 = s5
                            } else {
                                ic = s4;
                                s4 = h
                            }
                        } else {
                            ic = s4;
                            s4 = h
                        }
                    }
                    if (s3 !== h) {
                        id = s1;
                        s2 = gu(s2, s3);
                        s1 = s2
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 === h) {
                    s1 = null
                }
                if (s1 !== h) {
                    id = a;
                    s1 = gZ(s1)
                }
                a = s1;
                return a
            }

            function peg$parseTo() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseSIP_URI_noparams();
                if (s1 === h) {
                    s1 = peg$parsename_addr()
                }
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseSEMI();
                    if (s4 !== h) {
                        s5 = peg$parseto_param();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseSEMI();
                        if (s4 !== h) {
                            s5 = peg$parseto_param();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = ha();
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseto_param() {
                var a;
                a = peg$parsetag_param();
                if (a === h) {
                    a = peg$parsegeneric_param()
                }
                return a
            }

            function peg$parseVia() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parsevia_parm();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseCOMMA();
                    if (s4 !== h) {
                        s5 = peg$parsevia_parm();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseCOMMA();
                        if (s4 !== h) {
                            s5 = peg$parsevia_parm();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsevia_parm() {
                var a, s1, s2, s3, s4, s5, s6, s7;
                a = ic;
                s1 = peg$parsesent_protocol();
                if (s1 !== h) {
                    s2 = peg$parseLWS();
                    if (s2 !== h) {
                        s3 = peg$parsesent_by();
                        if (s3 !== h) {
                            s4 = [];
                            s5 = ic;
                            s6 = peg$parseSEMI();
                            if (s6 !== h) {
                                s7 = peg$parsevia_params();
                                if (s7 !== h) {
                                    s6 = [s6, s7];
                                    s5 = s6
                                } else {
                                    ic = s5;
                                    s5 = h
                                }
                            } else {
                                ic = s5;
                                s5 = h
                            }
                            while (s5 !== h) {
                                s4.push(s5);
                                s5 = ic;
                                s6 = peg$parseSEMI();
                                if (s6 !== h) {
                                    s7 = peg$parsevia_params();
                                    if (s7 !== h) {
                                        s6 = [s6, s7];
                                        s5 = s6
                                    } else {
                                        ic = s5;
                                        s5 = h
                                    }
                                } else {
                                    ic = s5;
                                    s5 = h
                                }
                            }
                            if (s4 !== h) {
                                s1 = [s1, s2, s3, s4];
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsevia_params() {
                var a;
                a = peg$parsevia_ttl();
                if (a === h) {
                    a = peg$parsevia_maddr();
                    if (a === h) {
                        a = peg$parsevia_received();
                        if (a === h) {
                            a = peg$parsevia_branch();
                            if (a === h) {
                                a = peg$parseresponse_port();
                                if (a === h) {
                                    a = peg$parsegeneric_param()
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parsevia_ttl() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 3)
                    .toLowerCase() === hb) {
                    s1 = f.substr(ic, 3);
                    ic += 3
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(hc)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parsettl();
                        if (s3 !== h) {
                            id = a;
                            s1 = hd(s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsevia_maddr() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 5)
                    .toLowerCase() === he) {
                    s1 = f.substr(ic, 5);
                    ic += 5
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(hf)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parsehost();
                        if (s3 !== h) {
                            id = a;
                            s1 = hg(s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsevia_received() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 8)
                    .toLowerCase() === hh) {
                    s1 = f.substr(ic, 8);
                    ic += 8
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(hi)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parseIPv4address();
                        if (s3 === h) {
                            s3 = peg$parseIPv6address();
                            if (s3 === h) {
                                s3 = peg$parseIPv6reference()
                            }
                        }
                        if (s3 !== h) {
                            id = a;
                            s1 = hj(s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsevia_branch() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 6)
                    .toLowerCase() === hk) {
                    s1 = f.substr(ic, 6);
                    ic += 6
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(hl)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parsetoken();
                        if (s3 !== h) {
                            id = a;
                            s1 = hm(s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseresponse_port() {
                var a, s1, s2, s3, s4;
                a = ic;
                if (f.substr(ic, 5)
                    .toLowerCase() === hn) {
                    s1 = f.substr(ic, 5);
                    ic += 5
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(ho)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = [];
                        s4 = peg$parseDIGIT();
                        while (s4 !== h) {
                            s3.push(s4);
                            s4 = peg$parseDIGIT()
                        }
                        if (s3 !== h) {
                            id = a;
                            s1 = hp(s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsesent_protocol() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseprotocol_name();
                if (s1 !== h) {
                    s2 = peg$parseSLASH();
                    if (s2 !== h) {
                        s3 = peg$parsetoken();
                        if (s3 !== h) {
                            s4 = peg$parseSLASH();
                            if (s4 !== h) {
                                s5 = peg$parsetransport();
                                if (s5 !== h) {
                                    s1 = [s1, s2, s3, s4, s5];
                                    a = s1
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseprotocol_name() {
                var a, s1;
                a = ic;
                if (f.substr(ic, 3)
                    .toLowerCase() === cB) {
                    s1 = f.substr(ic, 3);
                    ic += 3
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(dO)
                    }
                }
                if (s1 === h) {
                    s1 = peg$parsetoken()
                }
                if (s1 !== h) {
                    id = a;
                    s1 = hq(s1)
                }
                a = s1;
                return a
            }

            function peg$parsetransport() {
                var a, s1;
                a = ic;
                if (f.substr(ic, 3)
                    .toLowerCase() === dg) {
                    s1 = f.substr(ic, 3);
                    ic += 3
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(hr)
                    }
                }
                if (s1 === h) {
                    if (f.substr(ic, 3)
                        .toLowerCase() === di) {
                        s1 = f.substr(ic, 3);
                        ic += 3
                    } else {
                        s1 = h;
                        if (il === 0) {
                            peg$fail(hs)
                        }
                    }
                    if (s1 === h) {
                        if (f.substr(ic, 3)
                            .toLowerCase() === dm) {
                            s1 = f.substr(ic, 3);
                            ic += 3
                        } else {
                            s1 = h;
                            if (il === 0) {
                                peg$fail(ht)
                            }
                        }
                        if (s1 === h) {
                            if (f.substr(ic, 4)
                                .toLowerCase() === dk) {
                                s1 = f.substr(ic, 4);
                                ic += 4
                            } else {
                                s1 = h;
                                if (il === 0) {
                                    peg$fail(hu)
                                }
                            }
                            if (s1 === h) {
                                s1 = peg$parsetoken()
                            }
                        }
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = hv(s1)
                }
                a = s1;
                return a
            }

            function peg$parsesent_by() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = peg$parseviaHost();
                if (s1 !== h) {
                    s2 = ic;
                    s3 = peg$parseCOLON();
                    if (s3 !== h) {
                        s4 = peg$parsevia_port();
                        if (s4 !== h) {
                            s3 = [s3, s4];
                            s2 = s3
                        } else {
                            ic = s2;
                            s2 = h
                        }
                    } else {
                        ic = s2;
                        s2 = h
                    }
                    if (s2 === h) {
                        s2 = null
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseviaHost() {
                var a, s1;
                a = ic;
                s1 = peg$parsehostname();
                if (s1 === h) {
                    s1 = peg$parseIPv4address();
                    if (s1 === h) {
                        s1 = peg$parseIPv6reference()
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = hw()
                }
                a = s1;
                return a
            }

            function peg$parsevia_port() {
                var a, s1, s2, s3, s4, s5, s6;
                a = ic;
                s1 = ic;
                s2 = peg$parseDIGIT();
                if (s2 === h) {
                    s2 = null
                }
                if (s2 !== h) {
                    s3 = peg$parseDIGIT();
                    if (s3 === h) {
                        s3 = null
                    }
                    if (s3 !== h) {
                        s4 = peg$parseDIGIT();
                        if (s4 === h) {
                            s4 = null
                        }
                        if (s4 !== h) {
                            s5 = peg$parseDIGIT();
                            if (s5 === h) {
                                s5 = null
                            }
                            if (s5 !== h) {
                                s6 = peg$parseDIGIT();
                                if (s6 === h) {
                                    s6 = null
                                }
                                if (s6 !== h) {
                                    s2 = [s2, s3, s4, s5, s6];
                                    s1 = s2
                                } else {
                                    ic = s1;
                                    s1 = h
                                }
                            } else {
                                ic = s1;
                                s1 = h
                            }
                        } else {
                            ic = s1;
                            s1 = h
                        }
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 !== h) {
                    id = a;
                    s1 = hx(s1)
                }
                a = s1;
                return a
            }

            function peg$parsettl() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = ic;
                s2 = peg$parseDIGIT();
                if (s2 !== h) {
                    s3 = peg$parseDIGIT();
                    if (s3 === h) {
                        s3 = null
                    }
                    if (s3 !== h) {
                        s4 = peg$parseDIGIT();
                        if (s4 === h) {
                            s4 = null
                        }
                        if (s4 !== h) {
                            s2 = [s2, s3, s4];
                            s1 = s2
                        } else {
                            ic = s1;
                            s1 = h
                        }
                    } else {
                        ic = s1;
                        s1 = h
                    }
                } else {
                    ic = s1;
                    s1 = h
                }
                if (s1 !== h) {
                    id = a;
                    s1 = hy(s1)
                }
                a = s1;
                return a
            }

            function peg$parseWWW_Authenticate() {
                var a;
                a = peg$parsechallenge();
                return a
            }

            function peg$parseSession_Expires() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parsedelta_seconds();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseSEMI();
                    if (s4 !== h) {
                        s5 = peg$parsese_params();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseSEMI();
                        if (s4 !== h) {
                            s5 = peg$parsese_params();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = hz(s1);
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsese_params() {
                var a;
                a = peg$parserefresher_param();
                if (a === h) {
                    a = peg$parsegeneric_param()
                }
                return a
            }

            function peg$parserefresher_param() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 9) === hA) {
                    s1 = hA;
                    ic += 9
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(hB)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        if (f.substr(ic, 3) === hC) {
                            s3 = hC;
                            ic += 3
                        } else {
                            s3 = h;
                            if (il === 0) {
                                peg$fail(hD)
                            }
                        }
                        if (s3 === h) {
                            if (f.substr(ic, 3) === hE) {
                                s3 = hE;
                                ic += 3
                            } else {
                                s3 = h;
                                if (il === 0) {
                                    peg$fail(hF)
                                }
                            }
                        }
                        if (s3 !== h) {
                            id = a;
                            s1 = hG(s3);
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseMin_SE() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parsedelta_seconds();
                if (s1 !== h) {
                    s2 = [];
                    s3 = ic;
                    s4 = peg$parseSEMI();
                    if (s4 !== h) {
                        s5 = peg$parsegeneric_param();
                        if (s5 !== h) {
                            s4 = [s4, s5];
                            s3 = s4
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    } else {
                        ic = s3;
                        s3 = h
                    }
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = ic;
                        s4 = peg$parseSEMI();
                        if (s4 !== h) {
                            s5 = peg$parsegeneric_param();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                    }
                    if (s2 !== h) {
                        id = a;
                        s1 = hH(s1);
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseextension_header() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parsetoken();
                if (s1 !== h) {
                    s2 = peg$parseHCOLON();
                    if (s2 !== h) {
                        s3 = peg$parseheader_value();
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseheader_value() {
                var a, s1;
                a = [];
                s1 = peg$parseTEXT_UTF8char();
                if (s1 === h) {
                    s1 = peg$parseUTF8_CONT();
                    if (s1 === h) {
                        s1 = peg$parseLWS()
                    }
                }
                while (s1 !== h) {
                    a.push(s1);
                    s1 = peg$parseTEXT_UTF8char();
                    if (s1 === h) {
                        s1 = peg$parseUTF8_CONT();
                        if (s1 === h) {
                            s1 = peg$parseLWS()
                        }
                    }
                }
                return a
            }

            function peg$parsemessage_body() {
                var a, s1;
                a = [];
                s1 = peg$parseOCTET();
                while (s1 !== h) {
                    a.push(s1);
                    s1 = peg$parseOCTET()
                }
                return a
            }

            function peg$parsestun_URI() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parsestun_scheme();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 58) {
                        s2 = L;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(M)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parsestun_host_port();
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsestun_scheme() {
                var a, s1;
                a = ic;
                if (f.substr(ic, 5)
                    .toLowerCase() === hI) {
                    s1 = f.substr(ic, 5);
                    ic += 5
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(hJ)
                    }
                }
                if (s1 === h) {
                    if (f.substr(ic, 4)
                        .toLowerCase() === hK) {
                        s1 = f.substr(ic, 4);
                        ic += 4
                    } else {
                        s1 = h;
                        if (il === 0) {
                            peg$fail(hL)
                        }
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = hM(s1)
                }
                a = s1;
                return a
            }

            function peg$parsestun_host_port() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = peg$parsestun_host();
                if (s1 !== h) {
                    s2 = ic;
                    if (f.charCodeAt(ic) === 58) {
                        s3 = L;
                        ic++
                    } else {
                        s3 = h;
                        if (il === 0) {
                            peg$fail(M)
                        }
                    }
                    if (s3 !== h) {
                        s4 = peg$parseport();
                        if (s4 !== h) {
                            s3 = [s3, s4];
                            s2 = s3
                        } else {
                            ic = s2;
                            s2 = h
                        }
                    } else {
                        ic = s2;
                        s2 = h
                    }
                    if (s2 === h) {
                        s2 = null
                    }
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsestun_host() {
                var a, s1;
                a = ic;
                s1 = peg$parseIPv4address();
                if (s1 === h) {
                    s1 = peg$parseIPv6reference();
                    if (s1 === h) {
                        s1 = peg$parsereg_name()
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = hN(s1)
                }
                a = s1;
                return a
            }

            function peg$parsestun_unreserved() {
                var a;
                a = peg$parseALPHA();
                if (a === h) {
                    a = peg$parseDIGIT();
                    if (a === h) {
                        if (f.charCodeAt(ic) === 45) {
                            a = Z;
                            ic++
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(be)
                            }
                        }
                        if (a === h) {
                            if (f.charCodeAt(ic) === 46) {
                                a = bh;
                                ic++
                            } else {
                                a = h;
                                if (il === 0) {
                                    peg$fail(bi)
                                }
                            }
                            if (a === h) {
                                if (f.charCodeAt(ic) === 95) {
                                    a = bf;
                                    ic++
                                } else {
                                    a = h;
                                    if (il === 0) {
                                        peg$fail(bg)
                                    }
                                }
                                if (a === h) {
                                    if (f.charCodeAt(ic) === 126) {
                                        a = bl;
                                        ic++
                                    } else {
                                        a = h;
                                        if (il === 0) {
                                            peg$fail(bm)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parsesub_delims() {
                var a;
                if (f.charCodeAt(ic) === 33) {
                    a = bj;
                    ic++
                } else {
                    a = h;
                    if (il === 0) {
                        peg$fail(bk)
                    }
                }
                if (a === h) {
                    if (f.charCodeAt(ic) === 36) {
                        a = V;
                        ic++
                    } else {
                        a = h;
                        if (il === 0) {
                            peg$fail(W)
                        }
                    }
                    if (a === h) {
                        if (f.charCodeAt(ic) === 38) {
                            a = P;
                            ic++
                        } else {
                            a = h;
                            if (il === 0) {
                                peg$fail(Q)
                            }
                        }
                        if (a === h) {
                            if (f.charCodeAt(ic) === 39) {
                                a = bp;
                                ic++
                            } else {
                                a = h;
                                if (il === 0) {
                                    peg$fail(bq)
                                }
                            }
                            if (a === h) {
                                if (f.charCodeAt(ic) === 40) {
                                    a = br;
                                    ic++
                                } else {
                                    a = h;
                                    if (il === 0) {
                                        peg$fail(bs)
                                    }
                                }
                                if (a === h) {
                                    if (f.charCodeAt(ic) === 41) {
                                        a = bt;
                                        ic++
                                    } else {
                                        a = h;
                                        if (il === 0) {
                                            peg$fail(bu)
                                        }
                                    }
                                    if (a === h) {
                                        if (f.charCodeAt(ic) === 42) {
                                            a = bn;
                                            ic++
                                        } else {
                                            a = h;
                                            if (il === 0) {
                                                peg$fail(bo)
                                            }
                                        }
                                        if (a === h) {
                                            if (f.charCodeAt(ic) === 43) {
                                                a = T;
                                                ic++
                                            } else {
                                                a = h;
                                                if (il === 0) {
                                                    peg$fail(U)
                                                }
                                            }
                                            if (a === h) {
                                                if (f.charCodeAt(ic) === 44) {
                                                    a = X;
                                                    ic++
                                                } else {
                                                    a = h;
                                                    if (il === 0) {
                                                        peg$fail(Y)
                                                    }
                                                }
                                                if (a === h) {
                                                    if (f.charCodeAt(ic) === 59) {
                                                        a = F;
                                                        ic++
                                                    } else {
                                                        a = h;
                                                        if (il === 0) {
                                                            peg$fail(G)
                                                        }
                                                    }
                                                    if (a === h) {
                                                        if (f.charCodeAt(ic) === 61) {
                                                            a = R;
                                                            ic++
                                                        } else {
                                                            a = h;
                                                            if (il === 0) {
                                                                peg$fail(S)
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return a
            }

            function peg$parseturn_URI() {
                var a, s1, s2, s3, s4, s5, s6;
                a = ic;
                s1 = peg$parseturn_scheme();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 58) {
                        s2 = L;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(M)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parsestun_host_port();
                        if (s3 !== h) {
                            s4 = ic;
                            if (f.substr(ic, 11) === hO) {
                                s5 = hO;
                                ic += 11
                            } else {
                                s5 = h;
                                if (il === 0) {
                                    peg$fail(hP)
                                }
                            }
                            if (s5 !== h) {
                                s6 = peg$parsetransport();
                                if (s6 !== h) {
                                    s5 = [s5, s6];
                                    s4 = s5
                                } else {
                                    ic = s4;
                                    s4 = h
                                }
                            } else {
                                ic = s4;
                                s4 = h
                            }
                            if (s4 === h) {
                                s4 = null
                            }
                            if (s4 !== h) {
                                s1 = [s1, s2, s3, s4];
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseturn_scheme() {
                var a, s1;
                a = ic;
                if (f.substr(ic, 5)
                    .toLowerCase() === hQ) {
                    s1 = f.substr(ic, 5);
                    ic += 5
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(hR)
                    }
                }
                if (s1 === h) {
                    if (f.substr(ic, 4)
                        .toLowerCase() === hS) {
                        s1 = f.substr(ic, 4);
                        ic += 4
                    } else {
                        s1 = h;
                        if (il === 0) {
                            peg$fail(hT)
                        }
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = hM(s1)
                }
                a = s1;
                return a
            }

            function peg$parseturn_transport() {
                var a, s1, s2;
                a = ic;
                if (f.substr(ic, 3)
                    .toLowerCase() === dg) {
                    s1 = f.substr(ic, 3);
                    ic += 3
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(dh)
                    }
                }
                if (s1 === h) {
                    if (f.substr(ic, 3)
                        .toLowerCase() === di) {
                        s1 = f.substr(ic, 3);
                        ic += 3
                    } else {
                        s1 = h;
                        if (il === 0) {
                            peg$fail(dj)
                        }
                    }
                    if (s1 === h) {
                        s1 = [];
                        s2 = peg$parseunreserved();
                        while (s2 !== h) {
                            s1.push(s2);
                            s2 = peg$parseunreserved()
                        }
                    }
                }
                if (s1 !== h) {
                    id = a;
                    s1 = hU(s1)
                }
                a = s1;
                return a
            }

            function peg$parseuuid() {
                var a, s1, s2, s3, s4, s5, s6, s7, s8, s9;
                a = ic;
                s1 = peg$parsehex8();
                if (s1 !== h) {
                    if (f.charCodeAt(ic) === 45) {
                        s2 = Z;
                        ic++
                    } else {
                        s2 = h;
                        if (il === 0) {
                            peg$fail(be)
                        }
                    }
                    if (s2 !== h) {
                        s3 = peg$parsehex4();
                        if (s3 !== h) {
                            if (f.charCodeAt(ic) === 45) {
                                s4 = Z;
                                ic++
                            } else {
                                s4 = h;
                                if (il === 0) {
                                    peg$fail(be)
                                }
                            }
                            if (s4 !== h) {
                                s5 = peg$parsehex4();
                                if (s5 !== h) {
                                    if (f.charCodeAt(ic) === 45) {
                                        s6 = Z;
                                        ic++
                                    } else {
                                        s6 = h;
                                        if (il === 0) {
                                            peg$fail(be)
                                        }
                                    }
                                    if (s6 !== h) {
                                        s7 = peg$parsehex4();
                                        if (s7 !== h) {
                                            if (f.charCodeAt(ic) === 45) {
                                                s8 = Z;
                                                ic++
                                            } else {
                                                s8 = h;
                                                if (il === 0) {
                                                    peg$fail(be)
                                                }
                                            }
                                            if (s8 !== h) {
                                                s9 = peg$parsehex12();
                                                if (s9 !== h) {
                                                    id = a;
                                                    s1 = hV();
                                                    a = s1
                                                } else {
                                                    ic = a;
                                                    a = h
                                                }
                                            } else {
                                                ic = a;
                                                a = h
                                            }
                                        } else {
                                            ic = a;
                                            a = h
                                        }
                                    } else {
                                        ic = a;
                                        a = h
                                    }
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsehex4() {
                var a, s1, s2, s3, s4;
                a = ic;
                s1 = peg$parseHEXDIG();
                if (s1 !== h) {
                    s2 = peg$parseHEXDIG();
                    if (s2 !== h) {
                        s3 = peg$parseHEXDIG();
                        if (s3 !== h) {
                            s4 = peg$parseHEXDIG();
                            if (s4 !== h) {
                                s1 = [s1, s2, s3, s4];
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsehex8() {
                var a, s1, s2;
                a = ic;
                s1 = peg$parsehex4();
                if (s1 !== h) {
                    s2 = peg$parsehex4();
                    if (s2 !== h) {
                        s1 = [s1, s2];
                        a = s1
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsehex12() {
                var a, s1, s2, s3;
                a = ic;
                s1 = peg$parsehex4();
                if (s1 !== h) {
                    s2 = peg$parsehex4();
                    if (s2 !== h) {
                        s3 = peg$parsehex4();
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsesipfrag() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseRequest_Response();
                if (s1 !== h) {
                    s2 = [];
                    s3 = peg$parseheader();
                    while (s3 !== h) {
                        s2.push(s3);
                        s3 = peg$parseheader()
                    }
                    if (s2 !== h) {
                        s3 = ic;
                        s4 = peg$parseCRLF();
                        if (s4 !== h) {
                            s5 = peg$parsemessage_body();
                            if (s5 !== h) {
                                s4 = [s4, s5];
                                s3 = s4
                            } else {
                                ic = s3;
                                s3 = h
                            }
                        } else {
                            ic = s3;
                            s3 = h
                        }
                        if (s3 === h) {
                            s3 = null
                        }
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parseReferred_By() {
                var a, s1, s2, s3, s4, s5, s6, s7;
                a = ic;
                if (f.substr(ic, 11) === hW) {
                    s1 = hW;
                    ic += 11
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(hX)
                    }
                }
                if (s1 === h) {
                    if (f.charCodeAt(ic) === 98) {
                        s1 = hY;
                        ic++
                    } else {
                        s1 = h;
                        if (il === 0) {
                            peg$fail(hZ)
                        }
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseHCOLON();
                    if (s2 !== h) {
                        s3 = peg$parsereferrer_uri();
                        if (s3 !== h) {
                            s4 = [];
                            s5 = ic;
                            s6 = peg$parseSEMI();
                            if (s6 !== h) {
                                s7 = peg$parsereferredby_id_param();
                                if (s7 === h) {
                                    s7 = peg$parsegeneric_param()
                                }
                                if (s7 !== h) {
                                    s6 = [s6, s7];
                                    s5 = s6
                                } else {
                                    ic = s5;
                                    s5 = h
                                }
                            } else {
                                ic = s5;
                                s5 = h
                            }
                            while (s5 !== h) {
                                s4.push(s5);
                                s5 = ic;
                                s6 = peg$parseSEMI();
                                if (s6 !== h) {
                                    s7 = peg$parsereferredby_id_param();
                                    if (s7 === h) {
                                        s7 = peg$parsegeneric_param()
                                    }
                                    if (s7 !== h) {
                                        s6 = [s6, s7];
                                        s5 = s6
                                    } else {
                                        ic = s5;
                                        s5 = h
                                    }
                                } else {
                                    ic = s5;
                                    s5 = h
                                }
                            }
                            if (s4 !== h) {
                                s1 = [s1, s2, s3, s4];
                                a = s1
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsereferrer_uri() {
                var a;
                a = peg$parsename_addr();
                if (a === h) {
                    a = peg$parseSIP_URI_noparams()
                }
                return a
            }

            function peg$parsereferredby_id_param() {
                var a, s1, s2, s3;
                a = ic;
                if (f.substr(ic, 3) === ia) {
                    s1 = ia;
                    ic += 3
                } else {
                    s1 = h;
                    if (il === 0) {
                        peg$fail(ib)
                    }
                }
                if (s1 !== h) {
                    s2 = peg$parseEQUAL();
                    if (s2 !== h) {
                        s3 = peg$parsesip_clean_msg_id();
                        if (s3 !== h) {
                            s1 = [s1, s2, s3];
                            a = s1
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }

            function peg$parsesip_clean_msg_id() {
                var a, s1, s2, s3, s4, s5;
                a = ic;
                s1 = peg$parseLDQUOT();
                if (s1 !== h) {
                    s2 = peg$parsemark();
                    if (s2 !== h) {
                        if (f.charCodeAt(ic) === 64) {
                            s3 = N;
                            ic++
                        } else {
                            s3 = h;
                            if (il === 0) {
                                peg$fail(O)
                            }
                        }
                        if (s3 !== h) {
                            s4 = peg$parsemark();
                            if (s4 === h) {
                                s4 = peg$parsehost()
                            }
                            if (s4 !== h) {
                                s5 = peg$parseRDQUOT();
                                if (s5 !== h) {
                                    s1 = [s1, s2, s3, s4, s5];
                                    a = s1
                                } else {
                                    ic = a;
                                    a = h
                                }
                            } else {
                                ic = a;
                                a = h
                            }
                        } else {
                            ic = a;
                            a = h
                        }
                    } else {
                        ic = a;
                        a = h
                    }
                } else {
                    ic = a;
                    a = h
                }
                return a
            }
            g.data = {};

            function list(a, b) {
                return [a].concat(b)
            }
            im = j();
            if (im !== h && ic === f.length) {
                return im
            } else {
                if (im !== h && ic < f.length) {
                    peg$fail(peg$endExpectation())
                }
                throw peg$buildStructuredError(ik, ij < f.length ? f.charAt(ij) : null, ij < f.length ? peg$computeLocation(ij, ij + 1) : peg$computeLocation(ij, ij));
            }
        }
        ih.parse = peg$parse
    }), (function(f, g, h) {
        "use strict";
        var i = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        Object.defineProperty(g, "__esModule", {
            value: true
        });
        var j = h(5);
        var k = h(14);
        var l = (function(e) {
            i(l, e);

            function l(a, b, c) {
                var d = e.call(this, c) || this;
                d.type = j.TypeStrings.NameAddrHeader;
                if (!a || !(a.type === j.TypeStrings.URI)) {
                    throw new TypeError('missing or invalid "uri" parameter');
                }
                d.uri = a;
                d._displayName = b;
                return d
            }
            Object.defineProperty(l.prototype, "friendlyName", {
                get: function() {
                    return this.displayName || this.uri.aor
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(l.prototype, "displayName", {
                get: function() {
                    return this._displayName
                },
                set: function(a) {
                    this._displayName = a
                },
                enumerable: true,
                configurable: true
            });
            l.prototype.clone = function() {
                return new l(this.uri.clone(), this._displayName, JSON.parse(JSON.stringify(this.parameters)))
            };
            l.prototype.toString = function() {
                var a = (this.displayName || this.displayName === "0") ? '"' + this.displayName + '" ' : "";
                a += "<" + this.uri.toString() + ">";
                for (var b in this.parameters) {
                    if (this.parameters.hasOwnProperty(b)) {
                        a += ";" + b;
                        if (this.parameters[b] !== null) {
                            a += "=" + this.parameters[b]
                        }
                    }
                }
                return a
            };
            return l
        }(k.Parameters));
        g.NameAddrHeader = l
    }), (function(j, k, l) {
        "use strict";
        var m = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        Object.defineProperty(k, "__esModule", {
            value: true
        });
        var n = l(3);
        var o = l(5);
        var q = (function() {
            function q(a) {
                this.parameters = {};
                this.type = o.TypeStrings.Parameters;
                for (var b in a) {
                    if (a.hasOwnProperty(b)) {
                        this.setParam(b, a[b])
                    }
                }
            }
            q.prototype.setParam = function(a, b) {
                if (a) {
                    this.parameters[a.toLowerCase()] = (typeof b === "undefined" || b === null) ? null : b.toString()
                }
            };
            q.prototype.getParam = function(a) {
                if (a) {
                    return this.parameters[a.toLowerCase()]
                }
            };
            q.prototype.hasParam = function(a) {
                if (a) {
                    return !!this.parameters.hasOwnProperty(a.toLowerCase())
                }
                return false
            };
            q.prototype.deleteParam = function(a) {
                a = a.toLowerCase();
                if (this.parameters.hasOwnProperty(a)) {
                    var b = this.parameters[a];
                    delete this.parameters[a];
                    return b
                }
            };
            q.prototype.clearParams = function() {
                this.parameters = {}
            };
            return q
        }());
        k.Parameters = q;
        var r = (function(i) {
            m(r, i);

            function r(a, b, c, d, e, f) {
                var g = i.call(this, e) || this;
                g.headers = {};
                g.type = o.TypeStrings.URI;
                if (!c) {
                    throw new TypeError('missing or invalid "host" parameter');
                }
                a = a || n.C.SIP;
                for (var h in f) {
                    if (f.hasOwnProperty(h)) {
                        g.setHeader(h, f[h])
                    }
                }
                g.raw = {
                    scheme: a,
                    user: b,
                    host: c,
                    port: d
                };
                g.normal = {
                    scheme: a.toLowerCase(),
                    user: b,
                    host: c.toLowerCase(),
                    port: d
                };
                return g
            }
            Object.defineProperty(r.prototype, "_normal", {
                get: function() {
                    return this.normal
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(r.prototype, "_raw", {
                get: function() {
                    return this.raw
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(r.prototype, "scheme", {
                get: function() {
                    return this.normal.scheme
                },
                set: function(a) {
                    this.raw.scheme = a;
                    this.normal.scheme = a.toLowerCase()
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(r.prototype, "user", {
                get: function() {
                    return this.normal.user
                },
                set: function(a) {
                    this.normal.user = this.raw.user = a
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(r.prototype, "host", {
                get: function() {
                    return this.normal.host
                },
                set: function(a) {
                    this.raw.host = a;
                    this.normal.host = a.toLowerCase()
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(r.prototype, "aor", {
                get: function() {
                    return this.normal.user + "@" + this.normal.host
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(r.prototype, "port", {
                get: function() {
                    return this.normal.port
                },
                set: function(a) {
                    this.normal.port = this.raw.port = a === 0 ? a : a
                },
                enumerable: true,
                configurable: true
            });
            r.prototype.setHeader = function(a, b) {
                this.headers[this.headerize(a)] = (b instanceof Array) ? b : [b]
            };
            r.prototype.getHeader = function(a) {
                if (a) {
                    return this.headers[this.headerize(a)]
                }
            };
            r.prototype.hasHeader = function(a) {
                return !!a && !!this.headers.hasOwnProperty(this.headerize(a))
            };
            r.prototype.deleteHeader = function(a) {
                a = this.headerize(a);
                if (this.headers.hasOwnProperty(a)) {
                    var b = this.headers[a];
                    delete this.headers[a];
                    return b
                }
            };
            r.prototype.clearHeaders = function() {
                this.headers = {}
            };
            r.prototype.clone = function() {
                return new r(this._raw.scheme, this._raw.user || "", this._raw.host, this._raw.port, JSON.parse(JSON.stringify(this.parameters)), JSON.parse(JSON.stringify(this.headers)))
            };
            r.prototype.toRaw = function() {
                return this._toString(this._raw)
            };
            r.prototype.toString = function() {
                return this._toString(this._normal)
            };
            r.prototype._toString = function(a) {
                var b = a.scheme + ":";
                if (!a.scheme.toLowerCase()
                    .match("^sips?$")) {
                    b += "//"
                }
                if (a.user) {
                    b += this.escapeUser(a.user) + "@"
                }
                b += a.host;
                if (a.port || a.port === 0) {
                    b += ":" + a.port
                }
                for (var c in this.parameters) {
                    if (this.parameters.hasOwnProperty(c)) {
                        b += ";" + c;
                        if (this.parameters[c] !== null) {
                            b += "=" + this.parameters[c]
                        }
                    }
                }
                var d = [];
                for (var e in this.headers) {
                    if (this.headers.hasOwnProperty(e)) {
                        for (var f in this.headers[e]) {
                            if (this.headers[e].hasOwnProperty(f)) {
                                d.push(e + "=" + this.headers[e][f])
                            }
                        }
                    }
                }
                if (d.length > 0) {
                    b += "?" + d.join("&")
                }
                return b
            };
            r.prototype.escapeUser = function(a) {
                return encodeURIComponent(decodeURIComponent(a))
                    .replace(/%3A/ig, ":")
                    .replace(/%2B/ig, "+")
                    .replace(/%3F/ig, "?")
                    .replace(/%2F/ig, "/")
            };
            r.prototype.headerize = function(a) {
                var b = {
                    "Call-Id": "Call-ID",
                    "Cseq": "CSeq",
                    "Min-Se": "Min-SE",
                    "Rack": "RAck",
                    "Rseq": "RSeq",
                    "Www-Authenticate": "WWW-Authenticate",
                };
                var c = a.toLowerCase()
                    .replace(/_/g, "-")
                    .split("-");
                var d = c.length;
                var e = "";
                for (var f = 0; f < d; f++) {
                    if (f !== 0) {
                        e += "-"
                    }
                    e += c[f].charAt(0)
                        .toUpperCase() + c[f].substring(1)
                }
                if (b[e]) {
                    e = b[e]
                }
                return e
            };
            return r
        }(q));
        k.URI = r
    }), (function(h, j, k) {
        "use strict";
        Object.defineProperty(j, "__esModule", {
            value: true
        });
        var l = k(3);
        var m = k(5);
        var n = k(11);
        var o;
        (function(g) {
            function defer() {
                var c = {};
                c.promise = new Promise(function(a, b) {
                    c.resolve = a;
                    c.reject = b
                });
                return c
            }
            g.defer = defer;

            function reducePromises(c, d) {
                return c.reduce(function(a, b) {
                    a = a.then(b);
                    return a
                }, Promise.resolve(d))
            }
            g.reducePromises = reducePromises;

            function str_utf8_length(a) {
                return encodeURIComponent(a)
                    .replace(/%[A-F\d]{2}/g, "U")
                    .length
            }
            g.str_utf8_length = str_utf8_length;

            function generateFakeSDP(a) {
                if (!a) {
                    return
                }
                var b = a.indexOf("o=");
                var c = a.indexOf("\r\n", b);
                return "v=0\r\n" + a.slice(b, c) + "\r\ns=-\r\nt=0 0\r\nc=IN IP4 0.0.0.0"
            }
            g.generateFakeSDP = generateFakeSDP;

            function isDecimal(a) {
                var b = parseInt(a, 10);
                return !isNaN(b) && (parseFloat(a) === b)
            }
            g.isDecimal = isDecimal;

            function createRandomToken(a, b) {
                if (b === void 0) {
                    b = 32
                }
                var c = "";
                for (var i = 0; i < a; i++) {
                    var r = Math.floor(Math.random() * b);
                    c += r.toString(b)
                }
                return c
            }
            g.createRandomToken = createRandomToken;

            function newTag() {
                return g.createRandomToken(10)
            }
            g.newTag = newTag;

            function newUUID() {
                var a = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                    var r = Math.floor(Math.random() * 16);
                    var v = c === "x" ? r : (r % 4 + 8);
                    return v.toString(16)
                });
                return a
            }
            g.newUUID = newUUID;

            function normalizeTarget(a, b) {
                if (!a) {
                    return
                } else if (a.type === m.TypeStrings.URI) {
                    return a
                } else if (typeof a === "string") {
                    var c = a.split("@");
                    var d = void 0;
                    var e = void 0;
                    switch (c.length) {
                        case 1:
                            if (!b) {
                                return
                            }
                            d = a;
                            e = b;
                            break;
                        case 2:
                            d = c[0];
                            e = c[1];
                            break;
                        default:
                            d = c.slice(0, c.length - 1)
                                .join("@");
                            e = c[c.length - 1]
                    }
                    d = d.replace(/^(sips?|tel):/i, "");
                    if (/^[\-\.\(\)]*\+?[0-9\-\.\(\)]+$/.test(d)) {
                        d = d.replace(/[\-\.\(\)]/g, "")
                    }
                    a = l.C.SIP + ":" + g.escapeUser(d) + "@" + e;
                    return n.Grammar.URIParse(a)
                } else {
                    return
                }
            }
            g.normalizeTarget = normalizeTarget;

            function escapeUser(a) {
                return encodeURIComponent(decodeURIComponent(a))
                    .replace(/%3A/ig, ":")
                    .replace(/%2B/ig, "+")
                    .replace(/%3F/ig, "?")
                    .replace(/%2F/ig, "/")
            }
            g.escapeUser = escapeUser;

            function headerize(a) {
                var b = {
                    "Call-Id": "Call-ID",
                    "Cseq": "CSeq",
                    "Min-Se": "Min-SE",
                    "Rack": "RAck",
                    "Rseq": "RSeq",
                    "Www-Authenticate": "WWW-Authenticate",
                };
                var c = a.toLowerCase()
                    .replace(/_/g, "-")
                    .split("-");
                var d = c.length;
                var e = "";
                for (var f = 0; f < d; f++) {
                    if (f !== 0) {
                        e += "-"
                    }
                    e += c[f].charAt(0)
                        .toUpperCase() + c[f].substring(1)
                }
                if (b[e]) {
                    e = b[e]
                }
                return e
            }
            g.headerize = headerize;

            function sipErrorCause(a) {
                for (var b in l.C.SIP_ERROR_CAUSES) {
                    if (l.C.SIP_ERROR_CAUSES[b].indexOf(a) !== -1) {
                        return l.C.causes[b]
                    }
                }
                return l.C.causes.SIP_FAILURE_CODE
            }
            g.sipErrorCause = sipErrorCause;

            function getReasonPhrase(a, b) {
                return b || l.C.REASON_PHRASE[a] || ""
            }
            g.getReasonPhrase = getReasonPhrase;

            function getReasonHeaderValue(a, b) {
                b = g.getReasonPhrase(a, b);
                return "SIP;cause=" + a + ';text="' + b + '"'
            }
            g.getReasonHeaderValue = getReasonHeaderValue;

            function getCancelReason(a, b) {
                if (a && a < 200 || a > 699) {
                    throw new TypeError("Invalid statusCode: " + a);
                } else if (a) {
                    return g.getReasonHeaderValue(a, b)
                }
            }
            g.getCancelReason = getCancelReason;

            function buildStatusLine(a, b) {
                if (!a || (a < 100 || a > 699)) {
                    throw new TypeError("Invalid statusCode: " + a);
                } else if (b && typeof b !== "string" && !(b instanceof String)) {
                    throw new TypeError("Invalid reason: " + b);
                }
                b = g.getReasonPhrase(a, b);
                return "SIP/2.0 " + a + " " + b + "\r\n"
            }
            g.buildStatusLine = buildStatusLine
        })(o = j.Utils || (j.Utils = {}))
    }), (function(m, n, o) {
        "use strict";
        Object.defineProperty(n, "__esModule", {
            value: true
        });
        var p = o(3);
        var q = o(5);
        var r = o(6);
        var s = o(10);
        var t = o(7);
        var u = (function() {
            function u(a, b, c, d) {
                this.pracked = [];
                this.uacPendingReply = false;
                this.uasPendingReply = false;
                this.type = q.TypeStrings.Dialog;
                if (!b.hasHeader("contact")) {
                    throw new Error("unable to create a Dialog without Contact header field");
                }
                if (b.type === q.TypeStrings.IncomingResponse) {
                    var e = b.statusCode;
                    d = (e && e < 200) ? q.DialogStatus.STATUS_EARLY : q.DialogStatus.STATUS_CONFIRMED
                } else {
                    d = d || q.DialogStatus.STATUS_CONFIRMED
                }
                var f = b.parseHeader("contact");
                if (c === "UAS" && b.type === q.TypeStrings.IncomingRequest) {
                    this.id = {
                        callId: b.callId,
                        localTag: b.toTag,
                        remoteTag: b.fromTag,
                        toString: function() {
                            return b.callId + b.toTag + b.fromTag
                        }
                    };
                    this.state = d;
                    this.remoteSeqnum = b.cseq;
                    this.localUri = (b.parseHeader("to") || {})
                        .uri;
                    this.remoteUri = (b.parseHeader("from") || {})
                        .uri;
                    this.remoteTarget = f.uri;
                    this.routeSet = b.getHeaders("record-route");
                    this.inviteSeqnum = b.cseq;
                    this.localSeqnum = b.cseq
                } else {
                    this.id = {
                        callId: b.callId,
                        localTag: b.fromTag,
                        remoteTag: b.toTag,
                        toString: function() {
                            return b.callId + b.fromTag + b.toTag
                        }
                    };
                    this.state = d;
                    this.inviteSeqnum = b.cseq;
                    this.localSeqnum = b.cseq;
                    this.localUri = b.parseHeader("from")
                        .uri;
                    this.pracked = [];
                    this.remoteUri = b.parseHeader("to")
                        .uri;
                    this.remoteTarget = f.uri;
                    this.routeSet = b.getHeaders("record-route")
                        .reverse()
                }
                this.logger = a.ua.getLogger("sip.dialog", this.id.toString());
                this.owner = a;
                a.ua.dialogs[this.id.toString()] = this;
                this.logger.log("new " + c + " dialog created with status " + (this.state === q.DialogStatus.STATUS_EARLY ? "EARLY" : "CONFIRMED"));
                a.emit("dialog", this)
            }
            u.prototype.update = function(a, b) {
                this.state = q.DialogStatus.STATUS_CONFIRMED;
                this.logger.log("dialog " + this.id.toString() + "  changed to CONFIRMED state");
                if (b === "UAC") {
                    this.routeSet = a.getHeaders("record-route")
                        .reverse()
                }
            };
            u.prototype.terminate = function() {
                this.logger.log("dialog " + this.id.toString() + " deleted");
                if (this.sessionDescriptionHandler && this.state !== q.DialogStatus.STATUS_CONFIRMED) {
                    this.sessionDescriptionHandler.close()
                }
                delete this.owner.ua.dialogs[this.id.toString()]
            };
            u.prototype.createRequest = function(a, b, c) {
                if (b === void 0) {
                    b = []
                }
                b = b.slice();
                if (!this.localSeqnum) {
                    this.localSeqnum = Math.floor(Math.random() * 10000)
                }
                var d = (a === p.C.CANCEL || a === p.C.ACK) ? this.inviteSeqnum : this.localSeqnum += 1;
                var e = new s.OutgoingRequest(a, this.remoteTarget, this.owner.ua, {
                    cseq: d,
                    callId: this.id.callId,
                    fromUri: this.localUri,
                    fromTag: this.id.localTag,
                    toIri: this.remoteUri,
                    toTag: this.id.remoteTag,
                    routeSet: this.routeSet
                }, b, c);
                e.dialog = this;
                return e
            };
            u.prototype.checkInDialogRequest = function(a) {
                var b = this;
                if (!this.remoteSeqnum) {
                    this.remoteSeqnum = a.cseq
                } else if (a.cseq < this.remoteSeqnum) {
                    if (a.method !== p.C.ACK) {
                        a.reply(500)
                    }
                    return a.cseq === this.inviteSeqnum
                }
                switch (a.method) {
                    case p.C.INVITE:
                        if (this.uacPendingReply === true) {
                            a.reply(491)
                        } else if (this.uasPendingReply === true && a.cseq > this.remoteSeqnum) {
                            var c = Math.floor((Math.random() * 10)) + 1;
                            a.reply(500, undefined, ["Retry-After:" + c]);
                            this.remoteSeqnum = a.cseq;
                            return false
                        } else {
                            this.uasPendingReply = true;
                            var d = function() {
                                if (a.transaction && (a.transaction.state === t.TransactionState.Accepted || a.transaction.state === t.TransactionState.Completed || a.transaction.state === t.TransactionState.Terminated)) {
                                    a.transaction.removeListener("stateChanged", d);
                                    b.uasPendingReply = false
                                }
                            };
                            if (a.transaction) {
                                a.transaction.on("stateChanged", d)
                            }
                        }
                        if (a.hasHeader("contact") && a.transaction) {
                            a.transaction.on("stateChanged", function() {
                                if (a.transaction && a.transaction.state === t.TransactionState.Accepted) {
                                    b.remoteTarget = a.parseHeader("contact")
                                        .uri
                                }
                            })
                        }
                        break;
                    case p.C.NOTIFY:
                        if (a.hasHeader("contact") && a.transaction) {
                            a.transaction.on("stateChanged", function() {
                                if (a.transaction && a.transaction.state === t.TransactionState.Completed) {
                                    b.remoteTarget = a.parseHeader("contact")
                                        .uri
                                }
                            })
                        }
                        break
                }
                if (a.cseq > this.remoteSeqnum) {
                    this.remoteSeqnum = a.cseq
                }
                return true
            };
            u.prototype.sendRequest = function(e, f, g) {
                var h = this;
                if (g === void 0) {
                    g = {}
                }
                var i = (g.extraHeaders || [])
                    .slice();
                var j;
                if (g.body) {
                    if (g.body.body) {
                        j = g.body
                    } else {
                        j = {};
                        j.body = g.body;
                        if (g.contentType) {
                            j.contentType = g.contentType
                        }
                    }
                }
                var k = this.createRequest(f, i, j);
                var l = function(b) {
                    var c = new r.RequestSender({
                        request: k,
                        onRequestTimeout: e.onRequestTimeout.bind(e),
                        onTransportError: e.onTransportError.bind(e),
                        receiveResponse: function(a) {
                            if (a.statusCode === 408 || a.statusCode === 481) {
                                e.onDialogError(a)
                            } else if (a.method === p.C.INVITE && a.statusCode === 491) {
                                if (b) {
                                    e.receiveResponse(a)
                                } else {
                                    k.cseq = h.localSeqnum += 1;
                                    setTimeout(function() {
                                        if (h.owner.status !== undefined && h.owner.status !== q.SessionStatus.STATUS_TERMINATED) {
                                            l(true)
                                        }
                                    }, 1000)
                                }
                            } else {
                                e.receiveResponse(a)
                            }
                        }
                    }, h.owner.ua);
                    c.send();
                    if (!c.clientTransaction) {
                        return
                    } else if (k.method === p.C.INVITE && c.clientTransaction && c.clientTransaction.state !== t.TransactionState.Terminated) {
                        h.uacPendingReply = true;
                        var d = function() {
                            var a = c.clientTransaction.state;
                            if (!c.clientTransaction) {
                                return
                            } else if (c.clientTransaction && (a === t.TransactionState.Accepted || a === t.TransactionState.Completed || a === t.TransactionState.Terminated)) {
                                c.clientTransaction.removeListener("stateChanged", d);
                                h.uacPendingReply = false
                            }
                        };
                        c.clientTransaction.on("stateChanged", d)
                    }
                };
                l(false);
                return k
            };
            u.prototype.receiveRequest = function(a) {
                if (!this.checkInDialogRequest(a)) {
                    return
                }
                this.owner.receiveRequest(a)
            };
            u.C = q.DialogStatus;
            return u
        }());
        n.Dialog = u
    }), (function(d, e, f) {
        "use strict";
        Object.defineProperty(e, "__esModule", {
            value: true
        });
        var g = f(18);
        var h = f(5);
        var i = f(15);
        var j = (function() {
            function j(a) {
                this.type = h.TypeStrings.DigestAuthentication;
                this.logger = a.getLogger("sipjs.digestauthentication");
                this.username = a.configuration.authorizationUser;
                this.password = a.configuration.password;
                this.nc = 0;
                this.ncHex = "00000000"
            }
            j.prototype.authenticate = function(a, b, c) {
                this.algorithm = b.algorithm;
                this.realm = b.realm;
                this.nonce = b.nonce;
                this.opaque = b.opaque;
                this.stale = b.stale;
                if (this.algorithm) {
                    if (this.algorithm !== "MD5") {
                        this.logger.warn("challenge with Digest algorithm different than 'MD5', authentication aborted");
                        return false
                    }
                } else {
                    this.algorithm = "MD5"
                }
                if (!this.realm) {
                    this.logger.warn("challenge without Digest realm, authentication aborted");
                    return false
                }
                if (!this.nonce) {
                    this.logger.warn("challenge without Digest nonce, authentication aborted");
                    return false
                }
                if (b.qop) {
                    if (b.qop.indexOf("auth") > -1) {
                        this.qop = "auth"
                    } else if (b.qop.indexOf("auth-int") > -1) {
                        this.qop = "auth-int"
                    } else {
                        this.logger.warn("challenge without Digest qop different than 'auth' or 'auth-int', authentication aborted");
                        return false
                    }
                } else {
                    this.qop = undefined
                }
                this.method = a.method;
                this.uri = a.ruri;
                this.cnonce = i.Utils.createRandomToken(12);
                this.nc += 1;
                this.updateNcHex();
                if (this.nc === 4294967296) {
                    this.nc = 1;
                    this.ncHex = "00000001"
                }
                this.calculateResponse(c);
                return true
            };
            j.prototype.toString = function() {
                var a = [];
                if (!this.response) {
                    throw new Error("response field does not exist, cannot generate Authorization header");
                }
                a.push("algorithm=" + this.algorithm);
                a.push('username="' + this.username + '"');
                a.push('realm="' + this.realm + '"');
                a.push('nonce="' + this.nonce + '"');
                a.push('uri="' + this.uri + '"');
                a.push('response="' + this.response + '"');
                if (this.opaque) {
                    a.push('opaque="' + this.opaque + '"')
                }
                if (this.qop) {
                    a.push("qop=" + this.qop);
                    a.push('cnonce="' + this.cnonce + '"');
                    a.push("nc=" + this.ncHex)
                }
                return "Digest " + a.join(", ")
            };
            j.prototype.updateNcHex = function() {
                var a = Number(this.nc)
                    .toString(16);
                this.ncHex = "00000000".substr(0, 8 - a.length) + a
            };
            j.prototype.calculateResponse = function(a) {
                var b;
                var c = g(this.username + ":" + this.realm + ":" + this.password);
                if (this.qop === "auth") {
                    b = g(this.method + ":" + this.uri);
                    this.response = g(c + ":" + this.nonce + ":" + this.ncHex + ":" + this.cnonce + ":auth:" + b)
                } else if (this.qop === "auth-int") {
                    b = g(this.method + ":" + this.uri + ":" + g(a ? a : ""));
                    this.response = g(c + ":" + this.nonce + ":" + this.ncHex + ":" + this.cnonce + ":auth-int:" + b)
                } else if (this.qop === undefined) {
                    b = g(this.method + ":" + this.uri);
                    this.response = g(c + ":" + this.nonce + ":" + b)
                }
            };
            return j
        }());
        e.DigestAuthentication = j
    }), (function(G, I, J) {
        ;
        (function(a, b) {
            if (true) {
                G.exports = I = b(J(19))
            } else {}
        }(this, function(F) {
            (function(y) {
                var C = F;
                var z = C.lib;
                var A = z.WordArray;
                var B = z.Hasher;
                var D = C.algo;
                var T = [];
                (function() {
                    for (var i = 0; i < 64; i++) {
                        T[i] = (y.abs(y.sin(i + 1)) * 0x100000000) | 0
                    }
                }());
                var E = D.MD5 = B.extend({
                    _doReset: function() {
                        this._hash = new A.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476])
                    },
                    _doProcessBlock: function(M, e) {
                        for (var i = 0; i < 16; i++) {
                            var f = e + i;
                            var g = M[f];
                            M[f] = ((((g << 8) | (g >>> 24)) & 0x00ff00ff) | (((g << 24) | (g >>> 8)) & 0xff00ff00))
                        }
                        var H = this._hash.words;
                        var h = M[e + 0];
                        var j = M[e + 1];
                        var k = M[e + 2];
                        var l = M[e + 3];
                        var m = M[e + 4];
                        var n = M[e + 5];
                        var o = M[e + 6];
                        var p = M[e + 7];
                        var q = M[e + 8];
                        var r = M[e + 9];
                        var s = M[e + 10];
                        var t = M[e + 11];
                        var u = M[e + 12];
                        var v = M[e + 13];
                        var w = M[e + 14];
                        var x = M[e + 15];
                        var a = H[0];
                        var b = H[1];
                        var c = H[2];
                        var d = H[3];
                        a = FF(a, b, c, d, h, 7, T[0]);
                        d = FF(d, a, b, c, j, 12, T[1]);
                        c = FF(c, d, a, b, k, 17, T[2]);
                        b = FF(b, c, d, a, l, 22, T[3]);
                        a = FF(a, b, c, d, m, 7, T[4]);
                        d = FF(d, a, b, c, n, 12, T[5]);
                        c = FF(c, d, a, b, o, 17, T[6]);
                        b = FF(b, c, d, a, p, 22, T[7]);
                        a = FF(a, b, c, d, q, 7, T[8]);
                        d = FF(d, a, b, c, r, 12, T[9]);
                        c = FF(c, d, a, b, s, 17, T[10]);
                        b = FF(b, c, d, a, t, 22, T[11]);
                        a = FF(a, b, c, d, u, 7, T[12]);
                        d = FF(d, a, b, c, v, 12, T[13]);
                        c = FF(c, d, a, b, w, 17, T[14]);
                        b = FF(b, c, d, a, x, 22, T[15]);
                        a = GG(a, b, c, d, j, 5, T[16]);
                        d = GG(d, a, b, c, o, 9, T[17]);
                        c = GG(c, d, a, b, t, 14, T[18]);
                        b = GG(b, c, d, a, h, 20, T[19]);
                        a = GG(a, b, c, d, n, 5, T[20]);
                        d = GG(d, a, b, c, s, 9, T[21]);
                        c = GG(c, d, a, b, x, 14, T[22]);
                        b = GG(b, c, d, a, m, 20, T[23]);
                        a = GG(a, b, c, d, r, 5, T[24]);
                        d = GG(d, a, b, c, w, 9, T[25]);
                        c = GG(c, d, a, b, l, 14, T[26]);
                        b = GG(b, c, d, a, q, 20, T[27]);
                        a = GG(a, b, c, d, v, 5, T[28]);
                        d = GG(d, a, b, c, k, 9, T[29]);
                        c = GG(c, d, a, b, p, 14, T[30]);
                        b = GG(b, c, d, a, u, 20, T[31]);
                        a = HH(a, b, c, d, n, 4, T[32]);
                        d = HH(d, a, b, c, q, 11, T[33]);
                        c = HH(c, d, a, b, t, 16, T[34]);
                        b = HH(b, c, d, a, w, 23, T[35]);
                        a = HH(a, b, c, d, j, 4, T[36]);
                        d = HH(d, a, b, c, m, 11, T[37]);
                        c = HH(c, d, a, b, p, 16, T[38]);
                        b = HH(b, c, d, a, s, 23, T[39]);
                        a = HH(a, b, c, d, v, 4, T[40]);
                        d = HH(d, a, b, c, h, 11, T[41]);
                        c = HH(c, d, a, b, l, 16, T[42]);
                        b = HH(b, c, d, a, o, 23, T[43]);
                        a = HH(a, b, c, d, r, 4, T[44]);
                        d = HH(d, a, b, c, u, 11, T[45]);
                        c = HH(c, d, a, b, x, 16, T[46]);
                        b = HH(b, c, d, a, k, 23, T[47]);
                        a = II(a, b, c, d, h, 6, T[48]);
                        d = II(d, a, b, c, p, 10, T[49]);
                        c = II(c, d, a, b, w, 15, T[50]);
                        b = II(b, c, d, a, n, 21, T[51]);
                        a = II(a, b, c, d, u, 6, T[52]);
                        d = II(d, a, b, c, l, 10, T[53]);
                        c = II(c, d, a, b, s, 15, T[54]);
                        b = II(b, c, d, a, j, 21, T[55]);
                        a = II(a, b, c, d, q, 6, T[56]);
                        d = II(d, a, b, c, x, 10, T[57]);
                        c = II(c, d, a, b, o, 15, T[58]);
                        b = II(b, c, d, a, v, 21, T[59]);
                        a = II(a, b, c, d, m, 6, T[60]);
                        d = II(d, a, b, c, t, 10, T[61]);
                        c = II(c, d, a, b, k, 15, T[62]);
                        b = II(b, c, d, a, r, 21, T[63]);
                        H[0] = (H[0] + a) | 0;
                        H[1] = (H[1] + b) | 0;
                        H[2] = (H[2] + c) | 0;
                        H[3] = (H[3] + d) | 0
                    },
                    _doFinalize: function() {
                        var a = this._data;
                        var b = a.words;
                        var c = this._nDataBytes * 8;
                        var d = a.sigBytes * 8;
                        b[d >>> 5] |= 0x80 << (24 - d % 32);
                        var e = y.floor(c / 0x100000000);
                        var f = c;
                        b[(((d + 64) >>> 9) << 4) + 15] = ((((e << 8) | (e >>> 24)) & 0x00ff00ff) | (((e << 24) | (e >>> 8)) & 0xff00ff00));
                        b[(((d + 64) >>> 9) << 4) + 14] = ((((f << 8) | (f >>> 24)) & 0x00ff00ff) | (((f << 24) | (f >>> 8)) & 0xff00ff00));
                        a.sigBytes = (b.length + 1) * 4;
                        this._process();
                        var g = this._hash;
                        var H = g.words;
                        for (var i = 0; i < 4; i++) {
                            var h = H[i];
                            H[i] = (((h << 8) | (h >>> 24)) & 0x00ff00ff) | (((h << 24) | (h >>> 8)) & 0xff00ff00)
                        }
                        return g
                    },
                    clone: function() {
                        var a = B.clone.call(this);
                        a._hash = this._hash.clone();
                        return a
                    }
                });

                function FF(a, b, c, d, x, s, t) {
                    var n = a + ((b & c) | (~b & d)) + x + t;
                    return ((n << s) | (n >>> (32 - s))) + b
                }

                function GG(a, b, c, d, x, s, t) {
                    var n = a + ((b & d) | (c & ~d)) + x + t;
                    return ((n << s) | (n >>> (32 - s))) + b
                }

                function HH(a, b, c, d, x, s, t) {
                    var n = a + (b ^ c ^ d) + x + t;
                    return ((n << s) | (n >>> (32 - s))) + b
                }

                function II(a, b, c, d, x, s, t) {
                    var n = a + (c ^ (b | ~d)) + x + t;
                    return ((n << s) | (n >>> (32 - s))) + b
                }
                C.MD5 = B._createHelper(E);
                C.HmacMD5 = B._createHmacHelper(E)
            }(Math));
            return F.MD5
        }))
    }), (function(A, B, D) {
        ;
        (function(a, b) {
            if (true) {
                A.exports = B = b()
            } else {}
        }(this, function() {
            var z = z || (function(l, m) {
                var n = Object.create || (function() {
                    function F() {};
                    return function(a) {
                        var b;
                        F.prototype = a;
                        b = new F();
                        F.prototype = null;
                        return b
                    }
                }());
                var C = {};
                var o = C.lib = {};
                var p = o.Base = (function() {
                    return {
                        extend: function(a) {
                            var b = n(this);
                            if (a) {
                                b.mixIn(a)
                            }
                            if (!b.hasOwnProperty('init') || this.init === b.init) {
                                b.init = function() {
                                    b.$super.init.apply(this, arguments)
                                }
                            }
                            b.init.prototype = b;
                            b.$super = this;
                            return b
                        },
                        create: function() {
                            var a = this.extend();
                            a.init.apply(a, arguments);
                            return a
                        },
                        init: function() {},
                        mixIn: function(a) {
                            for (var b in a) {
                                if (a.hasOwnProperty(b)) {
                                    this[b] = a[b]
                                }
                            }
                            if (a.hasOwnProperty('toString')) {
                                this.toString = a.toString
                            }
                        },
                        clone: function() {
                            return this.init.prototype.extend(this)
                        }
                    }
                }());
                var q = o.WordArray = p.extend({
                    init: function(a, b) {
                        a = this.words = a || [];
                        if (b != m) {
                            this.sigBytes = b
                        } else {
                            this.sigBytes = a.length * 4
                        }
                    },
                    toString: function(a) {
                        return (a || t)
                            .stringify(this)
                    },
                    concat: function(a) {
                        var b = this.words;
                        var c = a.words;
                        var d = this.sigBytes;
                        var e = a.sigBytes;
                        this.clamp();
                        if (d % 4) {
                            for (var i = 0; i < e; i++) {
                                var f = (c[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                                b[(d + i) >>> 2] |= f << (24 - ((d + i) % 4) * 8)
                            }
                        } else {
                            for (var i = 0; i < e; i += 4) {
                                b[(d + i) >>> 2] = c[i >>> 2]
                            }
                        }
                        this.sigBytes += e;
                        return this
                    },
                    clamp: function() {
                        var a = this.words;
                        var b = this.sigBytes;
                        a[b >>> 2] &= 0xffffffff << (32 - (b % 4) * 8);
                        a.length = l.ceil(b / 4)
                    },
                    clone: function() {
                        var a = p.clone.call(this);
                        a.words = this.words.slice(0);
                        return a
                    },
                    random: function(e) {
                        var f = [];
                        var r = (function(b) {
                            var b = b;
                            var c = 0x3ade68b1;
                            var d = 0xffffffff;
                            return function() {
                                c = (0x9069 * (c & 0xFFFF) + (c >> 0x10)) & d;
                                b = (0x4650 * (b & 0xFFFF) + (b >> 0x10)) & d;
                                var a = ((c << 0x10) + b) & d;
                                a /= 0x100000000;
                                a += 0.5;
                                return a * (l.random() > .5 ? 1 : -1)
                            }
                        });
                        for (var i = 0, rcache; i < e; i += 4) {
                            var g = r((rcache || l.random()) * 0x100000000);
                            rcache = g() * 0x3ade67b7;
                            f.push((g() * 0x100000000) | 0)
                        }
                        return new q.init(f, e)
                    }
                });
                var s = C.enc = {};
                var t = s.Hex = {
                    stringify: function(a) {
                        var b = a.words;
                        var c = a.sigBytes;
                        var d = [];
                        for (var i = 0; i < c; i++) {
                            var e = (b[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                            d.push((e >>> 4)
                                .toString(16));
                            d.push((e & 0x0f)
                                .toString(16))
                        }
                        return d.join('')
                    },
                    parse: function(a) {
                        var b = a.length;
                        var c = [];
                        for (var i = 0; i < b; i += 2) {
                            c[i >>> 3] |= parseInt(a.substr(i, 2), 16) << (24 - (i % 8) * 4)
                        }
                        return new q.init(c, b / 2)
                    }
                };
                var u = s.Latin1 = {
                    stringify: function(a) {
                        var b = a.words;
                        var c = a.sigBytes;
                        var d = [];
                        for (var i = 0; i < c; i++) {
                            var e = (b[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                            d.push(String.fromCharCode(e))
                        }
                        return d.join('')
                    },
                    parse: function(a) {
                        var b = a.length;
                        var c = [];
                        for (var i = 0; i < b; i++) {
                            c[i >>> 2] |= (a.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8)
                        }
                        return new q.init(c, b)
                    }
                };
                var v = s.Utf8 = {
                    stringify: function(a) {
                        try {
                            return decodeURIComponent(escape(u.stringify(a)))
                        } catch (e) {
                            throw new Error('Malformed UTF-8 data');
                        }
                    },
                    parse: function(a) {
                        return u.parse(unescape(encodeURIComponent(a)))
                    }
                };
                var w = o.BufferedBlockAlgorithm = p.extend({
                    reset: function() {
                        this._data = new q.init();
                        this._nDataBytes = 0
                    },
                    _append: function(a) {
                        if (typeof a == 'string') {
                            a = v.parse(a)
                        }
                        this._data.concat(a);
                        this._nDataBytes += a.sigBytes
                    },
                    _process: function(a) {
                        var b = this._data;
                        var c = b.words;
                        var d = b.sigBytes;
                        var e = this.blockSize;
                        var f = e * 4;
                        var g = d / f;
                        if (a) {
                            g = l.ceil(g)
                        } else {
                            g = l.max((g | 0) - this._minBufferSize, 0)
                        }
                        var h = g * e;
                        var i = l.min(h * 4, d);
                        if (h) {
                            for (var j = 0; j < h; j += e) {
                                this._doProcessBlock(c, j)
                            }
                            var k = c.splice(0, h);
                            b.sigBytes -= i
                        }
                        return new q.init(k, i)
                    },
                    clone: function() {
                        var a = p.clone.call(this);
                        a._data = this._data.clone();
                        return a
                    },
                    _minBufferSize: 0
                });
                var x = o.Hasher = w.extend({
                    cfg: p.extend(),
                    init: function(a) {
                        this.cfg = this.cfg.extend(a);
                        this.reset()
                    },
                    reset: function() {
                        w.reset.call(this);
                        this._doReset()
                    },
                    update: function(a) {
                        this._append(a);
                        this._process();
                        return this
                    },
                    finalize: function(a) {
                        if (a) {
                            this._append(a)
                        }
                        var b = this._doFinalize();
                        return b
                    },
                    blockSize: 512 / 32,
                    _createHelper: function(c) {
                        return function(a, b) {
                            return new c.init(b)
                                .finalize(a)
                        }
                    },
                    _createHmacHelper: function(c) {
                        return function(a, b) {
                            return new y.HMAC.init(c, b)
                                .finalize(a)
                        }
                    }
                });
                var y = C.algo = {};
                return C
            }(Math));
            return z
        }))
    }), (function(f, g, h) {
        "use strict";
        Object.defineProperty(g, "__esModule", {
            value: true
        });
        var i = h(5);
        var j;
        (function(a) {
            a[a["error"] = 0] = "error";
            a[a["warn"] = 1] = "warn";
            a[a["log"] = 2] = "log";
            a[a["debug"] = 3] = "debug"
        })(j = g.Levels || (g.Levels = {}));
        var k = (function() {
            function k() {
                this.builtinEnabled = true;
                this._level = j.log;
                this.loggers = {};
                this.type = i.TypeStrings.LoggerFactory;
                this.logger = this.getLogger("sip:loggerfactory")
            }
            Object.defineProperty(k.prototype, "level", {
                get: function() {
                    return this._level
                },
                set: function(a) {
                    if (a >= 0 && a <= 3) {
                        this._level = a
                    } else if (a > 3) {
                        this._level = 3
                    } else if (j.hasOwnProperty(a)) {
                        this._level = a
                    } else {
                        this.logger.error("invalid 'level' parameter value: " + JSON.stringify(a))
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(k.prototype, "connector", {
                get: function() {
                    return this._connector
                },
                set: function(a) {
                    if (!a) {
                        this._connector = undefined
                    } else if (typeof a === "function") {
                        this._connector = a
                    } else {
                        this.logger.error("invalid 'connector' parameter value: " + JSON.stringify(a))
                    }
                },
                enumerable: true,
                configurable: true
            });
            k.prototype.getLogger = function(a, b) {
                if (b && this.level === 3) {
                    return new l(this, a, b)
                } else if (this.loggers[a]) {
                    return this.loggers[a]
                } else {
                    var c = new l(this, a);
                    this.loggers[a] = c;
                    return c
                }
            };
            k.prototype.genericLog = function(a, b, c, d) {
                if (this.level >= a) {
                    if (this.builtinEnabled) {
                        this.print(console[j[a]], b, c, d)
                    }
                }
                if (this.connector) {
                    this.connector(j[a], b, c, d)
                }
            };
            k.prototype.print = function(a, b, c, d) {
                if (typeof d === "string") {
                    var e = [new Date(), b];
                    if (c) {
                        e.push(c)
                    }
                    d = e.concat(d)
                        .join(" | ")
                }
                a.call(console, d)
            };
            return k
        }());
        g.LoggerFactory = k;
        var l = (function() {
            function l(a, b, c) {
                this.type = i.TypeStrings.Logger;
                this.logger = a;
                this.category = b;
                this.label = c
            }
            l.prototype.error = function(a) {
                this.genericLog(j.error, a)
            };
            l.prototype.warn = function(a) {
                this.genericLog(j.warn, a)
            };
            l.prototype.log = function(a) {
                this.genericLog(j.log, a)
            };
            l.prototype.debug = function(a) {
                this.genericLog(j.debug, a)
            };
            l.prototype.genericLog = function(a, b) {
                this.logger.genericLog(a, this.category, this.label, b)
            };
            return l
        }());
        g.Logger = l
    }), (function(l, m, n) {
        "use strict";
        Object.defineProperty(m, "__esModule", {
            value: true
        });
        var o = n(5);
        var p = n(11);
        var q = n(10);
        var r;
        (function(k) {
            function getHeader(a, b) {
                var c = b;
                var d = 0;
                var e = 0;
                if (a.substring(c, c + 2)
                    .match(/(^\r\n)/)) {
                    return -2
                }
                while (d === 0) {
                    e = a.indexOf("\r\n", c);
                    if (e === -1) {
                        return e
                    }
                    if (!a.substring(e + 2, e + 4)
                        .match(/(^\r\n)/) && a.charAt(e + 2)
                        .match(/(^\s+)/)) {
                        c = e + 2
                    } else {
                        d = e
                    }
                }
                return d
            }
            k.getHeader = getHeader;

            function parseHeader(b, c, d, e) {
                var f = c.indexOf(":", d);
                var g = c.substring(d, f)
                    .trim();
                var h = c.substring(f + 1, e)
                    .trim();
                var i;
                switch (g.toLowerCase()) {
                    case "via":
                    case "v":
                        b.addHeader("via", h);
                        if (b.getHeaders("via")
                            .length === 1) {
                            i = b.parseHeader("Via");
                            if (i) {
                                b.via = i;
                                b.viaBranch = i.branch
                            }
                        } else {
                            i = 0
                        }
                        break;
                    case "from":
                    case "f":
                        b.setHeader("from", h);
                        i = b.parseHeader("from");
                        if (i) {
                            b.from = i;
                            b.fromTag = i.getParam("tag")
                        }
                        break;
                    case "to":
                    case "t":
                        b.setHeader("to", h);
                        i = b.parseHeader("to");
                        if (i) {
                            b.to = i;
                            b.toTag = i.getParam("tag")
                        }
                        break;
                    case "record-route":
                        i = p.Grammar.parse(h, "Record_Route");
                        if (i === -1) {
                            i = undefined;
                            break
                        }
                        for (var j in i) {
                            if (i[j]) {
                                b.addHeader("record-route", h.substring(i[j].position, i[j].offset));
                                b.headers["Record-Route"][b.getHeaders("record-route")
                                    .length - 1
                                ].parsed = i[j].parsed
                            }
                        }
                        break;
                    case "call-id":
                    case "i":
                        b.setHeader("call-id", h);
                        i = b.parseHeader("call-id");
                        if (i) {
                            b.callId = h
                        }
                        break;
                    case "contact":
                    case "m":
                        i = p.Grammar.parse(h, "Contact");
                        if (i === -1) {
                            i = undefined;
                            break
                        }
                        if (!(i instanceof Array)) {
                            i = undefined;
                            break
                        }
                        i.forEach(function(a) {
                            b.addHeader("contact", h.substring(a.position, a.offset));
                            b.headers.Contact[b.getHeaders("contact")
                                .length - 1].parsed = a.parsed
                        });
                        break;
                    case "content-length":
                    case "l":
                        b.setHeader("content-length", h);
                        i = b.parseHeader("content-length");
                        break;
                    case "content-type":
                    case "c":
                        b.setHeader("content-type", h);
                        i = b.parseHeader("content-type");
                        break;
                    case "cseq":
                        b.setHeader("cseq", h);
                        i = b.parseHeader("cseq");
                        if (i) {
                            b.cseq = i.value
                        }
                        if (b.type === o.TypeStrings.IncomingResponse) {
                            b.method = i.method
                        }
                        break;
                    case "max-forwards":
                        b.setHeader("max-forwards", h);
                        i = b.parseHeader("max-forwards");
                        break;
                    case "www-authenticate":
                        b.setHeader("www-authenticate", h);
                        i = b.parseHeader("www-authenticate");
                        break;
                    case "proxy-authenticate":
                        b.setHeader("proxy-authenticate", h);
                        i = b.parseHeader("proxy-authenticate");
                        break;
                    case "refer-to":
                    case "r":
                        b.setHeader("refer-to", h);
                        i = b.parseHeader("refer-to");
                        if (i) {
                            b.referTo = i
                        }
                        break;
                    default:
                        b.setHeader(g, h);
                        i = 0
                }
                if (i === undefined) {
                    return {
                        error: "error parsing header '" + g + "'"
                    }
                } else {
                    return true
                }
            }
            k.parseHeader = parseHeader;

            function parseMessage(a, b) {
                var c = 0;
                var d = a.indexOf("\r\n");
                var e = b.getLogger("sip.parser");
                if (d === -1) {
                    e.warn("no CRLF found, not a SIP message, discarded");
                    return
                }
                var f = a.substring(0, d);
                var g = p.Grammar.parse(f, "Request_Response");
                var h;
                if (g === -1) {
                    e.warn('error parsing first line of SIP message: "' + f + '"');
                    return
                } else if (!g.status_code) {
                    h = new q.IncomingRequest(b);
                    h.method = g.method;
                    h.ruri = g.uri
                } else {
                    h = new q.IncomingResponse(b);
                    h.statusCode = g.status_code;
                    h.reasonPhrase = g.reason_phrase
                }
                h.data = a;
                c = d + 2;
                var i;
                while (true) {
                    d = getHeader(a, c);
                    if (d === -2) {
                        i = c + 2;
                        break
                    } else if (d === -1) {
                        e.error("malformed message");
                        return
                    }
                    var j = parseHeader(h, a, c, d);
                    if (j !== true) {
                        e.error(g.error);
                        return
                    }
                    c = d + 2
                }
                if (h.hasHeader("content-length")) {
                    h.body = a.substr(i, Number(h.getHeader("content-length")))
                } else {
                    h.body = a.substring(i)
                }
                return h
            }
            k.parseMessage = parseMessage
        })(r = m.Parser || (m.Parser = {}))
    }), (function(h, i, j) {
        "use strict";
        var k = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        Object.defineProperty(i, "__esModule", {
            value: true
        });
        var l = j(1);
        var m = j(3);
        var n = j(5);
        var o = j(8);
        var q = j(10);
        var r = j(15);
        var s = (function(g) {
            k(s, g);

            function s(b, c, d, e) {
                if (e === void 0) {
                    e = {}
                }
                var f = this;
                e.extraHeaders = (e.extraHeaders || [])
                    .slice();
                e.contentType = (e.contentType || "text/plain");
                if (typeof e.expires !== "number" || (e.expires % 1) !== 0) {
                    e.expires = 3600
                } else {
                    e.expires = Number(e.expires)
                }
                if (typeof(e.unpublishOnClose) !== "boolean") {
                    e.unpublishOnClose = true
                }
                if (c === undefined || c === null || c === "") {
                    throw new o.Exceptions.MethodParameterError("Publish", "Target", c);
                } else {
                    c = b.normalizeTarget(c);
                    if (c === undefined) {
                        throw new o.Exceptions.MethodParameterError("Publish", "Target", c);
                    }
                }
                f = g.call(this, b, m.C.PUBLISH, c, e) || this;
                f.type = n.TypeStrings.PublishContext;
                f.options = e;
                f.target = c;
                if (d === undefined || d === null || d === "") {
                    throw new o.Exceptions.MethodParameterError("Publish", "Event", d);
                } else {
                    f.event = d
                }
                f.logger = b.getLogger("sip.publish");
                f.pubRequestExpires = f.options.expires;
                b.on("transportCreated", function(a) {
                    a.on("transportError", function() {
                        return f.onTransportError()
                    })
                });
                return f
            }
            s.prototype.publish = function(a) {
                if (this.publishRefreshTimer) {
                    clearTimeout(this.publishRefreshTimer);
                    this.publishRefreshTimer = undefined
                }
                this.options.body = a;
                this.pubRequestBody = this.options.body;
                if (this.pubRequestExpires === 0) {
                    this.pubRequestExpires = this.options.expires;
                    this.pubRequestEtag = undefined
                }
                if (!(this.ua.publishers[this.target.toString() + ":" + this.event])) {
                    this.ua.publishers[this.target.toString() + ":" + this.event] = this
                }
                this.sendPublishRequest()
            };
            s.prototype.unpublish = function() {
                if (this.publishRefreshTimer) {
                    clearTimeout(this.publishRefreshTimer);
                    this.publishRefreshTimer = undefined
                }
                this.pubRequestBody = undefined;
                this.pubRequestExpires = 0;
                if (this.pubRequestEtag !== undefined) {
                    this.sendPublishRequest()
                }
            };
            s.prototype.close = function() {
                if (this.options.unpublishOnClose) {
                    this.unpublish()
                } else {
                    if (this.publishRefreshTimer) {
                        clearTimeout(this.publishRefreshTimer);
                        this.publishRefreshTimer = undefined
                    }
                    this.pubRequestBody = undefined;
                    this.pubRequestExpires = 0;
                    this.pubRequestEtag = undefined
                }
                if (this.ua.publishers[this.target.toString() + ":" + this.event]) {
                    delete this.ua.publishers[this.target.toString() + ":" + this.event]
                }
            };
            s.prototype.onRequestTimeout = function() {
                g.prototype.onRequestTimeout.call(this);
                this.emit("unpublished", undefined, m.C.causes.REQUEST_TIMEOUT)
            };
            s.prototype.onTransportError = function() {
                g.prototype.onTransportError.call(this);
                this.emit("unpublished", undefined, m.C.causes.CONNECTION_ERROR)
            };
            s.prototype.receiveResponse = function(a) {
                var b = this;
                var c = a.statusCode || 0;
                var d = r.Utils.getReasonPhrase(c);
                switch (true) {
                    case /^1[0-9]{2}$/.test(c.toString()):
                        this.emit("progress", a, d);
                        break;
                    case /^2[0-9]{2}$/.test(c.toString()):
                        if (a.hasHeader("SIP-ETag")) {
                            this.pubRequestEtag = a.getHeader("SIP-ETag")
                        } else {
                            this.logger.warn("SIP-ETag header missing in a 200-class response to PUBLISH")
                        }
                        if (a.hasHeader("Expires")) {
                            var e = Number(a.getHeader("Expires"));
                            if (typeof e === "number" && e >= 0 && e <= this.pubRequestExpires) {
                                this.pubRequestExpires = e
                            } else {
                                this.logger.warn("Bad Expires header in a 200-class response to PUBLISH")
                            }
                        } else {
                            this.logger.warn("Expires header missing in a 200-class response to PUBLISH")
                        }
                        if (this.pubRequestExpires !== 0) {
                            this.publishRefreshTimer = setTimeout(function() {
                                return b.refreshRequest()
                            }, this.pubRequestExpires * 900);
                            this.emit("published", a, d)
                        } else {
                            this.emit("unpublished", a, d)
                        }
                        break;
                    case /^412$/.test(c.toString()):
                        if (this.pubRequestEtag !== undefined && this.pubRequestExpires !== 0) {
                            this.logger.warn("412 response to PUBLISH, recovering");
                            this.pubRequestEtag = undefined;
                            this.emit("progress", a, d);
                            this.publish(this.options.body)
                        } else {
                            this.logger.warn("412 response to PUBLISH, recovery failed");
                            this.pubRequestExpires = 0;
                            this.emit("failed", a, d);
                            this.emit("unpublished", a, d)
                        }
                        break;
                    case /^423$/.test(c.toString()):
                        if (this.pubRequestExpires !== 0 && a.hasHeader("Min-Expires")) {
                            var f = Number(a.getHeader("Min-Expires"));
                            if (typeof f === "number" || f > this.pubRequestExpires) {
                                this.logger.warn("423 code in response to PUBLISH, adjusting the Expires value and trying to recover");
                                this.pubRequestExpires = f;
                                this.emit("progress", a, d);
                                this.publish(this.options.body)
                            } else {
                                this.logger.warn("Bad 423 response Min-Expires header received for PUBLISH");
                                this.pubRequestExpires = 0;
                                this.emit("failed", a, d);
                                this.emit("unpublished", a, d)
                            }
                        } else {
                            this.logger.warn("423 response to PUBLISH, recovery failed");
                            this.pubRequestExpires = 0;
                            this.emit("failed", a, d);
                            this.emit("unpublished", a, d)
                        }
                        break;
                    default:
                        this.pubRequestExpires = 0;
                        this.emit("failed", a, d);
                        this.emit("unpublished", a, d);
                        break
                }
                if (this.pubRequestExpires === 0) {
                    if (this.publishRefreshTimer) {
                        clearTimeout(this.publishRefreshTimer);
                        this.publishRefreshTimer = undefined
                    }
                    this.pubRequestBody = undefined;
                    this.pubRequestEtag = undefined
                }
            };
            s.prototype.refreshRequest = function() {
                if (this.publishRefreshTimer) {
                    clearTimeout(this.publishRefreshTimer);
                    this.publishRefreshTimer = undefined
                }
                this.pubRequestBody = undefined;
                if (this.pubRequestEtag === undefined) {
                    throw new o.Exceptions.MethodParameterError("Publish", "Body", undefined);
                }
                if (this.pubRequestExpires === 0) {
                    throw new o.Exceptions.MethodParameterError("Publish", "Expire", this.pubRequestExpires);
                }
                this.sendPublishRequest()
            };
            s.prototype.sendPublishRequest = function() {
                var a = Object.create(this.options || Object.prototype);
                a.extraHeaders = (this.options.extraHeaders || [])
                    .slice();
                a.extraHeaders.push("Event: " + this.event);
                a.extraHeaders.push("Expires: " + this.pubRequestExpires);
                if (this.pubRequestEtag !== undefined) {
                    a.extraHeaders.push("SIP-If-Match: " + this.pubRequestEtag)
                }
                this.request = new q.OutgoingRequest(m.C.PUBLISH, this.target, this.ua, this.options.params, a.extraHeaders);
                if (this.pubRequestBody !== undefined) {
                    this.request.body = {
                        body: this.pubRequestBody,
                        contentType: this.options.contentType
                    }
                }
                this.send()
            };
            return s
        }(l.ClientContext));
        i.PublishContext = s
    }), (function(j, k, l) {
        "use strict";
        var m = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        var o = (this && this.__assign) || function() {
            o = Object.assign || function(t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s)
                        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
                }
                return t
            };
            return o.apply(this, arguments)
        };
        Object.defineProperty(k, "__esModule", {
            value: true
        });
        var q = l(1);
        var r = l(3);
        var u = l(5);
        var v = l(8);
        var w = l(11);
        var x = l(15);

        function loadConfig(a) {
            var b = {
                expires: 600,
                extraContactHeaderParams: [],
                instanceId: undefined,
                params: {},
                regId: undefined,
                registrar: undefined,
            };
            var c = getConfigurationCheck();
            for (var d in c.mandatory) {
                if (!a.hasOwnProperty(d)) {
                    throw new v.Exceptions.ConfigurationError(d);
                } else {
                    var e = a[d];
                    var f = c.mandatory[d](e);
                    if (f !== undefined) {
                        b[d] = f
                    } else {
                        throw new v.Exceptions.ConfigurationError(d, e);
                    }
                }
            }
            for (var d in c.optional) {
                if (a.hasOwnProperty(d)) {
                    var e = a[d];
                    if (e instanceof Array && e.length === 0) {
                        continue
                    }
                    if (e === null || e === "" || e === undefined || (typeof(e) === "number" && isNaN(e))) {
                        continue
                    }
                    var f = c.optional[d](e);
                    if (f !== undefined) {
                        b[d] = f
                    } else {
                        throw new v.Exceptions.ConfigurationError(d, e);
                    }
                }
            }
            return b
        }

        function getConfigurationCheck() {
            return {
                mandatory: {},
                optional: {
                    expires: function(a) {
                        if (x.Utils.isDecimal(a)) {
                            var b = Number(a);
                            if (b >= 0) {
                                return b
                            }
                        }
                    },
                    extraContactHeaderParams: function(b) {
                        if (b instanceof Array) {
                            return b.filter(function(a) {
                                return (typeof a === "string")
                            })
                        }
                    },
                    instanceId: function(a) {
                        if (typeof a !== "string") {
                            return
                        }
                        if ((/^uuid:/i.test(a))) {
                            a = a.substr(5)
                        }
                        if (w.Grammar.parse(a, "uuid") === -1) {
                            return
                        } else {
                            return a
                        }
                    },
                    params: function(a) {
                        if (typeof a === "object") {
                            return a
                        }
                    },
                    regId: function(a) {
                        if (x.Utils.isDecimal(a)) {
                            var b = Number(a);
                            if (b >= 0) {
                                return b
                            }
                        }
                    },
                    registrar: function(a) {
                        if (typeof a !== "string") {
                            return
                        }
                        if (!/^sip:/i.test(a)) {
                            a = r.C.SIP + ":" + a
                        }
                        var b = w.Grammar.URIParse(a);
                        if (!b) {
                            return
                        } else if (b.user) {
                            return
                        } else {
                            return b
                        }
                    }
                }
            }
        }
        var y = (function(i) {
            m(y, i);

            function y(b, c) {
                if (c === void 0) {
                    c = {}
                }
                var d = this;
                var e = loadConfig(c);
                if (e.regId && !e.instanceId) {
                    e.instanceId = x.Utils.newUUID()
                } else if (!e.regId && e.instanceId) {
                    e.regId = 1
                }
                e.params.toUri = e.params.toUri || b.configuration.uri;
                e.params.toDisplayName = e.params.toDisplayName || b.configuration.displayName;
                e.params.callId = e.params.callId || x.Utils.createRandomToken(22);
                e.params.cseq = e.params.cseq || Math.floor(Math.random() * 10000);
                if (!e.registrar) {
                    var f = {};
                    if (typeof b.configuration.uri === "object") {
                        f = b.configuration.uri.clone();
                        f.user = undefined
                    } else {
                        f = b.configuration.uri
                    }
                    e.registrar = f
                }
                d = i.call(this, b, r.C.REGISTER, e.registrar, e) || this;
                d.type = u.TypeStrings.RegisterContext;
                d.options = e;
                d.logger = b.getLogger("sip.registercontext");
                d.logger.log("configuration parameters for RegisterContext after validation:");
                for (var g in e) {
                    if (e.hasOwnProperty(g)) {
                        d.logger.log("è·¯ " + g + ": " + JSON.stringify(e[g]))
                    }
                }
                d.expires = e.expires;
                d.cseq = e.params.cseq;
                d.contact = b.contact.toString();
                d.registered = false;
                b.on("transportCreated", function(a) {
                    a.on("disconnected", function() {
                        return d.onTransportDisconnected()
                    })
                });
                return d
            }
            y.prototype.register = function(f) {
                var g = this;
                if (f === void 0) {
                    f = {}
                }
                this.options = o({}, this.options, f);
                var h = (this.options.extraHeaders || [])
                    .slice();
                h.push("Contact: " + this.generateContactHeader(this.expires));
                h.push("Allow: " + ["ACK", "CANCEL", "INVITE", "MESSAGE", "BYE", "OPTIONS", "INFO", "NOTIFY", "REFER"].toString());
                this.closeHeaders = this.options.closeWithHeaders ? (this.options.extraHeaders || [])
                    .slice() : [];
                this.receiveResponse = function(a) {
                    if (a.cseq !== g.cseq) {
                        return
                    }
                    if (g.registrationTimer !== undefined) {
                        clearTimeout(g.registrationTimer);
                        g.registrationTimer = undefined
                    }
                    var b = (a.statusCode || 0)
                        .toString();
                    switch (true) {
                        case /^1[0-9]{2}$/.test(b):
                            g.emit("progress", a);
                            break;
                        case /^2[0-9]{2}$/.test(b):
                            g.emit("accepted", a);
                            var c = void 0;
                            if (a.hasHeader("expires")) {
                                c = Number(a.getHeader("expires"))
                            }
                            if (g.registrationExpiredTimer !== undefined) {
                                clearTimeout(g.registrationExpiredTimer);
                                g.registrationExpiredTimer = undefined
                            }
                            var d = a.getHeaders("contact")
                                .length;
                            if (!d) {
                                g.logger.warn("no Contact header in response to REGISTER, response ignored");
                                break
                            }
                            var e = void 0;
                            while (d--) {
                                e = a.parseHeader("contact", d);
                                if (e.uri.user === g.ua.contact.uri.user) {
                                    c = e.getParam("expires");
                                    break
                                } else {
                                    e = undefined
                                }
                            }
                            if (!e) {
                                g.logger.warn("no Contact header pointing to us, response ignored");
                                break
                            }
                            if (c === undefined) {
                                c = g.expires
                            }
                            g.registrationTimer = setTimeout(function() {
                                g.registrationTimer = undefined;
                                g.register(g.options)
                            }, (c * 1000) - 3000);
                            g.registrationExpiredTimer = setTimeout(function() {
                                g.logger.warn("registration expired");
                                if (g.registered) {
                                    g.unregistered(undefined, r.C.causes.EXPIRES)
                                }
                            }, c * 1000);
                            if (e.hasParam("temp-gruu")) {
                                g.ua.contact.tempGruu = w.Grammar.URIParse(e.getParam("temp-gruu")
                                    .replace(/"/g, ""))
                            }
                            if (e.hasParam("pub-gruu")) {
                                g.ua.contact.pubGruu = w.Grammar.URIParse(e.getParam("pub-gruu")
                                    .replace(/"/g, ""))
                            }
                            g.registered = true;
                            g.emit("registered", a || undefined);
                            break;
                        case /^423$/.test(b):
                            if (a.hasHeader("min-expires")) {
                                g.expires = Number(a.getHeader("min-expires"));
                                g.register(g.options)
                            } else {
                                g.logger.warn("423 response received for REGISTER without Min-Expires");
                                g.registrationFailure(a, r.C.causes.SIP_FAILURE_CODE)
                            }
                            break;
                        default:
                            g.registrationFailure(a, x.Utils.sipErrorCause(a.statusCode || 0))
                    }
                };
                this.onRequestTimeout = function() {
                    g.registrationFailure(undefined, r.C.causes.REQUEST_TIMEOUT)
                };
                this.onTransportError = function() {
                    g.registrationFailure(undefined, r.C.causes.CONNECTION_ERROR)
                };
                this.cseq++;
                if (this.request) {
                    this.request.cseq = this.cseq;
                    this.request.setHeader("cseq", this.cseq + " REGISTER");
                    this.request.extraHeaders = h
                }
                this.send()
            };
            y.prototype.close = function() {
                var a = {
                    all: false,
                    extraHeaders: this.closeHeaders
                };
                this.registeredBefore = this.registered;
                if (this.registered) {
                    this.unregister(a)
                }
            };
            y.prototype.unregister = function(c) {
                var d = this;
                if (c === void 0) {
                    c = {}
                }
                if (!this.registered && !c.all) {
                    this.logger.warn("Already unregistered, but sending an unregister anyways.")
                }
                var e = (c.extraHeaders || [])
                    .slice();
                this.registered = false;
                if (this.registrationTimer !== undefined) {
                    clearTimeout(this.registrationTimer);
                    this.registrationTimer = undefined
                }
                if (c.all) {
                    e.push("Contact: *");
                    e.push("Expires: 0")
                } else {
                    e.push("Contact: " + this.generateContactHeader(0))
                }
                this.receiveResponse = function(a) {
                    var b = (a && a.statusCode) ? a.statusCode.toString() : "";
                    switch (true) {
                        case /^1[0-9]{2}$/.test(b):
                            d.emit("progress", a);
                            break;
                        case /^2[0-9]{2}$/.test(b):
                            d.emit("accepted", a);
                            if (d.registrationExpiredTimer !== undefined) {
                                clearTimeout(d.registrationExpiredTimer);
                                d.registrationExpiredTimer = undefined
                            }
                            d.unregistered(a);
                            break;
                        default:
                            d.unregistered(a, x.Utils.sipErrorCause(a.statusCode || 0))
                    }
                };
                this.onRequestTimeout = function() {};
                this.cseq++;
                if (this.request) {
                    this.request.cseq = this.cseq;
                    this.request.setHeader("cseq", this.cseq + " REGISTER");
                    this.request.extraHeaders = e
                }
                this.send()
            };
            y.prototype.unregistered = function(a, b) {
                this.registered = false;
                this.emit("unregistered", a || undefined, b || undefined)
            };
            y.prototype.registrationFailure = function(a, b) {
                this.emit("failed", a || undefined, b || undefined)
            };
            y.prototype.onTransportDisconnected = function() {
                this.registeredBefore = this.registered;
                if (this.registrationTimer !== undefined) {
                    clearTimeout(this.registrationTimer);
                    this.registrationTimer = undefined
                }
                if (this.registrationExpiredTimer !== undefined) {
                    clearTimeout(this.registrationExpiredTimer);
                    this.registrationExpiredTimer = undefined
                }
                if (this.registered) {
                    this.unregistered(undefined, r.C.causes.CONNECTION_ERROR)
                }
            };
            y.prototype.generateContactHeader = function(b) {
                if (b === void 0) {
                    b = 0
                }
                var c = this.contact;
                if (this.options.regId && this.options.instanceId) {
                    c += ";reg-id=" + this.options.regId;
                    c += ';+sip.instance="<urn:uuid:' + this.options.instanceId + '>"'
                }
                if (this.options.extraContactHeaderParams) {
                    this.options.extraContactHeaderParams.forEach(function(a) {
                        c += ";" + a
                    })
                }
                c += ";expires=" + b;
                return c
            };
            return y
        }(q.ClientContext));
        k.RegisterContext = y
    }), (function(l, m, n) {
        "use strict";
        Object.defineProperty(m, "__esModule", {
            value: true
        });
        var o = n(3);
        var p = n(5);
        var q = n(15);
        var r;
        (function(k) {
            function reply(a, b, c) {
                var d = q.Utils.buildStatusLine(a);
                var e = b.getHeaders("via");
                for (var f = 0, vias_1 = e; f < vias_1.length; f++) {
                    var g = vias_1[f];
                    d += "Via: " + g + "\r\n"
                }
                var h = b.getHeader("To") || "";
                if (!b.toTag) {
                    h += ";tag=" + q.Utils.newTag()
                }
                d += "To: " + h + "\r\n";
                d += "From: " + b.getHeader("From") + "\r\n";
                d += "Call-ID: " + b.callId + "\r\n";
                d += "CSeq: " + b.cseq + " " + b.method + "\r\n";
                d += "\r\n";
                c.send(d)
            }
            k.reply = reply;

            function rfc3261_8_2_2_1(a, b, c) {
                if (!a.ruri || a.ruri.scheme !== "sip") {
                    reply(416, a, c);
                    return false
                }
                return true
            }
            k.rfc3261_8_2_2_1 = rfc3261_8_2_2_1;

            function rfc3261_16_3_4(a, b, c) {
                if (!a.toTag) {
                    if (a.callId.substr(0, 5) === b.configuration.sipjsId) {
                        reply(482, a, c);
                        return false
                    }
                }
                return true
            }
            k.rfc3261_16_3_4 = rfc3261_16_3_4;

            function rfc3261_18_3_request(a, b, c) {
                var d = q.Utils.str_utf8_length(a.body);
                var e = a.getHeader("content-length");
                if (e && d < Number(e)) {
                    reply(400, a, c);
                    return false
                }
                return true
            }
            k.rfc3261_18_3_request = rfc3261_18_3_request;

            function rfc3261_8_2_2_2(a, b, c) {
                var d = a.fromTag;
                var e = a.callId;
                var f = a.cseq;
                if (!a.toTag) {
                    if (a.method === o.C.INVITE) {
                        if (b.transactions.ist[a.viaBranch]) {
                            return true
                        } else {
                            for (var g in b.transactions.ist) {
                                if (b.transactions.ist.hasOwnProperty(g)) {
                                    var h = b.transactions.ist[g];
                                    if (h && h.request.fromTag === d && h.request.callId === e && h.request.cseq === f) {
                                        reply(482, a, c);
                                        return false
                                    }
                                }
                            }
                        }
                    } else {
                        if (b.transactions.nist[a.viaBranch]) {
                            return true
                        } else {
                            for (var g in b.transactions.nist) {
                                if (b.transactions.nist.hasOwnProperty(g)) {
                                    var h = b.transactions.nist[g];
                                    if (h && h.request.fromTag === d && h.request.callId === e && h.request.cseq === f) {
                                        reply(482, a, c);
                                        return false
                                    }
                                }
                            }
                        }
                    }
                }
                return true
            }
            k.rfc3261_8_2_2_2 = rfc3261_8_2_2_2;

            function rfc3261_8_1_3_3(a, b) {
                if (a.getHeaders("via")
                    .length > 1) {
                    b.getLogger("sip.sanitycheck")
                        .warn("More than one Via header field present in the response." + " Dropping the response");
                    return false
                }
                return true
            }
            k.rfc3261_8_1_3_3 = rfc3261_8_1_3_3;

            function rfc3261_18_1_2(a, b) {
                if (a.via.host !== b.configuration.viaHost || a.via.port !== undefined) {
                    b.getLogger("sip.sanitycheck")
                        .warn("Via sent-by in the response does not match UA Via host value." + " Dropping the response");
                    return false
                }
                return true
            }
            k.rfc3261_18_1_2 = rfc3261_18_1_2;

            function rfc3261_18_3_response(a, b) {
                var c = q.Utils.str_utf8_length(a.body);
                var d = a.getHeader("content-length");
                if (d && c < Number(d)) {
                    b.getLogger("sip.sanitycheck")
                        .warn("Message body length is lower than the value in" + " Content-Length header field. Dropping the response");
                    return false
                }
                return true
            }
            k.rfc3261_18_3_response = rfc3261_18_3_response;

            function minimumHeaders(a, b) {
                var c = ["from", "to", "call_id", "cseq", "via"];
                for (var d = 0, mandatoryHeaders_1 = c; d < mandatoryHeaders_1.length; d++) {
                    var e = mandatoryHeaders_1[d];
                    if (!a.hasHeader(e)) {
                        b.getLogger("sip.sanitycheck")
                            .warn("Missing mandatory header field : " + e + ". Dropping the response");
                        return false
                    }
                }
                return true
            }
            k.minimumHeaders = minimumHeaders;

            function sanityCheck(a, b, c) {
                var d = [rfc3261_8_2_2_1, rfc3261_16_3_4, rfc3261_18_3_request, rfc3261_8_2_2_2];
                var e = [rfc3261_8_1_3_3, rfc3261_18_1_2, rfc3261_18_3_response];
                var f = [minimumHeaders];
                for (var g = 0, all_1 = f; g < all_1.length; g++) {
                    var h = all_1[g];
                    if (!h(a, b, c)) {
                        return false
                    }
                }
                if (a.type === p.TypeStrings.IncomingRequest) {
                    for (var i = 0, requests_1 = d; i < requests_1.length; i++) {
                        var h = requests_1[i];
                        if (!h(a, b, c)) {
                            return false
                        }
                    }
                } else if (a.type === p.TypeStrings.IncomingResponse) {
                    for (var j = 0, responses_1 = e; j < responses_1.length; j++) {
                        var h = responses_1[j];
                        if (!h(a, b, c)) {
                            return false
                        }
                    }
                }
                return true
            }
            k.sanityCheck = sanityCheck
        })(r = m.SanityCheck || (m.SanityCheck = {}))
    }), (function(m, n, o) {
        "use strict";
        var q = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        Object.defineProperty(n, "__esModule", {
            value: true
        });
        var r = o(2);
        var s = o(3);
        var t = o(5);
        var u = o(11);
        var v = o(7);
        var w = o(15);
        var x = (function(l) {
            q(x, l);

            function x(a, b) {
                var c = l.call(this) || this;
                c.data = {};
                x.initializer(c, a, b);
                return c
            }
            x.initializer = function(b, c, d) {
                b.type = t.TypeStrings.ServerContext;
                b.ua = c;
                b.logger = c.getLogger("sip.servercontext");
                b.request = d;
                var e = c.transport;
                if (!e) {
                    throw new Error("Transport undefined.");
                }
                var f = {
                    loggerFactory: c.getLoggerFactory(),
                    onStateChange: function(a) {
                        if (a === v.TransactionState.Terminated) {
                            c.destroyTransaction(b.transaction)
                        }
                    },
                    onTransportError: function(a) {
                        b.logger.error(a.message);
                        b.onTransportError()
                    }
                };
                if (d.method === s.C.INVITE) {
                    b.transaction = new v.InviteServerTransaction(d, e, f)
                } else {
                    b.transaction = new v.NonInviteServerTransaction(d, e, f)
                }
                c.newTransaction(b.transaction);
                if (d.body) {
                    b.body = d.body
                }
                if (d.hasHeader("Content-Type")) {
                    b.contentType = d.getHeader("Content-Type")
                }
                b.method = d.method;
                b.localIdentity = d.to;
                b.remoteIdentity = d.from;
                var g = d.hasHeader("P-Asserted-Identity");
                if (g) {
                    var h = d.getHeader("P-Asserted-Identity");
                    if (h) {
                        b.assertedIdentity = u.Grammar.nameAddrHeaderParse(h)
                    }
                }
            };
            x.prototype.progress = function(a) {
                if (a === void 0) {
                    a = {}
                }
                a.statusCode = a.statusCode || 180;
                a.minCode = 100;
                a.maxCode = 199;
                a.events = ["progress"];
                return this.reply(a)
            };
            x.prototype.accept = function(a) {
                if (a === void 0) {
                    a = {}
                }
                a.statusCode = a.statusCode || 200;
                a.minCode = 200;
                a.maxCode = 299;
                a.events = ["accepted"];
                return this.reply(a)
            };
            x.prototype.reject = function(a) {
                if (a === void 0) {
                    a = {}
                }
                a.statusCode = a.statusCode || 480;
                a.minCode = 300;
                a.maxCode = 699;
                a.events = ["rejected", "failed"];
                return this.reply(a)
            };
            x.prototype.reply = function(b) {
                var c = this;
                if (b === void 0) {
                    b = {}
                }
                var d = b.statusCode || 100;
                var e = b.minCode || 100;
                var f = b.maxCode || 699;
                var g = w.Utils.getReasonPhrase(d, b.reasonPhrase);
                var h = b.extraHeaders || [];
                var i = b.body;
                var j = b.events || [];
                if (d < e || d > f) {
                    throw new TypeError("Invalid statusCode: " + d);
                }
                var k = this.request.reply(d, g, h, i);
                j.forEach(function(a) {
                    c.emit(a, k, g)
                });
                return this
            };
            x.prototype.onRequestTimeout = function() {
                this.emit("failed", undefined, s.C.causes.REQUEST_TIMEOUT)
            };
            x.prototype.onTransportError = function() {
                this.emit("failed", undefined, s.C.causes.CONNECTION_ERROR)
            };
            return x
        }(r.EventEmitter));
        n.ServerContext = x
    }), (function(q, r, s) {
        "use strict";
        var t = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        Object.defineProperty(r, "__esModule", {
            value: true
        });
        var u = s(2);
        var v = s(1);
        var w = s(3);
        var x = s(16);
        var y = s(5);
        var z = s(8);
        var A = s(11);
        var B = s(6);
        var C = s(25);
        var D = s(27);
        var E = s(10);
        var F = s(9);
        var G = s(7);
        var H = s(15);
        var I = (function(k) {
            t(I, k);

            function I(a) {
                var b = k.call(this) || this;
                b.data = {};
                b.type = y.TypeStrings.Session;
                if (!a) {
                    throw new z.Exceptions.SessionDescriptionHandlerError("A session description handler is required for the session to function");
                }
                b.status = I.C.STATUS_NULL;
                b.dialog = undefined;
                b.pendingReinvite = false;
                b.earlyDialogs = {};
                b.sessionDescriptionHandlerFactory = a;
                b.hasOffer = false;
                b.hasAnswer = false;
                b.timers = {
                    ackTimer: undefined,
                    expiresTimer: undefined,
                    invite2xxTimer: undefined,
                    userNoAnswerTimer: undefined,
                    rel1xxTimer: undefined,
                    prackTimer: undefined
                };
                b.startTime = undefined;
                b.endTime = undefined;
                b.tones = undefined;
                b.localHold = false;
                b.earlySdp = undefined;
                b.rel100 = w.C.supported.UNSUPPORTED;
                b.originalReceiveRequest = b.receiveRequest;
                return b
            }
            I.prototype.dtmf = function(c, d) {
                var e = this;
                if (d === void 0) {
                    d = {}
                }
                if (this.status !== y.SessionStatus.STATUS_CONFIRMED && this.status !== y.SessionStatus.STATUS_WAITING_FOR_ACK) {
                    throw new z.Exceptions.InvalidStateError(this.status);
                }
                if (!c || !c.toString()
                    .match(/^[0-9A-D#*,]+$/i)) {
                    throw new TypeError("Invalid tones: " + c);
                }
                var f = function() {
                    if (e.status === y.SessionStatus.STATUS_TERMINATED || !e.tones || e.tones.length === 0) {
                        e.tones = undefined;
                        return
                    }
                    var a = e.tones.shift();
                    var b;
                    if (a.tone === ",") {
                        b = 2000
                    } else {
                        a.on("failed", function() {
                            e.tones = undefined
                        });
                        a.send(d);
                        b = a.duration + a.interToneGap
                    }
                    setTimeout(f, b)
                };
                c = c.toString();
                var g = this.ua.configuration.dtmfType;
                if (this.sessionDescriptionHandler && g === w.C.dtmfType.RTP) {
                    var h = this.sessionDescriptionHandler.sendDtmf(c, d);
                    if (!h) {
                        this.logger.warn("Attempt to use dtmfType 'RTP' has failed, falling back to INFO packet method");
                        g = w.C.dtmfType.INFO
                    }
                }
                if (g === w.C.dtmfType.INFO) {
                    var i = [];
                    var j = c.split("");
                    while (j.length > 0) {
                        i.push(new D.DTMF(this, j.shift(), d))
                    }
                    if (this.tones) {
                        this.tones = this.tones.concat(i);
                        return this
                    }
                    this.tones = i;
                    f()
                }
                return this
            };
            I.prototype.bye = function(a) {
                if (a === void 0) {
                    a = {}
                }
                if (this.status === y.SessionStatus.STATUS_TERMINATED) {
                    this.logger.error("Error: Attempted to send BYE in a terminated session.");
                    return this
                }
                this.logger.log("terminating Session");
                var b = a.statusCode;
                if (b && (b < 200 || b >= 700)) {
                    throw new TypeError("Invalid statusCode: " + b);
                }
                a.receiveResponse = function() {};
                return this.sendRequest(w.C.BYE, a)
                    .terminated()
            };
            I.prototype.refer = function(a, b) {
                if (b === void 0) {
                    b = {}
                }
                if (this.status !== y.SessionStatus.STATUS_CONFIRMED) {
                    throw new z.Exceptions.InvalidStateError(this.status);
                }
                this.referContext = new L(this.ua, this, a, b);
                this.emit("referRequested", this.referContext);
                this.referContext.refer(b);
                return this.referContext
            };
            I.prototype.sendRequest = function(b, c) {
                var d = this;
                if (c === void 0) {
                    c = {}
                }
                c = c || {};
                if (!this.dialog) {
                    throw new Error("sending request without a dialog");
                }
                var e = new E.OutgoingRequest(b, this.dialog.remoteTarget, this.ua, {
                    cseq: c.cseq || (this.dialog.localSeqnum += 1),
                    callId: this.dialog.id.callId,
                    fromUri: this.dialog.localUri,
                    fromTag: this.dialog.id.localTag,
                    ToUri: this.dialog.remoteUri,
                    toTag: this.dialog.id.remoteTag,
                    routeSet: this.dialog.routeSet,
                    statusCode: c.statusCode,
                    reasonPhrase: c.reasonPhrase
                }, c.extraHeaders || [], c.body);
                new B.RequestSender({
                        request: e,
                        onRequestTimeout: function() {
                            return d.onRequestTimeout()
                        },
                        onTransportError: function() {
                            return d.onTransportError()
                        },
                        receiveResponse: function(a) {
                            return (c.receiveResponse || d.receiveNonInviteResponse.bind(d))(a)
                        }
                    }, this.ua)
                    .send();
                this.emit(b.toLowerCase(), e);
                return this
            };
            I.prototype.close = function() {
                if (this.status === y.SessionStatus.STATUS_TERMINATED) {
                    return this
                }
                this.logger.log("closing INVITE session " + this.id);
                if (this.sessionDescriptionHandler) {
                    this.sessionDescriptionHandler.close()
                }
                for (var a in this.timers) {
                    if (this.timers[a]) {
                        clearTimeout(this.timers[a])
                    }
                }
                if (this.dialog) {
                    this.dialog.terminate();
                    delete this.dialog
                }
                for (var b in this.earlyDialogs) {
                    if (this.earlyDialogs.hasOwnProperty(b)) {
                        this.earlyDialogs[b].terminate();
                        delete this.earlyDialogs[b]
                    }
                }
                this.status = y.SessionStatus.STATUS_TERMINATED;
                if (this.ua.transport) {
                    this.ua.transport.removeListener("transportError", this.errorListener)
                }
                delete this.ua.sessions[this.id];
                return this
            };
            I.prototype.createDialog = function(a, b, c) {
                if (c === void 0) {
                    c = false
                }
                var d = a[(b === "UAS") ? "toTag" : "fromTag"];
                var e = a[(b === "UAS") ? "fromTag" : "toTag"];
                var f = a.callId + d + e;
                if (c) {
                    if (this.earlyDialogs[f]) {
                        return true
                    } else {
                        var g = new x.Dialog(this, a, b, x.Dialog.C.STATUS_EARLY);
                        if (g.error) {
                            this.logger.error(g.error);
                            this.failed(a, w.C.causes.INTERNAL_ERROR);
                            return false
                        } else {
                            this.earlyDialogs[f] = g;
                            return true
                        }
                    }
                } else {
                    var g = this.earlyDialogs[f];
                    if (g) {
                        g.update(a, b);
                        this.dialog = g;
                        delete this.earlyDialogs[f];
                        for (var h in this.earlyDialogs) {
                            if (this.earlyDialogs.hasOwnProperty(h)) {
                                this.earlyDialogs[h].terminate();
                                delete this.earlyDialogs[h]
                            }
                        }
                        return true
                    }
                    var i = new x.Dialog(this, a, b);
                    if (i.error) {
                        this.logger.error(i.error);
                        this.failed(a, w.C.causes.INTERNAL_ERROR);
                        return false
                    } else {
                        this.toTag = a.toTag;
                        this.dialog = i;
                        return true
                    }
                }
            };
            I.prototype.hold = function(a, b) {
                if (a === void 0) {
                    a = {}
                }
                if (b === void 0) {
                    b = []
                }
                if (this.status !== y.SessionStatus.STATUS_WAITING_FOR_ACK && this.status !== y.SessionStatus.STATUS_CONFIRMED) {
                    throw new z.Exceptions.InvalidStateError(this.status);
                }
                if (this.localHold) {
                    this.logger.log("Session is already on hold, cannot put it on hold again");
                    return
                }
                a.modifiers = b;
                if (this.sessionDescriptionHandler) {
                    a.modifiers.push(this.sessionDescriptionHandler.holdModifier)
                }
                this.localHold = true;
                this.sendReinvite(a)
            };
            I.prototype.unhold = function(a, b) {
                if (a === void 0) {
                    a = {}
                }
                if (b === void 0) {
                    b = []
                }
                if (this.status !== y.SessionStatus.STATUS_WAITING_FOR_ACK && this.status !== y.SessionStatus.STATUS_CONFIRMED) {
                    throw new z.Exceptions.InvalidStateError(this.status);
                }
                if (!this.localHold) {
                    this.logger.log("Session is not on hold, cannot unhold it");
                    return
                }
                a.modifiers = b;
                this.localHold = false;
                this.sendReinvite(a)
            };
            I.prototype.reinvite = function(a, b) {
                if (a === void 0) {
                    a = {}
                }
                if (b === void 0) {
                    b = []
                }
                a.modifiers = b;
                return this.sendReinvite(a)
            };
            I.prototype.receiveRequest = function(a) {
                switch (a.method) {
                    case w.C.BYE:
                        a.reply(200);
                        if (this.status === y.SessionStatus.STATUS_CONFIRMED) {
                            this.emit("bye", a);
                            this.terminated(a, w.C.BYE)
                        }
                        break;
                    case w.C.INVITE:
                        if (this.status === y.SessionStatus.STATUS_CONFIRMED) {
                            this.logger.log("re-INVITE received");
                            this.receiveReinvite(a)
                        }
                        break;
                    case w.C.INFO:
                        if (this.status === y.SessionStatus.STATUS_CONFIRMED || this.status === y.SessionStatus.STATUS_WAITING_FOR_ACK) {
                            if (this.onInfo) {
                                return this.onInfo(a)
                            }
                            var b = a.getHeader("content-type");
                            if (b) {
                                if (b.match(/^application\/dtmf-relay/i)) {
                                    if (a.body) {
                                        var c = a.body.split("\r\n", 2);
                                        if (c.length === 2) {
                                            var d = void 0;
                                            var e = void 0;
                                            var f = /^(Signal\s*?=\s*?)([0-9A-D#*]{1})(\s)?.*/;
                                            if (f.test(c[0])) {
                                                d = c[0].replace(f, "$2")
                                            }
                                            var g = /^(Duration\s?=\s?)([0-9]{1,4})(\s)?.*/;
                                            if (g.test(c[1])) {
                                                e = parseInt(c[1].replace(g, "$2"), 10)
                                            }
                                            if (d && e) {
                                                new D.DTMF(this, d, {
                                                        duration: e
                                                    })
                                                    .init_incoming(a)
                                            }
                                        }
                                    }
                                } else {
                                    a.reply(415, undefined, ["Accept: application/dtmf-relay"])
                                }
                            }
                        }
                        break;
                    case w.C.REFER:
                        if (this.status === y.SessionStatus.STATUS_CONFIRMED) {
                            this.logger.log("REFER received");
                            this.referContext = new M(this.ua, a);
                            if (this.listeners("referRequested")
                                .length) {
                                this.emit("referRequested", this.referContext)
                            } else {
                                this.logger.log("No referRequested listeners, automatically accepting and following the refer");
                                var h = {
                                    followRefer: true
                                };
                                if (this.passedOptions) {
                                    h.inviteOptions = this.passedOptions
                                }
                                this.referContext.accept(h, this.modifiers)
                            }
                        }
                        break;
                    case w.C.NOTIFY:
                        if ((this.referContext && this.referContext.type === y.TypeStrings.ReferClientContext) && a.hasHeader("event") && /^refer(;.*)?$/.test(a.getHeader("event"))) {
                            this.referContext.receiveNotify(a);
                            return
                        }
                        a.reply(200, "OK");
                        this.emit("notify", a);
                        break
                }
            };
            I.prototype.terminate = function(a) {
                return this
            };
            I.prototype.onTransportError = function() {
                if (this.status !== y.SessionStatus.STATUS_CONFIRMED && this.status !== y.SessionStatus.STATUS_TERMINATED) {
                    this.failed(undefined, w.C.causes.CONNECTION_ERROR)
                }
            };
            I.prototype.onRequestTimeout = function() {
                if (this.status === y.SessionStatus.STATUS_CONFIRMED) {
                    this.terminated(undefined, w.C.causes.REQUEST_TIMEOUT)
                } else if (this.status !== y.SessionStatus.STATUS_TERMINATED) {
                    this.failed(undefined, w.C.causes.REQUEST_TIMEOUT);
                    this.terminated(undefined, w.C.causes.REQUEST_TIMEOUT)
                }
            };
            I.prototype.onDialogError = function(a) {
                if (this.status === y.SessionStatus.STATUS_CONFIRMED) {
                    this.terminated(a, w.C.causes.DIALOG_ERROR)
                } else if (this.status !== y.SessionStatus.STATUS_TERMINATED) {
                    this.failed(a, w.C.causes.DIALOG_ERROR);
                    this.terminated(a, w.C.causes.DIALOG_ERROR)
                }
            };
            I.prototype.on = function(a, b) {
                return k.prototype.on.call(this, a, b)
            };
            I.prototype.receiveReinvite = function(c) {
                var d = this;
                this.emit("reinvite", this, c);
                if (c.hasHeader("P-Asserted-Identity")) {
                    this.assertedIdentity = A.Grammar.nameAddrHeaderParse(c.getHeader("P-Asserted-Identity"))
                }
                var f;
                if (!this.sessionDescriptionHandler) {
                    this.logger.warn("No SessionDescriptionHandler to reinvite");
                    return
                }
                if (c.getHeader("Content-Length") === "0" && !c.getHeader("Content-Type")) {
                    f = this.sessionDescriptionHandler.getDescription(this.sessionDescriptionHandlerOptions, this.modifiers)
                } else if (this.sessionDescriptionHandler.hasDescription(c.getHeader("Content-Type") || "")) {
                    f = this.sessionDescriptionHandler.setDescription(c.body, this.sessionDescriptionHandlerOptions, this.modifiers)
                        .then(this.sessionDescriptionHandler.getDescription.bind(this.sessionDescriptionHandler, this.sessionDescriptionHandlerOptions, this.modifiers))
                } else {
                    c.reply(415);
                    this.emit("reinviteFailed", this);
                    return
                }
                this.receiveRequest = function(a) {
                    if (a.method === w.C.ACK && d.status === y.SessionStatus.STATUS_WAITING_FOR_ACK) {
                        if (d.sessionDescriptionHandler && d.sessionDescriptionHandler.hasDescription(a.getHeader("Content-Type") || "")) {
                            d.hasAnswer = true;
                            d.sessionDescriptionHandler.setDescription(a.body, d.sessionDescriptionHandlerOptions, d.modifiers)
                                .then(function() {
                                    clearTimeout(d.timers.ackTimer);
                                    clearTimeout(d.timers.invite2xxTimer);
                                    d.status = y.SessionStatus.STATUS_CONFIRMED;
                                    d.emit("confirmed", a)
                                })
                        } else {
                            clearTimeout(d.timers.ackTimer);
                            clearTimeout(d.timers.invite2xxTimer);
                            d.status = y.SessionStatus.STATUS_CONFIRMED;
                            d.emit("confirmed", a)
                        }
                    } else {
                        d.originalReceiveRequest(a)
                    }
                };
                f.catch(function(e) {
                        var a;
                        if (e.type === y.TypeStrings.SessionDescriptionHandlerError) {
                            a = 500
                        } else if (e.type === y.TypeStrings.RenegotiationError) {
                            d.emit("renegotiationError", e);
                            d.logger.warn(e.toString());
                            a = 488
                        } else {
                            d.logger.error(e);
                            a = 488
                        }
                        c.reply(a);
                        d.emit("reinviteFailed", d);
                        throw e;
                    })
                    .then(function(a) {
                        var b = ["Contact: " + d.contact];
                        c.reply(200, undefined, b, a);
                        d.status = y.SessionStatus.STATUS_WAITING_FOR_ACK;
                        d.setACKTimer();
                        d.emit("reinviteAccepted", d)
                    })
            };
            I.prototype.sendReinvite = function(c) {
                var d = this;
                if (c === void 0) {
                    c = {}
                }
                if (this.pendingReinvite) {
                    this.logger.warn("Reinvite in progress. Please wait until complete, then try again.");
                    return
                }
                if (!this.sessionDescriptionHandler) {
                    this.logger.warn("No SessionDescriptionHandler, can't reinvite..");
                    return
                }
                this.pendingReinvite = true;
                c.modifiers = c.modifiers || [];
                var f = (c.extraHeaders || [])
                    .slice();
                f.push("Contact: " + this.contact);
                f.push("Allow: " + ["ACK", "CANCEL", "INVITE", "MESSAGE", "BYE", "OPTIONS", "INFO", "NOTIFY", "REFER"].toString());
                this.sessionDescriptionHandler.getDescription(c.sessionDescriptionHandlerOptions, c.modifiers)
                    .then(function(b) {
                        d.sendRequest(w.C.INVITE, {
                            extraHeaders: f,
                            body: b,
                            receiveResponse: function(a) {
                                return d.receiveReinviteResponse(a)
                            }
                        })
                    })
                    .catch(function(e) {
                        if (e.type === y.TypeStrings.RenegotiationError) {
                            d.pendingReinvite = false;
                            d.emit("renegotiationError", e);
                            d.logger.warn("Renegotiation Error");
                            d.logger.warn(e.toString());
                            throw e;
                        }
                        d.logger.error("sessionDescriptionHandler error");
                        d.logger.error(e);
                        throw e;
                    })
            };
            I.prototype.receiveReinviteResponse = function(a) {
                var b = this;
                if (this.status === y.SessionStatus.STATUS_TERMINATED) {
                    this.logger.error("Received reinvite response, but in STATUS_TERMINATED");
                    return
                }
                if (!this.pendingReinvite) {
                    this.logger.error("Received reinvite response, but have no pending reinvite");
                    return
                }
                var c = a && a.statusCode ? a.statusCode.toString() : "";
                switch (true) {
                    case /^1[0-9]{2}$/.test(c):
                        break;
                    case /^2[0-9]{2}$/.test(c):
                        this.status = y.SessionStatus.STATUS_CONFIRMED;
                        this.emit("ack", a.ack());
                        this.pendingReinvite = false;
                        clearTimeout(this.timers.invite2xxTimer);
                        if (!this.sessionDescriptionHandler || !this.sessionDescriptionHandler.hasDescription(a.getHeader("Content-Type") || "")) {
                            this.logger.error("2XX response received to re-invite but did not have a description");
                            this.emit("reinviteFailed", this);
                            this.emit("renegotiationError", new z.Exceptions.RenegotiationError("2XX response received to re-invite but did not have a description"));
                            break
                        }
                        this.sessionDescriptionHandler.setDescription(a.body, this.sessionDescriptionHandlerOptions, this.modifiers)
                            .catch(function(e) {
                                b.logger.error("Could not set the description in 2XX response");
                                b.logger.error(e);
                                b.emit("reinviteFailed", b);
                                b.emit("renegotiationError", e);
                                b.sendRequest(w.C.BYE, {
                                    extraHeaders: ["Reason: " + H.Utils.getReasonHeaderValue(488, "Not Acceptable Here")]
                                });
                                b.terminated(undefined, w.C.causes.INCOMPATIBLE_SDP);
                                throw e;
                            })
                            .then(function() {
                                b.emit("reinviteAccepted", b)
                            });
                        break;
                    default:
                        this.pendingReinvite = false;
                        this.logger.log("Received a non 1XX or 2XX response to a re-invite");
                        this.emit("reinviteFailed", this);
                        this.emit("renegotiationError", new z.Exceptions.RenegotiationError("Invalid response to a re-invite"))
                }
            };
            I.prototype.acceptAndTerminate = function(a, b, c) {
                var d = [];
                if (b) {
                    d.push("Reason: " + H.Utils.getReasonHeaderValue(b, c))
                }
                if (this.dialog || this.createDialog(a, "UAC")) {
                    this.emit("ack", a.ack());
                    this.sendRequest(w.C.BYE, {
                        extraHeaders: d
                    })
                }
                return this
            };
            I.prototype.setInvite2xxTimer = function(b, c) {
                var d = this;
                var e = F.Timers.T1;
                var f = function() {
                    if (d.status !== y.SessionStatus.STATUS_WAITING_FOR_ACK) {
                        return
                    }
                    d.logger.log("no ACK received, attempting to retransmit OK");
                    var a = ["Contact: " + d.contact];
                    b.reply(200, undefined, a, c);
                    e = Math.min(e * 2, F.Timers.T2);
                    d.timers.invite2xxTimer = setTimeout(f, e)
                };
                this.timers.invite2xxTimer = setTimeout(f, e)
            };
            I.prototype.setACKTimer = function() {
                var a = this;
                this.timers.ackTimer = setTimeout(function() {
                    if (a.status === y.SessionStatus.STATUS_WAITING_FOR_ACK) {
                        a.logger.log("no ACK received for an extended period of time, terminating the call");
                        clearTimeout(a.timers.invite2xxTimer);
                        a.sendRequest(w.C.BYE);
                        a.terminated(undefined, w.C.causes.NO_ACK)
                    }
                }, F.Timers.TIMER_H)
            };
            I.prototype.failed = function(a, b) {
                if (this.status === y.SessionStatus.STATUS_TERMINATED) {
                    return this
                }
                this.emit("failed", a, b);
                return this
            };
            I.prototype.rejected = function(a, b) {
                this.emit("rejected", a, b);
                return this
            };
            I.prototype.canceled = function() {
                if (this.sessionDescriptionHandler) {
                    this.sessionDescriptionHandler.close()
                }
                this.emit("cancel");
                return this
            };
            I.prototype.accepted = function(a, b) {
                if (!(a instanceof String)) {
                    b = H.Utils.getReasonPhrase((a && a.statusCode) || 0, b)
                }
                this.startTime = new Date();
                if (this.replacee) {
                    this.replacee.emit("replaced", this);
                    this.replacee.terminate()
                }
                this.emit("accepted", a, b);
                return this
            };
            I.prototype.terminated = function(a, b) {
                if (this.status === y.SessionStatus.STATUS_TERMINATED) {
                    return this
                }
                this.endTime = new Date();
                this.close();
                this.emit("terminated", a, b);
                return this
            };
            I.prototype.connecting = function(a) {
                this.emit("connecting", {
                    request: a
                });
                return this
            };
            I.prototype.receiveNonInviteResponse = function(a) {};
            I.C = y.SessionStatus;
            return I
        }(u.EventEmitter));
        r.Session = I;
        var J = (function(l) {
            t(J, l);

            function J(c, d) {
                var e = this;
                if (!c.configuration.sessionDescriptionHandlerFactory) {
                    c.logger.warn("Can't build ISC without SDH Factory");
                    throw new Error("ISC Constructor Failed");
                }
                e = l.call(this, c.configuration.sessionDescriptionHandlerFactory) || this;
                C.ServerContext.initializer(e, c, d);
                e.type = y.TypeStrings.InviteServerContext;
                var f = d.parseHeader("Content-Disposition");
                if (f && f.type === "render") {
                    e.renderbody = d.body;
                    e.rendertype = d.getHeader("Content-Type")
                }
                e.status = y.SessionStatus.STATUS_INVITE_RECEIVED;
                e.fromTag = d.fromTag;
                e.id = d.callId + e.fromTag;
                e.request = d;
                e.contact = e.ua.contact.toString();
                e.receiveNonInviteResponse = function() {};
                e.logger = c.getLogger("sip.inviteservercontext", e.id);
                e.ua.sessions[e.id] = e;
                var g = function(a, b) {
                    if (d.hasHeader(a) && d.getHeader(a)
                        .toLowerCase()
                        .indexOf("100rel") >= 0) {
                        e.rel100 = b
                    }
                };
                g("require", w.C.supported.REQUIRED);
                g("supported", w.C.supported.SUPPORTED);
                d.toTag = H.Utils.newTag();
                if (!e.createDialog(d, "UAS", true)) {
                    d.reply(500, "Missing Contact header field");
                    return
                }
                var h = {
                    extraHeaders: ["Contact: " + e.contact]
                };
                if (e.rel100 !== w.C.supported.REQUIRED) {
                    e.progress(h)
                }
                e.status = y.SessionStatus.STATUS_WAITING_FOR_ANSWER;
                e.timers.userNoAnswerTimer = setTimeout(function() {
                    d.reply(408);
                    e.failed(d, w.C.causes.NO_ANSWER);
                    e.terminated(d, w.C.causes.NO_ANSWER)
                }, e.ua.configuration.noAnswerTimeout || 60);
                if (d.hasHeader("expires")) {
                    var i = Number(d.getHeader("expires") || 0) * 1000;
                    e.timers.expiresTimer = setTimeout(function() {
                        if (e.status === y.SessionStatus.STATUS_WAITING_FOR_ANSWER) {
                            d.reply(487);
                            e.failed(d, w.C.causes.EXPIRES);
                            e.terminated(d, w.C.causes.EXPIRES)
                        }
                    }, i)
                }
                e.errorListener = e.onTransportError.bind(e);
                if (c.transport) {
                    c.transport.on("transportError", e.errorListener)
                }
                return e
            }
            J.prototype.reject = function(b) {
                var c = this;
                if (b === void 0) {
                    b = {}
                }
                if (this.status === y.SessionStatus.STATUS_TERMINATED) {
                    throw new z.Exceptions.InvalidStateError(this.status);
                }
                this.logger.log("rejecting RTCSession");
                var d = b.statusCode || 480;
                var e = H.Utils.getReasonPhrase(d, b.reasonPhrase);
                var f = b.extraHeaders || [];
                if (d < 300 || d > 699) {
                    throw new TypeError("Invalid statusCode: " + d);
                }
                var g = this.request.reply(d, e, f, b.body);
                (["rejected", "failed"])
                .forEach(function(a) {
                    c.emit(a, g, e)
                });
                return this.terminated()
            };
            J.prototype.reply = function(a) {
                if (a === void 0) {
                    a = {}
                }
                return this
            };
            J.prototype.terminate = function(b) {
                var c = this;
                if (b === void 0) {
                    b = {}
                }
                var d = (b.extraHeaders || [])
                    .slice();
                if (this.status === y.SessionStatus.STATUS_WAITING_FOR_ACK && this.request.transaction && this.request.transaction.state !== G.TransactionState.Terminated) {
                    var e = this.dialog;
                    this.receiveRequest = function(a) {
                        if (a.method === w.C.ACK) {
                            c.sendRequest(w.C.BYE, {
                                extraHeaders: d
                            });
                            if (c.dialog) {
                                c.dialog.terminate()
                            }
                        }
                    };
                    this.request.transaction.on("stateChanged", function() {
                        if (c.request.transaction && c.request.transaction.state === G.TransactionState.Terminated && c.dialog) {
                            c.bye();
                            c.dialog.terminate()
                        }
                    });
                    this.emit("bye", this.request);
                    this.terminated();
                    this.dialog = e;
                    if (this.dialog) {
                        this.ua.dialogs[this.dialog.id.toString()] = this.dialog
                    }
                } else if (this.status === y.SessionStatus.STATUS_CONFIRMED) {
                    this.bye(b)
                } else {
                    this.reject(b)
                }
                return this
            };
            J.prototype.progress = function(f) {
                var g = this;
                if (f === void 0) {
                    f = {}
                }
                var h = f.statusCode || 180;
                var i = (f.extraHeaders || [])
                    .slice();
                if (h < 100 || h > 199) {
                    throw new TypeError("Invalid statusCode: " + h);
                }
                if (this.status === y.SessionStatus.STATUS_TERMINATED) {
                    return this
                }
                var j = function() {
                    var e = f.statusCode || 183;
                    g.status = y.SessionStatus.STATUS_WAITING_FOR_PRACK;
                    i.push("Contact: " + g.contact);
                    i.push("Require: 100rel");
                    i.push("RSeq: " + Math.floor(Math.random() * 10000));
                    if (!g.sessionDescriptionHandler) {
                        g.logger.warn("No SessionDescriptionHandler, can't do 100rel");
                        return
                    }
                    g.sessionDescriptionHandler.getDescription(f.sessionDescriptionHandlerOptions, f.modifiers)
                        .then(function(a) {
                            if (g.status === y.SessionStatus.STATUS_TERMINATED) {
                                return
                            }
                            g.earlySdp = a.body;
                            g[g.hasOffer ? "hasAnswer" : "hasOffer"] = true;
                            var b = F.Timers.T1;
                            var c = function() {
                                g.request.reply(e, undefined, i, a);
                                b *= 2;
                                g.timers.rel1xxTimer = setTimeout(c, b)
                            };
                            g.timers.rel1xxTimer = setTimeout(c, b);
                            g.timers.prackTimer = setTimeout(function() {
                                if (g.status !== y.SessionStatus.STATUS_WAITING_FOR_PRACK) {
                                    return
                                }
                                g.logger.log("no PRACK received, rejecting the call");
                                clearTimeout(g.timers.rel1xxTimer);
                                g.request.reply(504);
                                g.terminated(undefined, w.C.causes.NO_PRACK)
                            }, F.Timers.T1 * 64);
                            var d = g.request.reply(e, f.reasonPhrase, i, a);
                            g.emit("progress", d, f.reasonPhrase)
                        }, function() {
                            g.request.reply(480);
                            g.failed(undefined, w.C.causes.WEBRTC_ERROR);
                            g.terminated(undefined, w.C.causes.WEBRTC_ERROR)
                        })
                };
                var k = function() {
                    var a = g.request.reply(h, f.reasonPhrase, i, f.body);
                    g.emit("progress", a, f.reasonPhrase)
                };
                if (f.statusCode !== 100 && (this.rel100 === w.C.supported.REQUIRED || (this.rel100 === w.C.supported.SUPPORTED && f.rel100) || (this.rel100 === w.C.supported.SUPPORTED && (this.ua.configuration.rel100 === w.C.supported.REQUIRED)))) {
                    this.sessionDescriptionHandler = this.setupSessionDescriptionHandler();
                    this.emit("SessionDescriptionHandler-created", this.sessionDescriptionHandler);
                    if (this.sessionDescriptionHandler.hasDescription(this.request.getHeader("Content-Type") || "")) {
                        this.hasOffer = true;
                        this.sessionDescriptionHandler.setDescription(this.request.body, f.sessionDescriptionHandlerOptions, f.modifiers)
                            .then(j)
                            .catch(function(e) {
                                g.logger.warn("invalid description");
                                g.logger.warn(e);
                                g.failed(undefined, w.C.causes.WEBRTC_ERROR);
                                g.terminated(undefined, w.C.causes.WEBRTC_ERROR);
                                throw e;
                            })
                    } else {
                        j()
                    }
                } else {
                    k()
                }
                return this
            };
            J.prototype.accept = function(c) {
                var d = this;
                if (c === void 0) {
                    c = {}
                }
                this.onInfo = c.onInfo;
                var e = (c.extraHeaders || [])
                    .slice();
                var f = function(a) {
                    e.push("Contact: " + d.contact);
                    e.push("Allow: " + ["ACK", "CANCEL", "INVITE", "MESSAGE", "BYE", "OPTIONS", "INFO", "NOTIFY", "REFER"].toString());
                    if (!d.hasOffer) {
                        d.hasOffer = true
                    } else {
                        d.hasAnswer = true
                    }
                    var b = d.request.reply(200, undefined, e, a);
                    d.status = y.SessionStatus.STATUS_WAITING_FOR_ACK;
                    d.setInvite2xxTimer(d.request, a);
                    d.setACKTimer();
                    d.accepted(b, H.Utils.getReasonPhrase(200))
                };
                var g = function(a) {
                    if (a.type === y.TypeStrings.SessionDescriptionHandlerError) {
                        d.logger.log(a.message);
                        if (a.error) {
                            d.logger.log(a.error)
                        }
                    }
                    d.request.reply(480);
                    d.failed(undefined, w.C.causes.WEBRTC_ERROR);
                    d.terminated(undefined, w.C.causes.WEBRTC_ERROR);
                    throw a;
                };
                if (this.status === y.SessionStatus.STATUS_WAITING_FOR_PRACK) {
                    this.status = y.SessionStatus.STATUS_ANSWERED_WAITING_FOR_PRACK;
                    return this
                } else if (this.status === y.SessionStatus.STATUS_WAITING_FOR_ANSWER) {
                    this.status = y.SessionStatus.STATUS_ANSWERED
                } else if (this.status !== y.SessionStatus.STATUS_EARLY_MEDIA) {
                    throw new z.Exceptions.InvalidStateError(this.status);
                }
                if (!this.createDialog(this.request, "UAS")) {
                    this.request.reply(500, "Missing Contact header field");
                    return this
                }
                clearTimeout(this.timers.userNoAnswerTimer);
                if (this.status === y.SessionStatus.STATUS_EARLY_MEDIA) {
                    f({})
                } else {
                    this.sessionDescriptionHandler = this.setupSessionDescriptionHandler();
                    this.emit("SessionDescriptionHandler-created", this.sessionDescriptionHandler);
                    if (this.request.getHeader("Content-Length") === "0" && !this.request.getHeader("Content-Type")) {
                        this.sessionDescriptionHandler.getDescription(c.sessionDescriptionHandlerOptions, c.modifiers)
                            .catch(g)
                            .then(f)
                    } else if (this.sessionDescriptionHandler.hasDescription(this.request.getHeader("Content-Type") || "")) {
                        this.hasOffer = true;
                        this.sessionDescriptionHandler.setDescription(this.request.body, c.sessionDescriptionHandlerOptions, c.modifiers)
                            .then(function() {
                                if (!d.sessionDescriptionHandler) {
                                    throw new Error("No SDH");
                                }
                                return d.sessionDescriptionHandler.getDescription(c.sessionDescriptionHandlerOptions, c.modifiers)
                            })
                            .catch(g)
                            .then(f)
                    } else {
                        this.request.reply(415);
                        return this
                    }
                }
                return this
            };
            J.prototype.receiveRequest = function(b) {
                var c = this;
                var d = function() {
                    clearTimeout(c.timers.ackTimer);
                    clearTimeout(c.timers.invite2xxTimer);
                    c.status = y.SessionStatus.STATUS_CONFIRMED;
                    var a = b.getHeader("Content-Disposition");
                    if (a && a.type === "render") {
                        c.renderbody = b.body;
                        c.rendertype = b.getHeader("Content-Type")
                    }
                    c.emit("confirmed", b)
                };
                switch (b.method) {
                    case w.C.CANCEL:
                        if (this.status === y.SessionStatus.STATUS_WAITING_FOR_ANSWER || this.status === y.SessionStatus.STATUS_WAITING_FOR_PRACK || this.status === y.SessionStatus.STATUS_ANSWERED_WAITING_FOR_PRACK || this.status === y.SessionStatus.STATUS_EARLY_MEDIA || this.status === y.SessionStatus.STATUS_ANSWERED) {
                            this.status = y.SessionStatus.STATUS_CANCELED;
                            this.request.reply(487);
                            this.canceled();
                            this.rejected(b, w.C.causes.CANCELED);
                            this.failed(b, w.C.causes.CANCELED);
                            this.terminated(b, w.C.causes.CANCELED)
                        }
                        break;
                    case w.C.ACK:
                        if (this.status === y.SessionStatus.STATUS_WAITING_FOR_ACK) {
                            this.status = y.SessionStatus.STATUS_CONFIRMED;
                            if (this.sessionDescriptionHandler && this.sessionDescriptionHandler.hasDescription(b.getHeader("Content-Type") || "")) {
                                this.hasAnswer = true;
                                this.sessionDescriptionHandler.setDescription(b.body, this.sessionDescriptionHandlerOptions, this.modifiers)
                                    .catch(function(e) {
                                        c.logger.warn(e);
                                        c.terminate({
                                            statusCode: "488",
                                            reasonPhrase: "Bad Media Description"
                                        });
                                        c.failed(b, w.C.causes.BAD_MEDIA_DESCRIPTION);
                                        c.terminated(b, w.C.causes.BAD_MEDIA_DESCRIPTION);
                                        throw e;
                                    })
                                    .then(function() {
                                        return d()
                                    })
                            } else {
                                d()
                            }
                        }
                        break;
                    case w.C.PRACK:
                        if (this.status === y.SessionStatus.STATUS_WAITING_FOR_PRACK || this.status === y.SessionStatus.STATUS_ANSWERED_WAITING_FOR_PRACK) {
                            if (!this.hasAnswer) {
                                this.sessionDescriptionHandler = this.setupSessionDescriptionHandler();
                                this.emit("SessionDescriptionHandler-created", this.sessionDescriptionHandler);
                                if (this.sessionDescriptionHandler.hasDescription(b.getHeader("Content-Type") || "")) {
                                    this.hasAnswer = true;
                                    this.sessionDescriptionHandler.setDescription(b.body, this.sessionDescriptionHandlerOptions, this.modifiers)
                                        .then(function() {
                                            clearTimeout(c.timers.rel1xxTimer);
                                            clearTimeout(c.timers.prackTimer);
                                            b.reply(200);
                                            if (c.status === y.SessionStatus.STATUS_ANSWERED_WAITING_FOR_PRACK) {
                                                c.status = y.SessionStatus.STATUS_EARLY_MEDIA;
                                                c.accept()
                                            }
                                            c.status = y.SessionStatus.STATUS_EARLY_MEDIA
                                        }, function(e) {
                                            c.logger.warn(e);
                                            c.terminate({
                                                statusCode: "488",
                                                reasonPhrase: "Bad Media Description"
                                            });
                                            c.failed(b, w.C.causes.BAD_MEDIA_DESCRIPTION);
                                            c.terminated(b, w.C.causes.BAD_MEDIA_DESCRIPTION)
                                        })
                                } else {
                                    this.terminate({
                                        statusCode: "488",
                                        reasonPhrase: "Bad Media Description"
                                    });
                                    this.failed(b, w.C.causes.BAD_MEDIA_DESCRIPTION);
                                    this.terminated(b, w.C.causes.BAD_MEDIA_DESCRIPTION)
                                }
                            } else {
                                clearTimeout(this.timers.rel1xxTimer);
                                clearTimeout(this.timers.prackTimer);
                                b.reply(200);
                                if (this.status === y.SessionStatus.STATUS_ANSWERED_WAITING_FOR_PRACK) {
                                    this.status = y.SessionStatus.STATUS_EARLY_MEDIA;
                                    this.accept()
                                }
                                this.status = y.SessionStatus.STATUS_EARLY_MEDIA
                            }
                        } else if (this.status === y.SessionStatus.STATUS_EARLY_MEDIA) {
                            b.reply(200)
                        }
                        break;
                    default:
                        I.prototype.receiveRequest.apply(this, [b]);
                        break
                }
            };
            J.prototype.setupSessionDescriptionHandler = function() {
                if (this.sessionDescriptionHandler) {
                    return this.sessionDescriptionHandler
                }
                return this.sessionDescriptionHandlerFactory(this, this.ua.configuration.sessionDescriptionHandlerFactoryOptions)
            };
            return J
        }(I));
        r.InviteServerContext = J;
        var K = (function(o) {
            t(K, o);

            function K(a, b, c, d) {
                if (c === void 0) {
                    c = {}
                }
                if (d === void 0) {
                    d = []
                }
                var e = this;
                if (!a.configuration.sessionDescriptionHandlerFactory) {
                    a.logger.warn("Can't build ISC without SDH Factory");
                    throw new Error("ICC Constructor Failed");
                }
                c.params = c.params || {};
                var f = c.anonymous || false;
                var g = H.Utils.newTag();
                c.params.fromTag = g;
                var h = a.contact.toString({
                    anonymous: f,
                    outbound: f ? !a.contact.tempGruu : !a.contact.pubGruu
                });
                var i = (c.extraHeaders || [])
                    .slice();
                if (f && a.configuration.uri) {
                    c.params.from_displayName = "Anonymous";
                    c.params.from_uri = "sip:anonymous@anonymous.invalid";
                    i.push("P-Preferred-Identity: " + a.configuration.uri.toString());
                    i.push("Privacy: id")
                }
                i.push("Contact: " + h);
                i.push("Allow: " + ["ACK", "CANCEL", "INVITE", "MESSAGE", "BYE", "OPTIONS", "INFO", "NOTIFY", "REFER"].toString());
                if (a.configuration.rel100 === w.C.supported.REQUIRED) {
                    i.push("Require: 100rel")
                }
                if (a.configuration.replaces === w.C.supported.REQUIRED) {
                    i.push("Require: replaces")
                }
                c.extraHeaders = i;
                e = o.call(this, a.configuration.sessionDescriptionHandlerFactory) || this;
                v.ClientContext.initializer(e, a, w.C.INVITE, b, c);
                e.type = y.TypeStrings.InviteClientContext;
                e.passedOptions = c;
                e.sessionDescriptionHandlerOptions = c.sessionDescriptionHandlerOptions || {};
                e.modifiers = d;
                e.inviteWithoutSdp = c.inviteWithoutSdp || false;
                e.anonymous = c.anonymous || false;
                e.renderbody = c.renderbody || undefined;
                e.rendertype = c.rendertype || "text/plain";
                e.fromTag = g;
                e.contact = h;
                if (e.status !== y.SessionStatus.STATUS_NULL) {
                    throw new z.Exceptions.InvalidStateError(e.status);
                }
                e.isCanceled = false;
                e.received100 = false;
                e.method = w.C.INVITE;
                e.logger = a.getLogger("sip.inviteclientcontext");
                a.applicants[e.toString()] = e;
                e.id = e.request.callId + e.fromTag;
                e.onInfo = c.onInfo;
                e.errorListener = e.onTransportError.bind(e);
                if (a.transport) {
                    a.transport.on("transportError", e.errorListener)
                }
                return e
            }
            K.prototype.receiveNonInviteResponse = function(a) {
                this.receiveInviteResponse(a)
            };
            K.prototype.receiveResponse = function(a) {
                this.receiveInviteResponse(a)
            };
            K.prototype.send = function() {
                var a = new B.RequestSender(this, this.ua);
                a.send();
                return this
            };
            K.prototype.invite = function() {
                var b = this;
                this.ua.sessions[this.id] = this;
                Promise.resolve()
                    .then(function() {
                        if (b.inviteWithoutSdp) {
                            b.request.body = b.renderbody;
                            b.status = y.SessionStatus.STATUS_INVITE_SENT;
                            b.send()
                        } else {
                            b.sessionDescriptionHandler = b.sessionDescriptionHandlerFactory(b, b.ua.configuration.sessionDescriptionHandlerFactoryOptions || {});
                            b.emit("SessionDescriptionHandler-created", b.sessionDescriptionHandler);
                            b.sessionDescriptionHandler.getDescription(b.sessionDescriptionHandlerOptions, b.modifiers)
                                .then(function(a) {
                                    if (b.isCanceled || b.status === y.SessionStatus.STATUS_TERMINATED) {
                                        return
                                    }
                                    b.hasOffer = true;
                                    b.request.body = a;
                                    b.status = y.SessionStatus.STATUS_INVITE_SENT;
                                    b.send()
                                }, function(a) {
                                    if (a.type === y.TypeStrings.SessionDescriptionHandlerError) {
                                        b.logger.log(a.message);
                                        if (a.error) {
                                            b.logger.log(a.error)
                                        }
                                    }
                                    if (b.status === y.SessionStatus.STATUS_TERMINATED) {
                                        return
                                    }
                                    b.failed(undefined, w.C.causes.WEBRTC_ERROR);
                                    b.terminated(undefined, w.C.causes.WEBRTC_ERROR)
                                })
                        }
                    });
                return this
            };
            K.prototype.receiveInviteResponse = function(b) {
                var c = this;
                if (this.status === y.SessionStatus.STATUS_TERMINATED || b.method !== w.C.INVITE) {
                    return
                }
                var d = b.callId + b.fromTag + b.toTag;
                var f = [];
                if (this.dialog && (b.statusCode && b.statusCode >= 200 && b.statusCode <= 299)) {
                    if (d !== this.dialog.id.toString()) {
                        if (!this.createDialog(b, "UAC", true)) {
                            return
                        }
                        this.emit("ack", b.ack({
                            body: H.Utils.generateFakeSDP(b.body)
                        }));
                        this.earlyDialogs[d].sendRequest(this, w.C.BYE);
                        if (this.status !== y.SessionStatus.STATUS_CONFIRMED) {
                            this.failed(b, w.C.causes.WEBRTC_ERROR);
                            this.terminated(b, w.C.causes.WEBRTC_ERROR)
                        }
                        return
                    } else if (this.status === y.SessionStatus.STATUS_CONFIRMED) {
                        this.emit("ack", b.ack(b));
                        return
                    } else if (!this.hasAnswer) {
                        return
                    }
                }
                var g = b && b.statusCode;
                if (this.dialog && g && g < 200) {
                    var h = b.getHeader("rseq");
                    if (h && (this.dialog.pracked.indexOf(h) !== -1 || (Number(this.dialog.pracked[this.dialog.pracked.length - 1]) >= Number(h) && this.dialog.pracked.length > 0))) {
                        return
                    }
                    if (!this.earlyDialogs[d] && !this.createDialog(b, "UAC", true)) {
                        return
                    }
                    if (this.earlyDialogs[d].pracked.indexOf(b.getHeader("rseq")) !== -1 || (this.earlyDialogs[d].pracked[this.earlyDialogs[d].pracked.length - 1] >= Number(h) && this.earlyDialogs[d].pracked.length > 0)) {
                        return
                    }
                    f.push("RAck: " + b.getHeader("rseq") + " " + b.getHeader("cseq"));
                    this.earlyDialogs[d].pracked.push(b.getHeader("rseq"));
                    this.earlyDialogs[d].sendRequest(this, w.C.PRACK, {
                        extraHeaders: f,
                        body: H.Utils.generateFakeSDP(b.body)
                    });
                    return
                }
                if (this.isCanceled) {
                    if (g && g >= 100 && g < 200) {
                        this.request.cancel(this.cancelReason, f);
                        this.canceled()
                    } else if (g && g >= 200 && g < 299) {
                        this.acceptAndTerminate(b);
                        this.emit("bye", this.request)
                    } else if (g && g >= 300) {
                        var i = w.C.REASON_PHRASE[b.statusCode || 0] || w.C.causes.CANCELED;
                        this.rejected(b, i);
                        this.failed(b, i);
                        this.terminated(b, i)
                    }
                    return
                }
                var j = g ? g.toString() : "";
                switch (true) {
                    case /^100$/.test(j):
                        this.received100 = true;
                        this.emit("progress", b);
                        break;
                    case (/^1[0-9]{2}$/.test(j)):
                        if (!b.toTag) {
                            this.logger.warn("1xx response received without to tag");
                            break
                        }
                        if (b.hasHeader("contact")) {
                            if (!this.createDialog(b, "UAC", true)) {
                                break
                            }
                        }
                        this.status = y.SessionStatus.STATUS_1XX_RECEIVED;
                        if (b.hasHeader("P-Asserted-Identity")) {
                            this.assertedIdentity = A.Grammar.nameAddrHeaderParse(b.getHeader("P-Asserted-Identity"))
                        }
                        if (b.hasHeader("require") && b.getHeader("require")
                            .indexOf("100rel") !== -1) {
                            if (this.dialog || !this.earlyDialogs[d]) {
                                break
                            }
                            var k = b.getHeader("rseq");
                            if (this.earlyDialogs[d].pracked.indexOf(k) !== -1 || (this.earlyDialogs[d].pracked[this.earlyDialogs[d].pracked.length - 1] >= Number(k) && this.earlyDialogs[d].pracked.length > 0)) {
                                return
                            }
                            this.sessionDescriptionHandler = this.sessionDescriptionHandlerFactory(this, this.ua.configuration.sessionDescriptionHandlerFactoryOptions || {});
                            this.emit("SessionDescriptionHandler-created", this.sessionDescriptionHandler);
                            if (!this.sessionDescriptionHandler.hasDescription(b.getHeader("Content-Type") || "")) {
                                f.push("RAck: " + b.getHeader("rseq") + " " + b.getHeader("cseq"));
                                this.earlyDialogs[d].pracked.push(b.getHeader("rseq"));
                                this.earlyDialogs[d].sendRequest(this, w.C.PRACK, {
                                    extraHeaders: f
                                });
                                this.emit("progress", b)
                            } else if (this.hasOffer) {
                                if (!this.createDialog(b, "UAC")) {
                                    break
                                }
                                this.hasAnswer = true;
                                if (this.dialog !== undefined && k) {
                                    this.dialog.pracked.push(k)
                                }
                                this.sessionDescriptionHandler.setDescription(b.body, this.sessionDescriptionHandlerOptions, this.modifiers)
                                    .then(function() {
                                        f.push("RAck: " + b.getHeader("rseq") + " " + b.getHeader("cseq"));
                                        c.sendRequest(w.C.PRACK, {
                                            extraHeaders: f,
                                            receiveResponse: function() {}
                                        });
                                        c.status = y.SessionStatus.STATUS_EARLY_MEDIA;
                                        c.emit("progress", b)
                                    }, function(e) {
                                        c.logger.warn(e);
                                        c.acceptAndTerminate(b, 488, "Not Acceptable Here");
                                        c.failed(b, w.C.causes.BAD_MEDIA_DESCRIPTION)
                                    })
                            } else {
                                var l = this.earlyDialogs[d];
                                l.sessionDescriptionHandler = this.sessionDescriptionHandlerFactory(this, this.ua.configuration.sessionDescriptionHandlerFactoryOptions || {});
                                this.emit("SessionDescriptionHandler-created", l.sessionDescriptionHandler);
                                if (k) {
                                    l.pracked.push(k)
                                }
                                if (l.sessionDescriptionHandler) {
                                    l.sessionDescriptionHandler.setDescription(b.body, this.sessionDescriptionHandlerOptions, this.modifiers)
                                        .then(function() {
                                            return l.sessionDescriptionHandler.getDescription(c.sessionDescriptionHandlerOptions, c.modifiers)
                                        })
                                        .then(function(a) {
                                            f.push("RAck: " + k + " " + b.getHeader("cseq"));
                                            l.sendRequest(c, w.C.PRACK, {
                                                extraHeaders: f,
                                                body: a
                                            });
                                            c.status = y.SessionStatus.STATUS_EARLY_MEDIA;
                                            c.emit("progress", b)
                                        })
                                        .catch(function(e) {
                                            if (k && e.type === y.TypeStrings.SessionDescriptionHandlerError) {
                                                l.pracked.push(k);
                                                if (c.status === y.SessionStatus.STATUS_TERMINATED) {
                                                    return
                                                }
                                                c.failed(undefined, w.C.causes.WEBRTC_ERROR);
                                                c.terminated(undefined, w.C.causes.WEBRTC_ERROR)
                                            } else {
                                                if (k) {
                                                    l.pracked.splice(l.pracked.indexOf(k), 1)
                                                }
                                                c.logger.warn("invalid description");
                                                c.logger.warn(e)
                                            }
                                        })
                                }
                            }
                        } else {
                            this.emit("progress", b)
                        }
                        break;
                    case /^2[0-9]{2}$/.test(j):
                        var m = this.request.cseq + " " + this.request.method;
                        if (m !== b.getHeader("cseq")) {
                            break
                        }
                        if (b.hasHeader("P-Asserted-Identity")) {
                            this.assertedIdentity = A.Grammar.nameAddrHeaderParse(b.getHeader("P-Asserted-Identity"))
                        }
                        if (this.status === y.SessionStatus.STATUS_EARLY_MEDIA && this.dialog) {
                            this.status = y.SessionStatus.STATUS_CONFIRMED;
                            var n = {};
                            if (this.renderbody) {
                                f.push("Content-Type: " + this.rendertype);
                                n.extraHeaders = f;
                                n.body = this.renderbody
                            }
                            this.emit("ack", b.ack(n));
                            this.accepted(b);
                            break
                        }
                        if (this.dialog) {
                            break
                        }
                        if (!this.hasOffer) {
                            if (this.earlyDialogs[d] && this.earlyDialogs[d].sessionDescriptionHandler) {
                                this.hasOffer = true;
                                this.hasAnswer = true;
                                this.sessionDescriptionHandler = this.earlyDialogs[d].sessionDescriptionHandler;
                                if (!this.createDialog(b, "UAC")) {
                                    break
                                }
                                this.status = y.SessionStatus.STATUS_CONFIRMED;
                                this.emit("ack", b.ack());
                                this.accepted(b)
                            } else {
                                this.sessionDescriptionHandler = this.sessionDescriptionHandlerFactory(this, this.ua.configuration.sessionDescriptionHandlerFactoryOptions || {});
                                this.emit("SessionDescriptionHandler-created", this.sessionDescriptionHandler);
                                if (!this.sessionDescriptionHandler.hasDescription(b.getHeader("Content-Type") || "")) {
                                    this.acceptAndTerminate(b, 400, "Missing session description");
                                    this.failed(b, w.C.causes.BAD_MEDIA_DESCRIPTION);
                                    break
                                }
                                if (!this.createDialog(b, "UAC")) {
                                    break
                                }
                                this.hasOffer = true;
                                this.sessionDescriptionHandler.setDescription(b.body, this.sessionDescriptionHandlerOptions, this.modifiers)
                                    .then(function() {
                                        return c.sessionDescriptionHandler.getDescription(c.sessionDescriptionHandlerOptions, c.modifiers)
                                    })
                                    .then(function(a) {
                                        if (c.isCanceled || c.status === y.SessionStatus.STATUS_TERMINATED) {
                                            return
                                        }
                                        c.status = y.SessionStatus.STATUS_CONFIRMED;
                                        c.hasAnswer = true;
                                        c.emit("ack", b.ack({
                                            body: a
                                        }));
                                        c.accepted(b)
                                    })
                                    .catch(function(e) {
                                        if (e.type === y.TypeStrings.SessionDescriptionHandlerError) {
                                            c.logger.warn("invalid description");
                                            c.logger.warn(e.toString());
                                            c.acceptAndTerminate(b, 488, "Invalid session description");
                                            c.failed(b, w.C.causes.BAD_MEDIA_DESCRIPTION)
                                        } else {
                                            throw e;
                                        }
                                    })
                            }
                        } else if (this.hasAnswer) {
                            var n = {};
                            if (this.renderbody) {
                                f.push("Content-Type: " + this.rendertype);
                                n.extraHeaders = f;
                                n.body = this.renderbody
                            }
                            this.emit("ack", b.ack(n))
                        } else {
                            if (!this.sessionDescriptionHandler || !this.sessionDescriptionHandler.hasDescription(b.getHeader("Content-Type") || "")) {
                                this.acceptAndTerminate(b, 400, "Missing session description");
                                this.failed(b, w.C.causes.BAD_MEDIA_DESCRIPTION);
                                break
                            }
                            if (!this.createDialog(b, "UAC")) {
                                break
                            }
                            this.hasAnswer = true;
                            this.sessionDescriptionHandler.setDescription(b.body, this.sessionDescriptionHandlerOptions, this.modifiers)
                                .then(function() {
                                    var a = {};
                                    c.status = y.SessionStatus.STATUS_CONFIRMED;
                                    if (c.renderbody) {
                                        f.push("Content-Type: " + c.rendertype);
                                        a.extraHeaders = f;
                                        a.body = c.renderbody
                                    }
                                    c.emit("ack", b.ack(a));
                                    c.accepted(b)
                                }, function(e) {
                                    c.logger.warn(e);
                                    c.acceptAndTerminate(b, 488, "Not Acceptable Here");
                                    c.failed(b, w.C.causes.BAD_MEDIA_DESCRIPTION)
                                })
                        }
                        break;
                    default:
                        var i = H.Utils.sipErrorCause(g || 0);
                        this.rejected(b, i);
                        this.failed(b, i);
                        this.terminated(b, i)
                }
            };
            K.prototype.cancel = function(a) {
                if (a === void 0) {
                    a = {}
                }
                a.extraHeaders = (a.extraHeaders || [])
                    .slice();
                if (this.isCanceled) {
                    throw new z.Exceptions.InvalidStateError(y.SessionStatus.STATUS_CANCELED);
                }
                if (this.status === y.SessionStatus.STATUS_TERMINATED || this.status === y.SessionStatus.STATUS_CONFIRMED) {
                    throw new z.Exceptions.InvalidStateError(this.status);
                }
                this.logger.log("canceling RTCSession");
                this.isCanceled = true;
                var b = H.Utils.getCancelReason(a.statusCode, a.reasonPhrase);
                if (this.status === y.SessionStatus.STATUS_NULL || (this.status === y.SessionStatus.STATUS_INVITE_SENT && !this.received100)) {
                    this.cancelReason = b
                } else if (this.status === y.SessionStatus.STATUS_INVITE_SENT || this.status === y.SessionStatus.STATUS_1XX_RECEIVED || this.status === y.SessionStatus.STATUS_EARLY_MEDIA) {
                    this.request.cancel(b, a.extraHeaders)
                }
                return this.canceled()
            };
            K.prototype.terminate = function(a) {
                if (this.status === y.SessionStatus.STATUS_TERMINATED) {
                    return this
                }
                if (this.status === y.SessionStatus.STATUS_WAITING_FOR_ACK || this.status === y.SessionStatus.STATUS_CONFIRMED) {
                    this.bye(a)
                } else {
                    this.cancel(a)
                }
                return this
            };
            K.prototype.receiveRequest = function(a) {
                if (a.method === w.C.CANCEL) {}
                if (a.method === w.C.ACK && this.status === y.SessionStatus.STATUS_WAITING_FOR_ACK) {
                    clearTimeout(this.timers.ackTimer);
                    clearTimeout(this.timers.invite2xxTimer);
                    this.status = y.SessionStatus.STATUS_CONFIRMED;
                    this.accepted()
                }
                return o.prototype.receiveRequest.call(this, a)
            };
            return K
        }(I));
        r.InviteClientContext = K;
        var L = (function(i) {
            t(L, i);

            function L(a, b, c, d) {
                if (d === void 0) {
                    d = {}
                }
                var e = this;
                if (a === undefined || b === undefined || c === undefined) {
                    throw new TypeError("Not enough arguments");
                }
                e = i.call(this, a, w.C.REFER, b.remoteIdentity.uri.toString(), d) || this;
                e.type = y.TypeStrings.ReferClientContext;
                e.options = d;
                e.extraHeaders = (e.options.extraHeaders || [])
                    .slice();
                e.applicant = b;
                if (!(typeof c === "string") && (c.type === y.TypeStrings.InviteServerContext || c.type === y.TypeStrings.InviteClientContext)) {
                    var f = c.dialog;
                    if (f) {
                        e.target = '"' + c.remoteIdentity.friendlyName + '" ' + "<" + f.remoteTarget.toString() + "?Replaces=" + encodeURIComponent(f.id.callId + ";to-tag=" + f.id.remoteTag + ";from-tag=" + f.id.localTag) + ">"
                    } else {
                        throw new TypeError("Invalid target due to no dialog: " + c);
                    }
                } else {
                    var g = A.Grammar.parse(c, "Refer_To");
                    e.target = g && g.uri ? g.uri : c;
                    var h = e.ua.normalizeTarget(e.target);
                    if (!h) {
                        throw new TypeError("Invalid target: " + c);
                    }
                    e.target = h
                }
                if (e.ua) {
                    e.extraHeaders.push("Referred-By: <" + e.ua.configuration.uri + ">")
                }
                e.extraHeaders.push("Contact: " + b.contact);
                e.extraHeaders.push("Allow: " + ["ACK", "CANCEL", "INVITE", "MESSAGE", "BYE", "OPTIONS", "INFO", "NOTIFY", "REFER"].toString());
                e.extraHeaders.push("Refer-To: " + e.target);
                e.errorListener = e.onTransportError.bind(e);
                if (a.transport) {
                    a.transport.on("transportError", e.errorListener)
                }
                return e
            }
            L.prototype.refer = function(c) {
                var d = this;
                if (c === void 0) {
                    c = {}
                }
                var e = (this.extraHeaders || [])
                    .slice();
                if (c.extraHeaders) {
                    e.concat(c.extraHeaders)
                }
                this.applicant.sendRequest(w.C.REFER, {
                    extraHeaders: this.extraHeaders,
                    receiveResponse: function(a) {
                        var b = a && a.statusCode ? a.statusCode.toString() : "";
                        if (/^1[0-9]{2}$/.test(b)) {
                            d.emit("referRequestProgress", d)
                        } else if (/^2[0-9]{2}$/.test(b)) {
                            d.emit("referRequestAccepted", d)
                        } else if (/^[4-6][0-9]{2}$/.test(b)) {
                            d.emit("referRequestRejected", d)
                        }
                        if (c.receiveResponse) {
                            c.receiveResponse(a)
                        }
                    }
                });
                return this
            };
            L.prototype.receiveNotify = function(a) {
                var b = a.hasHeader("Content-Type") ? a.getHeader("Content-Type") : undefined;
                if (b && b.search(/^message\/sipfrag/) !== -1) {
                    var c = A.Grammar.parse(a.body, "sipfrag");
                    if (c === -1) {
                        a.reply(489, "Bad Event");
                        return
                    }
                    switch (true) {
                        case (/^1[0-9]{2}$/.test(c.status_code)):
                            this.emit("referProgress", this);
                            break;
                        case (/^2[0-9]{2}$/.test(c.status_code)):
                            this.emit("referAccepted", this);
                            if (!this.options.activeAfterTransfer && this.applicant.terminate) {
                                this.applicant.terminate()
                            }
                            break;
                        default:
                            this.emit("referRejected", this);
                            break
                    }
                    a.reply(200);
                    this.emit("notify", a);
                    return
                }
                a.reply(489, "Bad Event")
            };
            return L
        }(v.ClientContext));
        r.ReferClientContext = L;
        var M = (function(k) {
            t(M, k);

            function M(a, b) {
                var c = k.call(this, a, b) || this;
                c.type = y.TypeStrings.ReferServerContext;
                c.ua = a;
                c.status = y.SessionStatus.STATUS_INVITE_RECEIVED;
                c.fromTag = b.fromTag;
                c.id = b.callId + c.fromTag;
                c.request = b;
                c.contact = c.ua.contact.toString();
                c.logger = a.getLogger("sip.referservercontext", c.id);
                c.cseq = Math.floor(Math.random() * 10000);
                c.callId = c.request.callId;
                c.fromUri = c.request.to.uri;
                c.fromTag = c.request.to.parameters.tag;
                c.remoteTarget = c.request.headers.Contact[0].parsed.uri;
                c.toUri = c.request.from.uri;
                c.toTag = c.request.fromTag;
                c.routeSet = c.request.getHeaders("record-route");
                if (!c.request.hasHeader("refer-to")) {
                    c.logger.warn("Invalid REFER packet. A refer-to header is required. Rejecting refer.");
                    c.reject();
                    return c
                }
                c.referTo = c.request.parseHeader("refer-to");
                c.referredSession = c.ua.findSession(b);
                if (c.request.hasHeader("referred-by")) {
                    c.referredBy = c.request.getHeader("referred-by")
                }
                if (c.referTo.uri.hasHeader("replaces")) {
                    c.replaces = c.referTo.uri.getHeader("replaces")
                }
                c.errorListener = c.onTransportError.bind(c);
                if (a.transport) {
                    a.transport.on("transportError", c.errorListener)
                }
                c.status = y.SessionStatus.STATUS_WAITING_FOR_ANSWER;
                return c
            }
            M.prototype.receiveNonInviteResponse = function(a) {};
            M.prototype.progress = function() {
                if (this.status !== y.SessionStatus.STATUS_WAITING_FOR_ANSWER) {
                    throw new z.Exceptions.InvalidStateError(this.status);
                }
                this.request.reply(100)
            };
            M.prototype.reject = function(a) {
                if (a === void 0) {
                    a = {}
                }
                if (this.status === y.SessionStatus.STATUS_TERMINATED) {
                    throw new z.Exceptions.InvalidStateError(this.status);
                }
                this.logger.log("Rejecting refer");
                this.status = y.SessionStatus.STATUS_TERMINATED;
                k.prototype.reject.call(this, a);
                this.emit("referRequestRejected", this)
            };
            M.prototype.accept = function(d, e) {
                var f = this;
                if (d === void 0) {
                    d = {}
                }
                if (this.status === y.SessionStatus.STATUS_WAITING_FOR_ANSWER) {
                    this.status = y.SessionStatus.STATUS_ANSWERED
                } else {
                    throw new z.Exceptions.InvalidStateError(this.status);
                }
                this.request.reply(202, "Accepted");
                this.emit("referRequestAccepted", this);
                if (d.followRefer) {
                    this.logger.log("Accepted refer, attempting to automatically follow it");
                    var g = this.referTo.uri;
                    if (!g.scheme || !g.scheme.match("^sips?$")) {
                        this.logger.error("SIP.js can only automatically follow SIP refer target");
                        this.reject();
                        return
                    }
                    var h = d.inviteOptions || {};
                    var i = (h.extraHeaders || [])
                        .slice();
                    if (this.replaces) {
                        i.push("Replaces: " + decodeURIComponent(this.replaces))
                    }
                    if (this.referredBy) {
                        i.push("Referred-By: " + this.referredBy)
                    }
                    h.extraHeaders = i;
                    g.clearHeaders();
                    this.targetSession = this.ua.invite(g.toString(), h, e);
                    this.emit("referInviteSent", this);
                    if (this.targetSession) {
                        this.targetSession.once("progress", function(a) {
                            var b = a.statusCode || 100;
                            var c = a.reasonPhrase;
                            f.sendNotify(("SIP/2.0 " + b + " " + c)
                                .trim());
                            f.emit("referProgress", f);
                            if (f.referredSession) {
                                f.referredSession.emit("referProgress", f)
                            }
                        });
                        this.targetSession.once("accepted", function() {
                            f.logger.log("Successfully followed the refer");
                            f.sendNotify("SIP/2.0 200 OK");
                            f.emit("referAccepted", f);
                            if (f.referredSession) {
                                f.referredSession.emit("referAccepted", f)
                            }
                        });
                        var j = function(a) {
                            if (f.status === y.SessionStatus.STATUS_TERMINATED) {
                                return
                            }
                            f.logger.log("Refer was not successful. Resuming session");
                            if (a && a.statusCode === 429) {
                                f.logger.log("Alerting referrer that identity is required.");
                                f.sendNotify("SIP/2.0 429 Provide Referrer Identity");
                                return
                            }
                            f.sendNotify("SIP/2.0 603 Declined");
                            f.status = y.SessionStatus.STATUS_TERMINATED;
                            f.emit("referRejected", f);
                            if (f.referredSession) {
                                f.referredSession.emit("referRejected")
                            }
                        };
                        this.targetSession.once("rejected", j);
                        this.targetSession.once("failed", j)
                    }
                } else {
                    this.logger.log("Accepted refer, but did not automatically follow it");
                    this.sendNotify("SIP/2.0 200 OK");
                    this.emit("referAccepted", this);
                    if (this.referredSession) {
                        this.referredSession.emit("referAccepted", this)
                    }
                }
            };
            M.prototype.sendNotify = function(a) {
                if (this.status !== y.SessionStatus.STATUS_ANSWERED) {
                    throw new z.Exceptions.InvalidStateError(this.status);
                }
                if (A.Grammar.parse(a, "sipfrag") === -1) {
                    throw new Error("sipfrag body is required to send notify for refer");
                }
                var b = new E.OutgoingRequest(w.C.NOTIFY, this.remoteTarget, this.ua, {
                    cseq: this.cseq += 1,
                    callId: this.callId,
                    fromUri: this.fromUri,
                    fromTag: this.fromTag,
                    toUri: this.toUri,
                    toTag: this.toTag,
                    routeSet: this.routeSet
                }, ["Event: refer", "Subscription-State: terminated", "Content-Type: message/sipfrag"], a);
                new B.RequestSender({
                        request: b,
                        onRequestTimeout: function() {
                            return
                        },
                        onTransportError: function() {
                            return
                        },
                        receiveResponse: function() {
                            return
                        }
                    }, this.ua)
                    .send()
            };
            M.prototype.on = function(a, b) {
                return k.prototype.on.call(this, a, b)
            };
            return M
        }(C.ServerContext));
        r.ReferServerContext = M
    }), (function(h, i, j) {
        "use strict";
        var k = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        Object.defineProperty(i, "__esModule", {
            value: true
        });
        var l = j(2);
        var m = j(3);
        var n = j(5);
        var o = j(8);
        var q = j(15);
        var r = (function(g) {
            k(r, g);

            function r(a, b, c) {
                if (c === void 0) {
                    c = {}
                }
                var d = g.call(this) || this;
                d.C = {
                    MIN_DURATION: 70,
                    MAX_DURATION: 6000,
                    DEFAULT_DURATION: 100,
                    MIN_INTER_TONE_GAP: 50,
                    DEFAULT_INTER_TONE_GAP: 500
                };
                d.type = n.TypeStrings.DTMF;
                if (b === undefined) {
                    throw new TypeError("Not enough arguments");
                }
                d.logger = a.ua.getLogger("sip.invitecontext.dtmf", a.id);
                d.owner = a;
                if (typeof b === "string") {
                    b = b.toUpperCase()
                } else if (typeof b === "number") {
                    b = b.toString()
                } else {
                    throw new TypeError("Invalid tone: " + b);
                }
                if (!b.match(/^[0-9A-D#*]$/)) {
                    throw new TypeError("Invalid tone: " + b);
                } else {
                    d.tone = b
                }
                var e = c.duration;
                var f = c.interToneGap;
                if (e && !q.Utils.isDecimal(e)) {
                    throw new TypeError("Invalid tone duration: " + e);
                } else if (!e) {
                    e = d.C.DEFAULT_DURATION
                } else if (e < d.C.MIN_DURATION) {
                    d.logger.warn("'duration' value is lower than the minimum allowed, setting it to " + d.C.MIN_DURATION + " milliseconds");
                    e = d.C.MIN_DURATION
                } else if (e > d.C.MAX_DURATION) {
                    d.logger.warn("'duration' value is greater than the maximum allowed, setting it to " + d.C.MAX_DURATION + " milliseconds");
                    e = d.C.MAX_DURATION
                } else {
                    e = Math.abs(e)
                }
                d.duration = e;
                if (f && !q.Utils.isDecimal(f)) {
                    throw new TypeError("Invalid interToneGap: " + f);
                } else if (!f) {
                    f = d.C.DEFAULT_INTER_TONE_GAP
                } else if (f < d.C.MIN_INTER_TONE_GAP) {
                    d.logger.warn("'interToneGap' value is lower than the minimum allowed, setting it to " + d.C.MIN_INTER_TONE_GAP + " milliseconds");
                    f = d.C.MIN_INTER_TONE_GAP
                } else {
                    f = Math.abs(f)
                }
                d.interToneGap = f;
                return d
            }
            r.prototype.send = function(a) {
                if (a === void 0) {
                    a = {}
                }
                if (this.owner.status !== n.SessionStatus.STATUS_CONFIRMED && this.owner.status !== n.SessionStatus.STATUS_WAITING_FOR_ACK) {
                    throw new o.Exceptions.InvalidStateError(this.owner.status);
                }
                var b = a.extraHeaders ? a.extraHeaders.slice() : [];
                var c = {
                    contentType: "application/dtmf-relay",
                    body: "Signal= " + this.tone + "\r\nDuration= " + this.duration
                };
                if (this.owner.dialog) {
                    var d = this.owner.dialog.sendRequest(this, m.C.INFO, {
                        extraHeaders: b,
                        body: c
                    });
                    this.owner.emit("dtmf", d, this)
                }
            };
            r.prototype.init_incoming = function(a) {
                a.reply(200);
                if (!this.tone || !this.duration) {
                    this.logger.warn("invalid INFO DTMF received, discarded")
                } else {
                    this.owner.emit("dtmf", a, this)
                }
            };
            r.prototype.receiveResponse = function(a) {
                var b = a && a.statusCode ? a.statusCode : 0;
                switch (true) {
                    case /^1[0-9]{2}$/.test(b.toString()):
                        break;
                    case /^2[0-9]{2}$/.test(b.toString()):
                        this.emit("succeeded", {
                            originator: "remote",
                            response: a
                        });
                        break;
                    default:
                        var c = q.Utils.sipErrorCause(b);
                        this.emit("failed", a, c);
                        break
                }
            };
            r.prototype.onRequestTimeout = function() {
                this.emit("failed", undefined, m.C.causes.REQUEST_TIMEOUT);
                this.owner.onRequestTimeout()
            };
            r.prototype.onTransportError = function() {
                this.emit("failed", undefined, m.C.causes.CONNECTION_ERROR);
                this.owner.onTransportError()
            };
            r.prototype.onDialogError = function(a) {
                this.emit("failed", a, m.C.causes.DIALOG_ERROR);
                this.owner.onDialogError(a)
            };
            return r
        }(l.EventEmitter));
        i.DTMF = r
    }), (function(h, i, j) {
        "use strict";
        var k = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        Object.defineProperty(i, "__esModule", {
            value: true
        });
        var l = j(1);
        var m = j(3);
        var n = j(16);
        var o = j(5);
        var q = j(9);
        var r = j(15);
        var s = (function(g) {
            k(s, g);

            function s(a, b, c, d) {
                if (d === void 0) {
                    d = {}
                }
                var e = this;
                if (!c) {
                    throw new TypeError("Event necessary to create a subscription.");
                }
                d.extraHeaders = (d.extraHeaders || [])
                    .slice();
                var f;
                if (typeof d.expires !== "number") {
                    a.logger.warn("expires must be a number. Using default of 3600.");
                    f = 3600
                } else {
                    f = d.expires
                }
                d.extraHeaders.push("Event: " + c);
                d.extraHeaders.push("Expires: " + f);
                d.extraHeaders.push("Contact: " + a.contact.toString());
                d.extraHeaders.push("Allow: " + ["ACK", "CANCEL", "INVITE", "MESSAGE", "BYE", "OPTIONS", "INFO", "NOTIFY", "REFER"].toString());
                e = g.call(this, a, m.C.SUBSCRIBE, b, d) || this;
                e.type = o.TypeStrings.Subscription;
                e.event = c;
                e.requestedExpires = f;
                e.state = "init";
                e.contact = a.contact.toString();
                e.extraHeaders = d.extraHeaders;
                e.logger = a.getLogger("sip.subscription");
                e.expires = f;
                e.timers = {
                    N: undefined,
                    subDuration: undefined
                };
                e.errorCodes = [404, 405, 410, 416, 480, 481, 482, 483, 484, 485, 489, 501, 604];
                return e
            }
            s.prototype.subscribe = function() {
                var a = this;
                if (this.state === "active") {
                    this.refresh();
                    return this
                } else if (this.state === "notify_wait") {
                    return this
                }
                clearTimeout(this.timers.subDuration);
                clearTimeout(this.timers.N);
                this.timers.N = setTimeout(function() {
                    return a.timer_fire()
                }, q.Timers.TIMER_N);
                if (this.request && this.request.from) {
                    this.ua.earlySubscriptions[this.request.callId + this.request.from.parameters.tag + this.event] = this
                }
                this.send();
                this.state = "notify_wait";
                return this
            };
            s.prototype.refresh = function() {
                if (this.state === "terminated" || this.state === "pending" || this.state === "notify_wait" || !this.dialog) {
                    return
                }
                this.dialog.sendRequest(this, m.C.SUBSCRIBE, {
                    extraHeaders: this.extraHeaders,
                    body: this.body
                })
            };
            s.prototype.receiveResponse = function(a) {
                var b = this;
                var c = a.statusCode ? a.statusCode : 0;
                var d = r.Utils.getReasonPhrase(c);
                if ((this.state === "notify_wait" && c >= 300) || (this.state !== "notify_wait" && this.errorCodes.indexOf(c) !== -1)) {
                    this.failed(a, undefined)
                } else if (/^2[0-9]{2}$/.test(c.toString())) {
                    this.emit("accepted", a, d);
                    var e = a.getHeader("Expires");
                    if (e && Number(e) <= this.requestedExpires) {
                        this.expires = Number(e);
                        this.timers.subDuration = setTimeout(function() {
                            return b.refresh()
                        }, Number(e) * 900)
                    } else {
                        if (!e) {
                            this.logger.warn("Expires header missing in a 200-class response to SUBSCRIBE");
                            this.failed(a, "Expires Header Missing")
                        } else {
                            this.logger.warn("Expires header in a 200-class response to" + " SUBSCRIBE with a higher value than the one in the request");
                            this.failed(a, "Invalid Expires Header")
                        }
                    }
                } else if (c > 300) {
                    this.emit("failed", a, d);
                    this.emit("rejected", a, d)
                }
            };
            s.prototype.unsubscribe = function() {
                var a = this;
                var b = [];
                this.state = "terminated";
                b.push("Event: " + this.event);
                b.push("Expires: 0");
                b.push("Contact: " + this.contact);
                b.push("Allow: " + ["ACK", "CANCEL", "INVITE", "MESSAGE", "BYE", "OPTIONS", "INFO", "NOTIFY", "REFER"].toString());
                this.receiveResponse = function() {};
                if (this.dialog) {
                    this.dialog.sendRequest(this, m.C.SUBSCRIBE, {
                        extraHeaders: b,
                        body: this.body
                    })
                }
                clearTimeout(this.timers.subDuration);
                clearTimeout(this.timers.N);
                this.timers.N = setTimeout(function() {
                    return a.timer_fire()
                }, q.Timers.TIMER_N);
                this.emit("terminated")
            };
            s.prototype.receiveRequest = function(a) {
                var b = this;
                var c;
                var d = function() {
                    if (c.expires) {
                        clearTimeout(b.timers.subDuration);
                        c.expires = Math.min(b.expires, Math.max(c.expires, 0));
                        b.timers.subDuration = setTimeout(function() {
                            return b.refresh()
                        }, c.expires * 900)
                    }
                };
                if (!this.matchEvent(a)) {
                    a.reply(489);
                    return
                }
                if (!this.dialog) {
                    if (this.createConfirmedDialog(a, "UAS")) {
                        if (this.dialog) {
                            this.id = this.dialog.id.toString();
                            if (this.request && this.request.from) {
                                delete this.ua.earlySubscriptions[this.request.callId + this.request.from.parameters.tag + this.event];
                                this.ua.subscriptions[this.id || ""] = this
                            }
                        }
                    }
                }
                c = a.parseHeader("Subscription-State");
                a.reply(200);
                clearTimeout(this.timers.N);
                this.emit("notify", {
                    request: a
                });
                if (this.state === "terminated") {
                    if (c.state === "terminated") {
                        this.terminateDialog();
                        clearTimeout(this.timers.N);
                        clearTimeout(this.timers.subDuration);
                        delete this.ua.subscriptions[this.id || ""]
                    }
                    return
                }
                switch (c.state) {
                    case "active":
                        this.state = "active";
                        d();
                        break;
                    case "pending":
                        if (this.state === "notify_wait") {
                            d()
                        }
                        this.state = "pending";
                        break;
                    case "terminated":
                        clearTimeout(this.timers.subDuration);
                        if (c.reason) {
                            this.logger.log("terminating subscription with reason " + c.reason);
                            switch (c.reason) {
                                case "deactivated":
                                case "timeout":
                                    this.subscribe();
                                    return;
                                case "probation":
                                case "giveup":
                                    if (c.params && c.params["retry-after"]) {
                                        this.timers.subDuration = setTimeout(function() {
                                            return b.subscribe()
                                        }, c.params["retry-after"])
                                    } else {
                                        this.subscribe()
                                    }
                                    return;
                                case "rejected":
                                case "noresource":
                                case "invariant":
                                    break
                            }
                        }
                        this.close();
                        break
                }
            };
            s.prototype.close = function() {
                if (this.state === "notify_wait") {
                    this.state = "terminated";
                    clearTimeout(this.timers.N);
                    clearTimeout(this.timers.subDuration);
                    this.receiveResponse = function() {};
                    if (this.request && this.request.from) {
                        delete this.ua.earlySubscriptions[this.request.callId + this.request.from.parameters.tag + this.event]
                    }
                    this.emit("terminated")
                } else if (this.state !== "terminated") {
                    this.unsubscribe()
                }
            };
            s.prototype.onDialogError = function(a) {
                this.failed(a, m.C.causes.DIALOG_ERROR)
            };
            s.prototype.on = function(a, b) {
                return g.prototype.on.call(this, a, b)
            };
            s.prototype.timer_fire = function() {
                if (this.state === "terminated") {
                    this.terminateDialog();
                    clearTimeout(this.timers.N);
                    clearTimeout(this.timers.subDuration);
                    delete this.ua.subscriptions[this.id || ""]
                } else if (this.state === "notify_wait" || this.state === "pending") {
                    this.close()
                } else {
                    this.refresh()
                }
            };
            s.prototype.createConfirmedDialog = function(a, b) {
                this.terminateDialog();
                var c = new n.Dialog(this, a, b);
                if (this.request) {
                    c.inviteSeqnum = this.request.cseq;
                    c.localSeqnum = this.request.cseq
                }
                if (!c.error) {
                    this.dialog = c;
                    return true
                } else {
                    return false
                }
            };
            s.prototype.terminateDialog = function() {
                if (this.dialog) {
                    delete this.ua.subscriptions[this.id || ""];
                    this.dialog.terminate();
                    delete this.dialog
                }
            };
            s.prototype.failed = function(a, b) {
                this.close();
                this.emit("failed", a, b);
                this.emit("rejected", a, b);
                return this
            };
            s.prototype.matchEvent = function(a) {
                if (!a.hasHeader("Event")) {
                    this.logger.warn("missing Event header");
                    return false
                }
                if (!a.hasHeader("Subscription-State")) {
                    this.logger.warn("missing Subscription-State header");
                    return false
                }
                var b = a.parseHeader("event")
                    .event;
                if (this.event !== b) {
                    this.logger.warn("event match failed");
                    a.reply(481, "Event Match Failed");
                    return false
                } else {
                    return true
                }
            };
            return s
        }(l.ClientContext));
        i.Subscription = s
    }), (function(f, g, h) {
        "use strict";
        var i = (this && this.__extends) || (function() {
            var a = function(d, b) {
                a = Object.setPrototypeOf || ({
                        __proto__: []
                    }
                    instanceof Array && function(d, b) {
                        d.__proto__ = b
                    }) || function(d, b) {
                    for (var p in b)
                        if (b.hasOwnProperty(p)) d[p] = b[p]
                };
                return a(d, b)
            };
            return function(d, b) {
                a(d, b);

                function __() {
                    this.constructor = d
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
            }
        })();
        Object.defineProperty(g, "__esModule", {
            value: true
        });
        var j = h(2);
        var k = h(5);
        var l = (function(e) {
            i(l, e);

            function l(a, b) {
                var c = e.call(this) || this;
                c.type = k.TypeStrings.Transport;
                c.logger = a;
                return c
            }
            l.prototype.connect = function(b) {
                var c = this;
                if (b === void 0) {
                    b = {}
                }
                return this.connectPromise(b)
                    .then(function(a) {
                        if (!a.overrideEvent) {
                            c.emit("connected")
                        }
                    })
            };
            l.prototype.send = function(b, c) {
                var d = this;
                if (c === void 0) {
                    c = {}
                }
                return this.sendPromise(b)
                    .then(function(a) {
                        if (!a.overrideEvent) {
                            d.emit("messageSent", a.msg)
                        }
                    })
            };
            l.prototype.disconnect = function(b) {
                var c = this;
                if (b === void 0) {
                    b = {}
                }
                return this.disconnectPromise(b)
                    .then(function(a) {
                        if (!a.overrideEvent) {
                            c.emit("disconnected")
                        }
                    })
            };
            l.prototype.afterConnected = function(a) {
                if (this.isConnected()) {
                    a()
                } else {
                    this.once("connected", a)
                }
            };
            l.prototype.waitForConnected = function() {
                var b = this;
                console.warn("DEPRECATION WARNING Transport.waitForConnected(): use afterConnected() instead");
                return new Promise(function(a) {
                    b.afterConnected(a)
                })
            };
            return l
        }(j.EventEmitter));
        g.Transport = l
    }), (function(Q, R, S) {
        "use strict";
        (function(r) {
            var s = (this && this.__extends) || (function() {
                var a = function(d, b) {
                    a = Object.setPrototypeOf || ({
                            __proto__: []
                        }
                        instanceof Array && function(d, b) {
                            d.__proto__ = b
                        }) || function(d, b) {
                        for (var p in b)
                            if (b.hasOwnProperty(p)) d[p] = b[p]
                    };
                    return a(d, b)
                };
                return function(d, b) {
                    a(d, b);

                    function __() {
                        this.constructor = d
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
                }
            })();
            Object.defineProperty(R, "__esModule", {
                value: true
            });
            var t = S(2);
            var u = S(1);
            var v = S(3);
            var w = S(17);
            var x = S(5);
            var y = S(8);
            var z = S(11);
            var A = S(20);
            var B = S(21);
            var C = S(22);
            var D = S(23);
            var E = S(24);
            var F = S(25);
            var G = S(26);
            var H = S(10);
            var I = S(28);
            var J = S(7);
            var K = S(14);
            var L = S(15);
            var M = S(32);
            var N = S(35);
            var O = r.window || r;
            var P = (function(q) {
                s(P, q);

                function P(a) {
                    var b = q.call(this) || this;
                    b.type = x.TypeStrings.UA;
                    b.log = new A.LoggerFactory();
                    b.logger = b.getLogger("sip.ua");
                    b.cache = {
                        credentials: {}
                    };
                    b.configuration = {};
                    b.dialogs = {};
                    b.applicants = {};
                    b.data = {};
                    b.sessions = {};
                    b.subscriptions = {};
                    b.earlySubscriptions = {};
                    b.publishers = {};
                    b.status = x.UAStatus.STATUS_INIT;
                    b.transactions = {
                        nist: {},
                        nict: {},
                        ist: {},
                        ict: {}
                    };
                    if (a === undefined) {
                        a = {}
                    } else if (typeof a === "string" || a instanceof String) {
                        a = {
                            uri: a
                        }
                    }
                    if (a.log) {
                        if (a.log.hasOwnProperty("builtinEnabled")) {
                            b.log.builtinEnabled = a.log.builtinEnabled
                        }
                        if (a.log.hasOwnProperty("connector")) {
                            b.log.connector = a.log.connector
                        }
                        if (a.log.hasOwnProperty("level")) {
                            var c = a.log.level;
                            var d = typeof c === "string" ? A.Levels[c] : c;
                            if (!d) {
                                b.logger.error("Invalid \"level\" parameter value: " + JSON.stringify(c))
                            } else {
                                b.log.level = d
                            }
                        }
                    }
                    try {
                        b.loadConfig(a)
                    } catch (e) {
                        b.status = x.UAStatus.STATUS_NOT_READY;
                        b.error = P.C.CONFIGURATION_ERROR;
                        throw e;
                    }
                    b.registerContext = new D.RegisterContext(b, a.registerOptions);
                    b.registerContext.on("failed", b.emit.bind(b, "registrationFailed"));
                    b.registerContext.on("registered", b.emit.bind(b, "registered"));
                    b.registerContext.on("unregistered", b.emit.bind(b, "unregistered"));
                    if (b.configuration.autostart) {
                        b.start()
                    }
                    return b
                }
                Object.defineProperty(P.prototype, "transactionsCount", {
                    get: function() {
                        var a = 0;
                        for (var b = 0, _a = ["nist", "nict", "ist", "ict"]; b < _a.length; b++) {
                            var c = _a[b];
                            a += Object.keys(this.transactions[c])
                                .length
                        }
                        return a
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(P.prototype, "nictTransactionsCount", {
                    get: function() {
                        return Object.keys(this.transactions.nict)
                            .length
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(P.prototype, "nistTransactionsCount", {
                    get: function() {
                        return Object.keys(this.transactions.nist)
                            .length
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(P.prototype, "ictTransactionsCount", {
                    get: function() {
                        return Object.keys(this.transactions.ict)
                            .length
                    },
                    enumerable: true,
                    configurable: true
                });
                Object.defineProperty(P.prototype, "istTransactionsCount", {
                    get: function() {
                        return Object.keys(this.transactions.ist)
                            .length
                    },
                    enumerable: true,
                    configurable: true
                });
                P.prototype.register = function(a) {
                    if (a === void 0) {
                        a = {}
                    }
                    if (a.register) {
                        this.configuration.register = true
                    }
                    this.registerContext.register(a);
                    return this
                };
                P.prototype.unregister = function(a) {
                    var b = this;
                    this.configuration.register = false;
                    if (this.transport) {
                        this.transport.afterConnected(function() {
                            b.registerContext.unregister(a)
                        })
                    }
                    return this
                };
                P.prototype.isRegistered = function() {
                    return this.registerContext.registered
                };
                P.prototype.invite = function(a, b, c) {
                    var d = this;
                    var e = new G.InviteClientContext(this, a, b, c);
                    if (this.transport) {
                        this.transport.afterConnected(function() {
                            e.invite();
                            d.emit("inviteSent", e)
                        })
                    }
                    return e
                };
                P.prototype.subscribe = function(a, b, c) {
                    var d = new I.Subscription(this, a, b, c);
                    if (this.transport) {
                        this.transport.afterConnected(function() {
                            return d.subscribe()
                        })
                    }
                    return d
                };
                P.prototype.publish = function(a, b, c, d) {
                    var e = new C.PublishContext(this, a, b, d);
                    if (this.transport) {
                        this.transport.afterConnected(function() {
                            e.publish(c)
                        })
                    }
                    return e
                };
                P.prototype.message = function(a, b, c) {
                    if (c === void 0) {
                        c = {}
                    }
                    if (b === undefined) {
                        throw new TypeError("Not enough arguments");
                    }
                    c.contentType = c.contentType || "text/plain";
                    c.body = b;
                    return this.request(v.C.MESSAGE, a, c)
                };
                P.prototype.request = function(a, b, c) {
                    var d = new u.ClientContext(this, a, b, c);
                    if (this.transport) {
                        this.transport.afterConnected(function() {
                            return d.send()
                        })
                    }
                    return d
                };
                P.prototype.stop = function() {
                    var a = this;
                    this.logger.log("user requested closure...");
                    if (this.status === x.UAStatus.STATUS_USER_CLOSED) {
                        this.logger.warn("UA already closed");
                        return this
                    }
                    this.logger.log("closing registerContext");
                    this.registerContext.close();
                    for (var b in this.sessions) {
                        if (this.sessions[b]) {
                            this.logger.log("closing session " + b);
                            this.sessions[b].terminate()
                        }
                    }
                    for (var c in this.subscriptions) {
                        if (this.subscriptions[c]) {
                            this.logger.log("unsubscribing from subscription " + c);
                            this.subscriptions[c].close()
                        }
                    }
                    for (var d in this.earlySubscriptions) {
                        if (this.earlySubscriptions[d]) {
                            this.logger.log("unsubscribing from early subscription " + d);
                            this.earlySubscriptions[d].close()
                        }
                    }
                    for (var e in this.publishers) {
                        if (this.publishers[e]) {
                            this.logger.log("unpublish " + e);
                            this.publishers[e].close()
                        }
                    }
                    for (var f in this.applicants) {
                        if (this.applicants[f]) {
                            this.applicants[f].close()
                        }
                    }
                    this.status = x.UAStatus.STATUS_USER_CLOSED;
                    if (this.nistTransactionsCount === 0 && this.nictTransactionsCount === 0 && this.transport) {
                        this.transport.disconnect()
                    } else {
                        var g = function() {
                            if (a.nistTransactionsCount === 0 && a.nictTransactionsCount === 0) {
                                a.removeListener("transactionDestroyed", g);
                                if (a.transport) {
                                    a.transport.disconnect()
                                }
                            }
                        };
                        this.on("transactionDestroyed", g)
                    }
                    if (typeof O.removeEventListener === "function") {
                        if (!(r.chrome && r.chrome.app && r.chrome.app.runtime)) {
                            O.removeEventListener("unload", this.environListener)
                        }
                    }
                    return this
                };
                P.prototype.start = function() {
                    var a = this;
                    this.logger.log("user requested startup...");
                    if (this.status === x.UAStatus.STATUS_INIT) {
                        this.status = x.UAStatus.STATUS_STARTING;
                        if (!this.configuration.transportConstructor) {
                            throw new y.Exceptions.TransportError("Transport constructor not set");
                        }
                        this.transport = new this.configuration.transportConstructor(this.getLogger("sip.transport"), this.configuration.transportOptions);
                        this.setTransportListeners();
                        this.emit("transportCreated", this.transport);
                        this.transport.connect()
                    } else if (this.status === x.UAStatus.STATUS_USER_CLOSED) {
                        this.logger.log("resuming");
                        this.status = x.UAStatus.STATUS_READY;
                        if (this.transport) {
                            this.transport.connect()
                        }
                    } else if (this.status === x.UAStatus.STATUS_STARTING) {
                        this.logger.log("UA is in STARTING status, not opening new connection")
                    } else if (this.status === x.UAStatus.STATUS_READY) {
                        this.logger.log("UA is in READY status, not resuming")
                    } else {
                        this.logger.error("Connection is down. Auto-Recovery system is trying to connect")
                    }
                    if (this.configuration.autostop && typeof O.addEventListener === "function") {
                        if (!(r.chrome && r.chrome.app && r.chrome.app.runtime)) {
                            this.environListener = this.stop;
                            O.addEventListener("unload", function() {
                                return a.environListener()
                            })
                        }
                    }
                    return this
                };
                P.prototype.normalizeTarget = function(a) {
                    return L.Utils.normalizeTarget(a, this.configuration.hostportParams)
                };
                P.prototype.getLogger = function(a, b) {
                    return this.log.getLogger(a, b)
                };
                P.prototype.getLoggerFactory = function() {
                    return this.log
                };
                P.prototype.newTransaction = function(a) {
                    this.transactions[a.kind][a.id] = a;
                    this.emit("newTransaction", {
                        transaction: a
                    })
                };
                P.prototype.destroyTransaction = function(a) {
                    delete this.transactions[a.kind][a.id];
                    this.emit("transactionDestroyed", {
                        transaction: a
                    })
                };
                P.prototype.findSession = function(a) {
                    return this.sessions[a.callId + a.fromTag] || this.sessions[a.callId + a.toTag] || undefined
                };
                P.prototype.on = function(a, b) {
                    return q.prototype.on.call(this, a, b)
                };
                P.prototype.saveCredentials = function(a) {
                    this.cache.credentials[a.realm] = this.cache.credentials[a.realm] || {};
                    this.cache.credentials[a.realm][a.uri] = a;
                    return this
                };
                P.prototype.getCredentials = function(a) {
                    var b = a.ruri.type === x.TypeStrings.URI ? a.ruri.host : "";
                    if (b && this.cache.credentials[b] && this.cache.credentials[b][a.ruri.toString()]) {
                        var c = this.cache.credentials[b][a.ruri.toString()];
                        c.method = a.method;
                        return c
                    }
                };
                P.prototype.onTransportError = function() {
                    if (this.status === x.UAStatus.STATUS_USER_CLOSED) {
                        return
                    }
                    if (!this.error || this.error !== P.C.NETWORK_ERROR) {
                        this.status = x.UAStatus.STATUS_NOT_READY;
                        this.error = P.C.NETWORK_ERROR
                    }
                };
                P.prototype.setTransportListeners = function() {
                    var b = this;
                    if (this.transport) {
                        this.transport.on("connected", function() {
                            return b.onTransportConnected()
                        });
                        this.transport.on("message", function(a) {
                            return b.onTransportReceiveMsg(a)
                        });
                        this.transport.on("transportError", function() {
                            return b.onTransportError()
                        })
                    }
                };
                P.prototype.onTransportConnected = function() {
                    var a = this;
                    if (this.configuration.register) {
                        Promise.resolve()
                            .then(function() {
                                return a.registerContext.register()
                            })
                    }
                };
                P.prototype.onTransportReceiveMsg = function(a) {
                    var b = B.Parser.parseMessage(a, this);
                    if (!b) {
                        this.logger.warn("UA failed to parse incoming SIP message - discarding.");
                        return
                    }
                    if (this.status === x.UAStatus.STATUS_USER_CLOSED && b instanceof H.IncomingRequest) {
                        this.logger.warn("UA received message when status = USER_CLOSED - aborting");
                        return
                    }
                    if (!this.transport) {
                        this.logger.warn("UA received message without transport - aborting");
                        return
                    }
                    if (!E.SanityCheck.sanityCheck(b, this, this.transport)) {
                        return
                    }
                    if (b instanceof H.IncomingRequest) {
                        this.receiveRequestFromTransport(b);
                        return
                    }
                    if (b instanceof H.IncomingResponse) {
                        this.receiveResponseFromTransport(b);
                        return
                    }
                    throw new Error("Invalid message type.");
                };
                P.prototype.receiveRequestFromTransport = function(b) {
                    b.transport = this.transport;
                    if (!(this.configuration.uri instanceof K.URI)) {
                        throw new Error("Configuration URI not instance of URI.");
                    }
                    if (!b.ruri) {
                        throw new Error("Request ruri undefined.");
                    }
                    if (b.ruri.scheme !== v.C.SIP) {
                        b.reply_sl(416);
                        return
                    }
                    var c = b.ruri;
                    var d = function(a) {
                        return !!a && a.user === c.user
                    };
                    if (!d(this.configuration.uri) && !(d(this.contact.uri) || d(this.contact.pubGruu) || d(this.contact.tempGruu))) {
                        this.logger.warn("Request-URI does not point to us");
                        if (b.method !== v.C.ACK) {
                            b.reply_sl(404)
                        }
                        return
                    }
                    var e = this.transactions.ist[b.viaBranch];
                    var f = this.transactions.nist[b.viaBranch];
                    if (b.method === v.C.CANCEL) {
                        if (e || f) {
                            b.reply_sl(200);
                            if (e && e.state === J.TransactionState.Proceeding) {
                                this.receiveRequest(b)
                            }
                        } else {
                            b.reply_sl(481)
                        }
                        return
                    }
                    if (b.method === v.C.ACK) {
                        if (e && e.state === J.TransactionState.Accepted) {
                            this.receiveRequest(b);
                            return
                        }
                    }
                    if (e) {
                        e.receiveRequest(b);
                        return
                    }
                    if (f) {
                        f.receiveRequest(b);
                        return
                    }
                    this.receiveRequest(b)
                };
                P.prototype.receiveResponseFromTransport = function(a) {
                    var b;
                    switch (a.method) {
                        case v.C.INVITE:
                            b = this.transactions.ict[a.viaBranch];
                            break;
                        case v.C.ACK:
                            break;
                        default:
                            b = this.transactions.nict[a.viaBranch];
                            break
                    }
                    if (!b) {
                        var c = "Discarding unmatched " + a.statusCode + " response to " + a.method + " " + a.viaBranch + ".";
                        this.logger.warn(c);
                        return
                    }
                    a.transaction = b;
                    b.receiveResponse(a)
                };
                P.prototype.receiveRequest = function(b) {
                    var c = this;
                    var d = b.method;
                    var e;
                    if (d === v.C.OPTIONS) {
                        var f = this.transport;
                        if (!f) {
                            throw new Error("Transport undefined.");
                        }
                        var g = {
                            loggerFactory: this.getLoggerFactory(),
                            onStateChange: function(a) {
                                if (a === J.TransactionState.Terminated) {
                                    c.destroyTransaction(h)
                                }
                            },
                            onTransportError: function(a) {
                                c.logger.error(a.message)
                            }
                        };
                        var h = new J.NonInviteServerTransaction(b, f, g);
                        this.newTransaction(h);
                        b.reply(200, undefined, ["Allow: " + P.C.ALLOWED_METHODS.toString(), "Accept: " + P.C.ACCEPTED_BODY_TYPES.toString()])
                    } else if (d === v.C.MESSAGE) {
                        e = new F.ServerContext(this, b);
                        e.body = b.body;
                        e.contentType = b.getHeader("Content-Type") || "text/plain";
                        b.reply(200, undefined);
                        this.emit("message", e)
                    } else if (d !== v.C.INVITE && d !== v.C.ACK) {
                        e = new F.ServerContext(this, b)
                    }
                    if (!b.toTag) {
                        switch (d) {
                            case v.C.INVITE:
                                var i = this.configuration.replaces !== v.C.supported.UNSUPPORTED && b.parseHeader("replaces");
                                var j = void 0;
                                if (i) {
                                    j = this.dialogs[i.call_id + i.replaces_to_tag + i.replaces_from_tag];
                                    if (!j) {
                                        b.reply_sl(481, undefined);
                                        return
                                    } else if (!(j.owner.type === x.TypeStrings.Subscription) && j.owner.status === x.SessionStatus.STATUS_TERMINATED) {
                                        b.reply_sl(603, undefined);
                                        return
                                    } else if (j.state === x.DialogStatus.STATUS_CONFIRMED && i.earlyOnly) {
                                        b.reply_sl(486, undefined);
                                        return
                                    }
                                }
                                var k = new G.InviteServerContext(this, b);
                                if (j && !(j.owner.type === x.TypeStrings.Subscription)) {
                                    k.replacee = j && j.owner
                                }
                                this.emit("invite", k);
                                break;
                            case v.C.BYE:
                                b.reply(481);
                                break;
                            case v.C.CANCEL:
                                var l = this.findSession(b);
                                if (l) {
                                    l.receiveRequest(b)
                                } else {
                                    this.logger.warn("received CANCEL request for a non existent session")
                                }
                                break;
                            case v.C.ACK:
                                break;
                            case v.C.NOTIFY:
                                if (this.configuration.allowLegacyNotifications && this.listeners("notify")
                                    .length > 0) {
                                    b.reply(200, undefined);
                                    this.emit("notify", {
                                        request: b
                                    })
                                } else {
                                    b.reply(481, "Subscription does not exist")
                                }
                                break;
                            case v.C.REFER:
                                this.logger.log("Received an out of dialog refer");
                                if (this.configuration.allowOutOfDialogRefers) {
                                    this.logger.log("Allow out of dialog refers is enabled on the UA");
                                    var m = new G.ReferServerContext(this, b);
                                    if (this.listeners("outOfDialogReferRequested")
                                        .length) {
                                        this.emit("outOfDialogReferRequested", m)
                                    } else {
                                        this.logger.log("No outOfDialogReferRequest listeners," + " automatically accepting and following the out of dialog refer");
                                        m.accept({
                                            followRefer: true
                                        })
                                    }
                                    break
                                }
                                b.reply(405);
                                break;
                            default:
                                b.reply(405);
                                break
                        }
                    } else {
                        var n = this.findDialog(b);
                        if (n) {
                            if (d === v.C.INVITE) {
                                var f = this.transport;
                                if (!f) {
                                    throw new Error("Transport undefined.");
                                }
                                var g = {
                                    loggerFactory: this.log,
                                    onStateChange: function(a) {
                                        if (a === J.TransactionState.Terminated) {
                                            c.destroyTransaction(o)
                                        }
                                    },
                                    onTransportError: function(a) {
                                        c.logger.error(a.message);
                                        n.owner.onTransportError()
                                    }
                                };
                                var o = new J.InviteServerTransaction(b, f, g);
                                this.newTransaction(o)
                            }
                            n.receiveRequest(b)
                        } else if (d === v.C.NOTIFY) {
                            var l = this.findSession(b);
                            var p = this.findEarlySubscription(b);
                            if (l) {
                                l.receiveRequest(b)
                            } else if (p) {
                                p.receiveRequest(b)
                            } else {
                                this.logger.warn("received NOTIFY request for a non existent session or subscription");
                                b.reply(481, "Subscription does not exist")
                            }
                        } else {
                            if (d !== v.C.ACK) {
                                b.reply(481)
                            }
                        }
                    }
                };
                P.prototype.findDialog = function(a) {
                    return this.dialogs[a.callId + a.fromTag + a.toTag] || this.dialogs[a.callId + a.toTag + a.fromTag] || undefined
                };
                P.prototype.findEarlySubscription = function(a) {
                    return this.earlySubscriptions[a.callId + a.toTag + a.getHeader("event")] || undefined
                };
                P.prototype.checkAuthenticationFactory = function(a) {
                    if (!(a instanceof Function)) {
                        return
                    }
                    if (!a.initialize) {
                        a.initialize = function() {
                            return Promise.resolve()
                        }
                    }
                    return a
                };
                P.prototype.loadConfig = function(e) {
                    var f = this;
                    var g = {
                        viaHost: L.Utils.createRandomToken(12) + ".invalid",
                        uri: new K.URI("sip", "anonymous." + L.Utils.createRandomToken(6), "anonymous.invalid", undefined, undefined),
                        custom: {},
                        displayName: "",
                        password: undefined,
                        register: true,
                        registerOptions: {},
                        transportConstructor: N.Transport,
                        transportOptions: {},
                        userAgentString: v.C.USER_AGENT,
                        noAnswerTimeout: 60,
                        hackViaTcp: false,
                        hackIpInContact: false,
                        hackWssInTransport: false,
                        hackAllowUnregisteredOptionTags: false,
                        sessionDescriptionHandlerFactoryOptions: {
                            constraints: {},
                            peerConnectionOptions: {}
                        },
                        extraSupported: [],
                        contactName: L.Utils.createRandomToken(8),
                        contactTransport: "ws",
                        forceRport: false,
                        autostart: true,
                        autostop: true,
                        rel100: v.C.supported.UNSUPPORTED,
                        dtmfType: v.C.dtmfType.INFO,
                        replaces: v.C.supported.UNSUPPORTED,
                        sessionDescriptionHandlerFactory: M.SessionDescriptionHandler.defaultFactory,
                        authenticationFactory: this.checkAuthenticationFactory(function(a) {
                            return new w.DigestAuthentication(a)
                        }),
                        allowLegacyNotifications: false,
                        allowOutOfDialogRefers: false,
                    };
                    var h = this.getConfigurationCheck();
                    for (var i in h.mandatory) {
                        if (!e.hasOwnProperty(i)) {
                            throw new y.Exceptions.ConfigurationError(i);
                        } else {
                            var j = e[i];
                            var k = h.mandatory[i](j);
                            if (k !== undefined) {
                                g[i] = k
                            } else {
                                throw new y.Exceptions.ConfigurationError(i, j);
                            }
                        }
                    }
                    for (var i in h.optional) {
                        if (e.hasOwnProperty(i)) {
                            var j = e[i];
                            if ((j instanceof Array && j.length === 0) || (j === null || j === "" || j === undefined) || (typeof(j) === "number" && isNaN(j))) {
                                continue
                            }
                            var k = h.optional[i](j);
                            if (k !== undefined) {
                                g[i] = k
                            } else {
                                throw new y.Exceptions.ConfigurationError(i, j);
                            }
                        }
                    }
                    if (g.displayName === 0) {
                        g.displayName = "0"
                    }
                    g.sipjsId = L.Utils.createRandomToken(5);
                    var l = g.uri.clone();
                    l.user = undefined;
                    g.hostportParams = l.toRaw()
                        .replace(/^sip:/i, "");
                    if (!g.authorizationUser) {
                        g.authorizationUser = g.uri.user
                    }
                    g.noAnswerTimeout = g.noAnswerTimeout * 1000;
                    if (g.hackIpInContact) {
                        if (typeof g.hackIpInContact === "boolean") {
                            var m = 1;
                            var n = 254;
                            var o = Math.floor(Math.random() * (n - m + 1) + m);
                            g.viaHost = "192.0.2." + o
                        } else if (typeof g.hackIpInContact === "string") {
                            g.viaHost = g.hackIpInContact
                        }
                    }
                    if (g.hackWssInTransport) {
                        g.contactTransport = "wss"
                    }
                    this.contact = {
                        pubGruu: undefined,
                        tempGruu: undefined,
                        uri: new K.URI("sip", g.contactName, g.viaHost, undefined, {
                            transport: g.contactTransport
                        }),
                        toString: function(a) {
                            if (a === void 0) {
                                a = {}
                            }
                            var b = a.anonymous || false;
                            var c = a.outbound || false;
                            var d = "<";
                            if (b) {
                                d += (f.contact.tempGruu || ("sip:anonymous@anonymous.invalid;transport=" + g.contactTransport))
                                    .toString()
                            } else {
                                d += (f.contact.pubGruu || f.contact.uri)
                                    .toString()
                            }
                            if (c) {
                                d += ";ob"
                            }
                            d += ">";
                            return d
                        }
                    };
                    var p = {};
                    for (var i in g) {
                        if (g.hasOwnProperty(i)) {
                            p[i] = g[i]
                        }
                    }
                    Object.assign(this.configuration, p);
                    this.logger.log("configuration parameters after validation:");
                    for (var i in g) {
                        if (g.hasOwnProperty(i)) {
                            switch (i) {
                                case "uri":
                                case "sessionDescriptionHandlerFactory":
                                    this.logger.log("è·¯ " + i + ": " + g[i]);
                                    break;
                                case "password":
                                    this.logger.log("è·¯ " + i + ": " + "NOT SHOWN");
                                    break;
                                case "transportConstructor":
                                    this.logger.log("è·¯ " + i + ": " + g[i].name);
                                    break;
                                default:
                                    this.logger.log("è·¯ " + i + ": " + JSON.stringify(g[i]))
                            }
                        }
                    }
                    return
                };
                P.prototype.getConfigurationCheck = function() {
                    return {
                        mandatory: {},
                        optional: {
                            uri: function(a) {
                                if (!(/^sip:/i)
                                    .test(a)) {
                                    a = v.C.SIP + ":" + a
                                }
                                var b = z.Grammar.URIParse(a);
                                if (!b || !b.user) {
                                    return
                                } else {
                                    return b
                                }
                            },
                            transportConstructor: function(a) {
                                if (a instanceof Function) {
                                    return a
                                }
                            },
                            transportOptions: function(a) {
                                if (typeof a === "object") {
                                    return a
                                }
                            },
                            authorizationUser: function(a) {
                                if (z.Grammar.parse('"' + a + '"', "quoted_string") === -1) {
                                    return
                                } else {
                                    return a
                                }
                            },
                            displayName: function(a) {
                                if (z.Grammar.parse('"' + a + '"', "displayName") === -1) {
                                    return
                                } else {
                                    return a
                                }
                            },
                            dtmfType: function(a) {
                                switch (a) {
                                    case v.C.dtmfType.RTP:
                                        return v.C.dtmfType.RTP;
                                    case v.C.dtmfType.INFO:
                                    default:
                                        return v.C.dtmfType.INFO
                                }
                            },
                            hackViaTcp: function(a) {
                                if (typeof a === "boolean") {
                                    return a
                                }
                            },
                            hackIpInContact: function(a) {
                                if (typeof a === "boolean") {
                                    return a
                                } else if (typeof a === "string" && z.Grammar.parse(a, "host") !== -1) {
                                    return a
                                }
                            },
                            hackWssInTransport: function(a) {
                                if (typeof a === "boolean") {
                                    return a
                                }
                            },
                            hackAllowUnregisteredOptionTags: function(a) {
                                if (typeof a === "boolean") {
                                    return a
                                }
                            },
                            contactTransport: function(a) {
                                if (typeof a === "string") {
                                    return a
                                }
                            },
                            extraSupported: function(a) {
                                if (!(a instanceof Array)) {
                                    return
                                }
                                for (var b = 0, optionTags_1 = a; b < optionTags_1.length; b++) {
                                    var c = optionTags_1[b];
                                    if (typeof c !== "string") {
                                        return
                                    }
                                }
                                return a
                            },
                            forceRport: function(a) {
                                if (typeof a === "boolean") {
                                    return a
                                }
                            },
                            noAnswerTimeout: function(a) {
                                if (L.Utils.isDecimal(a)) {
                                    var b = Number(a);
                                    if (b > 0) {
                                        return b
                                    }
                                }
                            },
                            password: function(a) {
                                return String(a)
                            },
                            rel100: function(a) {
                                if (a === v.C.supported.REQUIRED) {
                                    return v.C.supported.REQUIRED
                                } else if (a === v.C.supported.SUPPORTED) {
                                    return v.C.supported.SUPPORTED
                                } else {
                                    return v.C.supported.UNSUPPORTED
                                }
                            },
                            replaces: function(a) {
                                if (a === v.C.supported.REQUIRED) {
                                    return v.C.supported.REQUIRED
                                } else if (a === v.C.supported.SUPPORTED) {
                                    return v.C.supported.SUPPORTED
                                } else {
                                    return v.C.supported.UNSUPPORTED
                                }
                            },
                            register: function(a) {
                                if (typeof a === "boolean") {
                                    return a
                                }
                            },
                            registerOptions: function(a) {
                                if (typeof a === "object") {
                                    return a
                                }
                            },
                            userAgentString: function(a) {
                                if (typeof a === "string") {
                                    return a
                                }
                            },
                            autostart: function(a) {
                                if (typeof a === "boolean") {
                                    return a
                                }
                            },
                            autostop: function(a) {
                                if (typeof a === "boolean") {
                                    return a
                                }
                            },
                            sessionDescriptionHandlerFactory: function(a) {
                                if (a instanceof Function) {
                                    return a
                                }
                            },
                            sessionDescriptionHandlerFactoryOptions: function(a) {
                                if (typeof a === "object") {
                                    return a
                                }
                            },
                            authenticationFactory: this.checkAuthenticationFactory,
                            allowLegacyNotifications: function(a) {
                                if (typeof a === "boolean") {
                                    return a
                                }
                            },
                            custom: function(a) {
                                if (typeof a === "object") {
                                    return a
                                }
                            },
                            contactName: function(a) {
                                if (typeof a === "string") {
                                    return a
                                }
                            },
                        }
                    }
                };
                P.C = {
                    STATUS_INIT: 0,
                    STATUS_STARTING: 1,
                    STATUS_READY: 2,
                    STATUS_USER_CLOSED: 3,
                    STATUS_NOT_READY: 4,
                    CONFIGURATION_ERROR: 1,
                    NETWORK_ERROR: 2,
                    ALLOWED_METHODS: ["ACK", "CANCEL", "INVITE", "MESSAGE", "BYE", "OPTIONS", "INFO", "NOTIFY", "REFER"],
                    ACCEPTED_BODY_TYPES: ["application/sdp", "application/dtmf-relay"],
                    MAX_FORWARDS: 70,
                    TAG_LENGTH: 10
                };
                return P
            }(t.EventEmitter));
            R.UA = P;
            (function(b) {
                var c;
                (function(a) {
                    a["RTP"] = "rtp";
                    a["INFO"] = "info"
                })(c = b.DtmfType || (b.DtmfType = {}))
            })(P = R.UA || (R.UA = {}));
            R.UA = P
        }.call(this, S(31)))
    }), (function(a, b) {
        var g;
        g = (function() {
            return this
        })();
        try {
            g = g || new Function("return this")()
        } catch (e) {
            if (typeof window === "object") g = window
        }
        a.exports = g
    }), (function(s, t, u) {
        "use strict";
        (function(i) {
            var j = (this && this.__extends) || (function() {
                var a = function(d, b) {
                    a = Object.setPrototypeOf || ({
                            __proto__: []
                        }
                        instanceof Array && function(d, b) {
                            d.__proto__ = b
                        }) || function(d, b) {
                        for (var p in b)
                            if (b.hasOwnProperty(p)) d[p] = b[p]
                    };
                    return a(d, b)
                };
                return function(d, b) {
                    a(d, b);

                    function __() {
                        this.constructor = d
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
                }
            })();
            Object.defineProperty(t, "__esModule", {
                value: true
            });
            var k = u(2);
            var l = u(5);
            var m = u(8);
            var n = u(15);
            var o = u(33);
            var q = u(34);
            var r = (function(h) {
                j(r, h);

                function r(a, b, c) {
                    var d = h.call(this) || this;
                    d.type = l.TypeStrings.SessionDescriptionHandler;
                    d.options = c || {};
                    d.logger = a;
                    d.observer = b;
                    d.dtmfSender = undefined;
                    d.shouldAcquireMedia = true;
                    d.CONTENT_TYPE = "application/sdp";
                    d.C = {
                        DIRECTION: {
                            NULL: null,
                            SENDRECV: "sendrecv",
                            SENDONLY: "sendonly",
                            RECVONLY: "recvonly",
                            INACTIVE: "inactive"
                        }
                    };
                    d.logger.log("SessionDescriptionHandlerOptions: " + JSON.stringify(d.options));
                    d.direction = d.C.DIRECTION.NULL;
                    d.modifiers = d.options.modifiers || [];
                    if (!Array.isArray(d.modifiers)) {
                        d.modifiers = [d.modifiers]
                    }
                    var e = i.window || i;
                    d.WebRTC = {
                        MediaStream: e.MediaStream,
                        getUserMedia: e.navigator.mediaDevices.getUserMedia.bind(e.navigator.mediaDevices),
                        RTCPeerConnection: e.RTCPeerConnection
                    };
                    d.iceGatheringTimeout = false;
                    d.initPeerConnection(d.options.peerConnectionOptions);
                    d.constraints = d.checkAndDefaultConstraints(d.options.constraints);
                    return d
                }
                r.defaultFactory = function(a, b) {
                    var c = a.ua.getLogger("sip.invitecontext.sessionDescriptionHandler", a.id);
                    var d = new q.SessionDescriptionHandlerObserver(a, b);
                    return new r(c, d, b)
                };
                r.prototype.close = function() {
                    this.logger.log("closing PeerConnection");
                    if (this.peerConnection && this.peerConnection.signalingState !== "closed") {
                        if (this.peerConnection.getSenders) {
                            this.peerConnection.getSenders()
                                .forEach(function(a) {
                                    if (a.track) {
                                        a.track.stop()
                                    }
                                })
                        } else {
                            this.logger.warn("Using getLocalStreams which is deprecated");
                            this.peerConnection.getLocalStreams()
                                .forEach(function(b) {
                                    b.getTracks()
                                        .forEach(function(a) {
                                            a.stop()
                                        })
                                })
                        }
                        if (this.peerConnection.getReceivers) {
                            this.peerConnection.getReceivers()
                                .forEach(function(a) {
                                    if (a.track) {
                                        a.track.stop()
                                    }
                                })
                        } else {
                            this.logger.warn("Using getRemoteStreams which is deprecated");
                            this.peerConnection.getRemoteStreams()
                                .forEach(function(b) {
                                    b.getTracks()
                                        .forEach(function(a) {
                                            a.stop()
                                        })
                                })
                        }
                        this.resetIceGatheringComplete();
                        this.peerConnection.close()
                    }
                };
                r.prototype.getDescription = function(b, c) {
                    var d = this;
                    if (b === void 0) {
                        b = {}
                    }
                    if (c === void 0) {
                        c = []
                    }
                    if (b.peerConnectionOptions) {
                        this.initPeerConnection(b.peerConnectionOptions)
                    }
                    var e = Object.assign({}, this.constraints, b.constraints);
                    e = this.checkAndDefaultConstraints(e);
                    if (JSON.stringify(e) !== JSON.stringify(this.constraints)) {
                        this.constraints = e;
                        this.shouldAcquireMedia = true
                    }
                    if (!Array.isArray(c)) {
                        c = [c]
                    }
                    c = c.concat(this.modifiers);
                    return Promise.resolve()
                        .then(function() {
                            if (d.shouldAcquireMedia) {
                                return d.acquire(d.constraints)
                                    .then(function() {
                                        d.shouldAcquireMedia = false
                                    })
                            }
                        })
                        .then(function() {
                            return d.createOfferOrAnswer(b.RTCOfferOptions, c)
                        })
                        .then(function(a) {
                            if (a.sdp === undefined) {
                                throw new m.Exceptions.SessionDescriptionHandlerError("getDescription", undefined, "SDP undefined");
                            }
                            d.emit("getDescription", a);
                            return {
                                body: a.sdp,
                                contentType: d.CONTENT_TYPE
                            }
                        })
                };
                r.prototype.hasDescription = function(a) {
                    return a === this.CONTENT_TYPE
                };
                r.prototype.holdModifier = function(a) {
                    if (!a.sdp) {
                        return Promise.resolve(a)
                    }
                    if (!(/a=(sendrecv|sendonly|recvonly|inactive)/)
                        .test(a.sdp)) {
                        a.sdp = a.sdp.replace(/(m=[^\r]*\r\n)/g, "$1a=sendonly\r\n")
                    } else {
                        a.sdp = a.sdp.replace(/a=sendrecv\r\n/g, "a=sendonly\r\n");
                        a.sdp = a.sdp.replace(/a=recvonly\r\n/g, "a=inactive\r\n")
                    }
                    return Promise.resolve(a)
                };
                r.prototype.setDescription = function(b, c, d) {
                    var f = this;
                    if (c === void 0) {
                        c = {}
                    }
                    if (d === void 0) {
                        d = []
                    }
                    if (c.peerConnectionOptions) {
                        this.initPeerConnection(c.peerConnectionOptions)
                    }
                    if (!Array.isArray(d)) {
                        d = [d]
                    }
                    d = d.concat(this.modifiers);
                    var g = {
                        type: this.hasOffer("local") ? "answer" : "offer",
                        sdp: b
                    };
                    return Promise.resolve()
                        .then(function() {
                            if (f.shouldAcquireMedia && f.options.alwaysAcquireMediaFirst) {
                                return f.acquire(f.constraints)
                                    .then(function() {
                                        f.shouldAcquireMedia = false
                                    })
                            }
                        })
                        .then(function() {
                            return n.Utils.reducePromises(d, g)
                        })
                        .catch(function(e) {
                            if (e.type === l.TypeStrings.SessionDescriptionHandlerError) {
                                throw e;
                            }
                            var a = new m.Exceptions.SessionDescriptionHandlerError("setDescription", e, "The modifiers did not resolve successfully");
                            f.logger.error(a.message);
                            f.emit("peerConnection-setRemoteDescriptionFailed", a);
                            throw a;
                        })
                        .then(function(a) {
                            f.emit("setDescription", a);
                            return f.peerConnection.setRemoteDescription(a)
                        })
                        .catch(function(e) {
                            if (e.type === l.TypeStrings.SessionDescriptionHandlerError) {
                                throw e;
                            }
                            if ((/^m=video.+$/gm)
                                .test(b) && !c.disableAudioFallback) {
                                c.disableAudioFallback = true;
                                return f.setDescription(b, c, [o.stripVideo].concat(d))
                            }
                            var a = new m.Exceptions.SessionDescriptionHandlerError("setDescription", e);
                            if (a.error) {
                                f.logger.error(a.error)
                            }
                            f.emit("peerConnection-setRemoteDescriptionFailed", a);
                            throw a;
                        })
                        .then(function() {
                            if (f.peerConnection.getReceivers) {
                                f.emit("setRemoteDescription", f.peerConnection.getReceivers())
                            } else {
                                f.emit("setRemoteDescription", f.peerConnection.getRemoteStreams())
                            }
                            f.emit("confirmed", f)
                        })
                };
                r.prototype.sendDtmf = function(a, b) {
                    if (b === void 0) {
                        b = {}
                    }
                    if (!this.dtmfSender && this.hasBrowserGetSenderSupport()) {
                        var c = this.peerConnection.getSenders();
                        if (c.length > 0) {
                            this.dtmfSender = c[0].dtmf
                        }
                    }
                    if (!this.dtmfSender && this.hasBrowserTrackSupport()) {
                        var d = this.peerConnection.getLocalStreams();
                        if (d.length > 0) {
                            var f = d[0].getAudioTracks();
                            if (f.length > 0) {
                                this.dtmfSender = this.peerConnection.createDTMFSender(f[0])
                            }
                        }
                    }
                    if (!this.dtmfSender) {
                        return false
                    }
                    try {
                        this.dtmfSender.insertDTMF(a, b.duration, b.interToneGap)
                    } catch (e) {
                        if (e.type === "InvalidStateError" || e.type === "InvalidCharacterError") {
                            this.logger.error(e);
                            return false
                        } else {
                            throw e;
                        }
                    }
                    this.logger.log("DTMF sent via RTP: " + a.toString());
                    return true
                };
                r.prototype.getDirection = function() {
                    return this.direction
                };
                r.prototype.on = function(a, b) {
                    return h.prototype.on.call(this, a, b)
                };
                r.prototype.createOfferOrAnswer = function(b, c) {
                    var d = this;
                    if (b === void 0) {
                        b = {}
                    }
                    if (c === void 0) {
                        c = []
                    }
                    var f = this.hasOffer("remote") ? "createAnswer" : "createOffer";
                    var g = this.peerConnection;
                    this.logger.log(f);
                    return g[f](b)
                        .catch(function(e) {
                            if (e.type === l.TypeStrings.SessionDescriptionHandlerError) {
                                throw e;
                            }
                            var a = new m.Exceptions.SessionDescriptionHandlerError("createOfferOrAnswer", e, "peerConnection-" + f + "Failed");
                            d.emit("peerConnection-" + f + "Failed", a);
                            throw a;
                        })
                        .then(function(a) {
                            return n.Utils.reducePromises(c, d.createRTCSessionDescriptionInit(a))
                        })
                        .then(function(a) {
                            d.resetIceGatheringComplete();
                            d.logger.log("Setting local sdp.");
                            d.logger.log("sdp is " + a.sdp || false);
                            return g.setLocalDescription(a)
                        })
                        .catch(function(e) {
                            if (e.type === l.TypeStrings.SessionDescriptionHandlerError) {
                                throw e;
                            }
                            var a = new m.Exceptions.SessionDescriptionHandlerError("createOfferOrAnswer", e, "peerConnection-SetLocalDescriptionFailed");
                            d.emit("peerConnection-SetLocalDescriptionFailed", a);
                            throw a;
                        })
                        .then(function() {
                            return d.waitForIceGatheringComplete()
                        })
                        .then(function() {
                            var a = d.createRTCSessionDescriptionInit(d.peerConnection.localDescription);
                            return n.Utils.reducePromises(c, a)
                        })
                        .then(function(a) {
                            d.setDirection(a.sdp || "");
                            return a
                        })
                        .catch(function(e) {
                            if (e.type === l.TypeStrings.SessionDescriptionHandlerError) {
                                throw e;
                            }
                            var a = new m.Exceptions.SessionDescriptionHandlerError("createOfferOrAnswer", e);
                            d.logger.error(a.toString());
                            throw a;
                        })
                };
                r.prototype.createRTCSessionDescriptionInit = function(a) {
                    return {
                        type: a.type,
                        sdp: a.sdp
                    }
                };
                r.prototype.addDefaultIceCheckingTimeout = function(a) {
                    if (a.iceCheckingTimeout === undefined) {
                        a.iceCheckingTimeout = 10000
                    }
                    return a
                };
                r.prototype.addDefaultIceServers = function(a) {};
                r.prototype.checkAndDefaultConstraints = function(a) {
                    var b = {
                        audio: true,
                        video: !this.options.alwaysAcquireMediaFirst
                    };
                    a = a || b;
                    if (Object.keys(a)
                        .length === 0 && a.constructor === Object) {
                        return b
                    }
                    return a
                };
                r.prototype.hasBrowserTrackSupport = function() {
                    return Boolean(this.peerConnection.addTrack)
                };
                r.prototype.hasBrowserGetSenderSupport = function() {
                    return Boolean(this.peerConnection.getSenders)
                };
                r.prototype.initPeerConnection = function(b) {
                    var c = this;
                    if (b === void 0) {
                        b = {}
                    }
                    b = this.addDefaultIceCheckingTimeout(b);
                    b.rtcConfiguration = b.rtcConfiguration || {};
                    b.rtcConfiguration = this.addDefaultIceServers(b.rtcConfiguration);
                    this.logger.log("initPeerConnection");
                    if (this.peerConnection) {
                        this.logger.log("Already have a peer connection for this session. Tearing down.");
                        this.resetIceGatheringComplete();
                        this.peerConnection.close()
                    }
                    this.peerConnection = new this.WebRTC.RTCPeerConnection(b.rtcConfiguration);
                    this.logger.log("New peer connection created");
                    if ("ontrack" in this.peerConnection) {
                        this.peerConnection.addEventListener("track", function(e) {
                            c.logger.log("track added");
                            c.observer.trackAdded();
                            c.emit("addTrack", e)
                        })
                    } else {
                        this.logger.warn("Using onaddstream which is deprecated");
                        this.peerConnection.onaddstream = function(e) {
                            c.logger.log("stream added");
                            c.emit("addStream", e)
                        }
                    }
                    this.peerConnection.onicecandidate = function(e) {
                        c.emit("iceCandidate", e);
                        if (e.candidate) {
                            c.logger.log("ICE candidate received: " + (e.candidate.candidate === null ? null : e.candidate.candidate.trim()))
                        } else if (e.candidate === null) {
                            c.logger.log("ICE candidate gathering complete");
                            c.triggerIceGatheringComplete()
                        }
                    };
                    this.peerConnection.onicegatheringstatechange = function() {
                        c.logger.log("RTCIceGatheringState changed: " + c.peerConnection.iceGatheringState);
                        switch (c.peerConnection.iceGatheringState) {
                            case "gathering":
                                c.emit("iceGathering", c);
                                if (!c.iceGatheringTimer && b.iceCheckingTimeout) {
                                    c.iceGatheringTimeout = false;
                                    c.iceGatheringTimer = setTimeout(function() {
                                        c.logger.log("RTCIceChecking Timeout Triggered after " + b.iceCheckingTimeout + " milliseconds");
                                        c.iceGatheringTimeout = true;
                                        c.triggerIceGatheringComplete()
                                    }, b.iceCheckingTimeout)
                                }
                                break;
                            case "complete":
                                c.triggerIceGatheringComplete();
                                break
                        }
                    };
                    this.peerConnection.oniceconnectionstatechange = function() {
                        var a;
                        switch (c.peerConnection.iceConnectionState) {
                            case "new":
                                a = "iceConnection";
                                break;
                            case "checking":
                                a = "iceConnectionChecking";
                                break;
                            case "connected":
                                a = "iceConnectionConnected";
                                break;
                            case "completed":
                                a = "iceConnectionCompleted";
                                break;
                            case "failed":
                                a = "iceConnectionFailed";
                                break;
                            case "disconnected":
                                a = "iceConnectionDisconnected";
                                break;
                            case "closed":
                                a = "iceConnectionClosed";
                                break;
                            default:
                                c.logger.warn("Unknown iceConnection state: " + c.peerConnection.iceConnectionState);
                                return
                        }
                        c.logger.log("ICE Connection State changed to " + a);
                        c.emit(a, c)
                    }
                };
                r.prototype.acquire = function(d) {
                    var f = this;
                    d = this.checkAndDefaultConstraints(d);
                    return new Promise(function(b, c) {
                            f.logger.log("acquiring local media");
                            f.emit("userMediaRequest", d);
                            if (d.audio || d.video) {
                                f.WebRTC.getUserMedia(d)
                                    .then(function(a) {
                                        f.observer.trackAdded();
                                        f.emit("userMedia", a);
                                        b(a)
                                    })
                                    .catch(function(e) {
                                        f.emit("userMediaFailed", e);
                                        c(e)
                                    })
                            } else {
                                b([])
                            }
                        })
                        .catch(function(e) {
                            if (e.type === l.TypeStrings.SessionDescriptionHandlerError) {
                                throw e;
                            }
                            var a = new m.Exceptions.SessionDescriptionHandlerError("acquire", e, "unable to acquire streams");
                            f.logger.error(a.message);
                            if (a.error) {
                                f.logger.error(a.error)
                            }
                            throw a;
                        })
                        .then(function(b) {
                            f.logger.log("acquired local media streams");
                            try {
                                if (f.peerConnection.removeTrack) {
                                    f.peerConnection.getSenders()
                                        .forEach(function(a) {
                                            f.peerConnection.removeTrack(a)
                                        })
                                }
                                return b
                            } catch (e) {
                                return Promise.reject(e)
                            }
                        })
                        .catch(function(e) {
                            if (e.type === l.TypeStrings.SessionDescriptionHandlerError) {
                                throw e;
                            }
                            var a = new m.Exceptions.SessionDescriptionHandlerError("acquire", e, "error removing streams");
                            f.logger.error(a.message);
                            if (a.error) {
                                f.logger.error(a.error)
                            }
                            throw a;
                        })
                        .then(function(c) {
                            try {
                                c = [].concat(c);
                                c.forEach(function(b) {
                                    if (f.peerConnection.addTrack) {
                                        b.getTracks()
                                            .forEach(function(a) {
                                                f.peerConnection.addTrack(a, b)
                                            })
                                    } else {
                                        f.peerConnection.addStream(b)
                                    }
                                })
                            } catch (e) {
                                return Promise.reject(e)
                            }
                            return Promise.resolve()
                        })
                        .catch(function(e) {
                            if (e.type === l.TypeStrings.SessionDescriptionHandlerError) {
                                throw e;
                            }
                            var a = new m.Exceptions.SessionDescriptionHandlerError("acquire", e, "error adding stream");
                            f.logger.error(a.message);
                            if (a.error) {
                                f.logger.error(a.error)
                            }
                            throw a;
                        })
                };
                r.prototype.hasOffer = function(a) {
                    var b = "have-" + a + "-offer";
                    return this.peerConnection.signalingState === b
                };
                r.prototype.isIceGatheringComplete = function() {
                    return this.peerConnection.iceGatheringState === "complete" || this.iceGatheringTimeout
                };
                r.prototype.resetIceGatheringComplete = function() {
                    this.iceGatheringTimeout = false;
                    this.logger.log("resetIceGatheringComplete");
                    if (this.iceGatheringTimer) {
                        clearTimeout(this.iceGatheringTimer);
                        this.iceGatheringTimer = undefined
                    }
                    if (this.iceGatheringDeferred) {
                        this.iceGatheringDeferred.reject();
                        this.iceGatheringDeferred = undefined
                    }
                };
                r.prototype.setDirection = function(a) {
                    var b = a.match(/a=(sendrecv|sendonly|recvonly|inactive)/);
                    if (b === null) {
                        this.direction = this.C.DIRECTION.NULL;
                        this.observer.directionChanged();
                        return
                    }
                    var c = b[1];
                    switch (c) {
                        case this.C.DIRECTION.SENDRECV:
                        case this.C.DIRECTION.SENDONLY:
                        case this.C.DIRECTION.RECVONLY:
                        case this.C.DIRECTION.INACTIVE:
                            this.direction = c;
                            break;
                        default:
                            this.direction = this.C.DIRECTION.NULL;
                            break
                    }
                    this.observer.directionChanged()
                };
                r.prototype.triggerIceGatheringComplete = function() {
                    if (this.isIceGatheringComplete()) {
                        this.emit("iceGatheringComplete", this);
                        if (this.iceGatheringTimer) {
                            clearTimeout(this.iceGatheringTimer);
                            this.iceGatheringTimer = undefined
                        }
                        if (this.iceGatheringDeferred) {
                            this.iceGatheringDeferred.resolve();
                            this.iceGatheringDeferred = undefined
                        }
                    }
                };
                r.prototype.waitForIceGatheringComplete = function() {
                    this.logger.log("waitForIceGatheringComplete");
                    if (this.isIceGatheringComplete()) {
                        this.logger.log("ICE is already complete. Return resolved.");
                        return Promise.resolve()
                    } else if (!this.iceGatheringDeferred) {
                        this.iceGatheringDeferred = n.Utils.defer()
                    }
                    this.logger.log("ICE is not complete. Returning promise");
                    return this.iceGatheringDeferred ? this.iceGatheringDeferred.promise : Promise.resolve()
                };
                return r
            }(k.EventEmitter));
            t.SessionDescriptionHandler = r
        }.call(this, u(31)))
    }), (function(m, n, o) {
        "use strict";
        Object.defineProperty(n, "__esModule", {
            value: true
        });
        var p = function(a, b) {
            var c = [];
            var d = a.split(/\r\n/);
            var e;
            for (var i = 0; i < d.length;) {
                var f = d[i];
                if (/^m=(?:audio|video)/.test(f)) {
                    e = {
                        index: i,
                        stripped: []
                    };
                    c.push(e)
                } else if (e) {
                    var g = /^a=rtpmap:(\d+) ([^/]+)/;
                    if (g && b === g[2]) {
                        d.splice(i, 1);
                        e.stripped.push(g[1]);
                        continue
                    }
                }
                i++
            }
            for (var h = 0, mediaDescs_1 = c; h < mediaDescs_1.length; h++) {
                var k = mediaDescs_1[h];
                var l = d[k.index].split(" ");
                for (var j = 3; j < l.length;) {
                    if (k.stripped.indexOf(l[j]) !== -1) {
                        l.splice(j, 1);
                        continue
                    }
                    j++
                }
                d[k.index] = l.join(" ")
            }
            return d.join("\r\n")
        };
        var q = function(c, d) {
            var e = new RegExp("m=" + d + ".*$", "gm");
            var f = new RegExp("^a=group:.*$", "gm");
            if (e.test(c)) {
                var g;
                c = c.split(/ ^ m = /gm)
                    .filter(function(a) {
                        if (a.substr(0, d.length) === d) {
                            g = a.match(/^a=mid:.*$/gm);
                            if (g) {
                                var b = g[0].match(/:.+$/g);
                                if (b) {
                                    g = b[0].substr(1)
                                }
                            }
                            return false
                        }
                        return true
                    })
                    .join("m=");
                var h = c.match(f);
                if (h && h.length === 1) {
                    var i = h[0];
                    var j = new RegExp("\ *" + g + "[^\ ]*", "g");
                    i = i.replace(j, "");
                    c = c.split(f)
                        .join(i)
                }
            }
            return c
        };

        function stripTcpCandidates(a) {
            a.sdp = (a.sdp || "")
                .replace(/^a=candidate:\d+ \d+ tcp .*?\r\n/img, "");
            return Promise.resolve(a)
        }
        n.stripTcpCandidates = stripTcpCandidates;

        function stripTelephoneEvent(a) {
            a.sdp = p(a.sdp || "", "telephone-event");
            return Promise.resolve(a)
        }
        n.stripTelephoneEvent = stripTelephoneEvent;

        function cleanJitsiSdpImageattr(a) {
            a.sdp = (a.sdp || "")
                .replace(/^(a=imageattr:.*?)(x|y)=\[0-/gm, "$1$2=[1:");
            return Promise.resolve(a)
        }
        n.cleanJitsiSdpImageattr = cleanJitsiSdpImageattr;

        function stripG722(a) {
            a.sdp = p(a.sdp || "", "G722");
            return Promise.resolve(a)
        }
        n.stripG722 = stripG722;

        function stripRtpPayload(b) {
            return function(a) {
                a.sdp = p(a.sdp || "", b);
                return Promise.resolve(a)
            }
        }
        n.stripRtpPayload = stripRtpPayload;

        function stripVideo(a) {
            a.sdp = q(a.sdp || "", "video");
            return Promise.resolve(a)
        }
        n.stripVideo = stripVideo;

        function addMidLines(c) {
            var d = c.sdp || "";
            if (d.search(/^a=mid.*$/gm) === -1) {
                var e = d.match(/^m=.*$/gm);
                var f = d.split(/^m=.*$/gm);
                if (e) {
                    e.forEach(function(a, b) {
                        e[b] = a + "\na=mid:" + b
                    })
                }
                f.forEach(function(a, b) {
                    if (e && e[b]) {
                        f[b] = a + e[b]
                    }
                });
                d = f.join("");
                c.sdp = d
            }
            return Promise.resolve(c)
        }
        n.addMidLines = addMidLines
    }), (function(c, d, e) {
        "use strict";
        Object.defineProperty(d, "__esModule", {
            value: true
        });
        var f = e(5);
        var g = (function() {
            function g(a, b) {
                this.type = f.TypeStrings.SessionDescriptionHandlerObserver;
                this.session = a;
                this.options = b
            }
            g.prototype.trackAdded = function() {
                this.session.emit("trackAdded")
            };
            g.prototype.directionChanged = function() {
                this.session.emit("directionChanged")
            };
            return g
        }());
        d.SessionDescriptionHandlerObserver = g
    }), (function(u, v, w) {
        "use strict";
        (function(j) {
            var k = (this && this.__extends) || (function() {
                var a = function(d, b) {
                    a = Object.setPrototypeOf || ({
                            __proto__: []
                        }
                        instanceof Array && function(d, b) {
                            d.__proto__ = b
                        }) || function(d, b) {
                        for (var p in b)
                            if (b.hasOwnProperty(p)) d[p] = b[p]
                    };
                    return a(d, b)
                };
                return function(d, b) {
                    a(d, b);

                    function __() {
                        this.constructor = d
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
                }
            })();
            Object.defineProperty(v, "__esModule", {
                value: true
            });
            var l = w(5);
            var m = w(8);
            var n = w(11);
            var o = w(29);
            var q = w(15);
            var r;
            (function(a) {
                a[a["STATUS_CONNECTING"] = 0] = "STATUS_CONNECTING";
                a[a["STATUS_OPEN"] = 1] = "STATUS_OPEN";
                a[a["STATUS_CLOSING"] = 2] = "STATUS_CLOSING";
                a[a["STATUS_CLOSED"] = 3] = "STATUS_CLOSED"
            })(r = v.TransportStatus || (v.TransportStatus = {}));
            var s = function(a) {
                var b = a * 0.8;
                return 1000 * (Math.random() * (a - b) + b)
            };
            var t = (function(i) {
                k(t, i);

                function t(a, b) {
                    if (b === void 0) {
                        b = {}
                    }
                    var c = i.call(this, a, b) || this;
                    c.WebSocket = (j.window || j)
                        .WebSocket;
                    c.type = l.TypeStrings.Transport;
                    c.reconnectionAttempts = 0;
                    c.status = r.STATUS_CONNECTING;
                    c.configuration = c.loadConfig(b);
                    c.server = c.configuration.wsServers[0];
                    return c
                }
                t.prototype.isConnected = function() {
                    return this.status === r.STATUS_OPEN
                };
                t.prototype.sendPromise = function(a, b) {
                    if (b === void 0) {
                        b = {}
                    }
                    if (!this.statusAssert(r.STATUS_OPEN, b.force)) {
                        this.onError("unable to send message - WebSocket not open");
                        return Promise.reject()
                    }
                    var c = a.toString();
                    if (this.ws) {
                        if (this.configuration.traceSip === true) {
                            this.logger.log("sending WebSocket message:\n\n" + c + "\n")
                        }
                        this.ws.send(c);
                        return Promise.resolve({
                            msg: c
                        })
                    } else {
                        this.onError("unable to send message - WebSocket does not exist");
                        return Promise.reject()
                    }
                };
                t.prototype.disconnectPromise = function(c) {
                    var d = this;
                    if (c === void 0) {
                        c = {}
                    }
                    if (this.disconnectionPromise) {
                        return this.disconnectionPromise
                    }
                    c.code = c.code || 1000;
                    if (!this.statusTransition(r.STATUS_CLOSING, c.force)) {
                        if (this.status === r.STATUS_CLOSED) {
                            return Promise.resolve({
                                overrideEvent: true
                            })
                        } else if (this.connectionPromise) {
                            return this.connectionPromise.then(function() {
                                    return Promise.reject("The websocket did not disconnect")
                                })
                                .catch(function() {
                                    return Promise.resolve({
                                        overrideEvent: true
                                    })
                                })
                        } else {
                            return Promise.reject("The websocket did not disconnect")
                        }
                    }
                    this.emit("disconnecting");
                    this.disconnectionPromise = new Promise(function(a, b) {
                        d.disconnectDeferredResolve = a;
                        if (d.reconnectTimer) {
                            clearTimeout(d.reconnectTimer);
                            d.reconnectTimer = undefined
                        }
                        if (d.ws) {
                            d.stopSendingKeepAlives();
                            d.logger.log("closing WebSocket " + d.server.wsUri);
                            d.ws.close(c.code, c.reason)
                        } else {
                            b("Attempted to disconnect but the websocket doesn't exist")
                        }
                    });
                    return this.disconnectionPromise
                };
                t.prototype.connectPromise = function(c) {
                    var d = this;
                    if (c === void 0) {
                        c = {}
                    }
                    if (this.status === r.STATUS_CLOSING && !c.force) {
                        return Promise.reject("WebSocket " + this.server.wsUri + " is closing")
                    }
                    if (this.connectionPromise) {
                        return this.connectionPromise
                    }
                    this.server = this.server || this.getNextWsServer(c.force);
                    this.connectionPromise = new Promise(function(a, b) {
                        if ((d.status === r.STATUS_OPEN || d.status === r.STATUS_CLOSING) && !c.force) {
                            d.logger.warn("WebSocket " + d.server.wsUri + " is already connected");
                            b("Failed status check - attempted to open a connection but already open/closing");
                            return
                        }
                        d.connectDeferredResolve = a;
                        d.status = r.STATUS_CONNECTING;
                        d.emit("connecting");
                        d.logger.log("connecting to WebSocket " + d.server.wsUri);
                        d.disposeWs();
                        try {
                            d.ws = new WebSocket(d.server.wsUri, "sip")
                        } catch (e) {
                            d.ws = null;
                            d.status = r.STATUS_CLOSED;
                            d.onError("error connecting to WebSocket " + d.server.wsUri + ":" + e);
                            b("Failed to create a websocket");
                            return
                        }
                        if (!d.ws) {
                            b("Unexpected instance websocket not set");
                            return
                        }
                        d.connectionTimeout = setTimeout(function() {
                            d.statusTransition(r.STATUS_CLOSED);
                            d.logger.warn("took too long to connect - exceeded time set in configuration.connectionTimeout: " + d.configuration.connectionTimeout + "s");
                            d.emit("disconnected", {
                                code: 1000
                            });
                            d.connectionPromise = undefined;
                            b("Connection timeout")
                        }, d.configuration.connectionTimeout * 1000);
                        d.boundOnOpen = d.onOpen.bind(d);
                        d.boundOnMessage = d.onMessage.bind(d);
                        d.boundOnClose = d.onClose.bind(d);
                        d.boundOnError = d.onWebsocketError.bind(d);
                        d.ws.addEventListener("open", d.boundOnOpen);
                        d.ws.addEventListener("message", d.boundOnMessage);
                        d.ws.addEventListener("close", d.boundOnClose);
                        d.ws.addEventListener("error", d.boundOnError)
                    });
                    return this.connectionPromise
                };
                t.prototype.onMessage = function(e) {
                    var a = e.data;
                    var b;
                    if (/^(\r\n)+$/.test(a)) {
                        this.clearKeepAliveTimeout();
                        if (this.configuration.traceSip === true) {
                            this.logger.log("received WebSocket message with CRLF Keep Alive response")
                        }
                        return
                    } else if (!a) {
                        this.logger.warn("received empty message, message discarded");
                        return
                    } else if (typeof a !== "string") {
                        try {
                            b = String.fromCharCode.apply(null, new Uint8Array(a))
                        } catch (err) {
                            this.logger.warn("received WebSocket binary message failed to be converted into string, message discarded");
                            return
                        }
                        if (this.configuration.traceSip === true) {
                            this.logger.log("received WebSocket binary message:\n\n" + a + "\n")
                        }
                    } else {
                        if (this.configuration.traceSip === true) {
                            this.logger.log("received WebSocket text message:\n\n" + a + "\n")
                        }
                        b = a
                    }
                    this.emit("message", b)
                };
                t.prototype.onOpen = function() {
                    if (this.status === r.STATUS_CLOSED) {
                        var a = this.ws;
                        this.disposeWs();
                        a.close(1000);
                        return
                    }
                    this.status = r.STATUS_OPEN;
                    this.emit("connected");
                    if (this.connectionTimeout) {
                        clearTimeout(this.connectionTimeout);
                        this.connectionTimeout = undefined
                    }
                    this.logger.log("WebSocket " + this.server.wsUri + " connected");
                    if (this.reconnectTimer !== undefined) {
                        clearTimeout(this.reconnectTimer);
                        this.reconnectTimer = undefined
                    }
                    this.reconnectionAttempts = 0;
                    this.disconnectionPromise = undefined;
                    this.disconnectDeferredResolve = undefined;
                    this.startSendingKeepAlives();
                    if (this.connectDeferredResolve) {
                        this.connectDeferredResolve({
                            overrideEvent: true
                        })
                    } else {
                        this.logger.warn("Unexpected websocket.onOpen with no connectDeferredResolve")
                    }
                };
                t.prototype.onClose = function(e) {
                    this.logger.log("WebSocket disconnected (code: " + e.code + (e.reason ? "| reason: " + e.reason : "") + ")");
                    if (this.status !== r.STATUS_CLOSING) {
                        this.logger.warn("WebSocket closed without SIP.js requesting it");
                        this.emit("transportError")
                    }
                    this.stopSendingKeepAlives();
                    if (this.connectionTimeout) {
                        clearTimeout(this.connectionTimeout)
                    }
                    this.connectionTimeout = undefined;
                    this.connectionPromise = undefined;
                    this.connectDeferredResolve = undefined;
                    if (this.disconnectDeferredResolve) {
                        this.disconnectDeferredResolve({
                            overrideEvent: true
                        });
                        this.statusTransition(r.STATUS_CLOSED);
                        this.disconnectDeferredResolve = undefined;
                        return
                    }
                    this.status = r.STATUS_CLOSED;
                    this.emit("disconnected", {
                        code: e.code,
                        reason: e.reason
                    });
                    this.reconnect()
                };
                t.prototype.disposeWs = function() {
                    if (this.ws) {
                        this.ws.removeEventListener("open", this.boundOnOpen);
                        this.ws.removeEventListener("message", this.boundOnMessage);
                        this.ws.removeEventListener("close", this.boundOnClose);
                        this.ws.removeEventListener("error", this.boundOnError);
                        this.ws = undefined
                    }
                };
                t.prototype.onError = function(e) {
                    this.logger.warn("Transport error: " + e);
                    this.emit("transportError")
                };
                t.prototype.onWebsocketError = function() {
                    this.onError("The Websocket had an error")
                };
                t.prototype.reconnect = function() {
                    var a = this;
                    if (this.reconnectionAttempts > 0) {
                        this.logger.log("Reconnection attempt " + this.reconnectionAttempts + " failed")
                    }
                    if (this.noAvailableServers()) {
                        this.logger.warn("attempted to get next ws server but there are no available ws servers left");
                        this.logger.warn("no available ws servers left - going to closed state");
                        this.status = r.STATUS_CLOSED;
                        this.emit("closed");
                        this.resetServerErrorStatus();
                        return
                    }
                    if (this.isConnected()) {
                        this.logger.warn("attempted to reconnect while connected - forcing disconnect");
                        this.disconnect({
                            force: true
                        })
                    }
                    this.reconnectionAttempts += 1;
                    if (this.reconnectionAttempts > this.configuration.maxReconnectionAttempts) {
                        this.logger.warn("maximum reconnection attempts for WebSocket " + this.server.wsUri);
                        this.logger.log("transport " + this.server.wsUri + " failed | connection state set to 'error'");
                        this.server.isError = true;
                        this.emit("transportError");
                        if (!this.noAvailableServers()) {
                            this.server = this.getNextWsServer()
                        }
                        this.reconnectionAttempts = 0;
                        this.reconnect()
                    } else {
                        this.logger.log("trying to reconnect to WebSocket " + this.server.wsUri + " (reconnection attempt " + this.reconnectionAttempts + ")");
                        this.reconnectTimer = setTimeout(function() {
                            a.connect();
                            a.reconnectTimer = undefined
                        }, (this.reconnectionAttempts === 1) ? 0 : this.configuration.reconnectionTimeout * 1000)
                    }
                };
                t.prototype.resetServerErrorStatus = function() {
                    for (var a = 0, _a = this.configuration.wsServers; a < _a.length; a++) {
                        var b = _a[a];
                        b.isError = false
                    }
                };
                t.prototype.getNextWsServer = function(a) {
                    if (a === void 0) {
                        a = false
                    }
                    if (this.noAvailableServers()) {
                        this.logger.warn("attempted to get next ws server but there are no available ws servers left");
                        throw new Error("Attempted to get next ws server, but there are no available ws servers left.");
                    }
                    var b = [];
                    for (var c = 0, _a = this.configuration.wsServers; c < _a.length; c++) {
                        var d = _a[c];
                        if (d.isError && !a) {
                            continue
                        } else if (b.length === 0) {
                            b.push(d)
                        } else if (d.weight > b[0].weight) {
                            b = [d]
                        } else if (d.weight === b[0].weight) {
                            b.push(d)
                        }
                    }
                    var e = Math.floor(Math.random() * b.length);
                    return b[e]
                };
                t.prototype.noAvailableServers = function() {
                    for (var a = 0, _a = this.configuration.wsServers; a < _a.length; a++) {
                        var b = _a[a];
                        if (!b.isError) {
                            return false
                        }
                    }
                    return true
                };
                t.prototype.sendKeepAlive = function() {
                    var a = this;
                    if (this.keepAliveDebounceTimeout) {
                        return
                    }
                    this.keepAliveDebounceTimeout = setTimeout(function() {
                        a.emit("keepAliveDebounceTimeout");
                        a.clearKeepAliveTimeout()
                    }, this.configuration.keepAliveDebounce * 1000);
                    return this.send("\r\n\r\n")
                };
                t.prototype.clearKeepAliveTimeout = function() {
                    if (this.keepAliveDebounceTimeout) {
                        clearTimeout(this.keepAliveDebounceTimeout)
                    }
                    this.keepAliveDebounceTimeout = undefined
                };
                t.prototype.startSendingKeepAlives = function() {
                    var a = this;
                    if (this.configuration.keepAliveInterval && !this.keepAliveInterval) {
                        this.keepAliveInterval = setInterval(function() {
                            a.sendKeepAlive();
                            a.startSendingKeepAlives()
                        }, s(this.configuration.keepAliveInterval))
                    }
                };
                t.prototype.stopSendingKeepAlives = function() {
                    if (this.keepAliveInterval) {
                        clearInterval(this.keepAliveInterval)
                    }
                    if (this.keepAliveDebounceTimeout) {
                        clearTimeout(this.keepAliveDebounceTimeout)
                    }
                    this.keepAliveInterval = undefined;
                    this.keepAliveDebounceTimeout = undefined
                };
                t.prototype.statusAssert = function(a, b) {
                    if (a === this.status) {
                        return true
                    } else {
                        if (b) {
                            this.logger.warn("Attempted to assert " + Object.keys(r)[this.status] + " as " + Object.keys(r)[a] + "- continuing with option: 'force'");
                            return true
                        } else {
                            this.logger.warn("Tried to assert " + Object.keys(r)[a] + " but is currently " + Object.keys(r)[this.status]);
                            return false
                        }
                    }
                };
                t.prototype.statusTransition = function(a, b) {
                    if (b === void 0) {
                        b = false
                    }
                    this.logger.log("Attempting to transition status from " + Object.keys(r)[this.status] + " to " + Object.keys(r)[a]);
                    if ((a === r.STATUS_CONNECTING && this.statusAssert(r.STATUS_CLOSED, b)) || (a === r.STATUS_OPEN && this.statusAssert(r.STATUS_CONNECTING, b)) || (a === r.STATUS_CLOSING && this.statusAssert(r.STATUS_OPEN, b)) || (a === r.STATUS_CLOSED)) {
                        this.status = a;
                        return true
                    } else {
                        this.logger.warn("Status transition failed - result: no-op - reason:" + " either gave an nonexistent status or attempted illegal transition");
                        return false
                    }
                };
                t.prototype.loadConfig = function(a) {
                    var b = {
                        wsServers: [{
                            scheme: "WSS",
                            sipUri: "<sip:edge.sip.onsip.com;transport=ws;lr>",
                            weight: 0,
                            wsUri: "wss://edge.sip.onsip.com",
                            isError: false
                        }],
                        connectionTimeout: 5,
                        maxReconnectionAttempts: 3,
                        reconnectionTimeout: 4,
                        keepAliveInterval: 0,
                        keepAliveDebounce: 10,
                        traceSip: false
                    };
                    var c = this.getConfigurationCheck();
                    for (var d in c.mandatory) {
                        if (!a.hasOwnProperty(d)) {
                            throw new m.Exceptions.ConfigurationError(d);
                        } else {
                            var e = a[d];
                            var f = c.mandatory[d](e);
                            if (f !== undefined) {
                                b[d] = f
                            } else {
                                throw new m.Exceptions.ConfigurationError(d, e);
                            }
                        }
                    }
                    for (var d in c.optional) {
                        if (a.hasOwnProperty(d)) {
                            var e = a[d];
                            if ((e instanceof Array && e.length === 0) || (e === null || e === "" || e === undefined) || (typeof(e) === "number" && isNaN(e))) {
                                continue
                            }
                            var f = c.optional[d](e);
                            if (f !== undefined) {
                                b[d] = f
                            } else {
                                throw new m.Exceptions.ConfigurationError(d, e);
                            }
                        }
                    }
                    var g = {};
                    for (var d in b) {
                        if (b.hasOwnProperty(d)) {
                            g[d] = {
                                value: b[d],
                            }
                        }
                    }
                    var h = Object.defineProperties({}, g);
                    this.logger.log("configuration parameters after validation:");
                    for (var d in b) {
                        if (b.hasOwnProperty(d)) {
                            this.logger.log("è·¯ " + d + ": " + JSON.stringify(b[d]))
                        }
                    }
                    return h
                };
                t.prototype.getConfigurationCheck = function() {
                    return {
                        mandatory: {},
                        optional: {
                            wsServers: function(a) {
                                if (typeof a === "string") {
                                    a = [{
                                        wsUri: a
                                    }]
                                } else if (a instanceof Array) {
                                    for (var b = 0; b < a.length; b++) {
                                        if (typeof a[b] === "string") {
                                            a[b] = {
                                                wsUri: a[b]
                                            }
                                        }
                                    }
                                } else {
                                    return
                                }
                                if (a.length === 0) {
                                    return false
                                }
                                for (var c = 0, wsServers_1 = a; c < wsServers_1.length; c++) {
                                    var d = wsServers_1[c];
                                    if (!d.wsUri) {
                                        return
                                    }
                                    if (d.weight && !Number(d.weight)) {
                                        return
                                    }
                                    var e = n.Grammar.parse(d.wsUri, "absoluteURI");
                                    if (e === -1) {
                                        return
                                    } else if (["wss", "ws", "udp"].indexOf(e.scheme) < 0) {
                                        return
                                    } else {
                                        d.sipUri = "<sip:" + e.host + (e.port ? ":" + e.port : "") + ";transport=" + e.scheme.replace(/^wss$/i, "ws") + ";lr>";
                                        if (!d.weight) {
                                            d.weight = 0
                                        }
                                        d.isError = false;
                                        d.scheme = e.scheme.toUpperCase()
                                    }
                                }
                                return a
                            },
                            keepAliveInterval: function(a) {
                                if (q.Utils.isDecimal(a)) {
                                    var b = Number(a);
                                    if (b > 0) {
                                        return b
                                    }
                                }
                            },
                            keepAliveDebounce: function(a) {
                                if (q.Utils.isDecimal(a)) {
                                    var b = Number(a);
                                    if (b > 0) {
                                        return b
                                    }
                                }
                            },
                            traceSip: function(a) {
                                if (typeof a === "boolean") {
                                    return a
                                }
                            },
                            connectionTimeout: function(a) {
                                if (q.Utils.isDecimal(a)) {
                                    var b = Number(a);
                                    if (b > 0) {
                                        return b
                                    }
                                }
                            },
                            maxReconnectionAttempts: function(a) {
                                if (q.Utils.isDecimal(a)) {
                                    var b = Number(a);
                                    if (b >= 0) {
                                        return b
                                    }
                                }
                            },
                            reconnectionTimeout: function(a) {
                                if (q.Utils.isDecimal(a)) {
                                    var b = Number(a);
                                    if (b > 0) {
                                        return b
                                    }
                                }
                            }
                        }
                    }
                };
                t.C = r;
                return t
            }(o.Transport));
            v.Transport = t
        }.call(this, w(31)))
    }), (function(a, b, c) {
        "use strict";
        Object.defineProperty(b, "__esModule", {
            value: true
        });
        var d = c(33);
        b.Modifiers = d;
        var e = c(37);
        b.Simple = e.Simple;
        var f = c(32);
        b.SessionDescriptionHandler = f.SessionDescriptionHandler;
        var g = c(35);
        b.Transport = g.Transport
    }), (function(q, r, s) {
        "use strict";
        (function(i) {
            var j = (this && this.__extends) || (function() {
                var a = function(d, b) {
                    a = Object.setPrototypeOf || ({
                            __proto__: []
                        }
                        instanceof Array && function(d, b) {
                            d.__proto__ = b
                        }) || function(d, b) {
                        for (var p in b)
                            if (b.hasOwnProperty(p)) d[p] = b[p]
                    };
                    return a(d, b)
                };
                return function(d, b) {
                    a(d, b);

                    function __() {
                        this.constructor = d
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __())
                }
            })();
            Object.defineProperty(r, "__esModule", {
                value: true
            });
            var k = s(2);
            var l = s(30);
            var m = s(33);
            var n;
            (function(a) {
                a[a["STATUS_NULL"] = 0] = "STATUS_NULL";
                a[a["STATUS_NEW"] = 1] = "STATUS_NEW";
                a[a["STATUS_CONNECTING"] = 2] = "STATUS_CONNECTING";
                a[a["STATUS_CONNECTED"] = 3] = "STATUS_CONNECTED";
                a[a["STATUS_COMPLETED"] = 4] = "STATUS_COMPLETED"
            })(n = r.SimpleStatus || (r.SimpleStatus = {}));
            var o = (function(h) {
                j(o, h);

                function o(b) {
                    var c = h.call(this) || this;
                    if (b.media.remote.video) {
                        c.video = true
                    } else {
                        c.video = false
                    }
                    if (b.media.remote.audio) {
                        c.audio = true
                    } else {
                        c.audio = false
                    }
                    if (!c.audio && !c.video) {
                        throw new Error("At least one remote audio or video element is required for Simple.");
                    }
                    c.options = b;
                    var d = i.navigator.userAgent.toLowerCase();
                    var e = false;
                    var f = false;
                    if (d.indexOf("safari") > -1 && d.indexOf("chrome") < 0) {
                        e = true
                    } else if (d.indexOf("firefox") > -1 && d.indexOf("chrome") < 0) {
                        f = true
                    }
                    var g = {};
                    if (e) {
                        g.modifiers = [m.stripG722]
                    }
                    if (f) {
                        g.alwaysAcquireMediaFirst = true
                    }
                    if (!c.options.ua.uri) {
                        c.anonymous = true
                    } else {
                        c.anonymous = false
                    }
                    c.ua = new l.UA({
                        uri: c.options.ua.uri,
                        authorizationUser: c.options.ua.authorizationUser,
                        password: c.options.ua.password,
                        displayName: c.options.ua.displayName,
                        userAgentString: c.options.ua.userAgentString,
                        register: true,
                        sessionDescriptionHandlerFactoryOptions: g,
                        transportOptions: {
                            traceSip: c.options.ua.traceSip,
                            wsServers: c.options.ua.wsServers
                        }
                    });
                    c.state = n.STATUS_NULL;
                    c.logger = c.ua.getLogger("sip.simple");
                    c.ua.on("registered", function() {
                        c.emit("registered", c.ua)
                    });
                    c.ua.on("unregistered", function() {
                        c.emit("unregistered", c.ua)
                    });
                    c.ua.on("registrationFailed", function() {
                        c.emit("unregistered", c.ua)
                    });
                    c.ua.on("invite", function(a) {
                        if (c.state !== n.STATUS_NULL && c.state !== n.STATUS_COMPLETED) {
                            c.logger.warn("Rejecting incoming call. Simple only supports 1 call at a time");
                            a.reject();
                            return
                        }
                        c.session = a;
                        c.setupSession();
                        c.emit("ringing", c.session)
                    });
                    c.ua.on("message", function(a) {
                        c.emit("message", a)
                    });
                    return c
                }
                o.prototype.call = function(a) {
                    if (!this.ua || !this.checkRegistration()) {
                        this.logger.warn("A registered UA is required for calling");
                        return
                    }
                    if (this.state !== n.STATUS_NULL && this.state !== n.STATUS_COMPLETED) {
                        this.logger.warn("Cannot make more than a single call with Simple");
                        return
                    }
                    if (this.options.media.remote.audio) {
                        this.options.media.remote.audio.autoplay = true
                    }
                    if (this.options.media.remote.video) {
                        this.options.media.remote.video.autoplay = true
                    }
                    if (this.options.media.local && this.options.media.local.video) {
                        this.options.media.local.video.autoplay = true;
                        this.options.media.local.video.volume = 0
                    }
                    this.session = this.ua.invite(a, {
                        sessionDescriptionHandlerOptions: {
                            constraints: {
                                audio: this.audio,
                                video: this.video
                            }
                        }
                    });
                    this.setupSession();
                    return this.session
                };
                o.prototype.answer = function() {
                    if (this.state !== n.STATUS_NEW && this.state !== n.STATUS_CONNECTING) {
                        this.logger.warn("No call to answer");
                        return
                    }
                    if (this.options.media.remote.audio) {
                        this.options.media.remote.audio.autoplay = true
                    }
                    if (this.options.media.remote.video) {
                        this.options.media.remote.video.autoplay = true
                    }
                    return this.session.accept({
                        sessionDescriptionHandlerOptions: {
                            constraints: {
                                audio: this.audio,
                                video: this.video
                            }
                        }
                    })
                };
                o.prototype.reject = function() {
                    if (this.state !== n.STATUS_NEW && this.state !== n.STATUS_CONNECTING) {
                        this.logger.warn("Call is already answered");
                        return
                    }
                    return this.session.reject()
                };
                o.prototype.hangup = function() {
                    if (this.state !== n.STATUS_CONNECTED && this.state !== n.STATUS_CONNECTING && this.state !== n.STATUS_NEW) {
                        this.logger.warn("No active call to hang up on");
                        return
                    }
                    if (this.state !== n.STATUS_CONNECTED) {
                        return this.session.cancel()
                    } else if (this.session) {
                        return this.session.bye()
                    }
                };
                o.prototype.hold = function() {
                    if (this.state !== n.STATUS_CONNECTED || !this.session || this.session.localHold) {
                        this.logger.warn("Cannot put call on hold");
                        return
                    }
                    this.mute();
                    this.logger.log("Placing session on hold");
                    return this.session.hold()
                };
                o.prototype.unhold = function() {
                    if (this.state !== n.STATUS_CONNECTED || !this.session || !this.session.localHold) {
                        this.logger.warn("Cannot unhold a call that is not on hold");
                        return
                    }
                    this.unmute();
                    this.logger.log("Placing call off hold");
                    return this.session.unhold()
                };
                o.prototype.mute = function() {
                    if (this.state !== n.STATUS_CONNECTED) {
                        this.logger.warn("An acitve call is required to mute audio");
                        return
                    }
                    this.logger.log("Muting Audio");
                    this.toggleMute(true);
                    this.emit("mute", this)
                };
                o.prototype.unmute = function() {
                    if (this.state !== n.STATUS_CONNECTED) {
                        this.logger.warn("An active call is required to unmute audio");
                        return
                    }
                    this.logger.log("Unmuting Audio");
                    this.toggleMute(false);
                    this.emit("unmute", this)
                };
                o.prototype.sendDTMF = function(a) {
                    if (this.state !== n.STATUS_CONNECTED || !this.session) {
                        this.logger.warn("An active call is required to send a DTMF tone");
                        return
                    }
                    this.logger.log("Sending DTMF tone: " + a);
                    this.session.dtmf(a)
                };
                o.prototype.message = function(a, b) {
                    if (!this.ua || !this.checkRegistration()) {
                        this.logger.warn("A registered UA is required to send a message");
                        return
                    }
                    if (!a || !b) {
                        this.logger.warn("A destination and message are required to send a message");
                        return
                    }
                    this.ua.message(a, b)
                };
                o.prototype.checkRegistration = function() {
                    return (this.anonymous || (this.ua && this.ua.isRegistered()))
                };
                o.prototype.setupRemoteMedia = function() {
                    var c = this;
                    if (!this.session) {
                        this.logger.warn("No session to set remote media on");
                        return
                    }
                    var d = this.session.sessionDescriptionHandler.peerConnection;
                    var e;
                    if (d.getReceivers) {
                        e = new i.window.MediaStream();
                        d.getReceivers()
                            .forEach(function(a) {
                                var b = a.track;
                                if (b) {
                                    e.addTrack(b)
                                }
                            })
                    } else {
                        e = d.getRemoteStreams()[0]
                    }
                    if (this.video) {
                        this.options.media.remote.video.srcObject = e;
                        this.options.media.remote.video.play()
                            .catch(function() {
                                c.logger.log("play was rejected")
                            })
                    } else if (this.audio) {
                        this.options.media.remote.audio.srcObject = e;
                        this.options.media.remote.audio.play()
                            .catch(function() {
                                c.logger.log("play was rejected")
                            })
                    }
                };
                o.prototype.setupLocalMedia = function() {
                    if (!this.session) {
                        this.logger.warn("No session to set local media on");
                        return
                    }
                    if (this.video && this.options.media.local && this.options.media.local.video) {
                        var c = this.session.sessionDescriptionHandler.peerConnection;
                        var d;
                        if (c.getSenders) {
                            d = new i.window.MediaStream();
                            c.getSenders()
                                .forEach(function(a) {
                                    var b = a.track;
                                    if (b && b.kind === "video") {
                                        d.addTrack(b)
                                    }
                                })
                        } else {
                            d = c.getLocalStreams()[0]
                        }
                        this.options.media.local.video.srcObject = d;
                        this.options.media.local.video.volume = 0;
                        this.options.media.local.video.play()
                    }
                };
                o.prototype.cleanupMedia = function() {
                    if (this.video) {
                        this.options.media.remote.video.srcObject = null;
                        this.options.media.remote.video.pause();
                        if (this.options.media.local && this.options.media.local.video) {
                            this.options.media.local.video.srcObject = null;
                            this.options.media.local.video.pause()
                        }
                    }
                    if (this.audio) {
                        this.options.media.remote.audio.srcObject = null;
                        this.options.media.remote.audio.pause()
                    }
                };
                o.prototype.setupSession = function() {
                    var a = this;
                    if (!this.session) {
                        this.logger.warn("No session to set up");
                        return
                    }
                    this.state = n.STATUS_NEW;
                    this.emit("new", this.session);
                    this.session.on("progress", function() {
                        return a.onProgress()
                    });
                    this.session.on("accepted", function() {
                        return a.onAccepted()
                    });
                    this.session.on("rejected", function() {
                        return a.onEnded()
                    });
                    this.session.on("failed", function() {
                        return a.onFailed()
                    });
                    this.session.on("terminated", function() {
                        return a.onEnded()
                    })
                };
                o.prototype.destroyMedia = function() {
                    if (this.session && this.session.sessionDescriptionHandler) {
                        this.session.sessionDescriptionHandler.close()
                    }
                };
                o.prototype.toggleMute = function(c) {
                    if (!this.session) {
                        this.logger.warn("No session to toggle mute");
                        return
                    }
                    var d = this.session.sessionDescriptionHandler.peerConnection;
                    if (d.getSenders) {
                        d.getSenders()
                            .forEach(function(a) {
                                if (a.track) {
                                    a.track.enabled = !c
                                }
                            })
                    } else {
                        d.getLocalStreams()
                            .forEach(function(b) {
                                b.getAudioTracks()
                                    .forEach(function(a) {
                                        a.enabled = !c
                                    });
                                b.getVideoTracks()
                                    .forEach(function(a) {
                                        a.enabled = !c
                                    })
                            })
                    }
                };
                o.prototype.onAccepted = function() {
                    var c = this;
                    if (!this.session) {
                        this.logger.warn("No session for accepting");
                        return
                    }
                    this.state = n.STATUS_CONNECTED;
                    this.emit("connected", this.session);
                    this.setupLocalMedia();
                    this.setupRemoteMedia();
                    if (this.session.sessionDescriptionHandler) {
                        this.session.sessionDescriptionHandler.on("addTrack", function() {
                            c.logger.log("A track has been added, triggering new remoteMedia setup");
                            c.setupRemoteMedia()
                        });
                        this.session.sessionDescriptionHandler.on("addStream", function() {
                            c.logger.log("A stream has been added, trigger new remoteMedia setup");
                            c.setupRemoteMedia()
                        })
                    }
                    this.session.on("dtmf", function(a, b) {
                        c.emit("dtmf", b.tone)
                    });
                    this.session.on("bye", function() {
                        return c.onEnded()
                    })
                };
                o.prototype.onProgress = function() {
                    this.state = n.STATUS_CONNECTING;
                    this.emit("connecting", this.session)
                };
                o.prototype.onFailed = function() {
                    this.onEnded()
                };
                o.prototype.onEnded = function() {
                    this.state = n.STATUS_COMPLETED;
                    this.emit("ended", this.session);
                    this.cleanupMedia()
                };
                o.C = n;
                return o
            }(k.EventEmitter));
            r.Simple = o
        }.call(this, s(31)))
    })])
});;;
class ant_webPhone {
    constructor(token, host, port, blackfun) {
        this.token = token;
        var sendData = '{"token":"' + this.token + '"}';
        var url = "https://" + host + "/cloud-app/webphone.html?f=getExtenInfo";
        var res = this.ant_ajax(sendData, url);
        if (res["code"] != 0) {
            if (res["code"] == "1010") {
                var redata = {
                    "event": "sys",
                    "value": 'token_expire',
                    "data": "tokenè¿‡æœŸï¼Œè¯·é‡æ–°ç™»é™†ï¼"
                }
            } else {
                var redata = {
                    "event": "sys",
                    "value": '',
                    "data": res
                }
            }
            blackfun(redata);
            return false
        }
        this.extCode = res['data']['extension'];
        var extPass = res['data']['token'];
        this.host = host;
        this.port = port;
        var config = {
            uri: "sip:" + this.extCode + '@' + host + ':' + port,
            wsAddress: host,
            authorizationUser: this.extCode,
            password: extPass,
            displayName: this.extCode,
            log: {
                builtinEnabled: true,
                level: 1
            },
            transportOptions: {
                wsServers: ['wss://' + host + ':' + port],
                traceSip: false
            },
            allowLegacyNotifications: true,
            hackWssInTransport: true,
            hackIpInContact: host,
            userAgentString: "smarkdeskclient",
            autostart: true,
            register: false,
            rel100: SIP.C.supported.SUPPORTED,
            registerOptions: {
                expires: 1800,
                registrar: 'sip:' + host + ':' + port,
            },
            contactName: this.extCode,
        };
        this.config = config;
        var ua = new SIP.UA(config);
        this.ua = ua;
        this.uastatus = 0;
        this.blackfun = blackfun;
        this.getUaStatu(this.blackfun);
        document.write('<video id="ant_remoteVideo" autoplay="autoplay" hidden=""></video><video id="ant_localVideo" autoplay="autoplay" muted="muted" hidden=""></video>');
        this.remoteVideo = document.getElementById('ant_remoteVideo');
        this.localVideo = document.getElementById('ant_localVideo');
        this.sessionall;
        this.session
    }
    ant_register() {
        var sendData = '{"token":"' + this.token + '"}';
        var url = "https://" + this.host + "/cloud-app/webphone.html?f=getCheck";
        var res = this.ant_ajax(sendData, url);
        if (res["code"] != 0) {
            if (res["code"] == "1010") {
                var redata = {
                    "event": "sys",
                    "value": 'token_expire',
                    "data": "tokenè¿‡æœŸï¼Œè¯·é‡æ–°ç™»é™†ï¼"
                }
            } else {
                var redata = {
                    "event": "sys",
                    "value": '',
                    "data": res
                }
            }
            blackfun(redata);
            return false
        }
        this.ua.register({
            register: true
        })
    }
    ant_unregister() {
        var sendData = '{"token":"' + this.token + '"}';
        var url = "https://" + this.host + "/cloud-app/webphone.html?f=getCheck";
        var res = this.ant_ajax(sendData, url);
        if (res["code"] != 0) {
            if (res["code"] == "1010") {
                var redata = {
                    "event": "sys",
                    "value": 'token_expire',
                    "data": "tokenè¿‡æœŸï¼Œè¯·é‡æ–°ç™»é™†ï¼"
                }
            } else {
                var redata = {
                    "event": "sys",
                    "value": '',
                    "data": res
                }
            }
            blackfun(redata);
            return false
        }
        this.ua.unregister()
    }
    ant_startcall(number) {
        var that = this;
        var sendData = '{"token":"' + this.token + '","number":"' + number + '"}';
        var url = "https://" + this.host + "/cloud-app/webphone.html?f=asyncCoreOutcall";
        var res = this.ant_ajax(sendData, url);
        if (res["code"] != 0) {
            if (res["code"] == "1010") {
                var redata = {
                    "event": "sys",
                    "value": 'token_expire',
                    "data": "tokenè¿‡æœŸï¼Œè¯·é‡æ–°ç™»é™†ï¼"
                }
            } else {
                var redata = {
                    "event": "sys",
                    "value": '',
                    "data": res
                }
            }
            this.blackfun(redata);
            return false
        }
        this.sessionall = this.ua.invite(number + "@" + this.config.wsAddress, {
            sessionDescriptionHandlerOptions: {
                constraints: {
                    audio: true,
                    video: false
                },
                alwaysAcquireMediaFirst: true
            }
        });
        this.sessionall.on("bye", function(b, a) {
            var e = {
                "event": "call",
                "value": "bye",
                "data": ""
            };
            that.blackfun(e)
        });
        this.sessionall.on('rejected', function(b, a) {
            var e = {
                "event": "call",
                "value": "rejected",
                "data": ""
            };
            that.blackfun(e)
        });
        this.sessionall.on("failed", function(b, a) {
            var e = {
                "event": "call",
                "value": "failed",
                "data": ""
            };
            that.blackfun(e)
        });
        this.sessionall.on("terminated", function(b, a) {
            var e = {
                "event": "call",
                "value": "terminated",
                "data": ""
            };
            that.blackfun(e)
        });
        this.sessionall.on("accepted", function(e, g) {
            var c = {
                "event": "call",
                "value": "accepted",
                "data": ""
            };
            that.blackfun(c);
            var d = this.sessionDescriptionHandler.peerConnection;
            var f;
            if (d.getReceivers) {
                f = new window.MediaStream();
                d.getReceivers()
                    .forEach(function(b) {
                        var a = b.track;
                        if (a) {
                            f.addTrack(a)
                        }
                    })
            } else {
                f = d.getRemoteStreams()[0]
            }
            that.remoteVideo.srcObject = f;
            var h;
            if (d.getSenders) {
                h = new window.MediaStream();
                d.getSenders()
                    .forEach(function(b) {
                        var a = b.track;
                        if (a && a.kind === "video") {
                            h.addTrack(a)
                        }
                    })
            } else {
                h = d.getLocalStreams()[0]
            }
            that.localVideo.srcObject = h
        });
        this.sessionall.on('trackAdded', function() {
            var e = {
                "event": "call",
                "value": "trackAdded",
                "data": ""
            };
            that.blackfun(e);
            var g = this.sessionDescriptionHandler.peerConnection;
            var c;
            if (g.getReceivers) {
                c = new window.MediaStream();
                g.getReceivers()
                    .forEach(function(b) {
                        var a = b.track;
                        if (a) {
                            c.addTrack(a)
                        }
                    })
            } else {
                c = g.getRemoteStreams()[0]
            }
            that.remoteVideo.srcObject = c;
            var d;
            if (g.getSenders) {
                d = new window.MediaStream();
                g.getSenders()
                    .forEach(function(b) {
                        var a = b.track;
                        if (a && a.kind === "video") {
                            d.addTrack(a)
                        }
                    })
            } else {
                d = g.getLocalStreams()[0]
            }
            that.localVideo.srcObject = d
        })
    }
    ant_endcall() {
        if (!this.sessionall) {
            return
        } else if (this.sessionall.startTime) {
            this.sessionall.bye()
        } else if (this.sessionall.reject) {
            this.sessionall.reject()
        } else if (this.sessionall.cancel) {
            this.sessionall.cancel()
        }
    }
    ant_getStatu() {
        return this.uastatus
    }
    getUaStatu(blackfun) {
        this.ua.on('registered', function() {
            console.log('%c registered', 'color: #f00');
            this.uastatus = 1;
            var b = {
                "event": "status",
                "value": this.uastatus
            };
            blackfun(b)
        });
        this.ua.on('unregistered', function(b, a) {
            console.log('%c unregistered', 'color: #f00');
            this.uastatus = 0;
            var e = {
                "event": "status",
                "value": this.uastatus
            };
            blackfun(e)
        });
        this.ua.on('disconnected', function() {
            var b = {
                "event": "connect",
                "value": "error"
            };
            blackfun(b)
        });
        this.ua.on('connecting', function(b) {
            var a = {
                "event": "connect",
                "value": "start"
            };
            blackfun(a)
        });
        this.ua.on('connected', function() {
            var b = {
                "event": "connect",
                "value": "ok"
            };
            blackfun(b)
        });
        var that = this;
        this.ua.on('invite', function(h) {
            that.session = h;
            var k = h.remoteIdentity.uri.toString();
            var l = /\:(.+?)\@/g;
            var i;
            var j = "";
            if ((i = l.exec(k)) != null) {
                j = i[1]
            }
            var m = {
                "event": "call",
                "value": "invite",
                "data": j
            };
            that.blackfun(m);
            that.session.on("terminated", function(b, a) {
                console.log(b)
            });
            that.session.on('accepted', function(e, g) {
                var c = this.sessionDescriptionHandler.peerConnection;
                console.log(this.sessionDescriptionHandler);
                var d;
                if (c.getReceivers) {
                    d = new window.MediaStream();
                    c.getReceivers()
                        .forEach(function(b) {
                            var a = b.track;
                            if (a) {
                                d.addTrack(a)
                            }
                        })
                } else {
                    d = c.getRemoteStreams()[0]
                }
                that.remoteVideo.srcObject = d;
                var f;
                if (c.getSenders) {
                    f = new window.MediaStream();
                    c.getSenders()
                        .forEach(function(b) {
                            var a = b.track;
                            if (a && a.kind === "video") {
                                f.addTrack(a)
                            }
                        })
                } else {
                    f = c.getLocalStreams()[0]
                }
                that.localVideo.srcObject = f;
                that.localVideo.volume = 0
            });
            that.session.on('bye', function(b, a) {
                console.log("------------------------------------------------------- | viki bye .. ")
            })
        })
    }
    ant_answerCall() {
        this.session.accept({
            sessionDescriptionHandlerOptions: {
                constraints: {
                    audio: true,
                    video: false
                },
                render: {
                    remote: document.getElementById('remoteAudio'),
                    local: document.getElementById('localAudio')
                }
            }
        });
        this.sessionall = this.session;
        return true
    }
    ant_rejectCall() {
        this.session.reject();
        return true
    }
    ant_ajax(sendData, url) {
        var res;
        var ajax = new XMLHttpRequest();
        ajax.onreadystatechange = function() {
            if (ajax.readyState == 4 && ajax.status == 200) {
                res = eval("(" + ajax.responseText + ")")
            }
        };
        ajax.open("POST", url, false);
        ajax.send(sendData);
        return res
    }
}
window.MyObject = ant_webPhone;



function ant_sys_login(b, a, e, g) {
    var c = new XMLHttpRequest();
    var d;
    c.onreadystatechange = function() {
        if (c.readyState == 4 && c.status == 200) {
            d = eval("(" + c.responseText + ")")
        }
    };
    c.open("POST", "https://" + g + "/cloud-app/webphone.html?f=weblogin", false);
    var f = '{"code":"' + b + '","username": "' + a + '","password": "' + e + '"}';
    c.send(f);
    return d
};